export const tracksByArtists = {
  69: [
    { name: "Black Dare", slug: "69-black-dare", image: "69-black-dare.jpg" },
    { name: "Collision", slug: "69-collision", image: "69-collision.jpg" },
    {
      name: "Faster and Faster",
      slug: "69-faster-and-faster",
      image: "69-faster-and-faster.jpg",
    },
    {
      name: "March Of The Enemies",
      slug: "69-march-of-the-enemies",
      image: "69-march-of-the-enemies.jpg",
    },
    { name: "New Order", slug: "69-new-order", image: "69-new-order.jpg" },
    { name: "No People", slug: "69-no-people", image: "69-no-people.jpg" },
    {
      name: "One Man Army",
      slug: "69-one-man-army",
      image: "69-one-man-army.jpg",
    },
    {
      name: "Schizophonic",
      slug: "69-schizophonic",
      image: "69-schizophonic.jpg",
    },
    { name: "The Con", slug: "69-the-con", image: "69-the-con.jpg" },
  ],
  Viva: [
    { name: "#5", slug: "viva-5", image: "viva-5.jpg" },
    { name: "Alga", slug: "viva-alga", image: "viva-alga.jpg" },
    {
      name: "Bachata Morune Laser",
      slug: "viva-bachata-morune-laser",
      image: "viva-bachata-morune-laser.jpg",
    },
    {
      name: "Cancion Para La Cosecha",
      slug: "viva-cancion-para-la-cosecha",
      image: "viva-cancion-para-la-cosecha.jpg",
    },
    { name: "Candela", slug: "viva-candela", image: "viva-candela.jpg" },
    {
      name: "La Llamada",
      slug: "viva-la-llamada",
      image: "viva-la-llamada.jpg",
    },
    {
      name: "Ou est ton cahier",
      slug: "viva-ou-est-ton-cahier",
      image: "viva-ou-est-ton-cahier.jpg",
    },
  ],
  "Inigo Ugarteburu": [
    {
      name: "&",
      slug: "inigo-ugarteburu-and",
      image: "inigo-ugarteburu-and.jpg",
    },
    {
      name: "Araberan",
      slug: "inigo-ugarteburu-araberan",
      image: "inigo-ugarteburu-araberan.jpg",
    },
    {
      name: "Dordoka",
      slug: "inigo-ugarteburu-dordoka",
      image: "inigo-ugarteburu-dordoka.jpg",
    },
    {
      name: "Madari Katua",
      slug: "inigo-ugarteburu-madari-katua",
      image: "inigo-ugarteburu-madari-katua.jpg",
    },
    {
      name: "Mississippi is so far",
      slug: "inigo-ugarteburu-mississippi-is-so-far",
      image: "inigo-ugarteburu-mississippi-is-so-far.jpg",
    },
    {
      name: "Valentina",
      slug: "inigo-ugarteburu-valentina",
      image: "inigo-ugarteburu-valentina.jpg",
    },
  ],
  "Matter Of Tact": [
    {
      name: "00 14 53",
      slug: "matter-of-tact-00-14-53",
      image: "matter-of-tact-00-14-53.jpg",
    },
    {
      name: "Apollo",
      slug: "matter-of-tact-apollo",
      image: "matter-of-tact-apollo.jpg",
    },
    {
      name: "Ecuador feat. Acedy",
      slug: "matter-of-tact-ecuador-feat-acedy",
      image: "matter-of-tact-ecuador-feat-acedy.jpg",
    },
    {
      name: "On Your Side",
      slug: "matter-of-tact-on-your-side",
      image: "matter-of-tact-on-your-side.jpg",
    },
  ],
  "Pajaro Sunrise": [
    {
      name: "086",
      slug: "pajaro-sunrise-086",
      image: "pajaro-sunrise-086.jpg",
    },
    {
      name: "A Different Scene",
      slug: "pajaro-sunrise-a-different-scene",
      image: "pajaro-sunrise-a-different-scene.jpg",
    },
    {
      name: "A Lot Like Elvis",
      slug: "pajaro-sunrise-a-lot-like-elvis",
      image: "pajaro-sunrise-a-lot-like-elvis.jpg",
    },
    {
      name: "A Love Like Mine",
      slug: "pajaro-sunrise-a-love-like-mine",
      image: "pajaro-sunrise-a-love-like-mine.jpg",
    },
    {
      name: "Commitments",
      slug: "pajaro-sunrise-commitments",
      image: "pajaro-sunrise-commitments.jpg",
    },
    {
      name: "Echoing Bells",
      slug: "pajaro-sunrise-echoing-bells",
      image: "pajaro-sunrise-echoing-bells.jpg",
    },
    {
      name: "Filthy Paycheck",
      slug: "pajaro-sunrise-filthy-paycheck",
      image: "pajaro-sunrise-filthy-paycheck.jpg",
    },
    {
      name: "God Doesn't Care Anymore",
      slug: "pajaro-sunrise-god-doesn-t-care-anymore",
      image: "pajaro-sunrise-god-doesn-t-care-anymore.jpg",
    },
    {
      name: "Good To See You",
      slug: "pajaro-sunrise-good-to-see-you",
      image: "pajaro-sunrise-good-to-see-you.jpg",
    },
    {
      name: "Gorgeous Georgina",
      slug: "pajaro-sunrise-gorgeous-georgina",
      image: "pajaro-sunrise-gorgeous-georgina.jpg",
    },
    {
      name: "Home",
      slug: "pajaro-sunrise-home",
      image: "pajaro-sunrise-home.jpg",
    },
    {
      name: "Hopefully Pt1",
      slug: "pajaro-sunrise-hopefully-pt1",
      image: "pajaro-sunrise-hopefully-pt1.jpg",
    },
    {
      name: "Hopefully Pt2",
      slug: "pajaro-sunrise-hopefully-pt2",
      image: "pajaro-sunrise-hopefully-pt2.jpg",
    },
    {
      name: "I Don't Want To Love You No More",
      slug: "pajaro-sunrise-i-don-t-want-to-love-you-no-more",
      image: "pajaro-sunrise-i-don-t-want-to-love-you-no-more.jpg",
    },
    {
      name: "If I Could Choose",
      slug: "pajaro-sunrise-if-i-could-choose",
      image: "pajaro-sunrise-if-i-could-choose.jpg",
    },
    {
      name: "Il Sorpasso",
      slug: "pajaro-sunrise-il-sorpasso",
      image: "pajaro-sunrise-il-sorpasso.jpg",
    },
    {
      name: "Kahlenberg",
      slug: "pajaro-sunrise-kahlenberg",
      image: "pajaro-sunrise-kahlenberg.jpg",
    },
    {
      name: "Keep On Driving",
      slug: "pajaro-sunrise-keep-on-driving",
      image: "pajaro-sunrise-keep-on-driving.jpg",
    },
    {
      name: "Laura May",
      slug: "pajaro-sunrise-laura-may",
      image: "pajaro-sunrise-laura-may.jpg",
    },
    {
      name: "Leave The Rubbish Out",
      slug: "pajaro-sunrise-leave-the-rubbish-out",
      image: "pajaro-sunrise-leave-the-rubbish-out.jpg",
    },
    {
      name: "Long Forgotten Flowers",
      slug: "pajaro-sunrise-long-forgotten-flowers",
      image: "pajaro-sunrise-long-forgotten-flowers.jpg",
    },
    {
      name: "Look What We 've Become",
      slug: "pajaro-sunrise-look-what-we-ve-become",
      image: "pajaro-sunrise-look-what-we-ve-become.jpg",
    },
    {
      name: "Love Like A Drummer",
      slug: "pajaro-sunrise-love-like-a-drummer",
      image: "pajaro-sunrise-love-like-a-drummer.jpg",
    },
    {
      name: "Minolta",
      slug: "pajaro-sunrise-minolta",
      image: "pajaro-sunrise-minolta.jpg",
    },
    {
      name: "Move Like A Ghost",
      slug: "pajaro-sunrise-move-like-a-ghost",
      image: "pajaro-sunrise-move-like-a-ghost.jpg",
    },
    { name: "No", slug: "pajaro-sunrise-no", image: "pajaro-sunrise-no.jpg" },
    {
      name: "November",
      slug: "pajaro-sunrise-november",
      image: "pajaro-sunrise-november.jpg",
    },
    {
      name: "Now Everything Makes Sense",
      slug: "pajaro-sunrise-now-everything-makes-sense",
      image: "pajaro-sunrise-now-everything-makes-sense.jpg",
    },
    {
      name: "Old Goodbyes",
      slug: "pajaro-sunrise-old-goodbyes",
      image: "pajaro-sunrise-old-goodbyes.jpg",
    },
    {
      name: "Passings Birds",
      slug: "pajaro-sunrise-passings-birds",
      image: "pajaro-sunrise-passings-birds.jpg",
    },
    {
      name: "Reel Of The World",
      slug: "pajaro-sunrise-reel-of-the-world",
      image: "pajaro-sunrise-reel-of-the-world.jpg",
    },
    {
      name: "Sink Or Swim",
      slug: "pajaro-sunrise-sink-or-swim",
      image: "pajaro-sunrise-sink-or-swim.jpg",
    },
    {
      name: "Sky High",
      slug: "pajaro-sunrise-sky-high",
      image: "pajaro-sunrise-sky-high.jpg",
    },
    {
      name: "Song For Evangeline",
      slug: "pajaro-sunrise-song-for-evangeline",
      image: "pajaro-sunrise-song-for-evangeline.jpg",
    },
    {
      name: "Song For Evangeline (Part II)",
      slug: "pajaro-sunrise-song-for-evangeline-part-ii",
      image: "pajaro-sunrise-song-for-evangeline-part-ii.jpg",
    },
    {
      name: "Stone That Freud",
      slug: "pajaro-sunrise-stone-that-freud",
      image: "pajaro-sunrise-stone-that-freud.jpg",
    },
    {
      name: "Strangers",
      slug: "pajaro-sunrise-strangers",
      image: "pajaro-sunrise-strangers.jpg",
    },
    {
      name: "The Collapse Of Everything",
      slug: "pajaro-sunrise-the-collapse-of-everything",
      image: "pajaro-sunrise-the-collapse-of-everything.jpg",
    },
    {
      name: "Thirty One",
      slug: "pajaro-sunrise-thirty-one",
      image: "pajaro-sunrise-thirty-one.jpg",
    },
    {
      name: "This Place",
      slug: "pajaro-sunrise-this-place",
      image: "pajaro-sunrise-this-place.jpg",
    },
    {
      name: "This Vision",
      slug: "pajaro-sunrise-this-vision",
      image: "pajaro-sunrise-this-vision.jpg",
    },
    {
      name: "Tiny Hearts Make Big Plans",
      slug: "pajaro-sunrise-tiny-hearts-make-big-plans",
      image: "pajaro-sunrise-tiny-hearts-make-big-plans.jpg",
    },
    {
      name: "Total Mistake",
      slug: "pajaro-sunrise-total-mistake",
      image: "pajaro-sunrise-total-mistake.jpg",
    },
    {
      name: "Trembling Stars",
      slug: "pajaro-sunrise-trembling-stars",
      image: "pajaro-sunrise-trembling-stars.jpg",
    },
    {
      name: "What's There And What's Not There",
      slug: "pajaro-sunrise-what-s-there-and-what-s-not-there",
      image: "pajaro-sunrise-what-s-there-and-what-s-not-there.jpg",
    },
    {
      name: "Wolf",
      slug: "pajaro-sunrise-wolf",
      image: "pajaro-sunrise-wolf.jpg",
    },
  ],
  "Scary Mansion": [
    { name: "1%", slug: "scary-mansion-1", image: "scary-mansion-1.jpg" },
    {
      name: "Fatal Flaw",
      slug: "scary-mansion-fatal-flaw",
      image: "scary-mansion-fatal-flaw.jpg",
    },
    {
      name: "Look Through Your Eyes",
      slug: "scary-mansion-look-through-your-eyes",
      image: "scary-mansion-look-through-your-eyes.jpg",
    },
    {
      name: "Mighty",
      slug: "scary-mansion-mighty",
      image: "scary-mansion-mighty.jpg",
    },
    {
      name: "No Law",
      slug: "scary-mansion-no-law",
      image: "scary-mansion-no-law.jpg",
    },
    {
      name: "On My Mind",
      slug: "scary-mansion-on-my-mind",
      image: "scary-mansion-on-my-mind.jpg",
    },
    {
      name: "Over The Weekend",
      slug: "scary-mansion-over-the-weekend",
      image: "scary-mansion-over-the-weekend.jpg",
    },
    {
      name: "Yer Grief",
      slug: "scary-mansion-yer-grief",
      image: "scary-mansion-yer-grief.jpg",
    },
  ],
  "Hi Levelz": [
    {
      name: "100 Me (Instrumental)",
      slug: "hi-levelz-100-me-instrumental",
      image: "hi-levelz-100-me-instrumental.jpg",
    },
    {
      name: "Artificial Groove",
      slug: "hi-levelz-artificial-groove",
      image: "hi-levelz-artificial-groove.jpg",
    },
    {
      name: "Big Maybelle",
      slug: "hi-levelz-big-maybelle",
      image: "hi-levelz-big-maybelle.jpg",
    },
    {
      name: "Big Maybelle (Instrumental)",
      slug: "hi-levelz-big-maybelle-instrumental",
      image: "hi-levelz-big-maybelle-instrumental.jpg",
    },
    {
      name: "Blessed",
      slug: "hi-levelz-blessed",
      image: "hi-levelz-blessed.jpg",
    },
    {
      name: "Blessed (Instrumental)",
      slug: "hi-levelz-blessed-instrumental",
      image: "hi-levelz-blessed-instrumental.jpg",
    },
    {
      name: "Blue Angel",
      slug: "hi-levelz-blue-angel",
      image: "hi-levelz-blue-angel.jpg",
    },
    {
      name: "Came From Nothing",
      slug: "hi-levelz-came-from-nothing",
      image: "hi-levelz-came-from-nothing.jpg",
    },
    {
      name: "Came From Nothing (Instrumental)",
      slug: "hi-levelz-came-from-nothing-instrumental",
      image: "hi-levelz-came-from-nothing-instrumental.jpg",
    },
    {
      name: "Choosing A Dream",
      slug: "hi-levelz-choosing-a-dream",
      image: "hi-levelz-choosing-a-dream.jpg",
    },
    {
      name: "Choosing A Dream (Instrumental)",
      slug: "hi-levelz-choosing-a-dream-instrumental",
      image: "hi-levelz-choosing-a-dream-instrumental.jpg",
    },
    {
      name: "Floating",
      slug: "hi-levelz-floating",
      image: "hi-levelz-floating.jpg",
    },
    {
      name: "Floating (Instrumental)",
      slug: "hi-levelz-floating-instrumental",
      image: "hi-levelz-floating-instrumental.jpg",
    },
    {
      name: "Getting Closer feat. Royal Cheese (Instrumental)",
      slug: "hi-levelz-getting-closer-feat-royal-cheese-instrumental",
      image: "hi-levelz-getting-closer-feat-royal-cheese-instrumental.jpg",
    },
    {
      name: "Hell Yeah",
      slug: "hi-levelz-hell-yeah",
      image: "hi-levelz-hell-yeah.jpg",
    },
    {
      name: "I Don't Need",
      slug: "hi-levelz-i-don-t-need",
      image: "hi-levelz-i-don-t-need.jpg",
    },
    {
      name: "I Don't Need (Instrumental)",
      slug: "hi-levelz-i-don-t-need-instrumental",
      image: "hi-levelz-i-don-t-need-instrumental.jpg",
    },
    {
      name: "Jazz Black (Instrumental)",
      slug: "hi-levelz-jazz-black-instrumental",
      image: "hi-levelz-jazz-black-instrumental.jpg",
    },
    {
      name: "Jazz Black featuring Deon",
      slug: "hi-levelz-jazz-black-featuring-deon",
      image: "hi-levelz-jazz-black-featuring-deon.jpg",
    },
    { name: "Sway", slug: "hi-levelz-sway", image: "hi-levelz-sway.jpg" },
    {
      name: "Sway (Instrumental)",
      slug: "hi-levelz-sway-instrumental",
      image: "hi-levelz-sway-instrumental.jpg",
    },
    {
      name: "True Lie (Instrumental)",
      slug: "hi-levelz-true-lie-instrumental",
      image: "hi-levelz-true-lie-instrumental.jpg",
    },
    {
      name: "True Lie featuring Clarence Revil",
      slug: "hi-levelz-true-lie-featuring-clarence-revil",
      image: "hi-levelz-true-lie-featuring-clarence-revil.jpg",
    },
  ],
  "Kid Parade": [
    {
      name: "100 Tears",
      slug: "kid-parade-100-tears",
      image: "kid-parade-100-tears.jpg",
    },
    {
      name: "100 Tears (Instrumental)",
      slug: "kid-parade-100-tears-instrumental",
      image: "kid-parade-100-tears-instrumental.jpg",
    },
    {
      name: "Change Me",
      slug: "kid-parade-change-me",
      image: "kid-parade-change-me.jpg",
    },
    {
      name: "Change Me (Instrumental)",
      slug: "kid-parade-change-me-instrumental",
      image: "kid-parade-change-me-instrumental.jpg",
    },
    {
      name: "Friends",
      slug: "kid-parade-friends",
      image: "kid-parade-friends.jpg",
    },
    {
      name: "Friends (Instrumental)",
      slug: "kid-parade-friends-instrumental",
      image: "kid-parade-friends-instrumental.jpg",
    },
    {
      name: "Hey Boy",
      slug: "kid-parade-hey-boy",
      image: "kid-parade-hey-boy.jpg",
    },
    {
      name: "Hey Boy (Instrumental)",
      slug: "kid-parade-hey-boy-instrumental",
      image: "kid-parade-hey-boy-instrumental.jpg",
    },
    {
      name: "I Feel Alright",
      slug: "kid-parade-i-feel-alright",
      image: "kid-parade-i-feel-alright.jpg",
    },
    {
      name: "I Feel Alright (Instrumental)",
      slug: "kid-parade-i-feel-alright-instrumental",
      image: "kid-parade-i-feel-alright-instrumental.jpg",
    },
    {
      name: "Marnie",
      slug: "kid-parade-marnie",
      image: "kid-parade-marnie.jpg",
    },
    {
      name: "Marnie (Instrumental)",
      slug: "kid-parade-marnie-instrumental",
      image: "kid-parade-marnie-instrumental.jpg",
    },
    {
      name: "Moaning Mornings",
      slug: "kid-parade-moaning-mornings",
      image: "kid-parade-moaning-mornings.jpg",
    },
    {
      name: "Moaning Mornings (Instrumental)",
      slug: "kid-parade-moaning-mornings-instrumental",
      image: "kid-parade-moaning-mornings-instrumental.jpg",
    },
    {
      name: "My Dog Is A Cat",
      slug: "kid-parade-my-dog-is-a-cat",
      image: "kid-parade-my-dog-is-a-cat.jpg",
    },
    {
      name: "My Dog Is a Cat (Instrumental)",
      slug: "kid-parade-my-dog-is-a-cat-instrumental",
      image: "kid-parade-my-dog-is-a-cat-instrumental.jpg",
    },
    {
      name: "Raft On The Sea",
      slug: "kid-parade-raft-on-the-sea",
      image: "kid-parade-raft-on-the-sea.jpg",
    },
    {
      name: "Raft on The Sea (Instrumental)",
      slug: "kid-parade-raft-on-the-sea-instrumental",
      image: "kid-parade-raft-on-the-sea-instrumental.jpg",
    },
    {
      name: "Reflections",
      slug: "kid-parade-reflections",
      image: "kid-parade-reflections.jpg",
    },
    {
      name: "Reflections (Instrumental)",
      slug: "kid-parade-reflections-instrumental",
      image: "kid-parade-reflections-instrumental.jpg",
    },
    {
      name: "Tattooed Girl",
      slug: "kid-parade-tattooed-girl",
      image: "kid-parade-tattooed-girl.jpg",
    },
    {
      name: "Tattooed Girl (Instrumental)",
      slug: "kid-parade-tattooed-girl-instrumental",
      image: "kid-parade-tattooed-girl-instrumental.jpg",
    },
    {
      name: "The Turtle Waltz",
      slug: "kid-parade-the-turtle-waltz",
      image: "kid-parade-the-turtle-waltz.jpg",
    },
    {
      name: "The Turtle Waltz (Instrumental)",
      slug: "kid-parade-the-turtle-waltz-instrumental",
      image: "kid-parade-the-turtle-waltz-instrumental.jpg",
    },
    {
      name: "Wild Cat",
      slug: "kid-parade-wild-cat",
      image: "kid-parade-wild-cat.jpg",
    },
    {
      name: "Wild Cat (Instrumental)",
      slug: "kid-parade-wild-cat-instrumental",
      image: "kid-parade-wild-cat-instrumental.jpg",
    },
  ],
  Strapontin: [
    {
      name: "12 Men",
      slug: "strapontin-12-men",
      image: "strapontin-12-men.jpg",
    },
    {
      name: "It's a Trap",
      slug: "strapontin-it-s-a-trap",
      image: "strapontin-it-s-a-trap.jpg",
    },
    {
      name: "Les Yeux de la Tete",
      slug: "strapontin-les-yeux-de-la-tete",
      image: "strapontin-les-yeux-de-la-tete.jpg",
    },
    {
      name: "Offbeat",
      slug: "strapontin-offbeat",
      image: "strapontin-offbeat.jpg",
    },
    {
      name: "Pedigree",
      slug: "strapontin-pedigree",
      image: "strapontin-pedigree.jpg",
    },
  ],
  "Clap Rules": [
    { name: "123", slug: "clap-rules-123", image: "clap-rules-123.jpg" },
    {
      name: "Ancor Tree",
      slug: "clap-rules-ancor-tree",
      image: "clap-rules-ancor-tree.jpg",
    },
    {
      name: "Fredless",
      slug: "clap-rules-fredless",
      image: "clap-rules-fredless.jpg",
    },
    {
      name: "Happynomony",
      slug: "clap-rules-happynomony",
      image: "clap-rules-happynomony.jpg",
    },
    {
      name: "Happynomony (Bostro Remix)",
      slug: "clap-rules-happynomony-bostro-remix",
      image: "clap-rules-happynomony-bostro-remix.jpg",
    },
    {
      name: "Happynomony (Golden Bug Remix)",
      slug: "clap-rules-happynomony-golden-bug-remix",
      image: "clap-rules-happynomony-golden-bug-remix.jpg",
    },
    {
      name: "Happynomony (Justin Robertson Remix)",
      slug: "clap-rules-happynomony-justin-robertson-remix",
      image: "clap-rules-happynomony-justin-robertson-remix.jpg",
    },
    {
      name: "Happynomony (Moon Runner Remix)",
      slug: "clap-rules-happynomony-moon-runner-remix",
      image: "clap-rules-happynomony-moon-runner-remix.jpg",
    },
    {
      name: "Happynomony (Red Axes Remix)",
      slug: "clap-rules-happynomony-red-axes-remix",
      image: "clap-rules-happynomony-red-axes-remix.jpg",
    },
    {
      name: "You Empty",
      slug: "clap-rules-you-empty",
      image: "clap-rules-you-empty.jpg",
    },
  ],
  "Mans O": [
    { name: "1234567", slug: "mans-o-1234567", image: "mans-o-1234567.jpg" },
    {
      name: "A Caressed Thought Of Self",
      slug: "mans-o-a-caressed-thought-of-self",
      image: "mans-o-a-caressed-thought-of-self.jpg",
    },
    {
      name: "Ancestor Call",
      slug: "mans-o-ancestor-call",
      image: "mans-o-ancestor-call.jpg",
    },
    { name: "Anidada", slug: "mans-o-anidada", image: "mans-o-anidada.jpg" },
    {
      name: "As We Recognize Sense",
      slug: "mans-o-as-we-recognize-sense",
      image: "mans-o-as-we-recognize-sense.jpg",
    },
    { name: "At Play", slug: "mans-o-at-play", image: "mans-o-at-play.jpg" },
    {
      name: "Body Is A Soul Crystal",
      slug: "mans-o-body-is-a-soul-crystal",
      image: "mans-o-body-is-a-soul-crystal.jpg",
    },
    {
      name: "But Scratching The Surface",
      slug: "mans-o-but-scratching-the-surface",
      image: "mans-o-but-scratching-the-surface.jpg",
    },
    {
      name: "Clorophila",
      slug: "mans-o-clorophila",
      image: "mans-o-clorophila.jpg",
    },
    {
      name: "Divergent But Enclosed Free Will",
      slug: "mans-o-divergent-but-enclosed-free-will",
      image: "mans-o-divergent-but-enclosed-free-will.jpg",
    },
    {
      name: "Drops On Cooperation",
      slug: "mans-o-drops-on-cooperation",
      image: "mans-o-drops-on-cooperation.jpg",
    },
    { name: "Eolo", slug: "mans-o-eolo", image: "mans-o-eolo.jpg" },
    { name: "Go!", slug: "mans-o-go", image: "mans-o-go.jpg" },
    {
      name: "In Deep Breath",
      slug: "mans-o-in-deep-breath",
      image: "mans-o-in-deep-breath.jpg",
    },
    {
      name: "In Vacuum Imploding",
      slug: "mans-o-in-vacuum-imploding",
      image: "mans-o-in-vacuum-imploding.jpg",
    },
    {
      name: "Innocently Begging For Attention",
      slug: "mans-o-innocently-begging-for-attention",
      image: "mans-o-innocently-begging-for-attention.jpg",
    },
    {
      name: "It Was Cut But Still Remains",
      slug: "mans-o-it-was-cut-but-still-remains",
      image: "mans-o-it-was-cut-but-still-remains.jpg",
    },
    {
      name: "Look At Your Miracle",
      slug: "mans-o-look-at-your-miracle",
      image: "mans-o-look-at-your-miracle.jpg",
    },
    {
      name: "Mirror Outside",
      slug: "mans-o-mirror-outside",
      image: "mans-o-mirror-outside.jpg",
    },
    {
      name: "Mutual Unconditional II",
      slug: "mans-o-mutual-unconditional-ii",
      image: "mans-o-mutual-unconditional-ii.jpg",
    },
    {
      name: "Nesting In All Of This",
      slug: "mans-o-nesting-in-all-of-this",
      image: "mans-o-nesting-in-all-of-this.jpg",
    },
    {
      name: "On Triggering Density",
      slug: "mans-o-on-triggering-density",
      image: "mans-o-on-triggering-density.jpg",
    },
    {
      name: "Path Of Least Resistance",
      slug: "mans-o-path-of-least-resistance",
      image: "mans-o-path-of-least-resistance.jpg",
    },
    {
      name: "Reacting Perpetual Blooming Community",
      slug: "mans-o-reacting-perpetual-blooming-community",
      image: "mans-o-reacting-perpetual-blooming-community.jpg",
    },
    {
      name: "Rockbound Surface In An Dance With Air",
      slug: "mans-o-rockbound-surface-in-an-dance-with-air",
      image: "mans-o-rockbound-surface-in-an-dance-with-air.jpg",
    },
    {
      name: "Rockbound Surface Slowly Becoming Sand",
      slug: "mans-o-rockbound-surface-slowly-becoming-sand",
      image: "mans-o-rockbound-surface-slowly-becoming-sand.jpg",
    },
    {
      name: "Shaping A Future",
      slug: "mans-o-shaping-a-future",
      image: "mans-o-shaping-a-future.jpg",
    },
    {
      name: "Sitting On Trees",
      slug: "mans-o-sitting-on-trees",
      image: "mans-o-sitting-on-trees.jpg",
    },
    {
      name: "Spore Release",
      slug: "mans-o-spore-release",
      image: "mans-o-spore-release.jpg",
    },
    {
      name: "Stepping Into An Unobserved Garden Path",
      slug: "mans-o-stepping-into-an-unobserved-garden-path",
      image: "mans-o-stepping-into-an-unobserved-garden-path.jpg",
    },
    {
      name: "Tactile Radiation",
      slug: "mans-o-tactile-radiation",
      image: "mans-o-tactile-radiation.jpg",
    },
    {
      name: "Thin Melody Covered With A Thick Blanket",
      slug: "mans-o-thin-melody-covered-with-a-thick-blanket",
      image: "mans-o-thin-melody-covered-with-a-thick-blanket.jpg",
    },
    {
      name: "Through Crystalization Of Thought",
      slug: "mans-o-through-crystalization-of-thought",
      image: "mans-o-through-crystalization-of-thought.jpg",
    },
    {
      name: "Tridimensional Playground",
      slug: "mans-o-tridimensional-playground",
      image: "mans-o-tridimensional-playground.jpg",
    },
  ],
  Mythologen: [
    { name: "13", slug: "mythologen-13", image: "mythologen-13.jpg" },
    {
      name: "Arrival",
      slug: "mythologen-arrival",
      image: "mythologen-arrival.jpg",
    },
    {
      name: "Blackheath",
      slug: "mythologen-blackheath",
      image: "mythologen-blackheath.jpg",
    },
    { name: "Bobby", slug: "mythologen-bobby", image: "mythologen-bobby.jpg" },
    {
      name: "Bright Summer Day",
      slug: "mythologen-bright-summer-day",
      image: "mythologen-bright-summer-day.jpg",
    },
    { name: "Gold", slug: "mythologen-gold", image: "mythologen-gold.jpg" },
    { name: "Gone", slug: "mythologen-gone", image: "mythologen-gone.jpg" },
    { name: "Hain", slug: "mythologen-hain", image: "mythologen-hain.jpg" },
    {
      name: "Jungle Beats",
      slug: "mythologen-jungle-beats",
      image: "mythologen-jungle-beats.jpg",
    },
    {
      name: "Liwaya",
      slug: "mythologen-liwaya",
      image: "mythologen-liwaya.jpg",
    },
    {
      name: "Social",
      slug: "mythologen-social",
      image: "mythologen-social.jpg",
    },
    { name: "Trust", slug: "mythologen-trust", image: "mythologen-trust.jpg" },
  ],
  Balago: [
    {
      name: "14 De Mars",
      slug: "balago-14-de-mars",
      image: "balago-14-de-mars.jpg",
    },
    {
      name: "A l'Exterior",
      slug: "balago-a-l-exterior",
      image: "balago-a-l-exterior.jpg",
    },
    { name: "Aanval", slug: "balago-aanval", image: "balago-aanval.jpg" },
    { name: "Amherst", slug: "balago-amherst", image: "balago-amherst.jpg" },
    {
      name: "Començar De Nou",
      slug: "balago-comencar-de-nou",
      image: "balago-comencar-de-nou.jpg",
    },
    { name: "D'Ahir", slug: "balago-d-ahir", image: "balago-d-ahir.jpg" },
    { name: "El Buit", slug: "balago-el-buit", image: "balago-el-buit.jpg" },
    {
      name: "El Record Inclòs",
      slug: "balago-el-record-inclos",
      image: "balago-el-record-inclos.jpg",
    },
    {
      name: "El Retard",
      slug: "balago-el-retard",
      image: "balago-el-retard.jpg",
    },
    {
      name: "Entornar Me'n",
      slug: "balago-entornar-me-n",
      image: "balago-entornar-me-n.jpg",
    },
    {
      name: "Fins A L'Ultim Moment",
      slug: "balago-fins-a-l-ultim-moment",
      image: "balago-fins-a-l-ultim-moment.jpg",
    },
    { name: "Gest", slug: "balago-gest", image: "balago-gest.jpg" },
    { name: "Hergé", slug: "balago-herge", image: "balago-herge.jpg" },
    { name: "Hsh+Dis", slug: "balago-hsh-dis", image: "balago-hsh-dis.jpg" },
    {
      name: "L'Estrany A Qui Va Imitar",
      slug: "balago-l-estrany-a-qui-va-imitar",
      image: "balago-l-estrany-a-qui-va-imitar.jpg",
    },
    {
      name: "L'Evidencia",
      slug: "balago-l-evidencia",
      image: "balago-l-evidencia.jpg",
    },
    {
      name: "L'Interior",
      slug: "balago-l-interior",
      image: "balago-l-interior.jpg",
    },
    {
      name: "La Consciència de les Altres Coses",
      slug: "balago-la-consciencia-de-les-altres-coses",
      image: "balago-la-consciencia-de-les-altres-coses.jpg",
    },
    { name: "Negació", slug: "balago-negacio", image: "balago-negacio.jpg" },
    { name: "Part I", slug: "balago-part-i", image: "balago-part-i.jpg" },
    { name: "Velbert", slug: "balago-velbert", image: "balago-velbert.jpg" },
    { name: "Àvol", slug: "balago-avol", image: "balago-avol.jpg" },
  ],
  "The Hiiters": [
    {
      name: "150 MPH",
      slug: "the-hiiters-150-mph",
      image: "the-hiiters-150-mph.jpg",
    },
    {
      name: "Annunaki",
      slug: "the-hiiters-annunaki",
      image: "the-hiiters-annunaki.jpg",
    },
    {
      name: "Arachnophobia",
      slug: "the-hiiters-arachnophobia",
      image: "the-hiiters-arachnophobia.jpg",
    },
    {
      name: "Atlas",
      slug: "the-hiiters-atlas",
      image: "the-hiiters-atlas.jpg",
    },
    {
      name: "Cryostasis",
      slug: "the-hiiters-cryostasis",
      image: "the-hiiters-cryostasis.jpg",
    },
    { name: "Doom", slug: "the-hiiters-doom", image: "the-hiiters-doom.jpg" },
    {
      name: "Electric Hintermass",
      slug: "the-hiiters-electric-hintermass",
      image: "the-hiiters-electric-hintermass.jpg",
    },
    {
      name: "Electrogaga",
      slug: "the-hiiters-electrogaga",
      image: "the-hiiters-electrogaga.jpg",
    },
    {
      name: "Electrogaga (Chapelle Remix)",
      slug: "the-hiiters-electrogaga-chapelle-remix",
      image: "the-hiiters-electrogaga-chapelle-remix.jpg",
    },
    {
      name: "Electrogaga (Instrumental)",
      slug: "the-hiiters-electrogaga-instrumental",
      image: "the-hiiters-electrogaga-instrumental.jpg",
    },
    {
      name: "Electrogaga (The Pirates Remix)",
      slug: "the-hiiters-electrogaga-the-pirates-remix",
      image: "the-hiiters-electrogaga-the-pirates-remix.jpg",
    },
    {
      name: "Evasion feat. Monkey Freakz",
      slug: "the-hiiters-evasion-feat-monkey-freakz",
      image: "the-hiiters-evasion-feat-monkey-freakz.jpg",
    },
    {
      name: "Ghost Racer",
      slug: "the-hiiters-ghost-racer",
      image: "the-hiiters-ghost-racer.jpg",
    },
    {
      name: "Kairos (The Hiiters Remix)",
      slug: "the-hiiters-kairos-the-hiiters-remix",
      image: "the-hiiters-kairos-the-hiiters-remix.jpg",
    },
    {
      name: "Metatron",
      slug: "the-hiiters-metatron",
      image: "the-hiiters-metatron.jpg",
    },
    {
      name: "Midnight feat Summer",
      slug: "the-hiiters-midnight-feat-summer",
      image: "the-hiiters-midnight-feat-summer.jpg",
    },
    {
      name: "Pharaoh",
      slug: "the-hiiters-pharaoh",
      image: "the-hiiters-pharaoh.jpg",
    },
    {
      name: "Plymouth Fury",
      slug: "the-hiiters-plymouth-fury",
      image: "the-hiiters-plymouth-fury.jpg",
    },
    {
      name: "Shimmy Shake",
      slug: "the-hiiters-shimmy-shake",
      image: "the-hiiters-shimmy-shake.jpg",
    },
    {
      name: "Skynet",
      slug: "the-hiiters-skynet",
      image: "the-hiiters-skynet.jpg",
    },
    {
      name: "Space Rider",
      slug: "the-hiiters-space-rider",
      image: "the-hiiters-space-rider.jpg",
    },
    {
      name: "Starwalker",
      slug: "the-hiiters-starwalker",
      image: "the-hiiters-starwalker.jpg",
    },
    {
      name: "Tech Noir",
      slug: "the-hiiters-tech-noir",
      image: "the-hiiters-tech-noir.jpg",
    },
    {
      name: "Terraforming",
      slug: "the-hiiters-terraforming",
      image: "the-hiiters-terraforming.jpg",
    },
    {
      name: "The Chase",
      slug: "the-hiiters-the-chase",
      image: "the-hiiters-the-chase.jpg",
    },
    {
      name: "Triumphilius",
      slug: "the-hiiters-triumphilius",
      image: "the-hiiters-triumphilius.jpg",
    },
  ],
  "Colors Sound System": [
    {
      name: "1974",
      slug: "colors-sound-system-1974",
      image: "colors-sound-system-1974.jpg",
    },
    {
      name: "Ar",
      slug: "colors-sound-system-ar",
      image: "colors-sound-system-ar.jpg",
    },
    {
      name: "Poeira Lunar",
      slug: "colors-sound-system-poeira-lunar",
      image: "colors-sound-system-poeira-lunar.jpg",
    },
  ],
  Animic: [
    { name: "1979", slug: "animic-1979", image: "animic-1979.jpg" },
    { name: "GEM", slug: "animic-gem", image: "animic-gem.jpg" },
    {
      name: "GEM (Instrumental)",
      slug: "animic-gem-instrumental",
      image: "animic-gem-instrumental.jpg",
    },
    { name: "Glass", slug: "animic-glass", image: "animic-glass.jpg" },
    {
      name: "Glass (Instrumental)",
      slug: "animic-glass-instrumental",
      image: "animic-glass-instrumental.jpg",
    },
    { name: "Hannibal", slug: "animic-hannibal", image: "animic-hannibal.jpg" },
    { name: "Hidden", slug: "animic-hidden", image: "animic-hidden.jpg" },
    {
      name: "Hidden (Instrumental)",
      slug: "animic-hidden-instrumental",
      image: "animic-hidden-instrumental.jpg",
    },
    {
      name: "Horses Mane",
      slug: "animic-horses-mane",
      image: "animic-horses-mane.jpg",
    },
    { name: "Inhuman", slug: "animic-inhuman", image: "animic-inhuman.jpg" },
    {
      name: "Inhuman (Instrumental)",
      slug: "animic-inhuman-instrumental",
      image: "animic-inhuman-instrumental.jpg",
    },
    {
      name: "Shoot Em Up",
      slug: "animic-shoot-em-up",
      image: "animic-shoot-em-up.jpg",
    },
    { name: "Silence", slug: "animic-silence", image: "animic-silence.jpg" },
    {
      name: "Silence (Instrumental)",
      slug: "animic-silence-instrumental",
      image: "animic-silence-instrumental.jpg",
    },
    {
      name: "Skeletons",
      slug: "animic-skeletons",
      image: "animic-skeletons.jpg",
    },
    { name: "Slave", slug: "animic-slave", image: "animic-slave.jpg" },
    {
      name: "Slave (Instrumental)",
      slug: "animic-slave-instrumental",
      image: "animic-slave-instrumental.jpg",
    },
    { name: "TV", slug: "animic-tv", image: "animic-tv.jpg" },
    {
      name: "TV (Instrumental)",
      slug: "animic-tv-instrumental",
      image: "animic-tv-instrumental.jpg",
    },
    {
      name: "The Others",
      slug: "animic-the-others",
      image: "animic-the-others.jpg",
    },
    { name: "Whales", slug: "animic-whales", image: "animic-whales.jpg" },
    {
      name: "Whales (Instrumental)",
      slug: "animic-whales-instrumental",
      image: "animic-whales-instrumental.jpg",
    },
    {
      name: "Wooden Gun",
      slug: "animic-wooden-gun",
      image: "animic-wooden-gun.jpg",
    },
  ],
  Tversky: [
    { name: "1985", slug: "tversky-1985", image: "tversky-1985.jpg" },
    {
      name: "1985 (Instrumental)",
      slug: "tversky-1985-instrumental",
      image: "tversky-1985-instrumental.jpg",
    },
    {
      name: "Bcp Strut",
      slug: "tversky-bcp-strut",
      image: "tversky-bcp-strut.jpg",
    },
    {
      name: "Maybe After Tonight",
      slug: "tversky-maybe-after-tonight",
      image: "tversky-maybe-after-tonight.jpg",
    },
    {
      name: "Mother Tongue",
      slug: "tversky-mother-tongue",
      image: "tversky-mother-tongue.jpg",
    },
    {
      name: "The Way I Feel About You",
      slug: "tversky-the-way-i-feel-about-you",
      image: "tversky-the-way-i-feel-about-you.jpg",
    },
    {
      name: "This Time",
      slug: "tversky-this-time",
      image: "tversky-this-time.jpg",
    },
  ],
  Squadra: [
    { name: "1987", slug: "squadra-1987", image: "squadra-1987.jpg" },
    { name: "Bloody", slug: "squadra-bloody", image: "squadra-bloody.jpg" },
    { name: "David", slug: "squadra-david", image: "squadra-david.jpg" },
    { name: "Deep", slug: "squadra-deep", image: "squadra-deep.jpg" },
    { name: "Kombat", slug: "squadra-kombat", image: "squadra-kombat.jpg" },
    { name: "Leon", slug: "squadra-leon", image: "squadra-leon.jpg" },
    { name: "Real", slug: "squadra-real", image: "squadra-real.jpg" },
    { name: "Rebird", slug: "squadra-rebird", image: "squadra-rebird.jpg" },
    { name: "Reunion", slug: "squadra-reunion", image: "squadra-reunion.jpg" },
    {
      name: "Sexual Healing",
      slug: "squadra-sexual-healing",
      image: "squadra-sexual-healing.jpg",
    },
    { name: "Shyne", slug: "squadra-shyne", image: "squadra-shyne.jpg" },
    { name: "Tower", slug: "squadra-tower", image: "squadra-tower.jpg" },
  ],
  "Bot'Ox": [
    {
      name: "2.4.1 (Instrumental)",
      slug: "bot-ox-2-4-1-instrumental",
      image: "bot-ox-2-4-1-instrumental.jpg",
    },
    {
      name: "Another Form Of Fatigue",
      slug: "bot-ox-another-form-of-fatigue",
      image: "bot-ox-another-form-of-fatigue.jpg",
    },
    {
      name: "Another Form Of Fatigue (Edit)",
      slug: "bot-ox-another-form-of-fatigue-edit",
      image: "bot-ox-another-form-of-fatigue-edit.jpg",
    },
    {
      name: "Back FromThe Suburbs",
      slug: "bot-ox-back-fromthe-suburbs",
      image: "bot-ox-back-fromthe-suburbs.jpg",
    },
    {
      name: "Bearded Lady Motorcycle Club",
      slug: "bot-ox-bearded-lady-motorcycle-club",
      image: "bot-ox-bearded-lady-motorcycle-club.jpg",
    },
    {
      name: "Blue Steel (Instrumental)",
      slug: "bot-ox-blue-steel-instrumental",
      image: "bot-ox-blue-steel-instrumental.jpg",
    },
    {
      name: "Blue Steel (Para One & Tacteel Remix)",
      slug: "bot-ox-blue-steel-para-one-and-tacteel-remix",
      image: "bot-ox-blue-steel-para-one-and-tacteel-remix.jpg",
    },
    {
      name: "Blue Steel (Still Going Remix)",
      slug: "bot-ox-blue-steel-still-going-remix",
      image: "bot-ox-blue-steel-still-going-remix.jpg",
    },
    {
      name: "Blue Steel feat. Anna Jean",
      slug: "bot-ox-blue-steel-feat-anna-jean",
      image: "bot-ox-blue-steel-feat-anna-jean.jpg",
    },
    {
      name: "Grands Boulevards (Instrumental)",
      slug: "bot-ox-grands-boulevards-instrumental",
      image: "bot-ox-grands-boulevards-instrumental.jpg",
    },
    {
      name: "Grands Boulevards (Margot Remix)",
      slug: "bot-ox-grands-boulevards-margot-remix",
      image: "bot-ox-grands-boulevards-margot-remix.jpg",
    },
    {
      name: "Teenage Tricks",
      slug: "bot-ox-teenage-tricks",
      image: "bot-ox-teenage-tricks.jpg",
    },
    {
      name: "The Face Of Another (Colette Edit)",
      slug: "bot-ox-the-face-of-another-colette-edit",
      image: "bot-ox-the-face-of-another-colette-edit.jpg",
    },
  ],
  Prophit: [
    { name: "2M4.1M", slug: "prophit-2m4-1m", image: null },
    { name: "Ain't Uh", slug: "prophit-ain-t-uh", image: null },
    { name: "Born Ready", slug: "prophit-born-ready", image: null },
    { name: "Can't Tell Me", slug: "prophit-can-t-tell-me", image: null },
    { name: "Cliff Hanga", slug: "prophit-cliff-hanga", image: null },
    { name: "Death Metal", slug: "prophit-death-metal", image: null },
    { name: "Dennis Rodman", slug: "prophit-dennis-rodman", image: null },
    {
      name: "Desperate Measures",
      slug: "prophit-desperate-measures",
      image: null,
    },
    { name: "Devine Purpose", slug: "prophit-devine-purpose", image: null },
    { name: "Double Up", slug: "prophit-double-up", image: null },
    { name: "Dumb Shit", slug: "prophit-dumb-shit", image: null },
    { name: "Eastside Foreva", slug: "prophit-eastside-foreva", image: null },
    {
      name: "Emergency feat. Foeson",
      slug: "prophit-emergency-feat-foeson",
      image: null,
    },
    { name: "Far From Home", slug: "prophit-far-from-home", image: null },
    {
      name: "Frank Lucas (Red Squad Remix - Instrumental)",
      slug: "prophit-frank-lucas-red-squad-remix-instrumental",
      image: "prophit-frank-lucas-red-squad-remix-instrumental.jpg",
    },
    {
      name: "Frank Lucas (Red Squad Remix)",
      slug: "prophit-frank-lucas-red-squad-remix",
      image: "prophit-frank-lucas-red-squad-remix.jpg",
    },
    { name: "Frfr", slug: "prophit-frfr", image: null },
    {
      name: "Good Ole Ghetto Gospel",
      slug: "prophit-good-ole-ghetto-gospel",
      image: null,
    },
    {
      name: "The New Founding Father (Red Squad Remix)",
      slug: "prophit-the-new-founding-father-red-squad-remix",
      image: "prophit-the-new-founding-father-red-squad-remix.jpg",
    },
  ],
  "The Supermen Lovers": [
    {
      name: "30-40",
      slug: "the-supermen-lovers-30-40",
      image: "the-supermen-lovers-30-40.jpg",
    },
    {
      name: "Baroud",
      slug: "the-supermen-lovers-baroud",
      image: "the-supermen-lovers-baroud.jpg",
    },
    {
      name: "Belle Nuit",
      slug: "the-supermen-lovers-belle-nuit",
      image: "the-supermen-lovers-belle-nuit.jpg",
    },
    {
      name: "Born to love you (Dub)",
      slug: "the-supermen-lovers-born-to-love-you-dub",
      image: "the-supermen-lovers-born-to-love-you-dub.jpg",
    },
    {
      name: "Born to love you (Radio Edit)",
      slug: "the-supermen-lovers-born-to-love-you-radio-edit",
      image: "the-supermen-lovers-born-to-love-you-radio-edit.jpg",
    },
    {
      name: "Bus Stop",
      slug: "the-supermen-lovers-bus-stop",
      image: "the-supermen-lovers-bus-stop.jpg",
    },
    {
      name: "C'est Bon (Original)",
      slug: "the-supermen-lovers-c-est-bon-original",
      image: "the-supermen-lovers-c-est-bon-original.jpg",
    },
    {
      name: "Caravan",
      slug: "the-supermen-lovers-caravan",
      image: "the-supermen-lovers-caravan.jpg",
    },
    {
      name: "Clock Sucker",
      slug: "the-supermen-lovers-clock-sucker",
      image: "the-supermen-lovers-clock-sucker.jpg",
    },
    {
      name: "Debut (Spiller Remix)",
      slug: "the-supermen-lovers-debut-spiller-remix",
      image: "the-supermen-lovers-debut-spiller-remix.jpg",
    },
    {
      name: "Did we loose something",
      slug: "the-supermen-lovers-did-we-loose-something",
      image: "the-supermen-lovers-did-we-loose-something.jpg",
    },
    {
      name: "Drunk At The Gate",
      slug: "the-supermen-lovers-drunk-at-the-gate",
      image: "the-supermen-lovers-drunk-at-the-gate.jpg",
    },
    {
      name: "Eagle Shadow",
      slug: "the-supermen-lovers-eagle-shadow",
      image: "the-supermen-lovers-eagle-shadow.jpg",
    },
    {
      name: "Electronic Whisper",
      slug: "the-supermen-lovers-electronic-whisper",
      image: "the-supermen-lovers-electronic-whisper.jpg",
    },
    {
      name: "Electronic Whisper (Instrumental)",
      slug: "the-supermen-lovers-electronic-whisper-instrumental",
      image: "the-supermen-lovers-electronic-whisper-instrumental.jpg",
    },
    {
      name: "Eyes On You feat. Scarlet Quin",
      slug: "the-supermen-lovers-eyes-on-you-feat-scarlet-quin",
      image: "the-supermen-lovers-eyes-on-you-feat-scarlet-quin.jpg",
    },
    {
      name: "Fair Enough",
      slug: "the-supermen-lovers-fair-enough",
      image: "the-supermen-lovers-fair-enough.jpg",
    },
    {
      name: "Fairy Island",
      slug: "the-supermen-lovers-fairy-island",
      image: "the-supermen-lovers-fairy-island.jpg",
    },
    {
      name: "Faith (Alt Electronic Mix)",
      slug: "the-supermen-lovers-faith-alt-electronic-mix",
      image: "the-supermen-lovers-faith-alt-electronic-mix.jpg",
    },
    {
      name: "Family Business",
      slug: "the-supermen-lovers-family-business",
      image: "the-supermen-lovers-family-business.jpg",
    },
    {
      name: "Family Business (Instrumental)",
      slug: "the-supermen-lovers-family-business-instrumental",
      image: "the-supermen-lovers-family-business-instrumental.jpg",
    },
    {
      name: "Family Business 3D",
      slug: "the-supermen-lovers-family-business-3d",
      image: "the-supermen-lovers-family-business-3d.jpg",
    },
    {
      name: "Happy Route (The Supermen Lovers Remix)",
      slug: "the-supermen-lovers-happy-route-the-supermen-lovers-remix",
      image: "the-supermen-lovers-happy-route-the-supermen-lovers-remix.jpg",
    },
    {
      name: "Impact",
      slug: "the-supermen-lovers-impact",
      image: "the-supermen-lovers-impact.jpg",
    },
    {
      name: "It's Ok!",
      slug: "the-supermen-lovers-it-s-ok",
      image: "the-supermen-lovers-it-s-ok.jpg",
    },
    {
      name: "Keep The Funk Alive",
      slug: "the-supermen-lovers-keep-the-funk-alive",
      image: "the-supermen-lovers-keep-the-funk-alive.jpg",
    },
    {
      name: "Keep The Funk Alive (Chloé Remix)",
      slug: "the-supermen-lovers-keep-the-funk-alive-chloe-remix",
      image: "the-supermen-lovers-keep-the-funk-alive-chloe-remix.jpg",
    },
    {
      name: "Keep The Funk Alive (Electronic Pirates Remix)",
      slug: "the-supermen-lovers-keep-the-funk-alive-electronic-pirates-remix",
      image:
        "the-supermen-lovers-keep-the-funk-alive-electronic-pirates-remix.jpg",
    },
    {
      name: "Keep The Funk Alive (Inflagranti Remix)",
      slug: "the-supermen-lovers-keep-the-funk-alive-inflagranti-remix",
      image: "the-supermen-lovers-keep-the-funk-alive-inflagranti-remix.jpg",
    },
    {
      name: "Keep The Funk Alive (The Aiku Remix)",
      slug: "the-supermen-lovers-keep-the-funk-alive-the-aiku-remix",
      image: "the-supermen-lovers-keep-the-funk-alive-the-aiku-remix.jpg",
    },
    {
      name: "Let Me Show You",
      slug: "the-supermen-lovers-let-me-show-you",
      image: "the-supermen-lovers-let-me-show-you.jpg",
    },
    {
      name: "Longue Nuit",
      slug: "the-supermen-lovers-longue-nuit",
      image: "the-supermen-lovers-longue-nuit.jpg",
    },
    {
      name: "Magic Potion",
      slug: "the-supermen-lovers-magic-potion",
      image: "the-supermen-lovers-magic-potion.jpg",
    },
    {
      name: "Meteor",
      slug: "the-supermen-lovers-meteor",
      image: "the-supermen-lovers-meteor.jpg",
    },
    {
      name: "Moments",
      slug: "the-supermen-lovers-moments",
      image: "the-supermen-lovers-moments.jpg",
    },
    {
      name: "Moments (LLR Remix)",
      slug: "the-supermen-lovers-moments-llr-remix",
      image: "the-supermen-lovers-moments-llr-remix.jpg",
    },
    {
      name: "Neighborhood",
      slug: "the-supermen-lovers-neighborhood",
      image: "the-supermen-lovers-neighborhood.jpg",
    },
    {
      name: "Olga",
      slug: "the-supermen-lovers-olga",
      image: "the-supermen-lovers-olga.jpg",
    },
    {
      name: "Parallels",
      slug: "the-supermen-lovers-parallels",
      image: "the-supermen-lovers-parallels.jpg",
    },
    {
      name: "Pigeon (Radio Edit)",
      slug: "the-supermen-lovers-pigeon-radio-edit",
      image: "the-supermen-lovers-pigeon-radio-edit.jpg",
    },
    {
      name: "Poltergay's Theme",
      slug: "the-supermen-lovers-poltergay-s-theme",
      image: "the-supermen-lovers-poltergay-s-theme.jpg",
    },
    {
      name: "Rebirth",
      slug: "the-supermen-lovers-rebirth",
      image: "the-supermen-lovers-rebirth.jpg",
    },
    {
      name: "Say No More",
      slug: "the-supermen-lovers-say-no-more",
      image: "the-supermen-lovers-say-no-more.jpg",
    },
    {
      name: "Say No More (Andy Remix)",
      slug: "the-supermen-lovers-say-no-more-andy-remix",
      image: "the-supermen-lovers-say-no-more-andy-remix.jpg",
    },
    {
      name: "Say No More (Jupiter Remix)",
      slug: "the-supermen-lovers-say-no-more-jupiter-remix",
      image: "the-supermen-lovers-say-no-more-jupiter-remix.jpg",
    },
    {
      name: "Screen Night",
      slug: "the-supermen-lovers-screen-night",
      image: "the-supermen-lovers-screen-night.jpg",
    },
    {
      name: "Shower Thrill and Pool Vision",
      slug: "the-supermen-lovers-shower-thrill-and-pool-vision",
      image: "the-supermen-lovers-shower-thrill-and-pool-vision.jpg",
    },
    {
      name: "Take  A Chance (Cecile Remix)",
      slug: "the-supermen-lovers-take-a-chance-cecile-remix",
      image: "the-supermen-lovers-take-a-chance-cecile-remix.jpg",
    },
    {
      name: "Take A Chance (Body Double Remix)",
      slug: "the-supermen-lovers-take-a-chance-body-double-remix",
      image: "the-supermen-lovers-take-a-chance-body-double-remix.jpg",
    },
    {
      name: "Take A Chance (Clap Rules Remix)",
      slug: "the-supermen-lovers-take-a-chance-clap-rules-remix",
      image: "the-supermen-lovers-take-a-chance-clap-rules-remix.jpg",
    },
    {
      name: "Take A Chance (Herr Styler Remix)",
      slug: "the-supermen-lovers-take-a-chance-herr-styler-remix",
      image: "the-supermen-lovers-take-a-chance-herr-styler-remix.jpg",
    },
    {
      name: "Take A Chance (Instrumental)",
      slug: "the-supermen-lovers-take-a-chance-instrumental",
      image: "the-supermen-lovers-take-a-chance-instrumental.jpg",
    },
    {
      name: "Take A Chance (Radio Edit)",
      slug: "the-supermen-lovers-take-a-chance-radio-edit",
      image: "the-supermen-lovers-take-a-chance-radio-edit.jpg",
    },
    {
      name: "Take A Chance (Remix Of The Mix)",
      slug: "the-supermen-lovers-take-a-chance-remix-of-the-mix",
      image: "the-supermen-lovers-take-a-chance-remix-of-the-mix.jpg",
    },
    {
      name: "Take A Chance (Todd Edwards Remix)",
      slug: "the-supermen-lovers-take-a-chance-todd-edwards-remix",
      image: "the-supermen-lovers-take-a-chance-todd-edwards-remix.jpg",
    },
    {
      name: "The Bridge",
      slug: "the-supermen-lovers-the-bridge",
      image: "the-supermen-lovers-the-bridge.jpg",
    },
    {
      name: "The Howling Session Part 1",
      slug: "the-supermen-lovers-the-howling-session-part-1",
      image: "the-supermen-lovers-the-howling-session-part-1.jpg",
    },
    {
      name: "The Howling Session Part2",
      slug: "the-supermen-lovers-the-howling-session-part2",
      image: "the-supermen-lovers-the-howling-session-part2.jpg",
    },
    {
      name: "The Mission",
      slug: "the-supermen-lovers-the-mission",
      image: "the-supermen-lovers-the-mission.jpg",
    },
    {
      name: "Under Pressure",
      slug: "the-supermen-lovers-under-pressure",
      image: "the-supermen-lovers-under-pressure.jpg",
    },
    {
      name: "Urgence",
      slug: "the-supermen-lovers-urgence",
      image: "the-supermen-lovers-urgence.jpg",
    },
    {
      name: "Vodka feat. Igor and Natty Fensie",
      slug: "the-supermen-lovers-vodka-feat-igor-and-natty-fensie",
      image: "the-supermen-lovers-vodka-feat-igor-and-natty-fensie.jpg",
    },
    {
      name: "Walking On The Moon (Club Edit)",
      slug: "the-supermen-lovers-walking-on-the-moon-club-edit",
      image: "the-supermen-lovers-walking-on-the-moon-club-edit.jpg",
    },
    {
      name: "Walking On The Moon (Davina Moss Remix)",
      slug: "the-supermen-lovers-walking-on-the-moon-davina-moss-remix",
      image: "the-supermen-lovers-walking-on-the-moon-davina-moss-remix.jpg",
    },
    {
      name: "Walking On The Moon (Fell Reis Remix)",
      slug: "the-supermen-lovers-walking-on-the-moon-fell-reis-remix",
      image: "the-supermen-lovers-walking-on-the-moon-fell-reis-remix.jpg",
    },
    {
      name: "Walking On The Moon (Instrumental)",
      slug: "the-supermen-lovers-walking-on-the-moon-instrumental",
      image: "the-supermen-lovers-walking-on-the-moon-instrumental.jpg",
    },
    {
      name: "Walking On The Moon (Radio Edit)",
      slug: "the-supermen-lovers-walking-on-the-moon-radio-edit",
      image: "the-supermen-lovers-walking-on-the-moon-radio-edit.jpg",
    },
    {
      name: "Walking On The Moon (Stupead Remix)",
      slug: "the-supermen-lovers-walking-on-the-moon-stupead-remix",
      image: "the-supermen-lovers-walking-on-the-moon-stupead-remix.jpg",
    },
    {
      name: "We Got That Body",
      slug: "the-supermen-lovers-we-got-that-body",
      image: "the-supermen-lovers-we-got-that-body.jpg",
    },
    {
      name: "Wei Or Die",
      slug: "the-supermen-lovers-wei-or-die",
      image: "the-supermen-lovers-wei-or-die.jpg",
    },
    {
      name: "Wild Theme",
      slug: "the-supermen-lovers-wild-theme",
      image: "the-supermen-lovers-wild-theme.jpg",
    },
    {
      name: "Working Girl",
      slug: "the-supermen-lovers-working-girl",
      image: "the-supermen-lovers-working-girl.jpg",
    },
  ],
  "Dj Rocca": [
    {
      name: "300 Fonk",
      slug: "dj-rocca-300-fonk",
      image: "dj-rocca-300-fonk.jpg",
    },
    {
      name: "Bakerys Track",
      slug: "dj-rocca-bakerys-track",
      image: "dj-rocca-bakerys-track.jpg",
    },
    {
      name: "Moaning",
      slug: "dj-rocca-moaning",
      image: "dj-rocca-moaning.jpg",
    },
    {
      name: "Third Zero Third",
      slug: "dj-rocca-third-zero-third",
      image: "dj-rocca-third-zero-third.jpg",
    },
  ],
  "Da Chick": [
    { name: "377", slug: "da-chick-377", image: "da-chick-377.jpg" },
    { name: "A Boom", slug: "da-chick-a-boom", image: "da-chick-a-boom.jpg" },
    {
      name: "Call Me Foxy",
      slug: "da-chick-call-me-foxy",
      image: "da-chick-call-me-foxy.jpg",
    },
    {
      name: "Chick A Boom (Pete Herbert Piano Dub)",
      slug: "da-chick-chick-a-boom-pete-herbert-piano-dub",
      image: "da-chick-chick-a-boom-pete-herbert-piano-dub.jpg",
    },
    {
      name: "Chick A Boom (Pete Herbert Remix)",
      slug: "da-chick-chick-a-boom-pete-herbert-remix",
      image: "da-chick-chick-a-boom-pete-herbert-remix.jpg",
    },
    {
      name: "Cocktail",
      slug: "da-chick-cocktail",
      image: "da-chick-cocktail.jpg",
    },
    {
      name: "Cocktail (Instrumental)",
      slug: "da-chick-cocktail-instrumental",
      image: "da-chick-cocktail-instrumental.jpg",
    },
    {
      name: "Conversations",
      slug: "da-chick-conversations",
      image: "da-chick-conversations.jpg",
    },
    {
      name: "Do Tha Clap",
      slug: "da-chick-do-tha-clap",
      image: "da-chick-do-tha-clap.jpg",
    },
    {
      name: "Do The Clap (Mason's Re-Clap Remix)",
      slug: "da-chick-do-the-clap-mason-s-re-clap-remix",
      image: "da-chick-do-the-clap-mason-s-re-clap-remix.jpg",
    },
    {
      name: "Do Your Thang",
      slug: "da-chick-do-your-thang",
      image: "da-chick-do-your-thang.jpg",
    },
    {
      name: "Don't Touch My Soul",
      slug: "da-chick-don-t-touch-my-soul",
      image: "da-chick-don-t-touch-my-soul.jpg",
    },
    {
      name: "Drum Rack",
      slug: "da-chick-drum-rack",
      image: "da-chick-drum-rack.jpg",
    },
    {
      name: "Excuse Me",
      slug: "da-chick-excuse-me",
      image: "da-chick-excuse-me.jpg",
    },
    {
      name: "Flowering",
      slug: "da-chick-flowering",
      image: "da-chick-flowering.jpg",
    },
    {
      name: "Funk Call",
      slug: "da-chick-funk-call",
      image: "da-chick-funk-call.jpg",
    },
    {
      name: "Hot Sauce",
      slug: "da-chick-hot-sauce",
      image: "da-chick-hot-sauce.jpg",
    },
    { name: "I Say", slug: "da-chick-i-say", image: "da-chick-i-say.jpg" },
    {
      name: "Less Is More",
      slug: "da-chick-less-is-more",
      image: "da-chick-less-is-more.jpg",
    },
    {
      name: "Let Them Talk",
      slug: "da-chick-let-them-talk",
      image: "da-chick-let-them-talk.jpg",
    },
    {
      name: "Lotta Love (Original Mix)",
      slug: "da-chick-lotta-love-original-mix",
      image: "da-chick-lotta-love-original-mix.jpg",
    },
    {
      name: "Miss Darkness",
      slug: "da-chick-miss-darkness",
      image: "da-chick-miss-darkness.jpg",
    },
    {
      name: "Mustang",
      slug: "da-chick-mustang",
      image: "da-chick-mustang.jpg",
    },
    {
      name: "Okay Away",
      slug: "da-chick-okay-away",
      image: "da-chick-okay-away.jpg",
    },
    {
      name: "Ride My Pussy ( Wagon)",
      slug: "da-chick-ride-my-pussy-wagon",
      image: "da-chick-ride-my-pussy-wagon.jpg",
    },
    { name: "Sente", slug: "da-chick-sente", image: "da-chick-sente.jpg" },
    {
      name: "Until Night Is Day",
      slug: "da-chick-until-night-is-day",
      image: "da-chick-until-night-is-day.jpg",
    },
    {
      name: "Until Night Is Day (True Blood Remix)",
      slug: "da-chick-until-night-is-day-true-blood-remix",
      image: "da-chick-until-night-is-day-true-blood-remix.jpg",
    },
    {
      name: "Watch Me",
      slug: "da-chick-watch-me",
      image: "da-chick-watch-me.jpg",
    },
    {
      name: "Welcome To Heaven",
      slug: "da-chick-welcome-to-heaven",
      image: "da-chick-welcome-to-heaven.jpg",
    },
  ],
  "Joan Colomo": [
    {
      name: "3a Guerra Mundial (Instrumental)",
      slug: "joan-colomo-3a-guerra-mundial-instrumental",
      image: "joan-colomo-3a-guerra-mundial-instrumental.jpg",
    },
    {
      name: "Ens Miren Malament (Instrumental)",
      slug: "joan-colomo-ens-miren-malament-instrumental",
      image: "joan-colomo-ens-miren-malament-instrumental.jpg",
    },
  ],
  Mabreuch: [
    {
      name: "4 Avril 4",
      slug: "mabreuch-4-avril-4",
      image: "mabreuch-4-avril-4.jpg",
    },
    {
      name: "Complication Administrativ",
      slug: "mabreuch-complication-administrativ",
      image: "mabreuch-complication-administrativ.jpg",
    },
    {
      name: "Coulya Grenouil",
      slug: "mabreuch-coulya-grenouil",
      image: "mabreuch-coulya-grenouil.jpg",
    },
    {
      name: "Dolby The Aeropig",
      slug: "mabreuch-dolby-the-aeropig",
      image: "mabreuch-dolby-the-aeropig.jpg",
    },
    {
      name: "Erik Satir",
      slug: "mabreuch-erik-satir",
      image: "mabreuch-erik-satir.jpg",
    },
    {
      name: "Felatension",
      slug: "mabreuch-felatension",
      image: "mabreuch-felatension.jpg",
    },
    {
      name: "German Funk",
      slug: "mabreuch-german-funk",
      image: "mabreuch-german-funk.jpg",
    },
    {
      name: "Hip Hop Des Chiottes",
      slug: "mabreuch-hip-hop-des-chiottes",
      image: "mabreuch-hip-hop-des-chiottes.jpg",
    },
    {
      name: "James Tes Tongs",
      slug: "mabreuch-james-tes-tongs",
      image: "mabreuch-james-tes-tongs.jpg",
    },
    {
      name: "L'Orgasm Du Clown Mort",
      slug: "mabreuch-l-orgasm-du-clown-mort",
      image: "mabreuch-l-orgasm-du-clown-mort.jpg",
    },
    {
      name: "Litedakh Remix",
      slug: "mabreuch-litedakh-remix",
      image: "mabreuch-litedakh-remix.jpg",
    },
    {
      name: "Litle Dakh",
      slug: "mabreuch-litle-dakh",
      image: "mabreuch-litle-dakh.jpg",
    },
    {
      name: "Magnum Force",
      slug: "mabreuch-magnum-force",
      image: "mabreuch-magnum-force.jpg",
    },
    {
      name: "Mark Vador",
      slug: "mabreuch-mark-vador",
      image: "mabreuch-mark-vador.jpg",
    },
    {
      name: "Megapromo",
      slug: "mabreuch-megapromo",
      image: "mabreuch-megapromo.jpg",
    },
    { name: "Mekong", slug: "mabreuch-mekong", image: "mabreuch-mekong.jpg" },
    {
      name: "Ouich Do Brazil",
      slug: "mabreuch-ouich-do-brazil",
      image: "mabreuch-ouich-do-brazil.jpg",
    },
    {
      name: "Post Capilo",
      slug: "mabreuch-post-capilo",
      image: "mabreuch-post-capilo.jpg",
    },
    { name: "Saloon", slug: "mabreuch-saloon", image: "mabreuch-saloon.jpg" },
    {
      name: "Saloon Baston",
      slug: "mabreuch-saloon-baston",
      image: "mabreuch-saloon-baston.jpg",
    },
    {
      name: "Speed Gay",
      slug: "mabreuch-speed-gay",
      image: "mabreuch-speed-gay.jpg",
    },
    {
      name: "Swimming Pool",
      slug: "mabreuch-swimming-pool",
      image: "mabreuch-swimming-pool.jpg",
    },
    {
      name: "Vic Spirit",
      slug: "mabreuch-vic-spirit",
      image: "mabreuch-vic-spirit.jpg",
    },
  ],
  Zave: [
    { name: "4 You", slug: "zave-4-you", image: "zave-4-you.jpg" },
    { name: "Always", slug: "zave-always", image: "zave-always.jpg" },
    { name: "Child", slug: "zave-child", image: "zave-child.jpg" },
    { name: "Love", slug: "zave-love", image: "zave-love.jpg" },
    {
      name: "Miracle feat. Romy Wave",
      slug: "zave-miracle-feat-romy-wave",
      image: "zave-miracle-feat-romy-wave.jpg",
    },
    { name: "Romance", slug: "zave-romance", image: "zave-romance.jpg" },
  ],
  "Fringe Society": [
    { name: "42", slug: "fringe-society-42", image: "fringe-society-42.jpg" },
    {
      name: "Dear Rozz",
      slug: "fringe-society-dear-rozz",
      image: "fringe-society-dear-rozz.jpg",
    },
    {
      name: "Dimmet",
      slug: "fringe-society-dimmet",
      image: "fringe-society-dimmet.jpg",
    },
    {
      name: "Moltisanti",
      slug: "fringe-society-moltisanti",
      image: "fringe-society-moltisanti.jpg",
    },
  ],
  "Pas Sages": [
    {
      name: "45 Tours",
      slug: "pas-sages-45-tours",
      image: "pas-sages-45-tours.jpg",
    },
    {
      name: "Ayahuasca",
      slug: "pas-sages-ayahuasca",
      image: "pas-sages-ayahuasca.jpg",
    },
    {
      name: "Ciao Kyoto",
      slug: "pas-sages-ciao-kyoto",
      image: "pas-sages-ciao-kyoto.jpg",
    },
    {
      name: "Danser Encore",
      slug: "pas-sages-danser-encore",
      image: "pas-sages-danser-encore.jpg",
    },
    {
      name: "Je Penche",
      slug: "pas-sages-je-penche",
      image: "pas-sages-je-penche.jpg",
    },
    {
      name: "Nuit D'Azur",
      slug: "pas-sages-nuit-d-azur",
      image: "pas-sages-nuit-d-azur.jpg",
    },
    {
      name: "Nébuleuse",
      slug: "pas-sages-nebuleuse",
      image: "pas-sages-nebuleuse.jpg",
    },
    {
      name: "Tropicana",
      slug: "pas-sages-tropicana",
      image: "pas-sages-tropicana.jpg",
    },
  ],
  "Gecko Turner": [
    {
      name: "45.000$",
      slug: "gecko-turner-45-000usd",
      image: "gecko-turner-45-000usd.jpg",
    },
    {
      name: "Afrobeatnik",
      slug: "gecko-turner-afrobeatnik",
      image: "gecko-turner-afrobeatnik.jpg",
    },
    {
      name: "Bee Eater",
      slug: "gecko-turner-bee-eater",
      image: "gecko-turner-bee-eater.jpg",
    },
    {
      name: "Chicken Wire",
      slug: "gecko-turner-chicken-wire",
      image: "gecko-turner-chicken-wire.jpg",
    },
    {
      name: "Chicken Wire (Souleance Remix)",
      slug: "gecko-turner-chicken-wire-souleance-remix",
      image: "gecko-turner-chicken-wire-souleance-remix.jpg",
    },
    {
      name: "Corazon de Jesus",
      slug: "gecko-turner-corazon-de-jesus",
      image: "gecko-turner-corazon-de-jesus.jpg",
    },
    {
      name: "Cortando Bajito",
      slug: "gecko-turner-cortando-bajito",
      image: "gecko-turner-cortando-bajito.jpg",
    },
    {
      name: "Cortando Bajito (Jungle Fire Remix)",
      slug: "gecko-turner-cortando-bajito-jungle-fire-remix",
      image: "gecko-turner-cortando-bajito-jungle-fire-remix.jpg",
    },
    {
      name: "Did You Ever Wonder Why",
      slug: "gecko-turner-did-you-ever-wonder-why",
      image: "gecko-turner-did-you-ever-wonder-why.jpg",
    },
    {
      name: "Extremely Good",
      slug: "gecko-turner-extremely-good",
      image: "gecko-turner-extremely-good.jpg",
    },
    {
      name: "Fess It , Girl",
      slug: "gecko-turner-fess-it-girl",
      image: "gecko-turner-fess-it-girl.jpg",
    },
    {
      name: "Here Comes Friday",
      slug: "gecko-turner-here-comes-friday",
      image: "gecko-turner-here-comes-friday.jpg",
    },
    {
      name: "I'll Do That",
      slug: "gecko-turner-i-ll-do-that",
      image: "gecko-turner-i-ll-do-that.jpg",
    },
    {
      name: "I'll Do That (Kolours Remix)",
      slug: "gecko-turner-i-ll-do-that-kolours-remix",
      image: "gecko-turner-i-ll-do-that-kolours-remix.jpg",
    },
    {
      name: "Juanit",
      slug: "gecko-turner-juanit",
      image: "gecko-turner-juanit.jpg",
    },
    {
      name: "Little Sonny",
      slug: "gecko-turner-little-sonny",
      image: "gecko-turner-little-sonny.jpg",
    },
    {
      name: "Mbira Bira",
      slug: "gecko-turner-mbira-bira",
      image: "gecko-turner-mbira-bira.jpg",
    },
    {
      name: "Medium Rare",
      slug: "gecko-turner-medium-rare",
      image: "gecko-turner-medium-rare.jpg",
    },
    {
      name: "Monosabio Blues",
      slug: "gecko-turner-monosabio-blues",
      image: "gecko-turner-monosabio-blues.jpg",
    },
    {
      name: "Oye Muchacha",
      slug: "gecko-turner-oye-muchacha",
      image: "gecko-turner-oye-muchacha.jpg",
    },
    {
      name: "Pal Perú",
      slug: "gecko-turner-pal-peru",
      image: "gecko-turner-pal-peru.jpg",
    },
    {
      name: "Rockin' Didley",
      slug: "gecko-turner-rockin-didley",
      image: "gecko-turner-rockin-didley.jpg",
    },
    {
      name: "The Strange Adventures Of Two Runaway Elephants",
      slug: "gecko-turner-the-strange-adventures-of-two-runaway-elephants",
      image: "gecko-turner-the-strange-adventures-of-two-runaway-elephants.jpg",
    },
    {
      name: "This Is The One",
      slug: "gecko-turner-this-is-the-one",
      image: "gecko-turner-this-is-the-one.jpg",
    },
    {
      name: "Toda Mojaíta",
      slug: "gecko-turner-toda-mojaita",
      image: "gecko-turner-toda-mojaita.jpg",
    },
    {
      name: "Un Limón En La Cabeza",
      slug: "gecko-turner-un-limon-en-la-cabeza",
      image: "gecko-turner-un-limon-en-la-cabeza.jpg",
    },
    {
      name: "When I Woke Up",
      slug: "gecko-turner-when-i-woke-up",
      image: "gecko-turner-when-i-woke-up.jpg",
    },
    {
      name: "Ámame, Mímame",
      slug: "gecko-turner-amame-mimame",
      image: "gecko-turner-amame-mimame.jpg",
    },
  ],
  B1n0: [
    {
      name: "50-50 feat. Núria Graham",
      slug: "b1n0-50-50-feat-nuria-graham",
      image: "b1n0-50-50-feat-nuria-graham.jpg",
    },
    { name: "B1", slug: "b1n0-b1", image: "b1n0-b1.jpg" },
    {
      name: "F33L feat. Phoac",
      slug: "b1n0-f33l-feat-phoac",
      image: "b1n0-f33l-feat-phoac.jpg",
    },
    {
      name: "H4v3 Fun feat. 4dr14n0",
      slug: "b1n0-h4v3-fun-feat-4dr14n0",
      image: "b1n0-h4v3-fun-feat-4dr14n0.jpg",
    },
    {
      name: "Kornulov3 feat. Núria Graham",
      slug: "b1n0-kornulov3-feat-nuria-graham",
      image: "b1n0-kornulov3-feat-nuria-graham.jpg",
    },
    {
      name: "Kruml1n feat. Núria Graham",
      slug: "b1n0-kruml1n-feat-nuria-graham",
      image: "b1n0-kruml1n-feat-nuria-graham.jpg",
    },
    {
      name: "N03M1 feat. 4dr14n0",
      slug: "b1n0-n03m1-feat-4dr14n0",
      image: "b1n0-n03m1-feat-4dr14n0.jpg",
    },
    {
      name: "R0M4N71C153D feat. Phoac",
      slug: "b1n0-r0m4n71c153d-feat-phoac",
      image: "b1n0-r0m4n71c153d-feat-phoac.jpg",
    },
    {
      name: "UN1$€X feat. 4dr14n0",
      slug: "b1n0-un1usdeurx-feat-4dr14n0",
      image: "b1n0-un1usdeurx-feat-4dr14n0.jpg",
    },
  ],
  "Ukulele Clan Band": [
    {
      name: "607 Revisited",
      slug: "ukulele-clan-band-607-revisited",
      image: "ukulele-clan-band-607-revisited.jpg",
    },
    {
      name: "About A Chamaca",
      slug: "ukulele-clan-band-about-a-chamaca",
      image: "ukulele-clan-band-about-a-chamaca.jpg",
    },
    {
      name: "Adventures In The Park",
      slug: "ukulele-clan-band-adventures-in-the-park",
      image: "ukulele-clan-band-adventures-in-the-park.jpg",
    },
    {
      name: "Aloha",
      slug: "ukulele-clan-band-aloha",
      image: "ukulele-clan-band-aloha.jpg",
    },
    {
      name: "Dear Dog",
      slug: "ukulele-clan-band-dear-dog",
      image: "ukulele-clan-band-dear-dog.jpg",
    },
    {
      name: "Down The Train",
      slug: "ukulele-clan-band-down-the-train",
      image: "ukulele-clan-band-down-the-train.jpg",
    },
    {
      name: "Everybody Is Talking About You",
      slug: "ukulele-clan-band-everybody-is-talking-about-you",
      image: "ukulele-clan-band-everybody-is-talking-about-you.jpg",
    },
    {
      name: "Forevermore",
      slug: "ukulele-clan-band-forevermore",
      image: "ukulele-clan-band-forevermore.jpg",
    },
    {
      name: "Fox Hunters",
      slug: "ukulele-clan-band-fox-hunters",
      image: "ukulele-clan-band-fox-hunters.jpg",
    },
    {
      name: "Goodbye",
      slug: "ukulele-clan-band-goodbye",
      image: "ukulele-clan-band-goodbye.jpg",
    },
    {
      name: "Hello Hello",
      slug: "ukulele-clan-band-hello-hello",
      image: "ukulele-clan-band-hello-hello.jpg",
    },
    {
      name: "Hoy Me He Perdido",
      slug: "ukulele-clan-band-hoy-me-he-perdido",
      image: "ukulele-clan-band-hoy-me-he-perdido.jpg",
    },
    {
      name: "It's Alright Ma'",
      slug: "ukulele-clan-band-it-s-alright-ma",
      image: "ukulele-clan-band-it-s-alright-ma.jpg",
    },
    {
      name: "Let's Talk",
      slug: "ukulele-clan-band-let-s-talk",
      image: "ukulele-clan-band-let-s-talk.jpg",
    },
    {
      name: "More Sugar",
      slug: "ukulele-clan-band-more-sugar",
      image: "ukulele-clan-band-more-sugar.jpg",
    },
    {
      name: "No Vas A Volver",
      slug: "ukulele-clan-band-no-vas-a-volver",
      image: "ukulele-clan-band-no-vas-a-volver.jpg",
    },
    {
      name: "Pas De Problem",
      slug: "ukulele-clan-band-pas-de-problem",
      image: "ukulele-clan-band-pas-de-problem.jpg",
    },
    {
      name: "Redode",
      slug: "ukulele-clan-band-redode",
      image: "ukulele-clan-band-redode.jpg",
    },
    {
      name: "Sabor A Hiel",
      slug: "ukulele-clan-band-sabor-a-hiel",
      image: "ukulele-clan-band-sabor-a-hiel.jpg",
    },
    {
      name: "Slacker",
      slug: "ukulele-clan-band-slacker",
      image: "ukulele-clan-band-slacker.jpg",
    },
    {
      name: "Supersonic",
      slug: "ukulele-clan-band-supersonic",
      image: "ukulele-clan-band-supersonic.jpg",
    },
    {
      name: "The Further , The Better",
      slug: "ukulele-clan-band-the-further-the-better",
      image: "ukulele-clan-band-the-further-the-better.jpg",
    },
    {
      name: "The Sun",
      slug: "ukulele-clan-band-the-sun",
      image: "ukulele-clan-band-the-sun.jpg",
    },
    {
      name: "Top Of The World",
      slug: "ukulele-clan-band-top-of-the-world",
      image: "ukulele-clan-band-top-of-the-world.jpg",
    },
  ],
  "Thomas Naim": [
    {
      name: "68 Blues",
      slug: "thomas-naim-68-blues",
      image: "thomas-naim-68-blues.jpg",
    },
    {
      name: "Arabic Blues",
      slug: "thomas-naim-arabic-blues",
      image: "thomas-naim-arabic-blues.jpg",
    },
    {
      name: "Baraka",
      slug: "thomas-naim-baraka",
      image: "thomas-naim-baraka.jpg",
    },
    {
      name: "Black Cloud",
      slug: "thomas-naim-black-cloud",
      image: "thomas-naim-black-cloud.jpg",
    },
    {
      name: "California",
      slug: "thomas-naim-california",
      image: "thomas-naim-california.jpg",
    },
    {
      name: "Camminare",
      slug: "thomas-naim-camminare",
      image: "thomas-naim-camminare.jpg",
    },
    {
      name: "Desert Highway",
      slug: "thomas-naim-desert-highway",
      image: "thomas-naim-desert-highway.jpg",
    },
    {
      name: "El Hombre",
      slug: "thomas-naim-el-hombre",
      image: "thomas-naim-el-hombre.jpg",
    },
    {
      name: "Jealous Guy",
      slug: "thomas-naim-jealous-guy",
      image: "thomas-naim-jealous-guy.jpg",
    },
    { name: "Lady", slug: "thomas-naim-lady", image: "thomas-naim-lady.jpg" },
    {
      name: "Lonnie's Lament",
      slug: "thomas-naim-lonnie-s-lament",
      image: "thomas-naim-lonnie-s-lament.jpg",
    },
    {
      name: "Night Bloomers",
      slug: "thomas-naim-night-bloomers",
      image: "thomas-naim-night-bloomers.jpg",
    },
    {
      name: "Rainbow",
      slug: "thomas-naim-rainbow",
      image: "thomas-naim-rainbow.jpg",
    },
    {
      name: "Rock Big Band",
      slug: "thomas-naim-rock-big-band",
      image: "thomas-naim-rock-big-band.jpg",
    },
    {
      name: "Rootless Blues",
      slug: "thomas-naim-rootless-blues",
      image: "thomas-naim-rootless-blues.jpg",
    },
    {
      name: "Slidance",
      slug: "thomas-naim-slidance",
      image: "thomas-naim-slidance.jpg",
    },
    {
      name: "The Last One",
      slug: "thomas-naim-the-last-one",
      image: "thomas-naim-the-last-one.jpg",
    },
    {
      name: "The Wire",
      slug: "thomas-naim-the-wire",
      image: "thomas-naim-the-wire.jpg",
    },
    {
      name: "Tijuana",
      slug: "thomas-naim-tijuana",
      image: "thomas-naim-tijuana.jpg",
    },
    {
      name: "Valle De La Luna",
      slug: "thomas-naim-valle-de-la-luna",
      image: "thomas-naim-valle-de-la-luna.jpg",
    },
    {
      name: "Vinicius",
      slug: "thomas-naim-vinicius",
      image: "thomas-naim-vinicius.jpg",
    },
  ],
  Cleopatra: [
    {
      name: "7th Heaven",
      slug: "cleopatra-7th-heaven",
      image: "cleopatra-7th-heaven.jpg",
    },
    {
      name: "Air That I Breathe",
      slug: "cleopatra-air-that-i-breathe",
      image: "cleopatra-air-that-i-breathe.jpg",
    },
    {
      name: "Chill Pill",
      slug: "cleopatra-chill-pill",
      image: "cleopatra-chill-pill.jpg",
    },
    {
      name: "Entropy",
      slug: "cleopatra-entropy",
      image: "cleopatra-entropy.jpg",
    },
    {
      name: "Entropy (Instrumental)",
      slug: "cleopatra-entropy-instrumental",
      image: "cleopatra-entropy-instrumental.jpg",
    },
    { name: "Fly", slug: "cleopatra-fly", image: "cleopatra-fly.jpg" },
    {
      name: "Life Is A Wonder",
      slug: "cleopatra-life-is-a-wonder",
      image: "cleopatra-life-is-a-wonder.jpg",
    },
    {
      name: "Life Is A Wonder (Instrumental)",
      slug: "cleopatra-life-is-a-wonder-instrumental",
      image: "cleopatra-life-is-a-wonder-instrumental.jpg",
    },
    { name: "Maze", slug: "cleopatra-maze", image: "cleopatra-maze.jpg" },
    {
      name: "Moby Not",
      slug: "cleopatra-moby-not",
      image: "cleopatra-moby-not.jpg",
    },
    {
      name: "Time and Time Again",
      slug: "cleopatra-time-and-time-again",
      image: "cleopatra-time-and-time-again.jpg",
    },
    {
      name: "Velvet Martini",
      slug: "cleopatra-velvet-martini",
      image: "cleopatra-velvet-martini.jpg",
    },
  ],
  "Pedro Vian": [
    {
      name: "801 feat Carla Pérez Vas",
      slug: "pedro-vian-801-feat-carla-perez-vas",
      image: "pedro-vian-801-feat-carla-perez-vas.jpg",
    },
    {
      name: "A Romance Between Two Planets",
      slug: "pedro-vian-a-romance-between-two-planets",
      image: "pedro-vian-a-romance-between-two-planets.jpg",
    },
    {
      name: "Acid Brut",
      slug: "pedro-vian-acid-brut",
      image: "pedro-vian-acid-brut.jpg",
    },
    {
      name: "Ancient Island",
      slug: "pedro-vian-ancient-island",
      image: "pedro-vian-ancient-island.jpg",
    },
    {
      name: "Can Mortera",
      slug: "pedro-vian-can-mortera",
      image: "pedro-vian-can-mortera.jpg",
    },
    {
      name: "Colours Of Infinity",
      slug: "pedro-vian-colours-of-infinity",
      image: "pedro-vian-colours-of-infinity.jpg",
    },
    {
      name: "Cops de Caps",
      slug: "pedro-vian-cops-de-caps",
      image: "pedro-vian-cops-de-caps.jpg",
    },
    {
      name: "Dancing Hindus",
      slug: "pedro-vian-dancing-hindus",
      image: "pedro-vian-dancing-hindus.jpg",
    },
    {
      name: "Desmai",
      slug: "pedro-vian-desmai",
      image: "pedro-vian-desmai.jpg",
    },
    {
      name: "El Sueño Lúcido",
      slug: "pedro-vian-el-sueno-lucido",
      image: "pedro-vian-el-sueno-lucido.jpg",
    },
    {
      name: "El Sueño Lúcido (Massimiliano Pagliara Remix)",
      slug: "pedro-vian-el-sueno-lucido-massimiliano-pagliara-remix",
      image: "pedro-vian-el-sueno-lucido-massimiliano-pagliara-remix.jpg",
    },
    {
      name: "Flexible Girl",
      slug: "pedro-vian-flexible-girl",
      image: "pedro-vian-flexible-girl.jpg",
    },
    {
      name: "Hamets",
      slug: "pedro-vian-hamets",
      image: "pedro-vian-hamets.jpg",
    },
    {
      name: "Indian Strings",
      slug: "pedro-vian-indian-strings",
      image: "pedro-vian-indian-strings.jpg",
    },
    {
      name: "Interlude",
      slug: "pedro-vian-interlude",
      image: "pedro-vian-interlude.jpg",
    },
    {
      name: "Invisible Objects",
      slug: "pedro-vian-invisible-objects",
      image: "pedro-vian-invisible-objects.jpg",
    },
    { name: "Lagos", slug: "pedro-vian-lagos", image: "pedro-vian-lagos.jpg" },
    {
      name: "Le Fou",
      slug: "pedro-vian-le-fou",
      image: "pedro-vian-le-fou.jpg",
    },
    {
      name: "Le Printemps Est Arrivé",
      slug: "pedro-vian-le-printemps-est-arrive",
      image: "pedro-vian-le-printemps-est-arrive.jpg",
    },
    { name: "Maia", slug: "pedro-vian-maia", image: "pedro-vian-maia.jpg" },
    {
      name: "Medusa",
      slug: "pedro-vian-medusa",
      image: "pedro-vian-medusa.jpg",
    },
    {
      name: "Miralls",
      slug: "pedro-vian-miralls",
      image: "pedro-vian-miralls.jpg",
    },
    {
      name: "News From Near Future",
      slug: "pedro-vian-news-from-near-future",
      image: "pedro-vian-news-from-near-future.jpg",
    },
    {
      name: "Nine Is Nice",
      slug: "pedro-vian-nine-is-nice",
      image: "pedro-vian-nine-is-nice.jpg",
    },
    {
      name: "Pandora",
      slug: "pedro-vian-pandora",
      image: "pedro-vian-pandora.jpg",
    },
    {
      name: "Paradise",
      slug: "pedro-vian-paradise",
      image: "pedro-vian-paradise.jpg",
    },
    {
      name: "Platja",
      slug: "pedro-vian-platja",
      image: "pedro-vian-platja.jpg",
    },
    {
      name: "River Stones",
      slug: "pedro-vian-river-stones",
      image: "pedro-vian-river-stones.jpg",
    },
    {
      name: "Sant Moritz",
      slug: "pedro-vian-sant-moritz",
      image: "pedro-vian-sant-moritz.jpg",
    },
    {
      name: "Seneca feat. Laia Nada",
      slug: "pedro-vian-seneca-feat-laia-nada",
      image: "pedro-vian-seneca-feat-laia-nada.jpg",
    },
    {
      name: "Similar Faces",
      slug: "pedro-vian-similar-faces",
      image: "pedro-vian-similar-faces.jpg",
    },
    {
      name: "Start Again",
      slug: "pedro-vian-start-again",
      image: "pedro-vian-start-again.jpg",
    },
    {
      name: "Static Ecstasy",
      slug: "pedro-vian-static-ecstasy",
      image: "pedro-vian-static-ecstasy.jpg",
    },
    {
      name: "Terrestial Images",
      slug: "pedro-vian-terrestial-images",
      image: "pedro-vian-terrestial-images.jpg",
    },
    {
      name: "The Destiny Manifest",
      slug: "pedro-vian-the-destiny-manifest",
      image: "pedro-vian-the-destiny-manifest.jpg",
    },
    {
      name: "Tribute To Ligeti",
      slug: "pedro-vian-tribute-to-ligeti",
      image: "pedro-vian-tribute-to-ligeti.jpg",
    },
    {
      name: "Un Passatge Obscur",
      slug: "pedro-vian-un-passatge-obscur",
      image: "pedro-vian-un-passatge-obscur.jpg",
    },
    {
      name: "Unicorn",
      slug: "pedro-vian-unicorn",
      image: "pedro-vian-unicorn.jpg",
    },
    {
      name: "Vinçon",
      slug: "pedro-vian-vincon",
      image: "pedro-vian-vincon.jpg",
    },
    {
      name: "Vistes Desde Ses Illes",
      slug: "pedro-vian-vistes-desde-ses-illes",
      image: "pedro-vian-vistes-desde-ses-illes.jpg",
    },
    {
      name: "Western Snow",
      slug: "pedro-vian-western-snow",
      image: "pedro-vian-western-snow.jpg",
    },
  ],
  "Diego Hdez": [
    {
      name: "9 to 5",
      slug: "diego-hdez-9-to-5",
      image: "diego-hdez-9-to-5.jpg",
    },
    {
      name: "Bless The Rain",
      slug: "diego-hdez-bless-the-rain",
      image: "diego-hdez-bless-the-rain.jpg",
    },
    {
      name: "Brother Wood",
      slug: "diego-hdez-brother-wood",
      image: "diego-hdez-brother-wood.jpg",
    },
    {
      name: "Come The Summer",
      slug: "diego-hdez-come-the-summer",
      image: "diego-hdez-come-the-summer.jpg",
    },
    {
      name: "Dragonfly",
      slug: "diego-hdez-dragonfly",
      image: "diego-hdez-dragonfly.jpg",
    },
    { name: "Dress", slug: "diego-hdez-dress", image: "diego-hdez-dress.jpg" },
    {
      name: "Falling Apart",
      slug: "diego-hdez-falling-apart",
      image: "diego-hdez-falling-apart.jpg",
    },
    {
      name: "Free Sahara",
      slug: "diego-hdez-free-sahara",
      image: "diego-hdez-free-sahara.jpg",
    },
    {
      name: "Freedom",
      slug: "diego-hdez-freedom",
      image: "diego-hdez-freedom.jpg",
    },
    {
      name: "Heinsenberg",
      slug: "diego-hdez-heinsenberg",
      image: "diego-hdez-heinsenberg.jpg",
    },
    {
      name: "No Cowboy",
      slug: "diego-hdez-no-cowboy",
      image: "diego-hdez-no-cowboy.jpg",
    },
    {
      name: "Particular Universe",
      slug: "diego-hdez-particular-universe",
      image: "diego-hdez-particular-universe.jpg",
    },
    {
      name: "People I Never Met",
      slug: "diego-hdez-people-i-never-met",
      image: "diego-hdez-people-i-never-met.jpg",
    },
    {
      name: "Pink Car Phone",
      slug: "diego-hdez-pink-car-phone",
      image: "diego-hdez-pink-car-phone.jpg",
    },
    {
      name: "Progress",
      slug: "diego-hdez-progress",
      image: "diego-hdez-progress.jpg",
    },
    {
      name: "Responsability",
      slug: "diego-hdez-responsability",
      image: "diego-hdez-responsability.jpg",
    },
    {
      name: "The Map",
      slug: "diego-hdez-the-map",
      image: "diego-hdez-the-map.jpg",
    },
    {
      name: "Under The Microscope",
      slug: "diego-hdez-under-the-microscope",
      image: "diego-hdez-under-the-microscope.jpg",
    },
    {
      name: "Viva El Mar",
      slug: "diego-hdez-viva-el-mar",
      image: "diego-hdez-viva-el-mar.jpg",
    },
  ],
  "Cat Claws": [
    {
      name: "90 Minutes",
      slug: "cat-claws-90-minutes",
      image: "cat-claws-90-minutes.jpg",
    },
  ],
  "Marina Gallardo": [
    {
      name: "A Beast In Me",
      slug: "marina-gallardo-a-beast-in-me",
      image: "marina-gallardo-a-beast-in-me.jpg",
    },
    {
      name: "Beach Sand",
      slug: "marina-gallardo-beach-sand",
      image: "marina-gallardo-beach-sand.jpg",
    },
    {
      name: "Bright Lights",
      slug: "marina-gallardo-bright-lights",
      image: "marina-gallardo-bright-lights.jpg",
    },
    {
      name: "Climbing The Walls",
      slug: "marina-gallardo-climbing-the-walls",
      image: "marina-gallardo-climbing-the-walls.jpg",
    },
    {
      name: "Climbing The World",
      slug: "marina-gallardo-climbing-the-world",
      image: "marina-gallardo-climbing-the-world.jpg",
    },
    {
      name: "Cold Eye",
      slug: "marina-gallardo-cold-eye",
      image: "marina-gallardo-cold-eye.jpg",
    },
    {
      name: "Flowers",
      slug: "marina-gallardo-flowers",
      image: "marina-gallardo-flowers.jpg",
    },
    {
      name: "Funeral",
      slug: "marina-gallardo-funeral",
      image: "marina-gallardo-funeral.jpg",
    },
    {
      name: "Going To Die",
      slug: "marina-gallardo-going-to-die",
      image: "marina-gallardo-going-to-die.jpg",
    },
    {
      name: "Golden Ears",
      slug: "marina-gallardo-golden-ears",
      image: "marina-gallardo-golden-ears.jpg",
    },
    {
      name: "Interlude (The Pines)",
      slug: "marina-gallardo-interlude-the-pines",
      image: "marina-gallardo-interlude-the-pines.jpg",
    },
    {
      name: "Longer Days",
      slug: "marina-gallardo-longer-days",
      image: "marina-gallardo-longer-days.jpg",
    },
    {
      name: "Monsters",
      slug: "marina-gallardo-monsters",
      image: "marina-gallardo-monsters.jpg",
    },
    {
      name: "Moon's Wolf",
      slug: "marina-gallardo-moon-s-wolf",
      image: "marina-gallardo-moon-s-wolf.jpg",
    },
    {
      name: "Moonphases",
      slug: "marina-gallardo-moonphases",
      image: "marina-gallardo-moonphases.jpg",
    },
    {
      name: "New Worlds",
      slug: "marina-gallardo-new-worlds",
      image: "marina-gallardo-new-worlds.jpg",
    },
    {
      name: "Nora",
      slug: "marina-gallardo-nora",
      image: "marina-gallardo-nora.jpg",
    },
    {
      name: "Old Whiskey",
      slug: "marina-gallardo-old-whiskey",
      image: "marina-gallardo-old-whiskey.jpg",
    },
    {
      name: "Recurrent Dream",
      slug: "marina-gallardo-recurrent-dream",
      image: "marina-gallardo-recurrent-dream.jpg",
    },
    {
      name: "Sea Song",
      slug: "marina-gallardo-sea-song",
      image: "marina-gallardo-sea-song.jpg",
    },
    {
      name: "Smile",
      slug: "marina-gallardo-smile",
      image: "marina-gallardo-smile.jpg",
    },
    {
      name: "So Glad",
      slug: "marina-gallardo-so-glad",
      image: "marina-gallardo-so-glad.jpg",
    },
    {
      name: "Sparkle Eyes",
      slug: "marina-gallardo-sparkle-eyes",
      image: "marina-gallardo-sparkle-eyes.jpg",
    },
    {
      name: "Stones",
      slug: "marina-gallardo-stones",
      image: "marina-gallardo-stones.jpg",
    },
    {
      name: "Tears",
      slug: "marina-gallardo-tears",
      image: "marina-gallardo-tears.jpg",
    },
    {
      name: "The Squawking Bird",
      slug: "marina-gallardo-the-squawking-bird",
      image: "marina-gallardo-the-squawking-bird.jpg",
    },
    {
      name: "Tired Man",
      slug: "marina-gallardo-tired-man",
      image: "marina-gallardo-tired-man.jpg",
    },
    {
      name: "Touch",
      slug: "marina-gallardo-touch",
      image: "marina-gallardo-touch.jpg",
    },
    {
      name: "Trembling Bones",
      slug: "marina-gallardo-trembling-bones",
      image: "marina-gallardo-trembling-bones.jpg",
    },
    {
      name: "Vanishing Fears",
      slug: "marina-gallardo-vanishing-fears",
      image: "marina-gallardo-vanishing-fears.jpg",
    },
    {
      name: "White Glare",
      slug: "marina-gallardo-white-glare",
      image: "marina-gallardo-white-glare.jpg",
    },
  ],
  "Suki Brownies": [
    {
      name: "A Billion",
      slug: "suki-brownies-a-billion",
      image: "suki-brownies-a-billion.jpg",
    },
    {
      name: "Brick",
      slug: "suki-brownies-brick",
      image: "suki-brownies-brick.jpg",
    },
    {
      name: "Cregs",
      slug: "suki-brownies-cregs",
      image: "suki-brownies-cregs.jpg",
    },
    { name: "Eye", slug: "suki-brownies-eye", image: "suki-brownies-eye.jpg" },
    {
      name: "For Me",
      slug: "suki-brownies-for-me",
      image: "suki-brownies-for-me.jpg",
    },
    {
      name: "Four Walls",
      slug: "suki-brownies-four-walls",
      image: "suki-brownies-four-walls.jpg",
    },
    {
      name: "I Don't Know",
      slug: "suki-brownies-i-don-t-know",
      image: "suki-brownies-i-don-t-know.jpg",
    },
    {
      name: "Papa",
      slug: "suki-brownies-papa",
      image: "suki-brownies-papa.jpg",
    },
    {
      name: "Window",
      slug: "suki-brownies-window",
      image: "suki-brownies-window.jpg",
    },
    {
      name: "Yellow",
      slug: "suki-brownies-yellow",
      image: "suki-brownies-yellow.jpg",
    },
  ],
  Vanova: [
    {
      name: "A Boy From The Yard",
      slug: "vanova-a-boy-from-the-yard",
      image: "vanova-a-boy-from-the-yard.jpg",
    },
    {
      name: "Come Into Warm",
      slug: "vanova-come-into-warm",
      image: "vanova-come-into-warm.jpg",
    },
    {
      name: "If We Could Read His Mind",
      slug: "vanova-if-we-could-read-his-mind",
      image: "vanova-if-we-could-read-his-mind.jpg",
    },
    {
      name: "In A 1948 Black Sedan",
      slug: "vanova-in-a-1948-black-sedan",
      image: "vanova-in-a-1948-black-sedan.jpg",
    },
    {
      name: "Jigsaw Love",
      slug: "vanova-jigsaw-love",
      image: "vanova-jigsaw-love.jpg",
    },
    {
      name: "Lost Beginners",
      slug: "vanova-lost-beginners",
      image: "vanova-lost-beginners.jpg",
    },
    {
      name: "The Elephant In The Room",
      slug: "vanova-the-elephant-in-the-room",
      image: "vanova-the-elephant-in-the-room.jpg",
    },
    {
      name: "The Last Recipe",
      slug: "vanova-the-last-recipe",
      image: "vanova-the-last-recipe.jpg",
    },
    {
      name: "The Lost In Thought King",
      slug: "vanova-the-lost-in-thought-king",
      image: "vanova-the-lost-in-thought-king.jpg",
    },
    {
      name: "The Scene",
      slug: "vanova-the-scene",
      image: "vanova-the-scene.jpg",
    },
    {
      name: "Those Left Behind",
      slug: "vanova-those-left-behind",
      image: "vanova-those-left-behind.jpg",
    },
    {
      name: "Welcome Lesson",
      slug: "vanova-welcome-lesson",
      image: "vanova-welcome-lesson.jpg",
    },
  ],
  "Cosmo Vitelli": [
    {
      name: "A Brand New City feat. Fantastic Twins",
      slug: "cosmo-vitelli-a-brand-new-city-feat-fantastic-twins",
      image: "cosmo-vitelli-a-brand-new-city-feat-fantastic-twins.jpg",
    },
    {
      name: "Delayer (Quiet Village Remix)",
      slug: "cosmo-vitelli-delayer-quiet-village-remix",
      image: "cosmo-vitelli-delayer-quiet-village-remix.jpg",
    },
    {
      name: "Ketamine Karaoke",
      slug: "cosmo-vitelli-ketamine-karaoke",
      image: "cosmo-vitelli-ketamine-karaoke.jpg",
    },
  ],
  Isolaa: [
    {
      name: "A Bridge To Nowhere",
      slug: "isolaa-a-bridge-to-nowhere",
      image: "isolaa-a-bridge-to-nowhere.jpg",
    },
    { name: "Away", slug: "isolaa-away", image: "isolaa-away.jpg" },
    {
      name: "Fire Drops",
      slug: "isolaa-fire-drops",
      image: "isolaa-fire-drops.jpg",
    },
    {
      name: "Heartless",
      slug: "isolaa-heartless",
      image: "isolaa-heartless.jpg",
    },
    {
      name: "La Mia Tipa",
      slug: "isolaa-la-mia-tipa",
      image: "isolaa-la-mia-tipa.jpg",
    },
    {
      name: "Let Me Hold You",
      slug: "isolaa-let-me-hold-you",
      image: "isolaa-let-me-hold-you.jpg",
    },
    {
      name: "Trapstars",
      slug: "isolaa-trapstars",
      image: "isolaa-trapstars.jpg",
    },
    { name: "Visions", slug: "isolaa-visions", image: "isolaa-visions.jpg" },
  ],
  "Oma Nata": [
    {
      name: "A Day To Forget",
      slug: "oma-nata-a-day-to-forget",
      image: "oma-nata-a-day-to-forget.jpg",
    },
    {
      name: "A Place In Me",
      slug: "oma-nata-a-place-in-me",
      image: "oma-nata-a-place-in-me.jpg",
    },
    {
      name: "Fathers Son",
      slug: "oma-nata-fathers-son",
      image: "oma-nata-fathers-son.jpg",
    },
    {
      name: "Isso E Amor",
      slug: "oma-nata-isso-e-amor",
      image: "oma-nata-isso-e-amor.jpg",
    },
    {
      name: "Lost Kids",
      slug: "oma-nata-lost-kids",
      image: "oma-nata-lost-kids.jpg",
    },
    {
      name: "Memories",
      slug: "oma-nata-memories",
      image: "oma-nata-memories.jpg",
    },
    {
      name: "The Discovery",
      slug: "oma-nata-the-discovery",
      image: "oma-nata-the-discovery.jpg",
    },
  ],
  "Lucius Works Here": [
    {
      name: "A Diamond Row",
      slug: "lucius-works-here-a-diamond-row",
      image: "lucius-works-here-a-diamond-row.jpg",
    },
    {
      name: "Al Lado Del Lago Kawartha",
      slug: "lucius-works-here-al-lado-del-lago-kawartha",
      image: "lucius-works-here-al-lado-del-lago-kawartha.jpg",
    },
    {
      name: "Antes Todo Era Así",
      slug: "lucius-works-here-antes-todo-era-asi",
      image: "lucius-works-here-antes-todo-era-asi.jpg",
    },
    {
      name: "Capvespre a Cal Sala",
      slug: "lucius-works-here-capvespre-a-cal-sala",
      image: "lucius-works-here-capvespre-a-cal-sala.jpg",
    },
    {
      name: "Carolina Herschel",
      slug: "lucius-works-here-carolina-herschel",
      image: "lucius-works-here-carolina-herschel.jpg",
    },
    {
      name: "Contacto",
      slug: "lucius-works-here-contacto",
      image: "lucius-works-here-contacto.jpg",
    },
    {
      name: "Dardos De Papel",
      slug: "lucius-works-here-dardos-de-papel",
      image: "lucius-works-here-dardos-de-papel.jpg",
    },
    {
      name: "Després De La Terra",
      slug: "lucius-works-here-despres-de-la-terra",
      image: "lucius-works-here-despres-de-la-terra.jpg",
    },
    {
      name: "Diari d'una Bicicleta Sola",
      slug: "lucius-works-here-diari-d-una-bicicleta-sola",
      image: "lucius-works-here-diari-d-una-bicicleta-sola.jpg",
    },
    {
      name: "El Mar Besa La Tierra",
      slug: "lucius-works-here-el-mar-besa-la-tierra",
      image: "lucius-works-here-el-mar-besa-la-tierra.jpg",
    },
    {
      name: "El Viajero de los Mares del Sur",
      slug: "lucius-works-here-el-viajero-de-los-mares-del-sur",
      image: "lucius-works-here-el-viajero-de-los-mares-del-sur.jpg",
    },
    {
      name: "Energía, Frecuencia y Vibración",
      slug: "lucius-works-here-energia-frecuencia-y-vibracion",
      image: "lucius-works-here-energia-frecuencia-y-vibracion.jpg",
    },
    {
      name: "Entonces Me Recordarás",
      slug: "lucius-works-here-entonces-me-recordaras",
      image: "lucius-works-here-entonces-me-recordaras.jpg",
    },
    {
      name: "Escrito Matemático Del Disparate",
      slug: "lucius-works-here-escrito-matematico-del-disparate",
      image: "lucius-works-here-escrito-matematico-del-disparate.jpg",
    },
    {
      name: "Guia Para Un Mapa Celeste",
      slug: "lucius-works-here-guia-para-un-mapa-celeste",
      image: "lucius-works-here-guia-para-un-mapa-celeste.jpg",
    },
    {
      name: "Inconsciente Colectivo",
      slug: "lucius-works-here-inconsciente-colectivo",
      image: "lucius-works-here-inconsciente-colectivo.jpg",
    },
    {
      name: "La Luz Sobre El Espejo",
      slug: "lucius-works-here-la-luz-sobre-el-espejo",
      image: "lucius-works-here-la-luz-sobre-el-espejo.jpg",
    },
    {
      name: "La Mujer Más Peligrosa de América",
      slug: "lucius-works-here-la-mujer-mas-peligrosa-de-america",
      image: "lucius-works-here-la-mujer-mas-peligrosa-de-america.jpg",
    },
    {
      name: "Lecciones Nocturnas",
      slug: "lucius-works-here-lecciones-nocturnas",
      image: "lucius-works-here-lecciones-nocturnas.jpg",
    },
    {
      name: "Los Contrapuntos De Virginie Lebeau",
      slug: "lucius-works-here-los-contrapuntos-de-virginie-lebeau",
      image: "lucius-works-here-los-contrapuntos-de-virginie-lebeau.jpg",
    },
    {
      name: "Matices Para Un Solo Color",
      slug: "lucius-works-here-matices-para-un-solo-color",
      image: "lucius-works-here-matices-para-un-solo-color.jpg",
    },
    {
      name: "Memory Stick",
      slug: "lucius-works-here-memory-stick",
      image: "lucius-works-here-memory-stick.jpg",
    },
    {
      name: "Mira Ya No Estoy Pisando Verde",
      slug: "lucius-works-here-mira-ya-no-estoy-pisando-verde",
      image: "lucius-works-here-mira-ya-no-estoy-pisando-verde.jpg",
    },
    {
      name: "Passeig Per L'Illa De Canet",
      slug: "lucius-works-here-passeig-per-l-illa-de-canet",
      image: "lucius-works-here-passeig-per-l-illa-de-canet.jpg",
    },
    {
      name: "Preludi Per A Dues Llunes",
      slug: "lucius-works-here-preludi-per-a-dues-llunes",
      image: "lucius-works-here-preludi-per-a-dues-llunes.jpg",
    },
    {
      name: "Seguro Que Te Necesito",
      slug: "lucius-works-here-seguro-que-te-necesito",
      image: "lucius-works-here-seguro-que-te-necesito.jpg",
    },
    {
      name: "Tu El Oceano Y Yo El Cosmos",
      slug: "lucius-works-here-tu-el-oceano-y-yo-el-cosmos",
      image: "lucius-works-here-tu-el-oceano-y-yo-el-cosmos.jpg",
    },
    {
      name: "Un Mapa Del Alma",
      slug: "lucius-works-here-un-mapa-del-alma",
      image: "lucius-works-here-un-mapa-del-alma.jpg",
    },
    {
      name: "Una Hora De Domingo",
      slug: "lucius-works-here-una-hora-de-domingo",
      image: "lucius-works-here-una-hora-de-domingo.jpg",
    },
    {
      name: "Una Moral Excéntrica",
      slug: "lucius-works-here-una-moral-excentrica",
      image: "lucius-works-here-una-moral-excentrica.jpg",
    },
    {
      name: "Una Percusionista En La Antisinfonía",
      slug: "lucius-works-here-una-percusionista-en-la-antisinfonia",
      image: "lucius-works-here-una-percusionista-en-la-antisinfonia.jpg",
    },
    {
      name: "Una Revuelta Contra La Naturaleza",
      slug: "lucius-works-here-una-revuelta-contra-la-naturaleza",
      image: "lucius-works-here-una-revuelta-contra-la-naturaleza.jpg",
    },
    {
      name: "Viajando En Tu Interior",
      slug: "lucius-works-here-viajando-en-tu-interior",
      image: "lucius-works-here-viajando-en-tu-interior.jpg",
    },
  ],
  "Stranded Horse": [
    {
      name: "A Faint Light",
      slug: "stranded-horse-a-faint-light",
      image: "stranded-horse-a-faint-light.jpg",
    },
    {
      name: "And The Shoreline It Whithdrew In",
      slug: "stranded-horse-and-the-shoreline-it-whithdrew-in",
      image: "stranded-horse-and-the-shoreline-it-whithdrew-in.jpg",
    },
    {
      name: "Dakar",
      slug: "stranded-horse-dakar",
      image: "stranded-horse-dakar.jpg",
    },
    {
      name: "Monde",
      slug: "stranded-horse-monde",
      image: "stranded-horse-monde.jpg",
    },
    {
      name: "My Name Is Carnaval",
      slug: "stranded-horse-my-name-is-carnaval",
      image: "stranded-horse-my-name-is-carnaval.jpg",
    },
    {
      name: "Ode to Scabies",
      slug: "stranded-horse-ode-to-scabies",
      image: "stranded-horse-ode-to-scabies.jpg",
    },
    {
      name: "Sharp Tongues",
      slug: "stranded-horse-sharp-tongues",
      image: "stranded-horse-sharp-tongues.jpg",
    },
    {
      name: "Unusual Ways",
      slug: "stranded-horse-unusual-ways",
      image: "stranded-horse-unusual-ways.jpg",
    },
  ],
  Inhabitants: [
    {
      name: "A Ghost",
      slug: "inhabitants-a-ghost",
      image: "inhabitants-a-ghost.jpg",
    },
  ],
  "D.Y.O.R": [
    {
      name: "A Ground In The Hole",
      slug: "d-y-o-r-a-ground-in-the-hole",
      image: "d-y-o-r-a-ground-in-the-hole.jpg",
    },
    {
      name: "A Ground In The Hole (Damon Jee Remix)",
      slug: "d-y-o-r-a-ground-in-the-hole-damon-jee-remix",
      image: "d-y-o-r-a-ground-in-the-hole-damon-jee-remix.jpg",
    },
    {
      name: "Devil's Way",
      slug: "d-y-o-r-devil-s-way",
      image: "d-y-o-r-devil-s-way.jpg",
    },
    {
      name: "The Golden Boy",
      slug: "d-y-o-r-the-golden-boy",
      image: "d-y-o-r-the-golden-boy.jpg",
    },
    {
      name: "Your Love",
      slug: "d-y-o-r-your-love",
      image: "d-y-o-r-your-love.jpg",
    },
  ],
  Ursula: [
    {
      name: "A La Manana Siguiente",
      slug: "ursula-a-la-manana-siguiente",
      image: "ursula-a-la-manana-siguiente.jpg",
    },
    {
      name: "De Perdidos Al Rio",
      slug: "ursula-de-perdidos-al-rio",
      image: "ursula-de-perdidos-al-rio.jpg",
    },
    {
      name: "Desviaciones Morales",
      slug: "ursula-desviaciones-morales",
      image: "ursula-desviaciones-morales.jpg",
    },
    {
      name: "Detalles Sin Importancia",
      slug: "ursula-detalles-sin-importancia",
      image: "ursula-detalles-sin-importancia.jpg",
    },
    {
      name: "Fuerza Mayor",
      slug: "ursula-fuerza-mayor",
      image: "ursula-fuerza-mayor.jpg",
    },
    {
      name: "La Minoria Silenciosa",
      slug: "ursula-la-minoria-silenciosa",
      image: "ursula-la-minoria-silenciosa.jpg",
    },
    {
      name: "Maravilloso Miedo",
      slug: "ursula-maravilloso-miedo",
      image: "ursula-maravilloso-miedo.jpg",
    },
    {
      name: "Puedo Y No Quiero",
      slug: "ursula-puedo-y-no-quiero",
      image: "ursula-puedo-y-no-quiero.jpg",
    },
  ],
  "Nancy Boy": [
    {
      name: "A La Plage",
      slug: "nancy-boy-a-la-plage",
      image: "nancy-boy-a-la-plage.jpg",
    },
    {
      name: "Bleu As Everything",
      slug: "nancy-boy-bleu-as-everything",
      image: "nancy-boy-bleu-as-everything.jpg",
    },
    {
      name: "Emmène Moi A Formentera",
      slug: "nancy-boy-emmene-moi-a-formentera",
      image: "nancy-boy-emmene-moi-a-formentera.jpg",
    },
    {
      name: "Il Faut Que Tu Sois Là",
      slug: "nancy-boy-il-faut-que-tu-sois-la",
      image: "nancy-boy-il-faut-que-tu-sois-la.jpg",
    },
    {
      name: "Je T'Attends Toujours",
      slug: "nancy-boy-je-t-attends-toujours",
      image: null,
    },
    { name: "L'Absente", slug: "nancy-boy-l-absente", image: null },
    {
      name: "Rose City Lights",
      slug: "nancy-boy-rose-city-lights",
      image: "nancy-boy-rose-city-lights.jpg",
    },
    {
      name: "Toi , Moi",
      slug: "nancy-boy-toi-moi",
      image: "nancy-boy-toi-moi.jpg",
    },
    {
      name: "When You'll Be Mine",
      slug: "nancy-boy-when-you-ll-be-mine",
      image: null,
    },
    {
      name: "Where You Go I Go",
      slug: "nancy-boy-where-you-go-i-go",
      image: "nancy-boy-where-you-go-i-go.jpg",
    },
  ],
  Vermú: [
    {
      name: "A La Virgen",
      slug: "vermu-a-la-virgen",
      image: "vermu-a-la-virgen.jpg",
    },
    {
      name: "A Santo De Qué",
      slug: "vermu-a-santo-de-que",
      image: "vermu-a-santo-de-que.jpg",
    },
    {
      name: "Canto Alegre",
      slug: "vermu-canto-alegre",
      image: "vermu-canto-alegre.jpg",
    },
    { name: "Caterpie", slug: "vermu-caterpie", image: "vermu-caterpie.jpg" },
    {
      name: "El Más Listo De La Tierra",
      slug: "vermu-el-mas-listo-de-la-tierra",
      image: "vermu-el-mas-listo-de-la-tierra.jpg",
    },
    {
      name: "Los Campos Amarillos",
      slug: "vermu-los-campos-amarillos",
      image: "vermu-los-campos-amarillos.jpg",
    },
    {
      name: "Los Veranos Son Cortos",
      slug: "vermu-los-veranos-son-cortos",
      image: "vermu-los-veranos-son-cortos.jpg",
    },
    { name: "Éxodo", slug: "vermu-exodo", image: "vermu-exodo.jpg" },
  ],
  "Gregoire Linais": [
    {
      name: "A Litle Demo",
      slug: "gregoire-linais-a-litle-demo",
      image: "gregoire-linais-a-litle-demo.jpg",
    },
    {
      name: "Aube",
      slug: "gregoire-linais-aube",
      image: "gregoire-linais-aube.jpg",
    },
    {
      name: "Birth",
      slug: "gregoire-linais-birth",
      image: "gregoire-linais-birth.jpg",
    },
    {
      name: "But Still",
      slug: "gregoire-linais-but-still",
      image: "gregoire-linais-but-still.jpg",
    },
    {
      name: "Consolation",
      slug: "gregoire-linais-consolation",
      image: "gregoire-linais-consolation.jpg",
    },
    {
      name: "Evasion",
      slug: "gregoire-linais-evasion",
      image: "gregoire-linais-evasion.jpg",
    },
    {
      name: "French Waltz",
      slug: "gregoire-linais-french-waltz",
      image: "gregoire-linais-french-waltz.jpg",
    },
    {
      name: "Hache de Guerre",
      slug: "gregoire-linais-hache-de-guerre",
      image: "gregoire-linais-hache-de-guerre.jpg",
    },
    {
      name: "Improvisation en C Mineur",
      slug: "gregoire-linais-improvisation-en-c-mineur",
      image: "gregoire-linais-improvisation-en-c-mineur.jpg",
    },
    {
      name: "Jazzy",
      slug: "gregoire-linais-jazzy",
      image: "gregoire-linais-jazzy.jpg",
    },
    {
      name: "Joie sans parole",
      slug: "gregoire-linais-joie-sans-parole",
      image: "gregoire-linais-joie-sans-parole.jpg",
    },
    {
      name: "Kyrie Eleison",
      slug: "gregoire-linais-kyrie-eleison",
      image: "gregoire-linais-kyrie-eleison.jpg",
    },
    {
      name: "La Fulgurante",
      slug: "gregoire-linais-la-fulgurante",
      image: "gregoire-linais-la-fulgurante.jpg",
    },
    {
      name: "Love Letter",
      slug: "gregoire-linais-love-letter",
      image: "gregoire-linais-love-letter.jpg",
    },
    {
      name: "Prelude By Bach",
      slug: "gregoire-linais-prelude-by-bach",
      image: "gregoire-linais-prelude-by-bach.jpg",
    },
    {
      name: "Romance",
      slug: "gregoire-linais-romance",
      image: "gregoire-linais-romance.jpg",
    },
    {
      name: "Russian Waltz",
      slug: "gregoire-linais-russian-waltz",
      image: "gregoire-linais-russian-waltz.jpg",
    },
    {
      name: "Rêve en R Majeur",
      slug: "gregoire-linais-reve-en-r-majeur",
      image: "gregoire-linais-reve-en-r-majeur.jpg",
    },
    {
      name: "Say Goodbye",
      slug: "gregoire-linais-say-goodbye",
      image: "gregoire-linais-say-goodbye.jpg",
    },
    {
      name: "Sibelius And The Crazy Violin",
      slug: "gregoire-linais-sibelius-and-the-crazy-violin",
      image: "gregoire-linais-sibelius-and-the-crazy-violin.jpg",
    },
    {
      name: "Souvenir",
      slug: "gregoire-linais-souvenir",
      image: "gregoire-linais-souvenir.jpg",
    },
    {
      name: "Spanish Waltz",
      slug: "gregoire-linais-spanish-waltz",
      image: "gregoire-linais-spanish-waltz.jpg",
    },
    {
      name: "The Childish One",
      slug: "gregoire-linais-the-childish-one",
      image: "gregoire-linais-the-childish-one.jpg",
    },
    {
      name: "The Mad Race",
      slug: "gregoire-linais-the-mad-race",
      image: "gregoire-linais-the-mad-race.jpg",
    },
    {
      name: "The Stampede",
      slug: "gregoire-linais-the-stampede",
      image: "gregoire-linais-the-stampede.jpg",
    },
    {
      name: "Until The Top Of The Mountain",
      slug: "gregoire-linais-until-the-top-of-the-mountain",
      image: "gregoire-linais-until-the-top-of-the-mountain.jpg",
    },
    {
      name: "Valse Folle",
      slug: "gregoire-linais-valse-folle",
      image: "gregoire-linais-valse-folle.jpg",
    },
    {
      name: "Vivace",
      slug: "gregoire-linais-vivace",
      image: "gregoire-linais-vivace.jpg",
    },
    {
      name: "Voyage",
      slug: "gregoire-linais-voyage",
      image: "gregoire-linais-voyage.jpg",
    },
    {
      name: "Yeah Right",
      slug: "gregoire-linais-yeah-right",
      image: "gregoire-linais-yeah-right.jpg",
    },
  ],
  "Merci Beaucoup": [
    {
      name: "A Little Girl In Your Eyes",
      slug: "merci-beaucoup-a-little-girl-in-your-eyes",
      image: "merci-beaucoup-a-little-girl-in-your-eyes.jpg",
    },
    {
      name: "Sexy Million Sobs",
      slug: "merci-beaucoup-sexy-million-sobs",
      image: "merci-beaucoup-sexy-million-sobs.jpg",
    },
  ],
  Cáceres: [
    {
      name: "A Los Murgueros",
      slug: "caceres-a-los-murgueros",
      image: "caceres-a-los-murgueros.jpg",
    },
    {
      name: "Airecito",
      slug: "caceres-airecito",
      image: "caceres-airecito.jpg",
    },
    { name: "Antigua", slug: "caceres-antigua", image: "caceres-antigua.jpg" },
    {
      name: "Aquel Perfume (Agua Florida)",
      slug: "caceres-aquel-perfume-agua-florida",
      image: "caceres-aquel-perfume-agua-florida.jpg",
    },
    {
      name: "Asado Con Cuero",
      slug: "caceres-asado-con-cuero",
      image: "caceres-asado-con-cuero.jpg",
    },
    {
      name: "Asi Me Gusta",
      slug: "caceres-asi-me-gusta",
      image: "caceres-asi-me-gusta.jpg",
    },
    {
      name: "Bs Charleston",
      slug: "caceres-bs-charleston",
      image: "caceres-bs-charleston.jpg",
    },
    {
      name: "Caminando",
      slug: "caceres-caminando",
      image: "caceres-caminando.jpg",
    },
    {
      name: "Centro Murga (Los Quitapenas)",
      slug: "caceres-centro-murga-los-quitapenas",
      image: "caceres-centro-murga-los-quitapenas.jpg",
    },
    {
      name: "Cuesta Arriba",
      slug: "caceres-cuesta-arriba",
      image: "caceres-cuesta-arriba.jpg",
    },
    {
      name: "Cumtango",
      slug: "caceres-cumtango",
      image: "caceres-cumtango.jpg",
    },
    { name: "Dilema", slug: "caceres-dilema", image: "caceres-dilema.jpg" },
    {
      name: "El Sur El Norte",
      slug: "caceres-el-sur-el-norte",
      image: "caceres-el-sur-el-norte.jpg",
    },
    {
      name: "El Tango",
      slug: "caceres-el-tango",
      image: "caceres-el-tango.jpg",
    },
    {
      name: "Intro (Los Reyes del movimiento)",
      slug: "caceres-intro-los-reyes-del-movimiento",
      image: "caceres-intro-los-reyes-del-movimiento.jpg",
    },
    {
      name: "La Casa De Los Fantasmas",
      slug: "caceres-la-casa-de-los-fantasmas",
      image: "caceres-la-casa-de-los-fantasmas.jpg",
    },
    {
      name: "La Retirada",
      slug: "caceres-la-retirada",
      image: "caceres-la-retirada.jpg",
    },
    {
      name: "Macumambé",
      slug: "caceres-macumambe",
      image: "caceres-macumambe.jpg",
    },
    { name: "Manuela", slug: "caceres-manuela", image: "caceres-manuela.jpg" },
    {
      name: "Miremos Al Mañana",
      slug: "caceres-miremos-al-manana",
      image: "caceres-miremos-al-manana.jpg",
    },
    {
      name: "Pachamama",
      slug: "caceres-pachamama",
      image: "caceres-pachamama.jpg",
    },
    {
      name: "Pantera Negra",
      slug: "caceres-pantera-negra",
      image: "caceres-pantera-negra.jpg",
    },
    {
      name: "Paso Acelerado",
      slug: "caceres-paso-acelerado",
      image: "caceres-paso-acelerado.jpg",
    },
    {
      name: "Resistencia",
      slug: "caceres-resistencia",
      image: "caceres-resistencia.jpg",
    },
    {
      name: "Suéltame Pasado",
      slug: "caceres-sueltame-pasado",
      image: "caceres-sueltame-pasado.jpg",
    },
    {
      name: "Tango Negro II (La Vuelta)",
      slug: "caceres-tango-negro-ii-la-vuelta",
      image: "caceres-tango-negro-ii-la-vuelta.jpg",
    },
  ],
  "Alien Alien": [
    {
      name: "A Lume Di Pallas (Club Edit)",
      slug: "alien-alien-a-lume-di-pallas-club-edit",
      image: "alien-alien-a-lume-di-pallas-club-edit.jpg",
    },
    {
      name: "Bella L'Estate",
      slug: "alien-alien-bella-l-estate",
      image: "alien-alien-bella-l-estate.jpg",
    },
    {
      name: "Bella L'Estate (Naduve Remix)",
      slug: "alien-alien-bella-l-estate-naduve-remix",
      image: "alien-alien-bella-l-estate-naduve-remix.jpg",
    },
    {
      name: "Black Guru",
      slug: "alien-alien-black-guru",
      image: "alien-alien-black-guru.jpg",
    },
    {
      name: "Black Guru (Horse Meat Disco Remix)",
      slug: "alien-alien-black-guru-horse-meat-disco-remix",
      image: "alien-alien-black-guru-horse-meat-disco-remix.jpg",
    },
    {
      name: "Energia",
      slug: "alien-alien-energia",
      image: "alien-alien-energia.jpg",
    },
    {
      name: "Humana (GMPOP Remix Edit)",
      slug: "alien-alien-humana-gmpop-remix-edit",
      image: "alien-alien-humana-gmpop-remix-edit.jpg",
    },
    {
      name: "Humana (GMPOP Remix)",
      slug: "alien-alien-humana-gmpop-remix",
      image: "alien-alien-humana-gmpop-remix.jpg",
    },
    {
      name: "Let's pretend",
      slug: "alien-alien-let-s-pretend",
      image: "alien-alien-let-s-pretend.jpg",
    },
    {
      name: "Miseria Miseria",
      slug: "alien-alien-miseria-miseria",
      image: "alien-alien-miseria-miseria.jpg",
    },
    {
      name: "Monday",
      slug: "alien-alien-monday",
      image: "alien-alien-monday.jpg",
    },
    {
      name: "Myoosic",
      slug: "alien-alien-myoosic",
      image: "alien-alien-myoosic.jpg",
    },
    {
      name: "Nebula",
      slug: "alien-alien-nebula",
      image: "alien-alien-nebula.jpg",
    },
    {
      name: "Perfidia",
      slug: "alien-alien-perfidia",
      image: "alien-alien-perfidia.jpg",
    },
    {
      name: "Perfidia (Mang Lanzetta Remix)",
      slug: "alien-alien-perfidia-mang-lanzetta-remix",
      image: "alien-alien-perfidia-mang-lanzetta-remix.jpg",
    },
    {
      name: "Roygbiv",
      slug: "alien-alien-roygbiv",
      image: "alien-alien-roygbiv.jpg",
    },
    {
      name: "Sambaca (Heels Of Love)",
      slug: "alien-alien-sambaca-heels-of-love",
      image: "alien-alien-sambaca-heels-of-love.jpg",
    },
    {
      name: "The Nights",
      slug: "alien-alien-the-nights",
      image: "alien-alien-the-nights.jpg",
    },
    {
      name: "Ueberschalle and Tremor",
      slug: "alien-alien-ueberschalle-and-tremor",
      image: "alien-alien-ueberschalle-and-tremor.jpg",
    },
  ],
  Idaho: [
    {
      name: "A Million Reasons",
      slug: "idaho-a-million-reasons",
      image: "idaho-a-million-reasons.jpg",
    },
    { name: "Flames", slug: "idaho-flames", image: "idaho-flames.jpg" },
    { name: "Impaler", slug: "idaho-impaler", image: "idaho-impaler.jpg" },
    { name: "Reminder", slug: "idaho-reminder", image: "idaho-reminder.jpg" },
    {
      name: "Someone To Relate To",
      slug: "idaho-someone-to-relate-to",
      image: "idaho-someone-to-relate-to.jpg",
    },
    {
      name: "Structure",
      slug: "idaho-structure",
      image: "idaho-structure.jpg",
    },
    {
      name: "The Happiest Girl",
      slug: "idaho-the-happiest-girl",
      image: "idaho-the-happiest-girl.jpg",
    },
    {
      name: "The Serpent And The Shadow",
      slug: "idaho-the-serpent-and-the-shadow",
      image: "idaho-the-serpent-and-the-shadow.jpg",
    },
    {
      name: "The Setting Sun",
      slug: "idaho-the-setting-sun",
      image: "idaho-the-setting-sun.jpg",
    },
    {
      name: "The Space Between",
      slug: "idaho-the-space-between",
      image: "idaho-the-space-between.jpg",
    },
    {
      name: "Up The Hill",
      slug: "idaho-up-the-hill",
      image: "idaho-up-the-hill.jpg",
    },
    {
      name: "Weigh It Down",
      slug: "idaho-weigh-it-down",
      image: "idaho-weigh-it-down.jpg",
    },
    {
      name: "What Was That",
      slug: "idaho-what-was-that",
      image: "idaho-what-was-that.jpg",
    },
    {
      name: "You Were A Dick",
      slug: "idaho-you-were-a-dick",
      image: "idaho-you-were-a-dick.jpg",
    },
  ],
  "I Am Dive": [
    {
      name: "A New Heart To Break",
      slug: "i-am-dive-a-new-heart-to-break",
      image: "i-am-dive-a-new-heart-to-break.jpg",
    },
    {
      name: "Backwards",
      slug: "i-am-dive-backwards",
      image: "i-am-dive-backwards.jpg",
    },
    {
      name: "Days Become Ages",
      slug: "i-am-dive-days-become-ages",
      image: "i-am-dive-days-become-ages.jpg",
    },
    {
      name: "Departure",
      slug: "i-am-dive-departure",
      image: "i-am-dive-departure.jpg",
    },
    { name: "Dixie", slug: "i-am-dive-dixie", image: "i-am-dive-dixie.jpg" },
    {
      name: "Dixie (Dag Rosenqvist Remix)",
      slug: "i-am-dive-dixie-dag-rosenqvist-remix",
      image: "i-am-dive-dixie-dag-rosenqvist-remix.jpg",
    },
    {
      name: "Early Winter",
      slug: "i-am-dive-early-winter",
      image: "i-am-dive-early-winter.jpg",
    },
    {
      name: "Falling",
      slug: "i-am-dive-falling",
      image: "i-am-dive-falling.jpg",
    },
    {
      name: "Ghostwoods (Balago Remix)",
      slug: "i-am-dive-ghostwoods-balago-remix",
      image: "i-am-dive-ghostwoods-balago-remix.jpg",
    },
    { name: "Hands", slug: "i-am-dive-hands", image: "i-am-dive-hands.jpg" },
    {
      name: "Icy (The Suicide Of Western Culture Remix)",
      slug: "i-am-dive-icy-the-suicide-of-western-culture-remix",
      image: "i-am-dive-icy-the-suicide-of-western-culture-remix.jpg",
    },
    {
      name: "Mount Eerv",
      slug: "i-am-dive-mount-eerv",
      image: "i-am-dive-mount-eerv.jpg",
    },
    {
      name: "Mount Eerv (Asonat Remix)",
      slug: "i-am-dive-mount-eerv-asonat-remix",
      image: "i-am-dive-mount-eerv-asonat-remix.jpg",
    },
    {
      name: "Norman Oklahoma",
      slug: "i-am-dive-norman-oklahoma",
      image: "i-am-dive-norman-oklahoma.jpg",
    },
    {
      name: "Summer Camp (David Cordero remix)",
      slug: "i-am-dive-summer-camp-david-cordero-remix",
      image: "i-am-dive-summer-camp-david-cordero-remix.jpg",
    },
    {
      name: "The Cliff (Miaoux Miaux Remix)",
      slug: "i-am-dive-the-cliff-miaoux-miaux-remix",
      image: "i-am-dive-the-cliff-miaoux-miaux-remix.jpg",
    },
    {
      name: "The Lower You Fall",
      slug: "i-am-dive-the-lower-you-fall",
      image: "i-am-dive-the-lower-you-fall.jpg",
    },
    {
      name: "This Is Where The Rising Sun Dies (Superalgebra Remix)",
      slug: "i-am-dive-this-is-where-the-rising-sun-dies-superalgebra-remix",
      image:
        "i-am-dive-this-is-where-the-rising-sun-dies-superalgebra-remix.jpg",
    },
    { name: "Times", slug: "i-am-dive-times", image: "i-am-dive-times.jpg" },
    {
      name: "Transfixed",
      slug: "i-am-dive-transfixed",
      image: "i-am-dive-transfixed.jpg",
    },
    {
      name: "Winter And Spring",
      slug: "i-am-dive-winter-and-spring",
      image: "i-am-dive-winter-and-spring.jpg",
    },
    {
      name: "Winter And Spring (Maps and Diagrams Remix)",
      slug: "i-am-dive-winter-and-spring-maps-and-diagrams-remix",
      image: "i-am-dive-winter-and-spring-maps-and-diagrams-remix.jpg",
    },
    { name: "Wolves", slug: "i-am-dive-wolves", image: "i-am-dive-wolves.jpg" },
  ],
  "Sonic Satellite": [
    {
      name: "A New Joy",
      slug: "sonic-satellite-a-new-joy",
      image: "sonic-satellite-a-new-joy.jpg",
    },
    {
      name: "Blue",
      slug: "sonic-satellite-blue",
      image: "sonic-satellite-blue.jpg",
    },
    {
      name: "Family",
      slug: "sonic-satellite-family",
      image: "sonic-satellite-family.jpg",
    },
    {
      name: "I Wish",
      slug: "sonic-satellite-i-wish",
      image: "sonic-satellite-i-wish.jpg",
    },
  ],
  "Real Fake Mc": [
    {
      name: "A Real Good Day",
      slug: "real-fake-mc-a-real-good-day",
      image: "real-fake-mc-a-real-good-day.jpg",
    },
    {
      name: "Alligator Alligator",
      slug: "real-fake-mc-alligator-alligator",
      image: "real-fake-mc-alligator-alligator.jpg",
    },
    {
      name: "Books In The Subway",
      slug: "real-fake-mc-books-in-the-subway",
      image: "real-fake-mc-books-in-the-subway.jpg",
    },
    {
      name: "Bye Bye Planet Earth",
      slug: "real-fake-mc-bye-bye-planet-earth",
      image: "real-fake-mc-bye-bye-planet-earth.jpg",
    },
    {
      name: "Children Of The Breaks",
      slug: "real-fake-mc-children-of-the-breaks",
      image: "real-fake-mc-children-of-the-breaks.jpg",
    },
    {
      name: "Freezin",
      slug: "real-fake-mc-freezin",
      image: "real-fake-mc-freezin.jpg",
    },
    {
      name: "Futur Funk Survisors",
      slug: "real-fake-mc-futur-funk-survisors",
      image: "real-fake-mc-futur-funk-survisors.jpg",
    },
    {
      name: "Spider Rat",
      slug: "real-fake-mc-spider-rat",
      image: "real-fake-mc-spider-rat.jpg",
    },
    {
      name: "You Will See",
      slug: "real-fake-mc-you-will-see",
      image: "real-fake-mc-you-will-see.jpg",
    },
  ],
  "Flotation Toy Warning": [
    {
      name: "A Season Underground",
      slug: "flotation-toy-warning-a-season-underground",
      image: "flotation-toy-warning-a-season-underground.jpg",
    },
    {
      name: "Controlling The Sea",
      slug: "flotation-toy-warning-controlling-the-sea",
      image: "flotation-toy-warning-controlling-the-sea.jpg",
    },
    {
      name: "Donald Pleasance",
      slug: "flotation-toy-warning-donald-pleasance",
      image: "flotation-toy-warning-donald-pleasance.jpg",
    },
    {
      name: "Driving Under The Influence Of Loneliness",
      slug: "flotation-toy-warning-driving-under-the-influence-of-loneliness",
      image:
        "flotation-toy-warning-driving-under-the-influence-of-loneliness.jpg",
    },
    {
      name:
        "Due To Adverse Weather Conditions, All Of My Heroes Have Surrendered",
      slug:
        "flotation-toy-warning-due-to-adverse-weather-conditions-all-of-my-heroes-have-surrendered",
      image:
        "flotation-toy-warning-due-to-adverse-weather-conditions-all-of-my-heroes-have-surrendered.jpg",
    },
    {
      name: "Even Fantastica",
      slug: "flotation-toy-warning-even-fantastica",
      image: "flotation-toy-warning-even-fantastica.jpg",
    },
    {
      name: "Everything That Is Difficult Will Come To An End",
      slug:
        "flotation-toy-warning-everything-that-is-difficult-will-come-to-an-end",
      image:
        "flotation-toy-warning-everything-that-is-difficult-will-come-to-an-end.jpg",
    },
    {
      name: "Fire Engine On Fire Part I",
      slug: "flotation-toy-warning-fire-engine-on-fire-part-i",
      image: "flotation-toy-warning-fire-engine-on-fire-part-i.jpg",
    },
    {
      name: "Fire Engine On Fire Part II",
      slug: "flotation-toy-warning-fire-engine-on-fire-part-ii",
      image: "flotation-toy-warning-fire-engine-on-fire-part-ii.jpg",
    },
    {
      name: "Happy 13",
      slug: "flotation-toy-warning-happy-13",
      image: "flotation-toy-warning-happy-13.jpg",
    },
    {
      name: "How The Plains Left Me Flat",
      slug: "flotation-toy-warning-how-the-plains-left-me-flat",
      image: "flotation-toy-warning-how-the-plains-left-me-flat.jpg",
    },
    {
      name: "I Quite Like It When He Sings",
      slug: "flotation-toy-warning-i-quite-like-it-when-he-sings",
      image: "flotation-toy-warning-i-quite-like-it-when-he-sings.jpg",
    },
    {
      name: "King Of Foxgloves",
      slug: "flotation-toy-warning-king-of-foxgloves",
      image: "flotation-toy-warning-king-of-foxgloves.jpg",
    },
    {
      name: "Losing Carolina, For Drusky",
      slug: "flotation-toy-warning-losing-carolina-for-drusky",
      image: "flotation-toy-warning-losing-carolina-for-drusky.jpg",
    },
    {
      name: "Made From Tiny Boxes",
      slug: "flotation-toy-warning-made-from-tiny-boxes",
      image: "flotation-toy-warning-made-from-tiny-boxes.jpg",
    },
    {
      name: "Popstar Researching Oblivion",
      slug: "flotation-toy-warning-popstar-researching-oblivion",
      image: "flotation-toy-warning-popstar-researching-oblivion.jpg",
    },
    {
      name: "The Moongoose Analogue",
      slug: "flotation-toy-warning-the-moongoose-analogue",
      image: "flotation-toy-warning-the-moongoose-analogue.jpg",
    },
    {
      name: "To Live For Longer Slides",
      slug: "flotation-toy-warning-to-live-for-longer-slides",
      image: "flotation-toy-warning-to-live-for-longer-slides.jpg",
    },
    {
      name: "When The Boat Comes Inside Your House",
      slug: "flotation-toy-warning-when-the-boat-comes-inside-your-house",
      image: "flotation-toy-warning-when-the-boat-comes-inside-your-house.jpg",
    },
  ],
  "Emily Jane White": [
    {
      name: "A Shot Rang Out (Instrumental)",
      slug: "emily-jane-white-a-shot-rang-out-instrumental",
      image: "emily-jane-white-a-shot-rang-out-instrumental.jpg",
    },
    {
      name: "Antechamber",
      slug: "emily-jane-white-antechamber",
      image: "emily-jane-white-antechamber.jpg",
    },
    {
      name: "Antechamber (Instrumental)",
      slug: "emily-jane-white-antechamber-instrumental",
      image: "emily-jane-white-antechamber-instrumental.jpg",
    },
    {
      name: "Behind The Glass",
      slug: "emily-jane-white-behind-the-glass",
      image: "emily-jane-white-behind-the-glass.jpg",
    },
    {
      name: "Behind The Glass (Instrumental)",
      slug: "emily-jane-white-behind-the-glass-instrumental",
      image: "emily-jane-white-behind-the-glass-instrumental.jpg",
    },
    {
      name: "Black Silk (Instrumental)",
      slug: "emily-jane-white-black-silk-instrumental",
      image: "emily-jane-white-black-silk-instrumental.jpg",
    },
    {
      name: "Blue",
      slug: "emily-jane-white-blue",
      image: "emily-jane-white-blue.jpg",
    },
    {
      name: "Broken Words (Instrumental)",
      slug: "emily-jane-white-broken-words-instrumental",
      image: "emily-jane-white-broken-words-instrumental.jpg",
    },
    {
      name: "Clipped Wings (Instrumental)",
      slug: "emily-jane-white-clipped-wings-instrumental",
      image: "emily-jane-white-clipped-wings-instrumental.jpg",
    },
    {
      name: "Dagger",
      slug: "emily-jane-white-dagger",
      image: "emily-jane-white-dagger.jpg",
    },
    {
      name: "Dew",
      slug: "emily-jane-white-dew",
      image: "emily-jane-white-dew.jpg",
    },
    {
      name: "Dew (Instrumental)",
      slug: "emily-jane-white-dew-instrumental",
      image: "emily-jane-white-dew-instrumental.jpg",
    },
    {
      name: "Drowned",
      slug: "emily-jane-white-drowned",
      image: "emily-jane-white-drowned.jpg",
    },
    {
      name: "Drowned (Instrumental)",
      slug: "emily-jane-white-drowned-instrumental",
      image: "emily-jane-white-drowned-instrumental.jpg",
    },
    {
      name: "Entity",
      slug: "emily-jane-white-entity",
      image: "emily-jane-white-entity.jpg",
    },
    {
      name: "Entity (Instrumental)",
      slug: "emily-jane-white-entity-instrumental",
      image: "emily-jane-white-entity-instrumental.jpg",
    },
    {
      name: "Frozen Garden",
      slug: "emily-jane-white-frozen-garden",
      image: "emily-jane-white-frozen-garden.jpg",
    },
    {
      name: "Frozen Garden (Instrumental)",
      slug: "emily-jane-white-frozen-garden-instrumental",
      image: "emily-jane-white-frozen-garden-instrumental.jpg",
    },
    {
      name: "Frozen Heart (Instrumental)",
      slug: "emily-jane-white-frozen-heart-instrumental",
      image: "emily-jane-white-frozen-heart-instrumental.jpg",
    },
    {
      name: "Ghost of a Horse (Instrumental)",
      slug: "emily-jane-white-ghost-of-a-horse-instrumental",
      image: "emily-jane-white-ghost-of-a-horse-instrumental.jpg",
    },
    {
      name: "Hands",
      slug: "emily-jane-white-hands",
      image: "emily-jane-white-hands.jpg",
    },
    {
      name: "Hands (Instrumental)",
      slug: "emily-jane-white-hands-instrumental",
      image: "emily-jane-white-hands-instrumental.jpg",
    },
    {
      name: "I Lay To Rest California (Instrumental)",
      slug: "emily-jane-white-i-lay-to-rest-california-instrumental",
      image: "emily-jane-white-i-lay-to-rest-california-instrumental.jpg",
    },
    {
      name: "Infernal",
      slug: "emily-jane-white-infernal",
      image: "emily-jane-white-infernal.jpg",
    },
    {
      name: "Infernal (Instrumental)",
      slug: "emily-jane-white-infernal-instrumental",
      image: "emily-jane-white-infernal-instrumental.jpg",
    },
    {
      name: "Light",
      slug: "emily-jane-white-light",
      image: "emily-jane-white-light.jpg",
    },
    {
      name: "Light (Instrumental)",
      slug: "emily-jane-white-light-instrumental",
      image: "emily-jane-white-light-instrumental.jpg",
    },
    {
      name: "Liza (Instrumental)",
      slug: "emily-jane-white-liza-instrumental",
      image: "emily-jane-white-liza-instrumental.jpg",
    },
    {
      name: "Metamorphosis",
      slug: "emily-jane-white-metamorphosis",
      image: "emily-jane-white-metamorphosis.jpg",
    },
    {
      name: "Metamorphosis (Instrumental)",
      slug: "emily-jane-white-metamorphosis-instrumental",
      image: "emily-jane-white-metamorphosis-instrumental.jpg",
    },
    {
      name: "Moulding",
      slug: "emily-jane-white-moulding",
      image: "emily-jane-white-moulding.jpg",
    },
    {
      name: "Moulding (Instrumental)",
      slug: "emily-jane-white-moulding-instrumental",
      image: "emily-jane-white-moulding-instrumental.jpg",
    },
    {
      name: "Never Dead (Instrumental)",
      slug: "emily-jane-white-never-dead-instrumental",
      image: "emily-jane-white-never-dead-instrumental.jpg",
    },
    {
      name: "Nightmare on Repeat (Instrumental)",
      slug: "emily-jane-white-nightmare-on-repeat-instrumental",
      image: "emily-jane-white-nightmare-on-repeat-instrumental.jpg",
    },
    {
      name: "Nightmares On Repeat",
      slug: "emily-jane-white-nightmares-on-repeat",
      image: "emily-jane-white-nightmares-on-repeat.jpg",
    },
    {
      name: "Oh Katherine (Instrumental)",
      slug: "emily-jane-white-oh-katherine-instrumental",
      image: "emily-jane-white-oh-katherine-instrumental.jpg",
    },
    {
      name: "Pallid Eyes",
      slug: "emily-jane-white-pallid-eyes",
      image: "emily-jane-white-pallid-eyes.jpg",
    },
    {
      name: "Pallid Eyes (Instrumental)",
      slug: "emily-jane-white-pallid-eyes-instrumental",
      image: "emily-jane-white-pallid-eyes-instrumental.jpg",
    },
    {
      name: "Red Dress (Instrumental)",
      slug: "emily-jane-white-red-dress-instrumental",
      image: "emily-jane-white-red-dress-instrumental.jpg",
    },
    {
      name: "Red Serpent (Instrumental)",
      slug: "emily-jane-white-red-serpent-instrumental",
      image: "emily-jane-white-red-serpent-instrumental.jpg",
    },
    {
      name: "Requiem Waltz (Instrumental)",
      slug: "emily-jane-white-requiem-waltz-instrumental",
      image: "emily-jane-white-requiem-waltz-instrumental.jpg",
    },
    {
      name: "Rupturing",
      slug: "emily-jane-white-rupturing",
      image: "emily-jane-white-rupturing.jpg",
    },
    {
      name: "Rupturing (Instrumental)",
      slug: "emily-jane-white-rupturing-instrumental",
      image: "emily-jane-white-rupturing-instrumental.jpg",
    },
    {
      name: "Shroud",
      slug: "emily-jane-white-shroud",
      image: "emily-jane-white-shroud.jpg",
    },
    {
      name: "Shroud (Instrumental)",
      slug: "emily-jane-white-shroud-instrumental",
      image: "emily-jane-white-shroud-instrumental.jpg",
    },
    {
      name: "Stairs (Instrumental)",
      slug: "emily-jane-white-stairs-instrumental",
      image: "emily-jane-white-stairs-instrumental.jpg",
    },
    {
      name: "Surrender",
      slug: "emily-jane-white-surrender",
      image: "emily-jane-white-surrender.jpg",
    },
    {
      name: "Surrender (Instrumental)",
      slug: "emily-jane-white-surrender-instrumental",
      image: "emily-jane-white-surrender-instrumental.jpg",
    },
    {
      name: "The Baby (Instrumental)",
      slug: "emily-jane-white-the-baby-instrumental",
      image: "emily-jane-white-the-baby-instrumental.jpg",
    },
    {
      name: "The Black Dove",
      slug: "emily-jane-white-the-black-dove",
      image: "emily-jane-white-the-black-dove.jpg",
    },
    {
      name: "The Black Dove (Instrumental)",
      slug: "emily-jane-white-the-black-dove-instrumental",
      image: "emily-jane-white-the-black-dove-instrumental.jpg",
    },
    {
      name: "The Black Oak (Instrumental)",
      slug: "emily-jane-white-the-black-oak-instrumental",
      image: "emily-jane-white-the-black-oak-instrumental.jpg",
    },
    {
      name: "The Cliff (Instrumental)",
      slug: "emily-jane-white-the-cliff-instrumental",
      image: "emily-jane-white-the-cliff-instrumental.jpg",
    },
    {
      name: "The Country Life (Instrumental)",
      slug: "emily-jane-white-the-country-life-instrumental",
      image: "emily-jane-white-the-country-life-instrumental.jpg",
    },
    {
      name: "The Gates (Instrumental)",
      slug: "emily-jane-white-the-gates-instrumental",
      image: "emily-jane-white-the-gates-instrumental.jpg",
    },
    {
      name: "The Gates At The End",
      slug: "emily-jane-white-the-gates-at-the-end",
      image: "emily-jane-white-the-gates-at-the-end.jpg",
    },
    {
      name: "The Law (Instrumental)",
      slug: "emily-jane-white-the-law-instrumental",
      image: "emily-jane-white-the-law-instrumental.jpg",
    },
    {
      name: "The Ledge",
      slug: "emily-jane-white-the-ledge",
      image: "emily-jane-white-the-ledge.jpg",
    },
    {
      name: "The Ledge (Instrumental)",
      slug: "emily-jane-white-the-ledge-instrumental",
      image: "emily-jane-white-the-ledge-instrumental.jpg",
    },
    {
      name: "The Ravens",
      slug: "emily-jane-white-the-ravens",
      image: "emily-jane-white-the-ravens.jpg",
    },
    {
      name: "The Ravens (Instrumental)",
      slug: "emily-jane-white-the-ravens-instrumental",
      image: "emily-jane-white-the-ravens-instrumental.jpg",
    },
    {
      name: "Victoria America",
      slug: "emily-jane-white-victoria-america",
      image: "emily-jane-white-victoria-america.jpg",
    },
    {
      name: "Victorian America (Instrumental)",
      slug: "emily-jane-white-victorian-america-instrumental",
      image: "emily-jane-white-victorian-america-instrumental.jpg",
    },
    {
      name: "Washed Away",
      slug: "emily-jane-white-washed-away",
      image: "emily-jane-white-washed-away.jpg",
    },
    {
      name: "Washed Away (Instrumental)",
      slug: "emily-jane-white-washed-away-instrumental",
      image: "emily-jane-white-washed-away-instrumental.jpg",
    },
    {
      name: "Womankind",
      slug: "emily-jane-white-womankind",
      image: "emily-jane-white-womankind.jpg",
    },
    {
      name: "Womankind (Instrumental)",
      slug: "emily-jane-white-womankind-instrumental",
      image: "emily-jane-white-womankind-instrumental.jpg",
    },
  ],
  Thousand: [
    {
      name: "A Swallow",
      slug: "thousand-a-swallow",
      image: "thousand-a-swallow.jpg",
    },
    { name: "Eden", slug: "thousand-eden", image: "thousand-eden.jpg" },
    {
      name: "Regret n Remorse",
      slug: "thousand-regret-n-remorse",
      image: "thousand-regret-n-remorse.jpg",
    },
    {
      name: "Song Of Abdiction",
      slug: "thousand-song-of-abdiction",
      image: "thousand-song-of-abdiction.jpg",
    },
    {
      name: "The Break Of Day",
      slug: "thousand-the-break-of-day",
      image: "thousand-the-break-of-day.jpg",
    },
    {
      name: "The Dark",
      slug: "thousand-the-dark",
      image: "thousand-the-dark.jpg",
    },
    {
      name: "The Flying Pyramid",
      slug: "thousand-the-flying-pyramid",
      image: "thousand-the-flying-pyramid.jpg",
    },
    {
      name: "The Kill",
      slug: "thousand-the-kill",
      image: "thousand-the-kill.jpg",
    },
    {
      name: "The Sea The Mountain",
      slug: "thousand-the-sea-the-mountain",
      image: "thousand-the-sea-the-mountain.jpg",
    },
    {
      name: "The Wave",
      slug: "thousand-the-wave",
      image: "thousand-the-wave.jpg",
    },
    {
      name: "Where The Bluebird Flies",
      slug: "thousand-where-the-bluebird-flies",
      image: "thousand-where-the-bluebird-flies.jpg",
    },
  ],
  Ele: [
    {
      name: "A Thousand Miles Away From You",
      slug: "ele-a-thousand-miles-away-from-you",
      image: "ele-a-thousand-miles-away-from-you.jpg",
    },
    {
      name: "Am I Wasting My Time",
      slug: "ele-am-i-wasting-my-time",
      image: "ele-am-i-wasting-my-time.jpg",
    },
    {
      name: "Another Colour",
      slug: "ele-another-colour",
      image: "ele-another-colour.jpg",
    },
    {
      name: "Calling You",
      slug: "ele-calling-you",
      image: "ele-calling-you.jpg",
    },
    {
      name: "Daniel And Charlie",
      slug: "ele-daniel-and-charlie",
      image: "ele-daniel-and-charlie.jpg",
    },
    {
      name: "Go And Never Look Back",
      slug: "ele-go-and-never-look-back",
      image: "ele-go-and-never-look-back.jpg",
    },
    {
      name: "Love Me My Love,Above All",
      slug: "ele-love-me-my-love-above-all",
      image: "ele-love-me-my-love-above-all.jpg",
    },
    { name: "Positivity", slug: "ele-positivity", image: "ele-positivity.jpg" },
    { name: "Shadows", slug: "ele-shadows", image: "ele-shadows.jpg" },
    {
      name: "Summer Rain",
      slug: "ele-summer-rain",
      image: "ele-summer-rain.jpg",
    },
    {
      name: "We'll Keep Your Memories",
      slug: "ele-we-ll-keep-your-memories",
      image: "ele-we-ll-keep-your-memories.jpg",
    },
  ],
  "Middle Sky Boom": [
    {
      name: "A Tricky Time",
      slug: "middle-sky-boom-a-tricky-time",
      image: "middle-sky-boom-a-tricky-time.jpg",
    },
  ],
  Cherry: [
    { name: "A Veces", slug: "cherry-a-veces", image: "cherry-a-veces.jpg" },
    { name: "Area 51", slug: "cherry-area-51", image: "cherry-area-51.jpg" },
    {
      name: "Cabalgaré",
      slug: "cherry-cabalgare",
      image: "cherry-cabalgare.jpg",
    },
    {
      name: "Frio y Calor",
      slug: "cherry-frio-y-calor",
      image: "cherry-frio-y-calor.jpg",
    },
    {
      name: "La Dosis Perfecta",
      slug: "cherry-la-dosis-perfecta",
      image: "cherry-la-dosis-perfecta.jpg",
    },
    {
      name: "Los Misterios Del Universo",
      slug: "cherry-los-misterios-del-universo",
      image: "cherry-los-misterios-del-universo.jpg",
    },
    {
      name: "Mariposas De Lunares",
      slug: "cherry-mariposas-de-lunares",
      image: "cherry-mariposas-de-lunares.jpg",
    },
    {
      name: "Memoria Ram",
      slug: "cherry-memoria-ram",
      image: "cherry-memoria-ram.jpg",
    },
    {
      name: "Menestra de Verduras",
      slug: "cherry-menestra-de-verduras",
      image: "cherry-menestra-de-verduras.jpg",
    },
    {
      name: "Mutaciones En El Rio",
      slug: "cherry-mutaciones-en-el-rio",
      image: "cherry-mutaciones-en-el-rio.jpg",
    },
    {
      name: "No Volveras",
      slug: "cherry-no-volveras",
      image: "cherry-no-volveras.jpg",
    },
    {
      name: "Sin Piedad",
      slug: "cherry-sin-piedad",
      image: "cherry-sin-piedad.jpg",
    },
    {
      name: "Tiempo De Tempestad",
      slug: "cherry-tiempo-de-tempestad",
      image: "cherry-tiempo-de-tempestad.jpg",
    },
  ],
  "The Red Goes Black": [
    {
      name: "A Wave Will Rise",
      slug: "the-red-goes-black-a-wave-will-rise",
      image: "the-red-goes-black-a-wave-will-rise.jpg",
    },
    {
      name: "All I Want",
      slug: "the-red-goes-black-all-i-want",
      image: "the-red-goes-black-all-i-want.jpg",
    },
    {
      name: "Blu Bags Of Shame",
      slug: "the-red-goes-black-blu-bags-of-shame",
      image: "the-red-goes-black-blu-bags-of-shame.jpg",
    },
    {
      name: "Broken Man Blues",
      slug: "the-red-goes-black-broken-man-blues",
      image: "the-red-goes-black-broken-man-blues.jpg",
    },
    {
      name: "Fear Of Change",
      slug: "the-red-goes-black-fear-of-change",
      image: "the-red-goes-black-fear-of-change.jpg",
    },
    {
      name: "Fire",
      slug: "the-red-goes-black-fire",
      image: "the-red-goes-black-fire.jpg",
    },
    {
      name: "Good Things",
      slug: "the-red-goes-black-good-things",
      image: "the-red-goes-black-good-things.jpg",
    },
    {
      name: "Hold Back Time",
      slug: "the-red-goes-black-hold-back-time",
      image: "the-red-goes-black-hold-back-time.jpg",
    },
    {
      name: "I Quit You Dead City",
      slug: "the-red-goes-black-i-quit-you-dead-city",
      image: "the-red-goes-black-i-quit-you-dead-city.jpg",
    },
    {
      name: "I.T.N.O.G. feat. Lisa Kekaula",
      slug: "the-red-goes-black-i-t-n-o-g-feat-lisa-kekaula",
      image: "the-red-goes-black-i-t-n-o-g-feat-lisa-kekaula.jpg",
    },
    {
      name: "If One Day",
      slug: "the-red-goes-black-if-one-day",
      image: "the-red-goes-black-if-one-day.jpg",
    },
    {
      name: "It's All Gone",
      slug: "the-red-goes-black-it-s-all-gone",
      image: "the-red-goes-black-it-s-all-gone.jpg",
    },
    {
      name: "Life feat. Lisa Kekaula",
      slug: "the-red-goes-black-life-feat-lisa-kekaula",
      image: "the-red-goes-black-life-feat-lisa-kekaula.jpg",
    },
    {
      name: "Missing Light",
      slug: "the-red-goes-black-missing-light",
      image: "the-red-goes-black-missing-light.jpg",
    },
    {
      name: "Mr Something",
      slug: "the-red-goes-black-mr-something",
      image: "the-red-goes-black-mr-something.jpg",
    },
    {
      name: "Nobody But Me",
      slug: "the-red-goes-black-nobody-but-me",
      image: "the-red-goes-black-nobody-but-me.jpg",
    },
    {
      name: "Shadow Dancer",
      slug: "the-red-goes-black-shadow-dancer",
      image: "the-red-goes-black-shadow-dancer.jpg",
    },
    {
      name: "Sweet Melancholia",
      slug: "the-red-goes-black-sweet-melancholia",
      image: "the-red-goes-black-sweet-melancholia.jpg",
    },
    {
      name: "The Barren Hill",
      slug: "the-red-goes-black-the-barren-hill",
      image: "the-red-goes-black-the-barren-hill.jpg",
    },
    {
      name: "The Walker",
      slug: "the-red-goes-black-the-walker",
      image: "the-red-goes-black-the-walker.jpg",
    },
    {
      name: "The Warmth Of Dawn",
      slug: "the-red-goes-black-the-warmth-of-dawn",
      image: "the-red-goes-black-the-warmth-of-dawn.jpg",
    },
    {
      name: "World In A Bottle",
      slug: "the-red-goes-black-world-in-a-bottle",
      image: "the-red-goes-black-world-in-a-bottle.jpg",
    },
    {
      name: "Wrong Way Driver",
      slug: "the-red-goes-black-wrong-way-driver",
      image: "the-red-goes-black-wrong-way-driver.jpg",
    },
  ],
  "In Fields": [
    {
      name: "A Year Alone",
      slug: "in-fields-a-year-alone",
      image: "in-fields-a-year-alone.jpg",
    },
    {
      name: "Beginnings (Dub Mix)",
      slug: "in-fields-beginnings-dub-mix",
      image: "in-fields-beginnings-dub-mix.jpg",
    },
    {
      name: "Beginnings (Get A Room! Remix)",
      slug: "in-fields-beginnings-get-a-room-remix",
      image: "in-fields-beginnings-get-a-room-remix.jpg",
    },
    {
      name: "Beginnings (Vocal Mix)",
      slug: "in-fields-beginnings-vocal-mix",
      image: "in-fields-beginnings-vocal-mix.jpg",
    },
    {
      name: "Communicate",
      slug: "in-fields-communicate",
      image: "in-fields-communicate.jpg",
    },
    {
      name: "Ghostnights",
      slug: "in-fields-ghostnights",
      image: "in-fields-ghostnights.jpg",
    },
    { name: "Hands", slug: "in-fields-hands", image: "in-fields-hands.jpg" },
    { name: "JJR", slug: "in-fields-jjr", image: "in-fields-jjr.jpg" },
    { name: "Joy", slug: "in-fields-joy", image: "in-fields-joy.jpg" },
    {
      name: "No Romance",
      slug: "in-fields-no-romance",
      image: "in-fields-no-romance.jpg",
    },
    {
      name: "On Time",
      slug: "in-fields-on-time",
      image: "in-fields-on-time.jpg",
    },
    {
      name: "On Time (Brioski Remix)",
      slug: "in-fields-on-time-brioski-remix",
      image: "in-fields-on-time-brioski-remix.jpg",
    },
    {
      name: "On Time (FKCLUB Remix)",
      slug: "in-fields-on-time-fkclub-remix",
      image: "in-fields-on-time-fkclub-remix.jpg",
    },
    {
      name: "Rehearsal One",
      slug: "in-fields-rehearsal-one",
      image: "in-fields-rehearsal-one.jpg",
    },
    {
      name: "Rough Bloom",
      slug: "in-fields-rough-bloom",
      image: "in-fields-rough-bloom.jpg",
    },
    {
      name: "Sing It",
      slug: "in-fields-sing-it",
      image: "in-fields-sing-it.jpg",
    },
    {
      name: "South Quay",
      slug: "in-fields-south-quay",
      image: "in-fields-south-quay.jpg",
    },
    {
      name: "Stay Safe",
      slug: "in-fields-stay-safe",
      image: "in-fields-stay-safe.jpg",
    },
    {
      name: "Suit Yourself",
      slug: "in-fields-suit-yourself",
      image: "in-fields-suit-yourself.jpg",
    },
    { name: "Teeth", slug: "in-fields-teeth", image: "in-fields-teeth.jpg" },
    {
      name: "The View",
      slug: "in-fields-the-view",
      image: "in-fields-the-view.jpg",
    },
    {
      name: "This Time I&II",
      slug: "in-fields-this-time-i-and-ii",
      image: "in-fields-this-time-i-and-ii.jpg",
    },
    {
      name: "This Time Part II",
      slug: "in-fields-this-time-part-ii",
      image: "in-fields-this-time-part-ii.jpg",
    },
  ],
  Stiletti: [
    { name: "AB OVO", slug: "stiletti-ab-ovo", image: "stiletti-ab-ovo.jpg" },
    {
      name: "Ground Water",
      slug: "stiletti-ground-water",
      image: "stiletti-ground-water.jpg",
    },
    {
      name: "Horizon",
      slug: "stiletti-horizon",
      image: "stiletti-horizon.jpg",
    },
    {
      name: "Post Mortem",
      slug: "stiletti-post-mortem",
      image: "stiletti-post-mortem.jpg",
    },
    {
      name: "Prokrusteen Vuode",
      slug: "stiletti-prokrusteen-vuode",
      image: "stiletti-prokrusteen-vuode.jpg",
    },
    { name: "Rauha", slug: "stiletti-rauha", image: "stiletti-rauha.jpg" },
    {
      name: "Suuri Hiljainen Kävelijä",
      slug: "stiletti-suuri-hiljainen-kaevelijae",
      image: "stiletti-suuri-hiljainen-kaevelijae.jpg",
    },
  ],
  Killason: [
    { name: "ABTM", slug: "killason-abtm", image: "killason-abtm.jpg" },
    {
      name: "Black Crook",
      slug: "killason-black-crook",
      image: "killason-black-crook.jpg",
    },
    { name: "Blow", slug: "killason-blow", image: "killason-blow.jpg" },
    {
      name: "Deadpool",
      slug: "killason-deadpool",
      image: "killason-deadpool.jpg",
    },
    {
      name: "Deadpool (Instrumental)",
      slug: "killason-deadpool-instrumental",
      image: "killason-deadpool-instrumental.jpg",
    },
    { name: "Doubts", slug: "killason-doubts", image: "killason-doubts.jpg" },
    {
      name: "Doubts (Instrumental)",
      slug: "killason-doubts-instrumental",
      image: "killason-doubts-instrumental.jpg",
    },
    { name: "Energi", slug: "killason-energi", image: "killason-energi.jpg" },
    {
      name: "Energi (Instrumental)",
      slug: "killason-energi-instrumental",
      image: "killason-energi-instrumental.jpg",
    },
    { name: "Fuego", slug: "killason-fuego", image: "killason-fuego.jpg" },
    {
      name: "Fuego (Instrumental)",
      slug: "killason-fuego-instrumental",
      image: "killason-fuego-instrumental.jpg",
    },
    {
      name: "Fun (Instrumental)",
      slug: "killason-fun-instrumental",
      image: "killason-fun-instrumental.jpg",
    },
    {
      name: "Fun featuring She Real",
      slug: "killason-fun-featuring-she-real",
      image: "killason-fun-featuring-she-real.jpg",
    },
    { name: "Ghost", slug: "killason-ghost", image: "killason-ghost.jpg" },
    {
      name: "Hoddest In Town",
      slug: "killason-hoddest-in-town",
      image: "killason-hoddest-in-town.jpg",
    },
    {
      name: "Illumina",
      slug: "killason-illumina",
      image: "killason-illumina.jpg",
    },
    {
      name: "Live Life",
      slug: "killason-live-life",
      image: "killason-live-life.jpg",
    },
    {
      name: "Live Life (Instrumental)",
      slug: "killason-live-life-instrumental",
      image: "killason-live-life-instrumental.jpg",
    },
    {
      name: "M.N.M.N",
      slug: "killason-m-n-m-n",
      image: "killason-m-n-m-n.jpg",
    },
    { name: "Mean", slug: "killason-mean", image: "killason-mean.jpg" },
    {
      name: "Mean (Instrumental)",
      slug: "killason-mean-instrumental",
      image: "killason-mean-instrumental.jpg",
    },
    {
      name: "Moments",
      slug: "killason-moments",
      image: "killason-moments.jpg",
    },
    {
      name: "Moments (Instrumental)",
      slug: "killason-moments-instrumental",
      image: "killason-moments-instrumental.jpg",
    },
    {
      name: "New Plan",
      slug: "killason-new-plan",
      image: "killason-new-plan.jpg",
    },
    {
      name: "New Plan (Instrumental)",
      slug: "killason-new-plan-instrumental",
      image: "killason-new-plan-instrumental.jpg",
    },
    {
      name: "Number 41",
      slug: "killason-number-41",
      image: "killason-number-41.jpg",
    },
    {
      name: "Ready Or Not",
      slug: "killason-ready-or-not",
      image: "killason-ready-or-not.jpg",
    },
    {
      name: "Rollercoaster",
      slug: "killason-rollercoaster",
      image: "killason-rollercoaster.jpg",
    },
    {
      name: "Rollercoaster (Instrumental)",
      slug: "killason-rollercoaster-instrumental",
      image: "killason-rollercoaster-instrumental.jpg",
    },
    { name: "Shine", slug: "killason-shine", image: "killason-shine.jpg" },
    {
      name: "Stage Addikt",
      slug: "killason-stage-addikt",
      image: "killason-stage-addikt.jpg",
    },
    {
      name: "Strange World",
      slug: "killason-strange-world",
      image: "killason-strange-world.jpg",
    },
    {
      name: "The Mind's Eye",
      slug: "killason-the-mind-s-eye",
      image: "killason-the-mind-s-eye.jpg",
    },
    {
      name: "The Rize",
      slug: "killason-the-rize",
      image: "killason-the-rize.jpg",
    },
    { name: "UCWP", slug: "killason-ucwp", image: "killason-ucwp.jpg" },
    { name: "Wrong", slug: "killason-wrong", image: "killason-wrong.jpg" },
    { name: "Yonko", slug: "killason-yonko", image: "killason-yonko.jpg" },
    {
      name: "Yonko (Instrumental)",
      slug: "killason-yonko-instrumental",
      image: "killason-yonko-instrumental.jpg",
    },
    {
      name: "Young Prince",
      slug: "killason-young-prince",
      image: "killason-young-prince.jpg",
    },
  ],
  "Warner Case": [
    { name: "ATM", slug: "warner-case-atm", image: "warner-case-atm.jpg" },
    {
      name: "Walk With Me",
      slug: "warner-case-walk-with-me",
      image: "warner-case-walk-with-me.jpg",
    },
  ],
  Human: [
    { name: "Able", slug: "human-able", image: "human-able.jpg" },
    { name: "Clouds", slug: "human-clouds", image: "human-clouds.jpg" },
    {
      name: "Get On Top",
      slug: "human-get-on-top",
      image: "human-get-on-top.jpg",
    },
    { name: "Messages", slug: "human-messages", image: "human-messages.jpg" },
    {
      name: "Motocars and Lanes",
      slug: "human-motocars-and-lanes",
      image: "human-motocars-and-lanes.jpg",
    },
    {
      name: "Not Sleeping",
      slug: "human-not-sleeping",
      image: "human-not-sleeping.jpg",
    },
    {
      name: "Pantomime To Peices",
      slug: "human-pantomime-to-peices",
      image: "human-pantomime-to-peices.jpg",
    },
    {
      name: "Tricks In The Conversation",
      slug: "human-tricks-in-the-conversation",
      image: "human-tricks-in-the-conversation.jpg",
    },
    {
      name: "Your Grace",
      slug: "human-your-grace",
      image: "human-your-grace.jpg",
    },
  ],
  "Abou Diarra": [
    {
      name: "Aboubono",
      slug: "abou-diarra-aboubono",
      image: "abou-diarra-aboubono.jpg",
    },
    {
      name: "An Ka Belebele",
      slug: "abou-diarra-an-ka-belebele",
      image: "abou-diarra-an-ka-belebele.jpg",
    },
    {
      name: "Blablabla",
      slug: "abou-diarra-blablabla",
      image: "abou-diarra-blablabla.jpg",
    },
    { name: "Deli", slug: "abou-diarra-deli", image: "abou-diarra-deli.jpg" },
    {
      name: "Djarabi",
      slug: "abou-diarra-djarabi",
      image: "abou-diarra-djarabi.jpg",
    },
    {
      name: "Djoudjon",
      slug: "abou-diarra-djoudjon",
      image: "abou-diarra-djoudjon.jpg",
    },
    {
      name: "Démocratie",
      slug: "abou-diarra-democratie",
      image: "abou-diarra-democratie.jpg",
    },
    {
      name: "Foula",
      slug: "abou-diarra-foula",
      image: "abou-diarra-foula.jpg",
    },
    {
      name: "Ka Sikoum",
      slug: "abou-diarra-ka-sikoum",
      image: "abou-diarra-ka-sikoum.jpg",
    },
    {
      name: "Kambé Sogoma",
      slug: "abou-diarra-kambe-sogoma",
      image: "abou-diarra-kambe-sogoma.jpg",
    },
    { name: "Miri", slug: "abou-diarra-miri", image: "abou-diarra-miri.jpg" },
    {
      name: "N'dogoni",
      slug: "abou-diarra-n-dogoni",
      image: "abou-diarra-n-dogoni.jpg",
    },
    {
      name: "Noumou",
      slug: "abou-diarra-noumou",
      image: "abou-diarra-noumou.jpg",
    },
    {
      name: "Orokia Diakité",
      slug: "abou-diarra-orokia-diakite",
      image: "abou-diarra-orokia-diakite.jpg",
    },
    {
      name: "Sabou",
      slug: "abou-diarra-sabou",
      image: "abou-diarra-sabou.jpg",
    },
    {
      name: "Seguin",
      slug: "abou-diarra-seguin",
      image: "abou-diarra-seguin.jpg",
    },
    { name: "Toro", slug: "abou-diarra-toro", image: "abou-diarra-toro.jpg" },
    {
      name: "Vieux Kanté",
      slug: "abou-diarra-vieux-kante",
      image: "abou-diarra-vieux-kante.jpg",
    },
    {
      name: "Yoro Diallo",
      slug: "abou-diarra-yoro-diallo",
      image: "abou-diarra-yoro-diallo.jpg",
    },
  ],
  "Gatos Negros": [
    {
      name: "About You",
      slug: "gatos-negros-about-you",
      image: "gatos-negros-about-you.jpg",
    },
    {
      name: "Cayena",
      slug: "gatos-negros-cayena",
      image: "gatos-negros-cayena.jpg",
    },
    {
      name: "Chipotle (In Flagranti Remix)",
      slug: "gatos-negros-chipotle-in-flagranti-remix",
      image: "gatos-negros-chipotle-in-flagranti-remix.jpg",
    },
    {
      name: "El Lago",
      slug: "gatos-negros-el-lago",
      image: "gatos-negros-el-lago.jpg",
    },
    {
      name: "Habanero",
      slug: "gatos-negros-habanero",
      image: "gatos-negros-habanero.jpg",
    },
    {
      name: "Habanero (Squarewave Remix)",
      slug: "gatos-negros-habanero-squarewave-remix",
      image: "gatos-negros-habanero-squarewave-remix.jpg",
    },
    {
      name: "Overdrive",
      slug: "gatos-negros-overdrive",
      image: "gatos-negros-overdrive.jpg",
    },
    {
      name: "Overdrive (Jamie Paton Dub)",
      slug: "gatos-negros-overdrive-jamie-paton-dub",
      image: "gatos-negros-overdrive-jamie-paton-dub.jpg",
    },
    {
      name: "Overdrive (Jamie Paton Remix)",
      slug: "gatos-negros-overdrive-jamie-paton-remix",
      image: "gatos-negros-overdrive-jamie-paton-remix.jpg",
    },
    {
      name: "Rockets",
      slug: "gatos-negros-rockets",
      image: "gatos-negros-rockets.jpg",
    },
    {
      name: "Rockets (JackWasterFaster Remix)",
      slug: "gatos-negros-rockets-jackwasterfaster-remix",
      image: "gatos-negros-rockets-jackwasterfaster-remix.jpg",
    },
    {
      name: "Sriracha",
      slug: "gatos-negros-sriracha",
      image: "gatos-negros-sriracha.jpg",
    },
    {
      name: "Sriracha (Il Est Vilaine Remix)",
      slug: "gatos-negros-sriracha-il-est-vilaine-remix",
      image: "gatos-negros-sriracha-il-est-vilaine-remix.jpg",
    },
    {
      name: "Then I Realised",
      slug: "gatos-negros-then-i-realised",
      image: "gatos-negros-then-i-realised.jpg",
    },
    {
      name: "Then I Realised (Instrumental)",
      slug: "gatos-negros-then-i-realised-instrumental",
      image: "gatos-negros-then-i-realised-instrumental.jpg",
    },
    {
      name: "Vigilia",
      slug: "gatos-negros-vigilia",
      image: "gatos-negros-vigilia.jpg",
    },
  ],
  "Yan Wagner": [
    {
      name: "Abstinence",
      slug: "yan-wagner-abstinence",
      image: "yan-wagner-abstinence.jpg",
    },
    {
      name: "Changed",
      slug: "yan-wagner-changed",
      image: "yan-wagner-changed.jpg",
    },
    {
      name: "Elementary School",
      slug: "yan-wagner-elementary-school",
      image: "yan-wagner-elementary-school.jpg",
    },
    {
      name: "Follower",
      slug: "yan-wagner-follower",
      image: "yan-wagner-follower.jpg",
    },
    {
      name: "Forty Eight Hours",
      slug: "yan-wagner-forty-eight-hours",
      image: "yan-wagner-forty-eight-hours.jpg",
    },
    {
      name: "Le Spleen De L'Officier",
      slug: "yan-wagner-le-spleen-de-l-officier",
      image: "yan-wagner-le-spleen-de-l-officier.jpg",
    },
    {
      name: "On Her Knees",
      slug: "yan-wagner-on-her-knees",
      image: "yan-wagner-on-her-knees.jpg",
    },
    {
      name: "On Her Knees (Ouverture)",
      slug: "yan-wagner-on-her-knees-ouverture",
      image: "yan-wagner-on-her-knees-ouverture.jpg",
    },
    {
      name: "Slam Dunk Cha-Cha",
      slug: "yan-wagner-slam-dunk-cha-cha",
      image: "yan-wagner-slam-dunk-cha-cha.jpg",
    },
    {
      name: "Stranger In Town",
      slug: "yan-wagner-stranger-in-town",
      image: "yan-wagner-stranger-in-town.jpg",
    },
    {
      name: "The Blue Line",
      slug: "yan-wagner-the-blue-line",
      image: "yan-wagner-the-blue-line.jpg",
    },
    {
      name: "Vanished",
      slug: "yan-wagner-vanished",
      image: "yan-wagner-vanished.jpg",
    },
  ],
  "Eric Fuentes": [
    {
      name: "Academia",
      slug: "eric-fuentes-academia",
      image: "eric-fuentes-academia.jpg",
    },
    {
      name: "All Gone",
      slug: "eric-fuentes-all-gone",
      image: "eric-fuentes-all-gone.jpg",
    },
    {
      name: "Amb L'Aigua Al Coll",
      slug: "eric-fuentes-amb-l-aigua-al-coll",
      image: "eric-fuentes-amb-l-aigua-al-coll.jpg",
    },
    {
      name: "Barcelona",
      slug: "eric-fuentes-barcelona",
      image: "eric-fuentes-barcelona.jpg",
    },
    {
      name: "Brotherhood",
      slug: "eric-fuentes-brotherhood",
      image: "eric-fuentes-brotherhood.jpg",
    },
    {
      name: "Caus Al Fang",
      slug: "eric-fuentes-caus-al-fang",
      image: "eric-fuentes-caus-al-fang.jpg",
    },
    {
      name: "Confessionari",
      slug: "eric-fuentes-confessionari",
      image: "eric-fuentes-confessionari.jpg",
    },
    {
      name: "Copper & Gold",
      slug: "eric-fuentes-copper-and-gold",
      image: "eric-fuentes-copper-and-gold.jpg",
    },
    {
      name: "Cowboy",
      slug: "eric-fuentes-cowboy",
      image: "eric-fuentes-cowboy.jpg",
    },
    {
      name: "Crash",
      slug: "eric-fuentes-crash",
      image: "eric-fuentes-crash.jpg",
    },
    {
      name: "Deep Diver",
      slug: "eric-fuentes-deep-diver",
      image: "eric-fuentes-deep-diver.jpg",
    },
    {
      name: "Despenaperros",
      slug: "eric-fuentes-despenaperros",
      image: "eric-fuentes-despenaperros.jpg",
    },
    {
      name: "Disfruta Perdiendo",
      slug: "eric-fuentes-disfruta-perdiendo",
      image: "eric-fuentes-disfruta-perdiendo.jpg",
    },
    {
      name: "Drop Me A Line",
      slug: "eric-fuentes-drop-me-a-line",
      image: "eric-fuentes-drop-me-a-line.jpg",
    },
    {
      name: "Els Millors",
      slug: "eric-fuentes-els-millors",
      image: "eric-fuentes-els-millors.jpg",
    },
    {
      name: "Extinct Planet",
      slug: "eric-fuentes-extinct-planet",
      image: "eric-fuentes-extinct-planet.jpg",
    },
    {
      name: "Future Love Song",
      slug: "eric-fuentes-future-love-song",
      image: "eric-fuentes-future-love-song.jpg",
    },
    {
      name: "Hold Your Horses",
      slug: "eric-fuentes-hold-your-horses",
      image: "eric-fuentes-hold-your-horses.jpg",
    },
    {
      name: "Incansable",
      slug: "eric-fuentes-incansable",
      image: "eric-fuentes-incansable.jpg",
    },
    {
      name: "It Was A Very Good Year",
      slug: "eric-fuentes-it-was-a-very-good-year",
      image: "eric-fuentes-it-was-a-very-good-year.jpg",
    },
    {
      name: "Journey",
      slug: "eric-fuentes-journey",
      image: "eric-fuentes-journey.jpg",
    },
    {
      name: "Make A Wish",
      slug: "eric-fuentes-make-a-wish",
      image: "eric-fuentes-make-a-wish.jpg",
    },
    {
      name: "Names To Towns",
      slug: "eric-fuentes-names-to-towns",
      image: "eric-fuentes-names-to-towns.jpg",
    },
    {
      name: "Outness",
      slug: "eric-fuentes-outness",
      image: "eric-fuentes-outness.jpg",
    },
    {
      name: "Parlar Per Parlar",
      slug: "eric-fuentes-parlar-per-parlar",
      image: "eric-fuentes-parlar-per-parlar.jpg",
    },
    {
      name: "Platja Dels Morts",
      slug: "eric-fuentes-platja-dels-morts",
      image: "eric-fuentes-platja-dels-morts.jpg",
    },
    {
      name: "Sleep Within You",
      slug: "eric-fuentes-sleep-within-you",
      image: "eric-fuentes-sleep-within-you.jpg",
    },
    {
      name: "Soc Una Pedra",
      slug: "eric-fuentes-soc-una-pedra",
      image: "eric-fuentes-soc-una-pedra.jpg",
    },
    {
      name: "Superpowers",
      slug: "eric-fuentes-superpowers",
      image: "eric-fuentes-superpowers.jpg",
    },
    {
      name: "Terraprims",
      slug: "eric-fuentes-terraprims",
      image: "eric-fuentes-terraprims.jpg",
    },
    {
      name: "The Rush And The Wave",
      slug: "eric-fuentes-the-rush-and-the-wave",
      image: "eric-fuentes-the-rush-and-the-wave.jpg",
    },
    {
      name: "They Don't Like Us",
      slug: "eric-fuentes-they-don-t-like-us",
      image: "eric-fuentes-they-don-t-like-us.jpg",
    },
    {
      name: "To Dust",
      slug: "eric-fuentes-to-dust",
      image: "eric-fuentes-to-dust.jpg",
    },
    {
      name: "Trist i Patetic",
      slug: "eric-fuentes-trist-i-patetic",
      image: "eric-fuentes-trist-i-patetic.jpg",
    },
    {
      name: "Turbo Liver",
      slug: "eric-fuentes-turbo-liver",
      image: "eric-fuentes-turbo-liver.jpg",
    },
    {
      name: "Unspoken",
      slug: "eric-fuentes-unspoken",
      image: "eric-fuentes-unspoken.jpg",
    },
    {
      name: "You Must Have Been Crying Again",
      slug: "eric-fuentes-you-must-have-been-crying-again",
      image: "eric-fuentes-you-must-have-been-crying-again.jpg",
    },
  ],
  "Wild Honey": [
    {
      name: "Acantilado (Instrumental)",
      slug: "wild-honey-acantilado-instrumental",
      image: "wild-honey-acantilado-instrumental.jpg",
    },
    {
      name: "An Army Of Fat Synths",
      slug: "wild-honey-an-army-of-fat-synths",
      image: "wild-honey-an-army-of-fat-synths.jpg",
    },
    {
      name: "An Army Of Fat Synths (Al X Rock's B Boy Remix)",
      slug: "wild-honey-an-army-of-fat-synths-al-x-rock-s-b-boy-remix",
      image: "wild-honey-an-army-of-fat-synths-al-x-rock-s-b-boy-remix.jpg",
    },
    {
      name: "An Army Of Fat Synths (Emperor Machine Remix)",
      slug: "wild-honey-an-army-of-fat-synths-emperor-machine-remix",
      image: "wild-honey-an-army-of-fat-synths-emperor-machine-remix.jpg",
    },
    {
      name: "Brand New Hairdo",
      slug: "wild-honey-brand-new-hairdo",
      image: "wild-honey-brand-new-hairdo.jpg",
    },
    {
      name: "Cleopatra",
      slug: "wild-honey-cleopatra",
      image: "wild-honey-cleopatra.jpg",
    },
    {
      name: "Desenfocado (Instrumental)",
      slug: "wild-honey-desenfocado-instrumental",
      image: "wild-honey-desenfocado-instrumental.jpg",
    },
    {
      name: "Done It Forever",
      slug: "wild-honey-done-it-forever",
      image: "wild-honey-done-it-forever.jpg",
    },
    {
      name: "El Volcán de Montserrat (Instrumental)",
      slug: "wild-honey-el-volcan-de-montserrat-instrumental",
      image: "wild-honey-el-volcan-de-montserrat-instrumental.jpg",
    },
    {
      name: "Gold Leaf",
      slug: "wild-honey-gold-leaf",
      image: "wild-honey-gold-leaf.jpg",
    },
    {
      name: "Gothic Fiction",
      slug: "wild-honey-gothic-fiction",
      image: "wild-honey-gothic-fiction.jpg",
    },
    {
      name: "Hal Blane's Beat",
      slug: "wild-honey-hal-blane-s-beat",
      image: "wild-honey-hal-blane-s-beat.jpg",
    },
    {
      name: "Horóscopo (Instrumental)",
      slug: "wild-honey-horoscopo-instrumental",
      image: "wild-honey-horoscopo-instrumental.jpg",
    },
    {
      name: "Isabella",
      slug: "wild-honey-isabella",
      image: "wild-honey-isabella.jpg",
    },
    {
      name: "It's All In A Film",
      slug: "wild-honey-it-s-all-in-a-film",
      image: "wild-honey-it-s-all-in-a-film.jpg",
    },
    {
      name: "Keyboards Under A Microscope",
      slug: "wild-honey-keyboards-under-a-microscope",
      image: "wild-honey-keyboards-under-a-microscope.jpg",
    },
    {
      name: "Kings Of Tomorrow",
      slug: "wild-honey-kings-of-tomorrow",
      image: "wild-honey-kings-of-tomorrow.jpg",
    },
    {
      name: "Leopardo (Instrumental)",
      slug: "wild-honey-leopardo-instrumental",
      image: "wild-honey-leopardo-instrumental.jpg",
    },
    {
      name: "Mapas de Zonas Desiertas (Instrumental)",
      slug: "wild-honey-mapas-de-zonas-desiertas-instrumental",
      image: "wild-honey-mapas-de-zonas-desiertas-instrumental.jpg",
    },
    {
      name: "My Bride In Black Gloves",
      slug: "wild-honey-my-bride-in-black-gloves",
      image: "wild-honey-my-bride-in-black-gloves.jpg",
    },
    {
      name: "My Memory May Also Be A Wish",
      slug: "wild-honey-my-memory-may-also-be-a-wish",
      image: "wild-honey-my-memory-may-also-be-a-wish.jpg",
    },
    {
      name: "Ojo de Cristal (Instrumental)",
      slug: "wild-honey-ojo-de-cristal-instrumental",
      image: "wild-honey-ojo-de-cristal-instrumental.jpg",
    },
    {
      name: "One Word Prayer",
      slug: "wild-honey-one-word-prayer",
      image: "wild-honey-one-word-prayer.jpg",
    },
    {
      name: "Reverb Infinita (Instrumental)",
      slug: "wild-honey-reverb-infinita-instrumental",
      image: "wild-honey-reverb-infinita-instrumental.jpg",
    },
    {
      name: "Rogerio Duprat (Miguelito Superstar Dub)",
      slug: "wild-honey-rogerio-duprat-miguelito-superstar-dub",
      image: "wild-honey-rogerio-duprat-miguelito-superstar-dub.jpg",
    },
    {
      name: "Rogerio Duprat Looks Out The Window",
      slug: "wild-honey-rogerio-duprat-looks-out-the-window",
      image: "wild-honey-rogerio-duprat-looks-out-the-window.jpg",
    },
    {
      name: "Scissors In Hand",
      slug: "wild-honey-scissors-in-hand",
      image: "wild-honey-scissors-in-hand.jpg",
    },
    {
      name: "See How Hard My Heart Is Beating",
      slug: "wild-honey-see-how-hard-my-heart-is-beating",
      image: "wild-honey-see-how-hard-my-heart-is-beating.jpg",
    },
    {
      name: "Siguiendo A Desconocidos (Instrumental)",
      slug: "wild-honey-siguiendo-a-desconocidos-instrumental",
      image: "wild-honey-siguiendo-a-desconocidos-instrumental.jpg",
    },
    {
      name: "The Big Parade",
      slug: "wild-honey-the-big-parade",
      image: "wild-honey-the-big-parade.jpg",
    },
    {
      name: "The Kite And Captain John",
      slug: "wild-honey-the-kite-and-captain-john",
      image: "wild-honey-the-kite-and-captain-john.jpg",
    },
    {
      name: "The Newlyweds",
      slug: "wild-honey-the-newlyweds",
      image: "wild-honey-the-newlyweds.jpg",
    },
    {
      name: "To Steal A Piece Of Art",
      slug: "wild-honey-to-steal-a-piece-of-art",
      image: "wild-honey-to-steal-a-piece-of-art.jpg",
    },
    {
      name: "Tooth Tree",
      slug: "wild-honey-tooth-tree",
      image: "wild-honey-tooth-tree.jpg",
    },
    {
      name: "Torres Blancas (Instrumental)",
      slug: "wild-honey-torres-blancas-instrumental",
      image: "wild-honey-torres-blancas-instrumental.jpg",
    },
    {
      name: "Whistling Rivalry",
      slug: "wild-honey-whistling-rivalry",
      image: "wild-honey-whistling-rivalry.jpg",
    },
  ],
  Boreals: [
    {
      name: "Acapulco",
      slug: "boreals-acapulco",
      image: "boreals-acapulco.jpg",
    },
    { name: "Colibri", slug: "boreals-colibri", image: "boreals-colibri.jpg" },
    {
      name: "El Gecko",
      slug: "boreals-el-gecko",
      image: "boreals-el-gecko.jpg",
    },
    {
      name: "La Fin Du Monde",
      slug: "boreals-la-fin-du-monde",
      image: "boreals-la-fin-du-monde.jpg",
    },
    {
      name: "Mambo Jumbo",
      slug: "boreals-mambo-jumbo",
      image: "boreals-mambo-jumbo.jpg",
    },
    { name: "Nautla", slug: "boreals-nautla", image: "boreals-nautla.jpg" },
    {
      name: "Observatorio",
      slug: "boreals-observatorio",
      image: "boreals-observatorio.jpg",
    },
    { name: "Poro", slug: "boreals-poro", image: "boreals-poro.jpg" },
    { name: "Yo Naci", slug: "boreals-yo-naci", image: "boreals-yo-naci.jpg" },
  ],
  Naxxos: [
    { name: "Acapulco", slug: "naxxos-acapulco", image: "naxxos-acapulco.jpg" },
    { name: "Athens", slug: "naxxos-athens", image: "naxxos-athens.jpg" },
    { name: "Bangui", slug: "naxxos-bangui", image: "naxxos-bangui.jpg" },
    { name: "Brixton", slug: "naxxos-brixton", image: "naxxos-brixton.jpg" },
    {
      name: "Got Me Waiting feat. Kate Garné",
      slug: "naxxos-got-me-waiting-feat-kate-garne",
      image: "naxxos-got-me-waiting-feat-kate-garne.jpg",
    },
    {
      name: "Mississippi",
      slug: "naxxos-mississippi",
      image: "naxxos-mississippi.jpg",
    },
    {
      name: "Paper Tiger feat. Raphaella",
      slug: "naxxos-paper-tiger-feat-raphaella",
      image: "naxxos-paper-tiger-feat-raphaella.jpg",
    },
    {
      name: "Sweet Dreams",
      slug: "naxxos-sweet-dreams",
      image: "naxxos-sweet-dreams.jpg",
    },
    {
      name: "Thief feat. M. Maggie",
      slug: "naxxos-thief-feat-m-maggie",
      image: "naxxos-thief-feat-m-maggie.jpg",
    },
    {
      name: "Who Do You Love feat. Raphaella",
      slug: "naxxos-who-do-you-love-feat-raphaella",
      image: "naxxos-who-do-you-love-feat-raphaella.jpg",
    },
  ],
  Bullitt: [
    {
      name: "Accident Time",
      slug: "bullitt-accident-time",
      image: "bullitt-accident-time.jpg",
    },
    {
      name: "Accident Time (Instrumental)",
      slug: "bullitt-accident-time-instrumental",
      image: "bullitt-accident-time-instrumental.jpg",
    },
    {
      name: "Away (Instrumental)",
      slug: "bullitt-away-instrumental",
      image: "bullitt-away-instrumental.jpg",
    },
    {
      name: "Back To The End",
      slug: "bullitt-back-to-the-end",
      image: "bullitt-back-to-the-end.jpg",
    },
    { name: "Fallen", slug: "bullitt-fallen", image: "bullitt-fallen.jpg" },
    {
      name: "Friendship Never Ends",
      slug: "bullitt-friendship-never-ends",
      image: "bullitt-friendship-never-ends.jpg",
    },
    {
      name: "Friendship Never Ends (Instrumental)",
      slug: "bullitt-friendship-never-ends-instrumental",
      image: "bullitt-friendship-never-ends-instrumental.jpg",
    },
    {
      name: "Game Over",
      slug: "bullitt-game-over",
      image: "bullitt-game-over.jpg",
    },
    {
      name: "Game Over (Instrumental)",
      slug: "bullitt-game-over-instrumental",
      image: "bullitt-game-over-instrumental.jpg",
    },
    {
      name: "Have It All",
      slug: "bullitt-have-it-all",
      image: "bullitt-have-it-all.jpg",
    },
    {
      name: "Headblower",
      slug: "bullitt-headblower",
      image: "bullitt-headblower.jpg",
    },
    {
      name: "Hiding In The Trees",
      slug: "bullitt-hiding-in-the-trees",
      image: "bullitt-hiding-in-the-trees.jpg",
    },
    {
      name: "How Did You Think",
      slug: "bullitt-how-did-you-think",
      image: "bullitt-how-did-you-think.jpg",
    },
    {
      name: "I Don't Care",
      slug: "bullitt-i-don-t-care",
      image: "bullitt-i-don-t-care.jpg",
    },
    {
      name: "I Don't Care (Instrumental)",
      slug: "bullitt-i-don-t-care-instrumental",
      image: "bullitt-i-don-t-care-instrumental.jpg",
    },
    {
      name: "Live Unafraid",
      slug: "bullitt-live-unafraid",
      image: "bullitt-live-unafraid.jpg",
    },
    { name: "Lucky", slug: "bullitt-lucky", image: "bullitt-lucky.jpg" },
    {
      name: "Oceans In Motion",
      slug: "bullitt-oceans-in-motion",
      image: "bullitt-oceans-in-motion.jpg",
    },
    {
      name: "Oceans In Motion (Instrumental)",
      slug: "bullitt-oceans-in-motion-instrumental",
      image: "bullitt-oceans-in-motion-instrumental.jpg",
    },
    {
      name: "On The Edge",
      slug: "bullitt-on-the-edge",
      image: "bullitt-on-the-edge.jpg",
    },
    {
      name: "On The Edge (Instrumental)",
      slug: "bullitt-on-the-edge-instrumental",
      image: "bullitt-on-the-edge-instrumental.jpg",
    },
    {
      name: "See The Light",
      slug: "bullitt-see-the-light",
      image: "bullitt-see-the-light.jpg",
    },
    {
      name: "She Leads My Soul",
      slug: "bullitt-she-leads-my-soul",
      image: "bullitt-she-leads-my-soul.jpg",
    },
    { name: "Sister", slug: "bullitt-sister", image: "bullitt-sister.jpg" },
    {
      name: "Sister (Instrumental)",
      slug: "bullitt-sister-instrumental",
      image: "bullitt-sister-instrumental.jpg",
    },
    {
      name: "Slow Fall",
      slug: "bullitt-slow-fall",
      image: "bullitt-slow-fall.jpg",
    },
    {
      name: "Slow Fall (Instrumental)",
      slug: "bullitt-slow-fall-instrumental",
      image: "bullitt-slow-fall-instrumental.jpg",
    },
    { name: "Sparks", slug: "bullitt-sparks", image: "bullitt-sparks.jpg" },
    {
      name: "Sparks (Instrumental)",
      slug: "bullitt-sparks-instrumental",
      image: "bullitt-sparks-instrumental.jpg",
    },
    {
      name: "Spirit (Instrumental)",
      slug: "bullitt-spirit-instrumental",
      image: "bullitt-spirit-instrumental.jpg",
    },
    {
      name: "Standing In A Circle",
      slug: "bullitt-standing-in-a-circle",
      image: "bullitt-standing-in-a-circle.jpg",
    },
    {
      name: "Standing On A Circle (Instrumental)",
      slug: "bullitt-standing-on-a-circle-instrumental",
      image: "bullitt-standing-on-a-circle-instrumental.jpg",
    },
    {
      name: "Talk It Over",
      slug: "bullitt-talk-it-over",
      image: "bullitt-talk-it-over.jpg",
    },
    {
      name: "The Mighty Ones",
      slug: "bullitt-the-mighty-ones",
      image: "bullitt-the-mighty-ones.jpg",
    },
    {
      name: "The Mighty Ones (Instrumental)",
      slug: "bullitt-the-mighty-ones-instrumental",
      image: "bullitt-the-mighty-ones-instrumental.jpg",
    },
    {
      name: "Turn My Engine Down",
      slug: "bullitt-turn-my-engine-down",
      image: "bullitt-turn-my-engine-down.jpg",
    },
    {
      name: "Turn My Engine Down (Instrumental)",
      slug: "bullitt-turn-my-engine-down-instrumental",
      image: "bullitt-turn-my-engine-down-instrumental.jpg",
    },
  ],
  "Golden Bug": [
    {
      name: "Accroché à Moi feat Julienne Dessagne",
      slug: "golden-bug-accroche-a-moi-feat-julienne-dessagne",
      image: "golden-bug-accroche-a-moi-feat-julienne-dessagne.jpg",
    },
    {
      name: "Accroché à Moi feat Julienne Dessagne (Destino Remix)",
      slug: "golden-bug-accroche-a-moi-feat-julienne-dessagne-destino-remix",
      image:
        "golden-bug-accroche-a-moi-feat-julienne-dessagne-destino-remix.jpg",
    },
    {
      name: "Amazonia",
      slug: "golden-bug-amazonia",
      image: "golden-bug-amazonia.jpg",
    },
    {
      name: "Amazonia (Moscoman Remix)",
      slug: "golden-bug-amazonia-moscoman-remix",
      image: "golden-bug-amazonia-moscoman-remix.jpg",
    },
    {
      name: "Arcus Pluvius",
      slug: "golden-bug-arcus-pluvius",
      image: "golden-bug-arcus-pluvius.jpg",
    },
    {
      name: "Assassin",
      slug: "golden-bug-assassin",
      image: "golden-bug-assassin.jpg",
    },
    {
      name: "Barbie’s Back (Database Remix)",
      slug: "golden-bug-barbie-s-back-database-remix",
      image: "golden-bug-barbie-s-back-database-remix.jpg",
    },
    { name: "Bisco", slug: "golden-bug-bisco", image: "golden-bug-bisco.jpg" },
    {
      name: "Black Soul",
      slug: "golden-bug-black-soul",
      image: "golden-bug-black-soul.jpg",
    },
    {
      name: "Black Soul (2CV Remix)",
      slug: "golden-bug-black-soul-2cv-remix",
      image: "golden-bug-black-soul-2cv-remix.jpg",
    },
    {
      name: "Click Talk",
      slug: "golden-bug-click-talk",
      image: "golden-bug-click-talk.jpg",
    },
    {
      name: "Cooking With A Cannibal",
      slug: "golden-bug-cooking-with-a-cannibal",
      image: "golden-bug-cooking-with-a-cannibal.jpg",
    },
    {
      name: "Danse Macabre (STA Remix)",
      slug: "golden-bug-danse-macabre-sta-remix",
      image: "golden-bug-danse-macabre-sta-remix.jpg",
    },
    {
      name: "Disco Sensation",
      slug: "golden-bug-disco-sensation",
      image: "golden-bug-disco-sensation.jpg",
    },
    {
      name: "El Dorado",
      slug: "golden-bug-el-dorado",
      image: "golden-bug-el-dorado.jpg",
    },
    {
      name: "El Dorado (Thomass Jackson Remix)",
      slug: "golden-bug-el-dorado-thomass-jackson-remix",
      image: "golden-bug-el-dorado-thomass-jackson-remix.jpg",
    },
    {
      name: "Flamingo (Original)",
      slug: "golden-bug-flamingo-original",
      image: "golden-bug-flamingo-original.jpg",
    },
    {
      name: "Flamingo (Pete Herbert Remix)",
      slug: "golden-bug-flamingo-pete-herbert-remix",
      image: "golden-bug-flamingo-pete-herbert-remix.jpg",
    },
    {
      name: "Flasherman",
      slug: "golden-bug-flasherman",
      image: "golden-bug-flasherman.jpg",
    },
    {
      name: "Future Girl",
      slug: "golden-bug-future-girl",
      image: "golden-bug-future-girl.jpg",
    },
    {
      name: "Ghost Day",
      slug: "golden-bug-ghost-day",
      image: "golden-bug-ghost-day.jpg",
    },
    {
      name: "God Machine",
      slug: "golden-bug-god-machine",
      image: "golden-bug-god-machine.jpg",
    },
    {
      name: "Gomina",
      slug: "golden-bug-gomina",
      image: "golden-bug-gomina.jpg",
    },
    {
      name: "Hands In Your Pockets",
      slug: "golden-bug-hands-in-your-pockets",
      image: "golden-bug-hands-in-your-pockets.jpg",
    },
    {
      name: "Hands In Your Pockets (Database Remix)",
      slug: "golden-bug-hands-in-your-pockets-database-remix",
      image: "golden-bug-hands-in-your-pockets-database-remix.jpg",
    },
    {
      name: "Heroes",
      slug: "golden-bug-heroes",
      image: "golden-bug-heroes.jpg",
    },
    {
      name: "Hippie Friends",
      slug: "golden-bug-hippie-friends",
      image: "golden-bug-hippie-friends.jpg",
    },
    {
      name: "Hitodoma",
      slug: "golden-bug-hitodoma",
      image: "golden-bug-hitodoma.jpg",
    },
    {
      name: "Ik Voel Je",
      slug: "golden-bug-ik-voel-je",
      image: "golden-bug-ik-voel-je.jpg",
    },
    {
      name: "King Of Kong",
      slug: "golden-bug-king-of-kong",
      image: "golden-bug-king-of-kong.jpg",
    },
    {
      name: "Krokodil",
      slug: "golden-bug-krokodil",
      image: "golden-bug-krokodil.jpg",
    },
    {
      name: "L'Horloge",
      slug: "golden-bug-l-horloge",
      image: "golden-bug-l-horloge.jpg",
    },
    {
      name: "Last Dance In Tokyo (Gloves Remix)",
      slug: "golden-bug-last-dance-in-tokyo-gloves-remix",
      image: "golden-bug-last-dance-in-tokyo-gloves-remix.jpg",
    },
    {
      name: "LookLookLook",
      slug: "golden-bug-looklooklook",
      image: "golden-bug-looklooklook.jpg",
    },
    {
      name: "LookLookLook (Inflagranti Remix)",
      slug: "golden-bug-looklooklook-inflagranti-remix",
      image: "golden-bug-looklooklook-inflagranti-remix.jpg",
    },
    {
      name: "Lord Of Pleasure",
      slug: "golden-bug-lord-of-pleasure",
      image: "golden-bug-lord-of-pleasure.jpg",
    },
    {
      name: "One Way (Copycat & Martin Brodin Remix)",
      slug: "golden-bug-one-way-copycat-and-martin-brodin-remix",
      image: "golden-bug-one-way-copycat-and-martin-brodin-remix.jpg",
    },
    {
      name: "One Way (Freeformfive Remix)",
      slug: "golden-bug-one-way-freeformfive-remix",
      image: "golden-bug-one-way-freeformfive-remix.jpg",
    },
    {
      name: "One Way (In Fields Remix Edit)",
      slug: "golden-bug-one-way-in-fields-remix-edit",
      image: "golden-bug-one-way-in-fields-remix-edit.jpg",
    },
    {
      name: "One Way (In Fields Remix)",
      slug: "golden-bug-one-way-in-fields-remix",
      image: "golden-bug-one-way-in-fields-remix.jpg",
    },
    {
      name: "One Way (Kasper Bjork Remix)",
      slug: "golden-bug-one-way-kasper-bjork-remix",
      image: "golden-bug-one-way-kasper-bjork-remix.jpg",
    },
    {
      name: "One Way (Original)",
      slug: "golden-bug-one-way-original",
      image: "golden-bug-one-way-original.jpg",
    },
    {
      name: "Play Around (Original)",
      slug: "golden-bug-play-around-original",
      image: "golden-bug-play-around-original.jpg",
    },
    {
      name: "Play Around (Tad Wily Remix)",
      slug: "golden-bug-play-around-tad-wily-remix",
      image: "golden-bug-play-around-tad-wily-remix.jpg",
    },
    {
      name: "Play Around (The Deadstock 33s Remix)",
      slug: "golden-bug-play-around-the-deadstock-33s-remix",
      image: "golden-bug-play-around-the-deadstock-33s-remix.jpg",
    },
    {
      name: "Progress (Radio Edit)",
      slug: "golden-bug-progress-radio-edit",
      image: "golden-bug-progress-radio-edit.jpg",
    },
    {
      name: "Progress feat Diego Hdez",
      slug: "golden-bug-progress-feat-diego-hdez",
      image: "golden-bug-progress-feat-diego-hdez.jpg",
    },
    {
      name: "Radio SSG (Rovedogs Remix)",
      slug: "golden-bug-radio-ssg-rovedogs-remix",
      image: "golden-bug-radio-ssg-rovedogs-remix.jpg",
    },
    {
      name: "Rocket City",
      slug: "golden-bug-rocket-city",
      image: "golden-bug-rocket-city.jpg",
    },
    {
      name: "Room 666",
      slug: "golden-bug-room-666",
      image: "golden-bug-room-666.jpg",
    },
    {
      name: "Room 666 (Red Axes Remix)",
      slug: "golden-bug-room-666-red-axes-remix",
      image: "golden-bug-room-666-red-axes-remix.jpg",
    },
    {
      name: "Sex Beat (Jad and the Ladyboy Remix)",
      slug: "golden-bug-sex-beat-jad-and-the-ladyboy-remix",
      image: "golden-bug-sex-beat-jad-and-the-ladyboy-remix.jpg",
    },
    {
      name: "Sex Beat (Mustang Dub Remix)",
      slug: "golden-bug-sex-beat-mustang-dub-remix",
      image: "golden-bug-sex-beat-mustang-dub-remix.jpg",
    },
    {
      name: "Sex Beat (Mustang Remix)",
      slug: "golden-bug-sex-beat-mustang-remix",
      image: "golden-bug-sex-beat-mustang-remix.jpg",
    },
    {
      name: "Sex Beat (Original)",
      slug: "golden-bug-sex-beat-original",
      image: "golden-bug-sex-beat-original.jpg",
    },
    { name: "Slow", slug: "golden-bug-slow", image: "golden-bug-slow.jpg" },
    {
      name: "Soapopera (Dub Version)",
      slug: "golden-bug-soapopera-dub-version",
      image: "golden-bug-soapopera-dub-version.jpg",
    },
    {
      name: "Soapopera (Hannulelauri Remix)",
      slug: "golden-bug-soapopera-hannulelauri-remix",
      image: "golden-bug-soapopera-hannulelauri-remix.jpg",
    },
    {
      name: "Soapopera (Original)",
      slug: "golden-bug-soapopera-original",
      image: "golden-bug-soapopera-original.jpg",
    },
    {
      name: "St Tropez",
      slug: "golden-bug-st-tropez",
      image: "golden-bug-st-tropez.jpg",
    },
    {
      name: "Supernova",
      slug: "golden-bug-supernova",
      image: "golden-bug-supernova.jpg",
    },
    {
      name: "Taste Of Love (Fell Reis Dub Remix)",
      slug: "golden-bug-taste-of-love-fell-reis-dub-remix",
      image: "golden-bug-taste-of-love-fell-reis-dub-remix.jpg",
    },
    {
      name: "Taste Of Love (Fell Reis Remix)",
      slug: "golden-bug-taste-of-love-fell-reis-remix",
      image: "golden-bug-taste-of-love-fell-reis-remix.jpg",
    },
    {
      name: "Taste Of Love (Instrumental)",
      slug: "golden-bug-taste-of-love-instrumental",
      image: "golden-bug-taste-of-love-instrumental.jpg",
    },
    {
      name: "Taste Of Love feat. Pajaro Sunrise",
      slug: "golden-bug-taste-of-love-feat-pajaro-sunrise",
      image: "golden-bug-taste-of-love-feat-pajaro-sunrise.jpg",
    },
    {
      name: "Taste Of Love feat. Pajaro Sunrise (Il Est Vilaine Remix)",
      slug: "golden-bug-taste-of-love-feat-pajaro-sunrise-il-est-vilaine-remix",
      image:
        "golden-bug-taste-of-love-feat-pajaro-sunrise-il-est-vilaine-remix.jpg",
    },
    {
      name: "Tekila",
      slug: "golden-bug-tekila",
      image: "golden-bug-tekila.jpg",
    },
    {
      name: "The Game",
      slug: "golden-bug-the-game",
      image: "golden-bug-the-game.jpg",
    },
    {
      name: "U Are Magic",
      slug: "golden-bug-u-are-magic",
      image: "golden-bug-u-are-magic.jpg",
    },
    {
      name: "Un Paradis Artificiel feat. Julienne Dessagne",
      slug: "golden-bug-un-paradis-artificiel-feat-julienne-dessagne",
      image: "golden-bug-un-paradis-artificiel-feat-julienne-dessagne.jpg",
    },
    {
      name: "Viaje A Tenderloin",
      slug: "golden-bug-viaje-a-tenderloin",
      image: "golden-bug-viaje-a-tenderloin.jpg",
    },
    {
      name: "Visage",
      slug: "golden-bug-visage",
      image: "golden-bug-visage.jpg",
    },
    {
      name: "Voodoo Child",
      slug: "golden-bug-voodoo-child",
      image: "golden-bug-voodoo-child.jpg",
    },
    {
      name: "Washing Machine (Mickey Moonlight Remix)",
      slug: "golden-bug-washing-machine-mickey-moonlight-remix",
      image: "golden-bug-washing-machine-mickey-moonlight-remix.jpg",
    },
    {
      name: "Washing Machine (Moullinex Remix)",
      slug: "golden-bug-washing-machine-moullinex-remix",
      image: "golden-bug-washing-machine-moullinex-remix.jpg",
    },
    {
      name: "Washing Machine (Original Dub)",
      slug: "golden-bug-washing-machine-original-dub",
      image: "golden-bug-washing-machine-original-dub.jpg",
    },
    {
      name: "Washing Machine (Original Radio Edit)",
      slug: "golden-bug-washing-machine-original-radio-edit",
      image: "golden-bug-washing-machine-original-radio-edit.jpg",
    },
    {
      name: "Washing Machine (Toomy Disco Remix)",
      slug: "golden-bug-washing-machine-toomy-disco-remix",
      image: "golden-bug-washing-machine-toomy-disco-remix.jpg",
    },
    {
      name: "Washing Machine(C90s Remix)",
      slug: "golden-bug-washing-machine-c90s-remix",
      image: "golden-bug-washing-machine-c90s-remix.jpg",
    },
    {
      name: "Water Resistant",
      slug: "golden-bug-water-resistant",
      image: "golden-bug-water-resistant.jpg",
    },
    {
      name: "Wild Boys",
      slug: "golden-bug-wild-boys",
      image: "golden-bug-wild-boys.jpg",
    },
    {
      name: "Wild Boys (Strapontin Remix)",
      slug: "golden-bug-wild-boys-strapontin-remix",
      image: "golden-bug-wild-boys-strapontin-remix.jpg",
    },
    {
      name: "Wrong Thing (Jupiter Lion Remix)",
      slug: "golden-bug-wrong-thing-jupiter-lion-remix",
      image: "golden-bug-wrong-thing-jupiter-lion-remix.jpg",
    },
    {
      name: "Wrong Thing (Radio Edit)",
      slug: "golden-bug-wrong-thing-radio-edit",
      image: "golden-bug-wrong-thing-radio-edit.jpg",
    },
    {
      name: "Wrong Thing (Villa Remix)",
      slug: "golden-bug-wrong-thing-villa-remix",
      image: "golden-bug-wrong-thing-villa-remix.jpg",
    },
    { name: "Yama", slug: "golden-bug-yama", image: "golden-bug-yama.jpg" },
  ],
  Corleone: [
    { name: "Acid", slug: "corleone-acid", image: "corleone-acid.jpg" },
    {
      name: "Anatomica",
      slug: "corleone-anatomica",
      image: "corleone-anatomica.jpg",
    },
    {
      name: "Black Hole",
      slug: "corleone-black-hole",
      image: "corleone-black-hole.jpg",
    },
    { name: "Cobb", slug: "corleone-cobb", image: "corleone-cobb.jpg" },
    {
      name: "Come On Sister",
      slug: "corleone-come-on-sister",
      image: "corleone-come-on-sister.jpg",
    },
    {
      name: "Corleone",
      slug: "corleone-corleone",
      image: "corleone-corleone.jpg",
    },
    {
      name: "Cranky Gangster",
      slug: "corleone-cranky-gangster",
      image: "corleone-cranky-gangster.jpg",
    },
    {
      name: "Electric People",
      slug: "corleone-electric-people",
      image: "corleone-electric-people.jpg",
    },
    {
      name: "Feel Your Tongue",
      slug: "corleone-feel-your-tongue",
      image: "corleone-feel-your-tongue.jpg",
    },
    { name: "Ink", slug: "corleone-ink", image: "corleone-ink.jpg" },
    {
      name: "King Size",
      slug: "corleone-king-size",
      image: "corleone-king-size.jpg",
    },
    {
      name: "Make It",
      slug: "corleone-make-it",
      image: "corleone-make-it.jpg",
    },
    { name: "Monk", slug: "corleone-monk", image: "corleone-monk.jpg" },
    {
      name: "Music Boom",
      slug: "corleone-music-boom",
      image: "corleone-music-boom.jpg",
    },
    {
      name: "Romance Of Silence",
      slug: "corleone-romance-of-silence",
      image: "corleone-romance-of-silence.jpg",
    },
    {
      name: "Run People Run",
      slug: "corleone-run-people-run",
      image: "corleone-run-people-run.jpg",
    },
    { name: "Shock", slug: "corleone-shock", image: "corleone-shock.jpg" },
    {
      name: "Stop The Train",
      slug: "corleone-stop-the-train",
      image: "corleone-stop-the-train.jpg",
    },
    {
      name: "The Show",
      slug: "corleone-the-show",
      image: "corleone-the-show.jpg",
    },
    {
      name: "Welcome To The Underground",
      slug: "corleone-welcome-to-the-underground",
      image: "corleone-welcome-to-the-underground.jpg",
    },
  ],
  "Paprika Kinski": [
    {
      name: "Acid Love",
      slug: "paprika-kinski-acid-love",
      image: "paprika-kinski-acid-love.jpg",
    },
    {
      name: "All You Need",
      slug: "paprika-kinski-all-you-need",
      image: "paprika-kinski-all-you-need.jpg",
    },
    {
      name: "Diamond Queen",
      slug: "paprika-kinski-diamond-queen",
      image: "paprika-kinski-diamond-queen.jpg",
    },
    {
      name: "Eiffel Tower",
      slug: "paprika-kinski-eiffel-tower",
      image: "paprika-kinski-eiffel-tower.jpg",
    },
    {
      name: "Female Trouble",
      slug: "paprika-kinski-female-trouble",
      image: "paprika-kinski-female-trouble.jpg",
    },
    {
      name: "Jamaica",
      slug: "paprika-kinski-jamaica",
      image: "paprika-kinski-jamaica.jpg",
    },
    {
      name: "Mean Boy",
      slug: "paprika-kinski-mean-boy",
      image: "paprika-kinski-mean-boy.jpg",
    },
    {
      name: "Steady Lover",
      slug: "paprika-kinski-steady-lover",
      image: "paprika-kinski-steady-lover.jpg",
    },
    {
      name: "Steady Lover (Mijo Remix)",
      slug: "paprika-kinski-steady-lover-mijo-remix",
      image: "paprika-kinski-steady-lover-mijo-remix.jpg",
    },
    {
      name: "What You See Is What You Get",
      slug: "paprika-kinski-what-you-see-is-what-you-get",
      image: "paprika-kinski-what-you-see-is-what-you-get.jpg",
    },
  ],
  Delafaye: [
    {
      name: "Acid Tongue",
      slug: "delafaye-acid-tongue",
      image: "delafaye-acid-tongue.jpg",
    },
    { name: "Andy", slug: "delafaye-andy", image: "delafaye-andy.jpg" },
    { name: "Anyway", slug: "delafaye-anyway", image: "delafaye-anyway.jpg" },
    {
      name: "Cigarettes and Coffee",
      slug: "delafaye-cigarettes-and-coffee",
      image: "delafaye-cigarettes-and-coffee.jpg",
    },
    { name: "Down", slug: "delafaye-down", image: "delafaye-down.jpg" },
    {
      name: "Dreamers",
      slug: "delafaye-dreamers",
      image: "delafaye-dreamers.jpg",
    },
    { name: "Gideon", slug: "delafaye-gideon", image: "delafaye-gideon.jpg" },
    {
      name: "Go Away Just To Stay",
      slug: "delafaye-go-away-just-to-stay",
      image: "delafaye-go-away-just-to-stay.jpg",
    },
    {
      name: "Godspeed",
      slug: "delafaye-godspeed",
      image: "delafaye-godspeed.jpg",
    },
    {
      name: "Hallie , I'm Leaving You",
      slug: "delafaye-hallie-i-m-leaving-you",
      image: "delafaye-hallie-i-m-leaving-you.jpg",
    },
    {
      name: "Loaded Gun",
      slug: "delafaye-loaded-gun",
      image: "delafaye-loaded-gun.jpg",
    },
    { name: "Part I", slug: "delafaye-part-i", image: "delafaye-part-i.jpg" },
    {
      name: "Part II",
      slug: "delafaye-part-ii",
      image: "delafaye-part-ii.jpg",
    },
    {
      name: "Pushing Daisies feat. Kimberly Cundiff",
      slug: "delafaye-pushing-daisies-feat-kimberly-cundiff",
      image: "delafaye-pushing-daisies-feat-kimberly-cundiff.jpg",
    },
    { name: "Rain", slug: "delafaye-rain", image: "delafaye-rain.jpg" },
    {
      name: "She Shook Me",
      slug: "delafaye-she-shook-me",
      image: "delafaye-she-shook-me.jpg",
    },
    {
      name: "Tattoo Dreams",
      slug: "delafaye-tattoo-dreams",
      image: "delafaye-tattoo-dreams.jpg",
    },
    {
      name: "The County",
      slug: "delafaye-the-county",
      image: "delafaye-the-county.jpg",
    },
    {
      name: "These Days",
      slug: "delafaye-these-days",
      image: "delafaye-these-days.jpg",
    },
    {
      name: "Thinkin Of You",
      slug: "delafaye-thinkin-of-you",
      image: "delafaye-thinkin-of-you.jpg",
    },
    {
      name: "Time And Money",
      slug: "delafaye-time-and-money",
      image: "delafaye-time-and-money.jpg",
    },
    {
      name: "Time and Money (Acoustic Version)",
      slug: "delafaye-time-and-money-acoustic-version",
      image: "delafaye-time-and-money-acoustic-version.jpg",
    },
    {
      name: "Tripping and Rolling",
      slug: "delafaye-tripping-and-rolling",
      image: "delafaye-tripping-and-rolling.jpg",
    },
  ],
  Tannhauser: [
    {
      name: "Acrofobia",
      slug: "tannhauser-acrofobia",
      image: "tannhauser-acrofobia.jpg",
    },
    {
      name: "Arkanoid",
      slug: "tannhauser-arkanoid",
      image: "tannhauser-arkanoid.jpg",
    },
    {
      name: "El Tercer Hombre",
      slug: "tannhauser-el-tercer-hombre",
      image: "tannhauser-el-tercer-hombre.jpg",
    },
    {
      name: "Error y Culpa",
      slug: "tannhauser-error-y-culpa",
      image: "tannhauser-error-y-culpa.jpg",
    },
    {
      name: "Godzilla",
      slug: "tannhauser-godzilla",
      image: "tannhauser-godzilla.jpg",
    },
    {
      name: "Ondina",
      slug: "tannhauser-ondina",
      image: "tannhauser-ondina.jpg",
    },
    { name: "Otzi", slug: "tannhauser-otzi", image: "tannhauser-otzi.jpg" },
    {
      name: "Tannhauser",
      slug: "tannhauser-tannhauser",
      image: "tannhauser-tannhauser.jpg",
    },
    {
      name: "U-Matic",
      slug: "tannhauser-u-matic",
      image: "tannhauser-u-matic.jpg",
    },
    {
      name: "Vigilia",
      slug: "tannhauser-vigilia",
      image: "tannhauser-vigilia.jpg",
    },
  ],
  "Linn Youki": [
    {
      name: "Actarus",
      slug: "linn-youki-actarus",
      image: "linn-youki-actarus.jpg",
    },
    {
      name: "Cleopatra",
      slug: "linn-youki-cleopatra",
      image: "linn-youki-cleopatra.jpg",
    },
    {
      name: "Cochinillas",
      slug: "linn-youki-cochinillas",
      image: "linn-youki-cochinillas.jpg",
    },
    { name: "Duna", slug: "linn-youki-duna", image: "linn-youki-duna.jpg" },
    { name: "Eo Eo", slug: "linn-youki-eo-eo", image: "linn-youki-eo-eo.jpg" },
    {
      name: "Garrincha",
      slug: "linn-youki-garrincha",
      image: "linn-youki-garrincha.jpg",
    },
    {
      name: "Instamatic Guille",
      slug: "linn-youki-instamatic-guille",
      image: "linn-youki-instamatic-guille.jpg",
    },
    {
      name: "Instamatic Maila",
      slug: "linn-youki-instamatic-maila",
      image: "linn-youki-instamatic-maila.jpg",
    },
    {
      name: "La Fantastica Historia De Los Obsequios",
      slug: "linn-youki-la-fantastica-historia-de-los-obsequios",
      image: "linn-youki-la-fantastica-historia-de-los-obsequios.jpg",
    },
    {
      name: "Ouch Miau",
      slug: "linn-youki-ouch-miau",
      image: "linn-youki-ouch-miau.jpg",
    },
    {
      name: "Pluto Mambo Chihuahua",
      slug: "linn-youki-pluto-mambo-chihuahua",
      image: "linn-youki-pluto-mambo-chihuahua.jpg",
    },
    {
      name: "Quien Esta Gritando",
      slug: "linn-youki-quien-esta-gritando",
      image: "linn-youki-quien-esta-gritando.jpg",
    },
  ],
  Cosmos: [
    { name: "Action", slug: "cosmos-action", image: "cosmos-action.jpg" },
    { name: "Alone", slug: "cosmos-alone", image: "cosmos-alone.jpg" },
    { name: "Battle", slug: "cosmos-battle", image: "cosmos-battle.jpg" },
    { name: "Crise", slug: "cosmos-crise", image: "cosmos-crise.jpg" },
    { name: "Dark", slug: "cosmos-dark", image: "cosmos-dark.jpg" },
    { name: "Drakar", slug: "cosmos-drakar", image: "cosmos-drakar.jpg" },
    { name: "Dual", slug: "cosmos-dual", image: "cosmos-dual.jpg" },
    { name: "Enigme", slug: "cosmos-enigme", image: "cosmos-enigme.jpg" },
    { name: "Evil", slug: "cosmos-evil", image: "cosmos-evil.jpg" },
    {
      name: "Fantastique",
      slug: "cosmos-fantastique",
      image: "cosmos-fantastique.jpg",
    },
    { name: "Flag", slug: "cosmos-flag", image: "cosmos-flag.jpg" },
    { name: "Friction", slug: "cosmos-friction", image: "cosmos-friction.jpg" },
    { name: "Glory", slug: "cosmos-glory", image: "cosmos-glory.jpg" },
    { name: "Lost", slug: "cosmos-lost", image: "cosmos-lost.jpg" },
    { name: "Malaise", slug: "cosmos-malaise", image: "cosmos-malaise.jpg" },
    { name: "Mist", slug: "cosmos-mist", image: "cosmos-mist.jpg" },
    { name: "Never", slug: "cosmos-never", image: "cosmos-never.jpg" },
    { name: "Odd", slug: "cosmos-odd", image: "cosmos-odd.jpg" },
    { name: "Pression", slug: "cosmos-pression", image: "cosmos-pression.jpg" },
    { name: "Revenge", slug: "cosmos-revenge", image: "cosmos-revenge.jpg" },
    { name: "Shark", slug: "cosmos-shark", image: "cosmos-shark.jpg" },
    { name: "Tensions", slug: "cosmos-tensions", image: "cosmos-tensions.jpg" },
    { name: "Thriller", slug: "cosmos-thriller", image: "cosmos-thriller.jpg" },
    { name: "Victory", slug: "cosmos-victory", image: "cosmos-victory.jpg" },
    { name: "Viper", slug: "cosmos-viper", image: "cosmos-viper.jpg" },
    { name: "Voyager", slug: "cosmos-voyager", image: "cosmos-voyager.jpg" },
  ],
  Kim: [
    {
      name: "Ad Libitum Bordelo",
      slug: "kim-ad-libitum-bordelo",
      image: "kim-ad-libitum-bordelo.jpg",
    },
    {
      name: "Ad Libitum Melo",
      slug: "kim-ad-libitum-melo",
      image: "kim-ad-libitum-melo.jpg",
    },
    {
      name: "Adelaide Final",
      slug: "kim-adelaide-final",
      image: "kim-adelaide-final.jpg",
    },
    {
      name: "Adelaide Le Tempo Elle s'en Balance",
      slug: "kim-adelaide-le-tempo-elle-s-en-balance",
      image: "kim-adelaide-le-tempo-elle-s-en-balance.jpg",
    },
    {
      name: "Adelaide Prend Ses Quartiers",
      slug: "kim-adelaide-prend-ses-quartiers",
      image: "kim-adelaide-prend-ses-quartiers.jpg",
    },
    {
      name: "All My Family (Alb Remix)",
      slug: "kim-all-my-family-alb-remix",
      image: "kim-all-my-family-alb-remix.jpg",
    },
    {
      name: "Cantiamo Sta Canzone",
      slug: "kim-cantiamo-sta-canzone",
      image: "kim-cantiamo-sta-canzone.jpg",
    },
    {
      name: "Ci Sarai Tu",
      slug: "kim-ci-sarai-tu",
      image: "kim-ci-sarai-tu.jpg",
    },
    {
      name: "De La De La De La Drum",
      slug: "kim-de-la-de-la-de-la-drum",
      image: "kim-de-la-de-la-de-la-drum.jpg",
    },
    { name: "De La Drum", slug: "kim-de-la-drum", image: "kim-de-la-drum.jpg" },
    {
      name: "De La Drum Encore",
      slug: "kim-de-la-drum-encore",
      image: "kim-de-la-drum-encore.jpg",
    },
    {
      name: "De La Drum Pour Adelaide",
      slug: "kim-de-la-drum-pour-adelaide",
      image: "kim-de-la-drum-pour-adelaide.jpg",
    },
    {
      name: "De La Samba Drum",
      slug: "kim-de-la-samba-drum",
      image: "kim-de-la-samba-drum.jpg",
    },
    {
      name: "Don Lee Doo",
      slug: "kim-don-lee-doo",
      image: "kim-don-lee-doo.jpg",
    },
    {
      name: "Dub La Drum",
      slug: "kim-dub-la-drum",
      image: "kim-dub-la-drum.jpg",
    },
    {
      name: "Helena Canzone",
      slug: "kim-helena-canzone",
      image: "kim-helena-canzone.jpg",
    },
    {
      name: "Helena Rose Ballad",
      slug: "kim-helena-rose-ballad",
      image: "kim-helena-rose-ballad.jpg",
    },
    { name: "I Want U", slug: "kim-i-want-u", image: "kim-i-want-u.jpg" },
    {
      name: "Indian Bazar",
      slug: "kim-indian-bazar",
      image: "kim-indian-bazar.jpg",
    },
    {
      name: "La Grande Traversix",
      slug: "kim-la-grande-traversix",
      image: "kim-la-grande-traversix.jpg",
    },
    {
      name: "La Grande Traversée",
      slug: "kim-la-grande-traversee",
      image: "kim-la-grande-traversee.jpg",
    },
    {
      name: "Les Confessions D'Adelaide",
      slug: "kim-les-confessions-d-adelaide",
      image: "kim-les-confessions-d-adelaide.jpg",
    },
    {
      name: "Lilly Catastrophe",
      slug: "kim-lilly-catastrophe",
      image: "kim-lilly-catastrophe.jpg",
    },
    {
      name: "Mi Sodisferai",
      slug: "kim-mi-sodisferai",
      image: "kim-mi-sodisferai.jpg",
    },
    {
      name: "My Dolly Wake Up",
      slug: "kim-my-dolly-wake-up",
      image: "kim-my-dolly-wake-up.jpg",
    },
    { name: "Oui L'Eau", slug: "kim-oui-l-eau", image: "kim-oui-l-eau.jpg" },
    {
      name: "Over and Over",
      slug: "kim-over-and-over",
      image: "kim-over-and-over.jpg",
    },
    {
      name: "Panorama Parano Panoramic Banana Cold Drama",
      slug: "kim-panorama-parano-panoramic-banana-cold-drama",
      image: "kim-panorama-parano-panoramic-banana-cold-drama.jpg",
    },
    {
      name: "Pizza Giani",
      slug: "kim-pizza-giani",
      image: "kim-pizza-giani.jpg",
    },
    {
      name: "Racha Di Aleppo",
      slug: "kim-racha-di-aleppo",
      image: "kim-racha-di-aleppo.jpg",
    },
    {
      name: "Racha From Aleppo",
      slug: "kim-racha-from-aleppo",
      image: "kim-racha-from-aleppo.jpg",
    },
    {
      name: "Radio Lee Doo",
      slug: "kim-radio-lee-doo",
      image: "kim-radio-lee-doo.jpg",
    },
    {
      name: "Radio Valentino",
      slug: "kim-radio-valentino",
      image: "kim-radio-valentino.jpg",
    },
    {
      name: "Sei La Piu Bella",
      slug: "kim-sei-la-piu-bella",
      image: "kim-sei-la-piu-bella.jpg",
    },
    {
      name: "She's A Lion",
      slug: "kim-she-s-a-lion",
      image: "kim-she-s-a-lion.jpg",
    },
    { name: "Stay", slug: "kim-stay", image: "kim-stay.jpg" },
    {
      name: "Swing Swing",
      slug: "kim-swing-swing",
      image: "kim-swing-swing.jpg",
    },
    {
      name: "The Candidate",
      slug: "kim-the-candidate",
      image: "kim-the-candidate.jpg",
    },
    { name: "To Kremlin", slug: "kim-to-kremlin", image: "kim-to-kremlin.jpg" },
    {
      name: "Trema La Frontiera",
      slug: "kim-trema-la-frontiera",
      image: "kim-trema-la-frontiera.jpg",
    },
    {
      name: "Ultra Violence",
      slug: "kim-ultra-violence",
      image: "kim-ultra-violence.jpg",
    },
    { name: "Uptown", slug: "kim-uptown", image: "kim-uptown.jpg" },
    {
      name: "Vi Avverto, Sta Scoppiando Un",
      slug: "kim-vi-avverto-sta-scoppiando-un",
      image: "kim-vi-avverto-sta-scoppiando-un.jpg",
    },
  ],
  "The Spectre": [
    {
      name: "Addison's Tale",
      slug: "the-spectre-addison-s-tale",
      image: "the-spectre-addison-s-tale.jpg",
    },
    {
      name: "All My Life",
      slug: "the-spectre-all-my-life",
      image: "the-spectre-all-my-life.jpg",
    },
    {
      name: "Alone In Hollywood (Feat Lou Marco)",
      slug: "the-spectre-alone-in-hollywood-feat-lou-marco",
      image: "the-spectre-alone-in-hollywood-feat-lou-marco.jpg",
    },
    {
      name: "Chupa",
      slug: "the-spectre-chupa",
      image: "the-spectre-chupa.jpg",
    },
    {
      name: "Dangerous",
      slug: "the-spectre-dangerous",
      image: "the-spectre-dangerous.jpg",
    },
    {
      name: "Dragon",
      slug: "the-spectre-dragon",
      image: "the-spectre-dragon.jpg",
    },
    {
      name: "End Of Days",
      slug: "the-spectre-end-of-days",
      image: "the-spectre-end-of-days.jpg",
    },
    {
      name: "Everywhere I Go",
      slug: "the-spectre-everywhere-i-go",
      image: "the-spectre-everywhere-i-go.jpg",
    },
    {
      name: "Fairytale",
      slug: "the-spectre-fairytale",
      image: "the-spectre-fairytale.jpg",
    },
    {
      name: "Get Naughty With Me",
      slug: "the-spectre-get-naughty-with-me",
      image: "the-spectre-get-naughty-with-me.jpg",
    },
    {
      name: "Go Home",
      slug: "the-spectre-go-home",
      image: "the-spectre-go-home.jpg",
    },
    {
      name: "Good Vibrations",
      slug: "the-spectre-good-vibrations",
      image: "the-spectre-good-vibrations.jpg",
    },
    {
      name: "I Don't Know Why",
      slug: "the-spectre-i-don-t-know-why",
      image: "the-spectre-i-don-t-know-why.jpg",
    },
    {
      name: "I Represent Hip Hop",
      slug: "the-spectre-i-represent-hip-hop",
      image: "the-spectre-i-represent-hip-hop.jpg",
    },
    {
      name: "I Wanna Know (feat.Charly Bell)",
      slug: "the-spectre-i-wanna-know-feat-charly-bell",
      image: "the-spectre-i-wanna-know-feat-charly-bell.jpg",
    },
    {
      name: "Invest In Me (Feat Emma Topolski)",
      slug: "the-spectre-invest-in-me-feat-emma-topolski",
      image: "the-spectre-invest-in-me-feat-emma-topolski.jpg",
    },
    {
      name: "It's Ok",
      slug: "the-spectre-it-s-ok",
      image: "the-spectre-it-s-ok.jpg",
    },
    {
      name: "Let It Go",
      slug: "the-spectre-let-it-go",
      image: "the-spectre-let-it-go.jpg",
    },
    {
      name: "Lick My Stuff",
      slug: "the-spectre-lick-my-stuff",
      image: "the-spectre-lick-my-stuff.jpg",
    },
    {
      name: "Look Around You (Feat Fruit Salad)",
      slug: "the-spectre-look-around-you-feat-fruit-salad",
      image: "the-spectre-look-around-you-feat-fruit-salad.jpg",
    },
    {
      name: "Love Me",
      slug: "the-spectre-love-me",
      image: "the-spectre-love-me.jpg",
    },
    {
      name: "Need To Know Basis",
      slug: "the-spectre-need-to-know-basis",
      image: "the-spectre-need-to-know-basis.jpg",
    },
    {
      name: "Out of Town Girl",
      slug: "the-spectre-out-of-town-girl",
      image: "the-spectre-out-of-town-girl.jpg",
    },
    {
      name: "Playing With Fire",
      slug: "the-spectre-playing-with-fire",
      image: "the-spectre-playing-with-fire.jpg",
    },
    {
      name: "Pullu Pullu",
      slug: "the-spectre-pullu-pullu",
      image: "the-spectre-pullu-pullu.jpg",
    },
    {
      name: "Rifleman's Creed",
      slug: "the-spectre-rifleman-s-creed",
      image: "the-spectre-rifleman-s-creed.jpg",
    },
    {
      name: "Scumbag",
      slug: "the-spectre-scumbag",
      image: "the-spectre-scumbag.jpg",
    },
    {
      name: "Self Tired",
      slug: "the-spectre-self-tired",
      image: "the-spectre-self-tired.jpg",
    },
    {
      name: "Slow Down",
      slug: "the-spectre-slow-down",
      image: "the-spectre-slow-down.jpg",
    },
    {
      name: "Sometimes",
      slug: "the-spectre-sometimes",
      image: "the-spectre-sometimes.jpg",
    },
    {
      name: "Stanley Kubrick",
      slug: "the-spectre-stanley-kubrick",
      image: "the-spectre-stanley-kubrick.jpg",
    },
    {
      name: "Stranger (Feat Nefera)",
      slug: "the-spectre-stranger-feat-nefera",
      image: "the-spectre-stranger-feat-nefera.jpg",
    },
    {
      name: "The Show",
      slug: "the-spectre-the-show",
      image: "the-spectre-the-show.jpg",
    },
    {
      name: "Tramp",
      slug: "the-spectre-tramp",
      image: "the-spectre-tramp.jpg",
    },
    {
      name: "Welcome To The Jungle",
      slug: "the-spectre-welcome-to-the-jungle",
      image: "the-spectre-welcome-to-the-jungle.jpg",
    },
  ],
  Uabos: [
    {
      name: "Adriatica",
      slug: "uabos-adriatica",
      image: "uabos-adriatica.jpg",
    },
  ],
  Leuan: [
    {
      name: "Adventure Time feat. Commonminds",
      slug: "leuan-adventure-time-feat-commonminds",
      image: "leuan-adventure-time-feat-commonminds.jpg",
    },
    {
      name: "Boys That Dance",
      slug: "leuan-boys-that-dance",
      image: "leuan-boys-that-dance.jpg",
    },
    { name: "Closure", slug: "leuan-closure", image: "leuan-closure.jpg" },
    { name: "Goodbye", slug: "leuan-goodbye", image: null },
    {
      name: "Honey Lavender",
      slug: "leuan-honey-lavender",
      image: "leuan-honey-lavender.jpg",
    },
    { name: "Key Your Car", slug: "leuan-key-your-car", image: null },
    {
      name: "Love It When U Love Me",
      slug: "leuan-love-it-when-u-love-me",
      image: "leuan-love-it-when-u-love-me.jpg",
    },
    { name: "Nicotine", slug: "leuan-nicotine", image: "leuan-nicotine.jpg" },
    {
      name: "Over the Garden Wall",
      slug: "leuan-over-the-garden-wall",
      image: "leuan-over-the-garden-wall.jpg",
    },
    {
      name: "Please Stop Talking",
      slug: "leuan-please-stop-talking",
      image: "leuan-please-stop-talking.jpg",
    },
    {
      name: "Pretty When U Cry",
      slug: "leuan-pretty-when-u-cry",
      image: "leuan-pretty-when-u-cry.jpg",
    },
    { name: "R U Down", slug: "leuan-r-u-down", image: "leuan-r-u-down.jpg" },
    { name: "Ramona", slug: "leuan-ramona", image: "leuan-ramona.jpg" },
    {
      name: "Saint California",
      slug: "leuan-saint-california",
      image: "leuan-saint-california.jpg",
    },
    { name: "So Gone", slug: "leuan-so-gone", image: null },
    { name: "Sweet Boy", slug: "leuan-sweet-boy", image: null },
    {
      name: "The Day U Left Me",
      slug: "leuan-the-day-u-left-me",
      image: "leuan-the-day-u-left-me.jpg",
    },
    {
      name: "What Are U Looking For",
      slug: "leuan-what-are-u-looking-for",
      image: "leuan-what-are-u-looking-for.jpg",
    },
    { name: "Woe Me", slug: "leuan-woe-me", image: null },
  ],
  Eluard: [
    {
      name: "Affordable Programmable",
      slug: "eluard-affordable-programmable",
      image: "eluard-affordable-programmable.jpg",
    },
  ],
  "Count Jackula": [
    {
      name: "Africa",
      slug: "count-jackula-africa",
      image: "count-jackula-africa.jpg",
    },
    {
      name: "Africa (Golden Bug Remix)",
      slug: "count-jackula-africa-golden-bug-remix",
      image: "count-jackula-africa-golden-bug-remix.jpg",
    },
    {
      name: "Breakfast",
      slug: "count-jackula-breakfast",
      image: "count-jackula-breakfast.jpg",
    },
    {
      name: "Breakfast (Golden Fleece Remix)",
      slug: "count-jackula-breakfast-golden-fleece-remix",
      image: "count-jackula-breakfast-golden-fleece-remix.jpg",
    },
    {
      name: "Breakfast (The Supermen Lovers Remix)",
      slug: "count-jackula-breakfast-the-supermen-lovers-remix",
      image: "count-jackula-breakfast-the-supermen-lovers-remix.jpg",
    },
    {
      name: "Diner (Rework)",
      slug: "count-jackula-diner-rework",
      image: "count-jackula-diner-rework.jpg",
    },
    {
      name: "Diner For One",
      slug: "count-jackula-diner-for-one",
      image: "count-jackula-diner-for-one.jpg",
    },
    {
      name: "Slowburner",
      slug: "count-jackula-slowburner",
      image: "count-jackula-slowburner.jpg",
    },
  ],
  "Zulu Zulu": [
    {
      name: "Africa Attacks",
      slug: "zulu-zulu-africa-attacks",
      image: "zulu-zulu-africa-attacks.jpg",
    },
    {
      name: "Agumga Family",
      slug: "zulu-zulu-agumga-family",
      image: "zulu-zulu-agumga-family.jpg",
    },
    {
      name: "Bamboo Position",
      slug: "zulu-zulu-bamboo-position",
      image: "zulu-zulu-bamboo-position.jpg",
    },
    {
      name: "Emocions Septentrionals",
      slug: "zulu-zulu-emocions-septentrionals",
      image: "zulu-zulu-emocions-septentrionals.jpg",
    },
    {
      name: "Girafa Coure",
      slug: "zulu-zulu-girafa-coure",
      image: "zulu-zulu-girafa-coure.jpg",
    },
    {
      name: "Kilimanjaro Birds",
      slug: "zulu-zulu-kilimanjaro-birds",
      image: "zulu-zulu-kilimanjaro-birds.jpg",
    },
    {
      name: "Mogambo",
      slug: "zulu-zulu-mogambo",
      image: "zulu-zulu-mogambo.jpg",
    },
    { name: "Ponga", slug: "zulu-zulu-ponga", image: "zulu-zulu-ponga.jpg" },
    {
      name: "Selva Rossa",
      slug: "zulu-zulu-selva-rossa",
      image: "zulu-zulu-selva-rossa.jpg",
    },
    {
      name: "Sports Kenia",
      slug: "zulu-zulu-sports-kenia",
      image: "zulu-zulu-sports-kenia.jpg",
    },
  ],
  Mangor: [
    { name: "Afrika", slug: "mangor-afrika", image: "mangor-afrika.jpg" },
    { name: "Percuter", slug: "mangor-percuter", image: "mangor-percuter.jpg" },
  ],
  Tecwaa: [
    {
      name: "After Ambers",
      slug: "tecwaa-after-ambers",
      image: "tecwaa-after-ambers.jpg",
    },
    {
      name: "Always & The End (Cosmic Dub Edit)",
      slug: "tecwaa-always-and-the-end-cosmic-dub-edit",
      image: "tecwaa-always-and-the-end-cosmic-dub-edit.jpg",
    },
    {
      name: "Back To That Atomic Ether",
      slug: "tecwaa-back-to-that-atomic-ether",
      image: "tecwaa-back-to-that-atomic-ether.jpg",
    },
    { name: "Bania", slug: "tecwaa-bania", image: "tecwaa-bania.jpg" },
    { name: "Cï", slug: "tecwaa-ci", image: "tecwaa-ci.jpg" },
    { name: "Maha", slug: "tecwaa-maha", image: "tecwaa-maha.jpg" },
    { name: "Swords", slug: "tecwaa-swords", image: "tecwaa-swords.jpg" },
    {
      name: "Those Collective Dreams",
      slug: "tecwaa-those-collective-dreams",
      image: "tecwaa-those-collective-dreams.jpg",
    },
    {
      name: "Those Cosmic Plains",
      slug: "tecwaa-those-cosmic-plains",
      image: "tecwaa-those-cosmic-plains.jpg",
    },
    {
      name: "Tides Fall",
      slug: "tecwaa-tides-fall",
      image: "tecwaa-tides-fall.jpg",
    },
    { name: "Xentæh", slug: "tecwaa-xentaeh", image: "tecwaa-xentaeh.jpg" },
  ],
  "Mr Pauli": [
    {
      name: "After Hour Boogie",
      slug: "mr-pauli-after-hour-boogie",
      image: "mr-pauli-after-hour-boogie.jpg",
    },
  ],
  "Dogg Master": [
    {
      name: "After Midnight",
      slug: "dogg-master-after-midnight",
      image: "dogg-master-after-midnight.jpg",
    },
    {
      name: "Blind The Spot",
      slug: "dogg-master-blind-the-spot",
      image: "dogg-master-blind-the-spot.jpg",
    },
    {
      name: "Boogie With Me",
      slug: "dogg-master-boogie-with-me",
      image: "dogg-master-boogie-with-me.jpg",
    },
    {
      name: "Coast To Coast",
      slug: "dogg-master-coast-to-coast",
      image: "dogg-master-coast-to-coast.jpg",
    },
    {
      name: "Do That Dance",
      slug: "dogg-master-do-that-dance",
      image: "dogg-master-do-that-dance.jpg",
    },
    {
      name: "Egypt Funk",
      slug: "dogg-master-egypt-funk",
      image: "dogg-master-egypt-funk.jpg",
    },
    {
      name: "Funk Home",
      slug: "dogg-master-funk-home",
      image: "dogg-master-funk-home.jpg",
    },
    {
      name: "Gangsta Party",
      slug: "dogg-master-gangsta-party",
      image: "dogg-master-gangsta-party.jpg",
    },
    {
      name: "Girls Best Friend",
      slug: "dogg-master-girls-best-friend",
      image: "dogg-master-girls-best-friend.jpg",
    },
    {
      name: "How We Do It",
      slug: "dogg-master-how-we-do-it",
      image: "dogg-master-how-we-do-it.jpg",
    },
    {
      name: "Ignition",
      slug: "dogg-master-ignition",
      image: "dogg-master-ignition.jpg",
    },
    {
      name: "Pop Lock Funk",
      slug: "dogg-master-pop-lock-funk",
      image: "dogg-master-pop-lock-funk.jpg",
    },
    {
      name: "Round N Round",
      slug: "dogg-master-round-n-round",
      image: "dogg-master-round-n-round.jpg",
    },
    {
      name: "Show Me",
      slug: "dogg-master-show-me",
      image: "dogg-master-show-me.jpg",
    },
    {
      name: "Summer Time",
      slug: "dogg-master-summer-time",
      image: "dogg-master-summer-time.jpg",
    },
    {
      name: "Tick It",
      slug: "dogg-master-tick-it",
      image: "dogg-master-tick-it.jpg",
    },
    {
      name: "Waiting For The Sun",
      slug: "dogg-master-waiting-for-the-sun",
      image: "dogg-master-waiting-for-the-sun.jpg",
    },
    {
      name: "Whoop Whoop",
      slug: "dogg-master-whoop-whoop",
      image: "dogg-master-whoop-whoop.jpg",
    },
  ],
  Heart: [
    {
      name: "After Midnight",
      slug: "heart-after-midnight",
      image: "heart-after-midnight.jpg",
    },
  ],
  Sanchez: [
    {
      name: "After You Who Could There Be",
      slug: "sanchez-after-you-who-could-there-be",
      image: "sanchez-after-you-who-could-there-be.jpg",
    },
    {
      name: "Bring Back The Love",
      slug: "sanchez-bring-back-the-love",
      image: "sanchez-bring-back-the-love.jpg",
    },
  ],
  "Laughing Eye": [
    {
      name: "Agnetero Huset",
      slug: "laughing-eye-agnetero-huset",
      image: "laughing-eye-agnetero-huset.jpg",
    },
    {
      name: "August",
      slug: "laughing-eye-august",
      image: "laughing-eye-august.jpg",
    },
    {
      name: "Florian",
      slug: "laughing-eye-florian",
      image: "laughing-eye-florian.jpg",
    },
    {
      name: "Salomon",
      slug: "laughing-eye-salomon",
      image: "laughing-eye-salomon.jpg",
    },
    {
      name: "Thorild",
      slug: "laughing-eye-thorild",
      image: "laughing-eye-thorild.jpg",
    },
  ],
  "Ellis Island": [
    { name: "Ahah", slug: "ellis-island-ahah", image: "ellis-island-ahah.jpg" },
  ],
  "Eh!": [
    {
      name: "Ahora Mismo Ninguna",
      slug: "eh-ahora-mismo-ninguna",
      image: "eh-ahora-mismo-ninguna.jpg",
    },
    {
      name: "Baila Conmigo",
      slug: "eh-baila-conmigo",
      image: "eh-baila-conmigo.jpg",
    },
    {
      name: "Cerca Del Mar",
      slug: "eh-cerca-del-mar",
      image: "eh-cerca-del-mar.jpg",
    },
    {
      name: "Complicidad Adictiva",
      slug: "eh-complicidad-adictiva",
      image: "eh-complicidad-adictiva.jpg",
    },
    { name: "Coraje", slug: "eh-coraje", image: "eh-coraje.jpg" },
    {
      name: "Esqueletos En El Armario",
      slug: "eh-esqueletos-en-el-armario",
      image: "eh-esqueletos-en-el-armario.jpg",
    },
    {
      name: "Ilusiones y Expectativas",
      slug: "eh-ilusiones-y-expectativas",
      image: "eh-ilusiones-y-expectativas.jpg",
    },
    { name: "Km 451", slug: "eh-km-451", image: "eh-km-451.jpg" },
    {
      name: "Labios Vivos",
      slug: "eh-labios-vivos",
      image: "eh-labios-vivos.jpg",
    },
    {
      name: "Sugerir Sin Hablar",
      slug: "eh-sugerir-sin-hablar",
      image: "eh-sugerir-sin-hablar.jpg",
    },
    {
      name: "Titulos y Titulares",
      slug: "eh-titulos-y-titulares",
      image: "eh-titulos-y-titulares.jpg",
    },
    {
      name: "Una Impresion Momentanea",
      slug: "eh-una-impresion-momentanea",
      image: "eh-una-impresion-momentanea.jpg",
    },
  ],
  Ginferno: [
    {
      name: "Ahriman's Dance",
      slug: "ginferno-ahriman-s-dance",
      image: "ginferno-ahriman-s-dance.jpg",
    },
    {
      name: "Mambo Rabbits",
      slug: "ginferno-mambo-rabbits",
      image: "ginferno-mambo-rabbits.jpg",
    },
    {
      name: "Skeletten",
      slug: "ginferno-skeletten",
      image: "ginferno-skeletten.jpg",
    },
    {
      name: "Sugar Ray",
      slug: "ginferno-sugar-ray",
      image: "ginferno-sugar-ray.jpg",
    },
  ],
  Strand: [
    {
      name: "Ain't No Fun , If Bankz Have Non",
      slug: "strand-ain-t-no-fun-if-bankz-have-non",
      image: "strand-ain-t-no-fun-if-bankz-have-non.jpg",
    },
    {
      name: "Ain't Nuttin A B Thang (Om Unit Remix)",
      slug: "strand-ain-t-nuttin-a-b-thang-om-unit-remix",
      image: "strand-ain-t-nuttin-a-b-thang-om-unit-remix.jpg",
    },
    {
      name: "Ain't Nuttin But A Thang",
      slug: "strand-ain-t-nuttin-but-a-thang",
      image: "strand-ain-t-nuttin-but-a-thang.jpg",
    },
    { name: "Arabe", slug: "strand-arabe", image: "strand-arabe.jpg" },
    {
      name: "Bankstaz' Groove",
      slug: "strand-bankstaz-groove",
      image: "strand-bankstaz-groove.jpg",
    },
    {
      name: "De Sucios Desahucios",
      slug: "strand-de-sucios-desahucios",
      image: "strand-de-sucios-desahucios.jpg",
    },
    {
      name: "Dun Laoghaire",
      slug: "strand-dun-laoghaire",
      image: "strand-dun-laoghaire.jpg",
    },
    {
      name: "Insultar y Matar",
      slug: "strand-insultar-y-matar",
      image: "strand-insultar-y-matar.jpg",
    },
    {
      name: "Le Monde Dans Lequel Je vis",
      slug: "strand-le-monde-dans-lequel-je-vis",
      image: "strand-le-monde-dans-lequel-je-vis.jpg",
    },
    {
      name: "Mein Freud Victor",
      slug: "strand-mein-freud-victor",
      image: "strand-mein-freud-victor.jpg",
    },
    {
      name: "Night Buses",
      slug: "strand-night-buses",
      image: "strand-night-buses.jpg",
    },
    {
      name: "Osbourne Ruddock",
      slug: "strand-osbourne-ruddock",
      image: "strand-osbourne-ruddock.jpg",
    },
    {
      name: "Que Soy Companero Cono!",
      slug: "strand-que-soy-companero-cono",
      image: "strand-que-soy-companero-cono.jpg",
    },
    {
      name: "Se Sjuk Ut",
      slug: "strand-se-sjuk-ut",
      image: "strand-se-sjuk-ut.jpg",
    },
    {
      name: "Soy Petroleo, Soy La Muerte",
      slug: "strand-soy-petroleo-soy-la-muerte",
      image: "strand-soy-petroleo-soy-la-muerte.jpg",
    },
  ],
  Maresme: [
    {
      name: "Ain't Summers",
      slug: "maresme-ain-t-summers",
      image: "maresme-ain-t-summers.jpg",
    },
    {
      name: "Cala Osaka",
      slug: "maresme-cala-osaka",
      image: "maresme-cala-osaka.jpg",
    },
    {
      name: "Evening Views",
      slug: "maresme-evening-views",
      image: "maresme-evening-views.jpg",
    },
    {
      name: "Gentle Rain",
      slug: "maresme-gentle-rain",
      image: "maresme-gentle-rain.jpg",
    },
    {
      name: "Golden Coast",
      slug: "maresme-golden-coast",
      image: "maresme-golden-coast.jpg",
    },
    {
      name: "Love Again",
      slug: "maresme-love-again",
      image: "maresme-love-again.jpg",
    },
    {
      name: "Modern Monkey",
      slug: "maresme-modern-monkey",
      image: "maresme-modern-monkey.jpg",
    },
    { name: "Smooth", slug: "maresme-smooth", image: "maresme-smooth.jpg" },
    { name: "Waikiki", slug: "maresme-waikiki", image: "maresme-waikiki.jpg" },
  ],
  "Linda Mirada": [
    {
      name: "Aire (Secret Circuit's Gone Tropic Mix)",
      slug: "linda-mirada-aire-secret-circuit-s-gone-tropic-mix",
      image: "linda-mirada-aire-secret-circuit-s-gone-tropic-mix.jpg",
    },
    {
      name: "Dinamo (Daniel Kyo Remix)",
      slug: "linda-mirada-dinamo-daniel-kyo-remix",
      image: "linda-mirada-dinamo-daniel-kyo-remix.jpg",
    },
    {
      name: "La Costa (Lippelys and Simple Simmetry Remix)",
      slug: "linda-mirada-la-costa-lippelys-and-simple-simmetry-remix",
      image: "linda-mirada-la-costa-lippelys-and-simple-simmetry-remix.jpg",
    },
    {
      name: "Lio En Rio (Sabore Bicoro Remix)",
      slug: "linda-mirada-lio-en-rio-sabore-bicoro-remix",
      image: "linda-mirada-lio-en-rio-sabore-bicoro-remix.jpg",
    },
    {
      name: "Secundario (Phenomenal Hanclap Band Remix)",
      slug: "linda-mirada-secundario-phenomenal-hanclap-band-remix",
      image: "linda-mirada-secundario-phenomenal-hanclap-band-remix.jpg",
    },
  ],
  "Osynlige Mann": [
    {
      name: "Airports",
      slug: "osynlige-mann-airports",
      image: "osynlige-mann-airports.jpg",
    },
    {
      name: "Electrodes",
      slug: "osynlige-mann-electrodes",
      image: "osynlige-mann-electrodes.jpg",
    },
    {
      name: "Exodus",
      slug: "osynlige-mann-exodus",
      image: "osynlige-mann-exodus.jpg",
    },
    {
      name: "Snake Eye",
      slug: "osynlige-mann-snake-eye",
      image: "osynlige-mann-snake-eye.jpg",
    },
  ],
  Myoboku: [
    {
      name: "Al Final Et Que Des Putu Sol",
      slug: "myoboku-al-final-et-que-des-putu-sol",
      image: "myoboku-al-final-et-que-des-putu-sol.jpg",
    },
    {
      name: "Cosa Guapa",
      slug: "myoboku-cosa-guapa",
      image: "myoboku-cosa-guapa.jpg",
    },
    {
      name: "Likitung",
      slug: "myoboku-likitung",
      image: "myoboku-likitung.jpg",
    },
    {
      name: "Tic Viu Pot Ser Ok",
      slug: "myoboku-tic-viu-pot-ser-ok",
      image: "myoboku-tic-viu-pot-ser-ok.jpg",
    },
    {
      name: "Wtf Cafè",
      slug: "myoboku-wtf-cafe",
      image: "myoboku-wtf-cafe.jpg",
    },
  ],
  "The New Raemon": [
    {
      name: "Al Margen (Instrumental)",
      slug: "the-new-raemon-al-margen-instrumental",
      image: "the-new-raemon-al-margen-instrumental.jpg",
    },
    {
      name: "Contrapunto",
      slug: "the-new-raemon-contrapunto",
      image: "the-new-raemon-contrapunto.jpg",
    },
    {
      name: "Desencuentros (Instrumental)",
      slug: "the-new-raemon-desencuentros-instrumental",
      image: "the-new-raemon-desencuentros-instrumental.jpg",
    },
    {
      name: "Dia de difuntos (Instrumental)",
      slug: "the-new-raemon-dia-de-difuntos-instrumental",
      image: "the-new-raemon-dia-de-difuntos-instrumental.jpg",
    },
    {
      name: "El Yeti (Instrumental)",
      slug: "the-new-raemon-el-yeti-instrumental",
      image: "the-new-raemon-el-yeti-instrumental.jpg",
    },
    {
      name: "Los Hechos (Instrumental)",
      slug: "the-new-raemon-los-hechos-instrumental",
      image: "the-new-raemon-los-hechos-instrumental.jpg",
    },
    {
      name: "Mientras sea un intruso (Instrumental)",
      slug: "the-new-raemon-mientras-sea-un-intruso-instrumental",
      image: "the-new-raemon-mientras-sea-un-intruso-instrumental.jpg",
    },
    {
      name: "Money Penny (Instrumental)",
      slug: "the-new-raemon-money-penny-instrumental",
      image: "the-new-raemon-money-penny-instrumental.jpg",
    },
    {
      name: "Oh Rompehielos (Instrumental)",
      slug: "the-new-raemon-oh-rompehielos-instrumental",
      image: "the-new-raemon-oh-rompehielos-instrumental.jpg",
    },
    {
      name: "Quimera (Instrumental)",
      slug: "the-new-raemon-quimera-instrumental",
      image: "the-new-raemon-quimera-instrumental.jpg",
    },
    {
      name: "Reina del Amazonia (Instrumental)",
      slug: "the-new-raemon-reina-del-amazonia-instrumental",
      image: "the-new-raemon-reina-del-amazonia-instrumental.jpg",
    },
    {
      name: "Una Historia Real (Instrumental)",
      slug: "the-new-raemon-una-historia-real-instrumental",
      image: "the-new-raemon-una-historia-real-instrumental.jpg",
    },
  ],
  Honolulu: [
    { name: "Alfa", slug: "honolulu-alfa", image: "honolulu-alfa.jpg" },
    { name: "Bats", slug: "honolulu-bats", image: "honolulu-bats.jpg" },
    {
      name: "Boys In The Park",
      slug: "honolulu-boys-in-the-park",
      image: "honolulu-boys-in-the-park.jpg",
    },
    { name: "Intro", slug: "honolulu-intro", image: "honolulu-intro.jpg" },
    {
      name: "Not A Star",
      slug: "honolulu-not-a-star",
      image: "honolulu-not-a-star.jpg",
    },
    {
      name: "Sparrows",
      slug: "honolulu-sparrows",
      image: "honolulu-sparrows.jpg",
    },
    {
      name: "Stop The Time",
      slug: "honolulu-stop-the-time",
      image: "honolulu-stop-the-time.jpg",
    },
    {
      name: "Summer Danger",
      slug: "honolulu-summer-danger",
      image: "honolulu-summer-danger.jpg",
    },
    {
      name: "What It's Like",
      slug: "honolulu-what-it-s-like",
      image: "honolulu-what-it-s-like.jpg",
    },
  ],
  Retrovisores: [
    {
      name: "Algo Que Ocultar",
      slug: "retrovisores-algo-que-ocultar",
      image: "retrovisores-algo-que-ocultar.jpg",
    },
    {
      name: "Algo Que Ocultar (Instrumental)",
      slug: "retrovisores-algo-que-ocultar-instrumental",
      image: "retrovisores-algo-que-ocultar-instrumental.jpg",
    },
    {
      name: "Me Olvide De Ti (Instrumental)",
      slug: "retrovisores-me-olvide-de-ti-instrumental",
      image: "retrovisores-me-olvide-de-ti-instrumental.jpg",
    },
    {
      name: "Mentiras",
      slug: "retrovisores-mentiras",
      image: "retrovisores-mentiras.jpg",
    },
    {
      name: "Mentiras (Instrumental)",
      slug: "retrovisores-mentiras-instrumental",
      image: "retrovisores-mentiras-instrumental.jpg",
    },
    {
      name: "No Quiero Regresar",
      slug: "retrovisores-no-quiero-regresar",
      image: "retrovisores-no-quiero-regresar.jpg",
    },
    {
      name: "No Quiero Regresar (Instrumental)",
      slug: "retrovisores-no-quiero-regresar-instrumental",
      image: "retrovisores-no-quiero-regresar-instrumental.jpg",
    },
    {
      name: "Pandeayer (Instrumental)",
      slug: "retrovisores-pandeayer-instrumental",
      image: "retrovisores-pandeayer-instrumental.jpg",
    },
    {
      name: "Soy Libre (Instrumental)",
      slug: "retrovisores-soy-libre-instrumental",
      image: "retrovisores-soy-libre-instrumental.jpg",
    },
    {
      name: "Trovador (Instrumental)",
      slug: "retrovisores-trovador-instrumental",
      image: "retrovisores-trovador-instrumental.jpg",
    },
    {
      name: "Tu Cancion De Amor (Instrumental)",
      slug: "retrovisores-tu-cancion-de-amor-instrumental",
      image: "retrovisores-tu-cancion-de-amor-instrumental.jpg",
    },
    {
      name: "Tus Ganas De Huir",
      slug: "retrovisores-tus-ganas-de-huir",
      image: "retrovisores-tus-ganas-de-huir.jpg",
    },
    {
      name: "Tus Ganas de Huir (Instrumental)",
      slug: "retrovisores-tus-ganas-de-huir-instrumental",
      image: "retrovisores-tus-ganas-de-huir-instrumental.jpg",
    },
  ],
  "Jamie 4 President": [
    {
      name: "Ali With An I",
      slug: "jamie-4-president-ali-with-an-i",
      image: "jamie-4-president-ali-with-an-i.jpg",
    },
    {
      name: "Born To Run",
      slug: "jamie-4-president-born-to-run",
      image: "jamie-4-president-born-to-run.jpg",
    },
    {
      name: "Candyfloss",
      slug: "jamie-4-president-candyfloss",
      image: "jamie-4-president-candyfloss.jpg",
    },
    {
      name: "Cheap Perfume",
      slug: "jamie-4-president-cheap-perfume",
      image: "jamie-4-president-cheap-perfume.jpg",
    },
    {
      name: "Consolation Prize",
      slug: "jamie-4-president-consolation-prize",
      image: "jamie-4-president-consolation-prize.jpg",
    },
    {
      name: "Everything Fades",
      slug: "jamie-4-president-everything-fades",
      image: "jamie-4-president-everything-fades.jpg",
    },
    {
      name: "Far From Blue",
      slug: "jamie-4-president-far-from-blue",
      image: "jamie-4-president-far-from-blue.jpg",
    },
    {
      name: "Fever Dream Fridays",
      slug: "jamie-4-president-fever-dream-fridays",
      image: "jamie-4-president-fever-dream-fridays.jpg",
    },
    {
      name: "Lindsay Weird",
      slug: "jamie-4-president-lindsay-weird",
      image: "jamie-4-president-lindsay-weird.jpg",
    },
    {
      name: "Mexico 86",
      slug: "jamie-4-president-mexico-86",
      image: "jamie-4-president-mexico-86.jpg",
    },
    {
      name: "Salty Lemonade",
      slug: "jamie-4-president-salty-lemonade",
      image: "jamie-4-president-salty-lemonade.jpg",
    },
    {
      name: "Secret World",
      slug: "jamie-4-president-secret-world",
      image: "jamie-4-president-secret-world.jpg",
    },
    {
      name: "Seven Magic Words",
      slug: "jamie-4-president-seven-magic-words",
      image: "jamie-4-president-seven-magic-words.jpg",
    },
    {
      name: "Tears Of Benavides",
      slug: "jamie-4-president-tears-of-benavides",
      image: "jamie-4-president-tears-of-benavides.jpg",
    },
    {
      name: "The Human Lightning Rod",
      slug: "jamie-4-president-the-human-lightning-rod",
      image: "jamie-4-president-the-human-lightning-rod.jpg",
    },
    {
      name: "The Mystery Of Amy Woo",
      slug: "jamie-4-president-the-mystery-of-amy-woo",
      image: "jamie-4-president-the-mystery-of-amy-woo.jpg",
    },
    {
      name: "The Pressing Catch",
      slug: "jamie-4-president-the-pressing-catch",
      image: "jamie-4-president-the-pressing-catch.jpg",
    },
    {
      name: "Wrinkle",
      slug: "jamie-4-president-wrinkle",
      image: "jamie-4-president-wrinkle.jpg",
    },
  ],
  Neumodel: [
    {
      name: "Alive feat Eylia",
      slug: "neumodel-alive-feat-eylia",
      image: "neumodel-alive-feat-eylia.jpg",
    },
    {
      name: "Amsterdam",
      slug: "neumodel-amsterdam",
      image: "neumodel-amsterdam.jpg",
    },
    { name: "Ariane", slug: "neumodel-ariane", image: "neumodel-ariane.jpg" },
    {
      name: "Ariane (Instrumental)",
      slug: "neumodel-ariane-instrumental",
      image: "neumodel-ariane-instrumental.jpg",
    },
    { name: "Blue", slug: "neumodel-blue", image: "neumodel-blue.jpg" },
    {
      name: "Clouded feat Tessa B",
      slug: "neumodel-clouded-feat-tessa-b",
      image: "neumodel-clouded-feat-tessa-b.jpg",
    },
    {
      name: "Cry Cry Cry feat Claude Gallo",
      slug: "neumodel-cry-cry-cry-feat-claude-gallo",
      image: "neumodel-cry-cry-cry-feat-claude-gallo.jpg",
    },
    {
      name: "Dicaprio On Acid",
      slug: "neumodel-dicaprio-on-acid",
      image: "neumodel-dicaprio-on-acid.jpg",
    },
    {
      name: "Dicaprio On Acid (Instrumental)",
      slug: "neumodel-dicaprio-on-acid-instrumental",
      image: "neumodel-dicaprio-on-acid-instrumental.jpg",
    },
    {
      name: "Disco Night",
      slug: "neumodel-disco-night",
      image: "neumodel-disco-night.jpg",
    },
    {
      name: "French Coast",
      slug: "neumodel-french-coast",
      image: "neumodel-french-coast.jpg",
    },
    {
      name: "Fresh feat Tessa B",
      slug: "neumodel-fresh-feat-tessa-b",
      image: "neumodel-fresh-feat-tessa-b.jpg",
    },
    {
      name: "Go On feat. Eylia",
      slug: "neumodel-go-on-feat-eylia",
      image: "neumodel-go-on-feat-eylia.jpg",
    },
    {
      name: "Lay Low fea. Eylia",
      slug: "neumodel-lay-low-fea-eylia",
      image: "neumodel-lay-low-fea-eylia.jpg",
    },
    { name: "Numb", slug: "neumodel-numb", image: "neumodel-numb.jpg" },
    {
      name: "Paranoid",
      slug: "neumodel-paranoid",
      image: "neumodel-paranoid.jpg",
    },
    {
      name: "Sippin' feat. Hendrix Harris",
      slug: "neumodel-sippin-feat-hendrix-harris",
      image: "neumodel-sippin-feat-hendrix-harris.jpg",
    },
    {
      name: "Slipknot",
      slug: "neumodel-slipknot",
      image: "neumodel-slipknot.jpg",
    },
    {
      name: "Teens feat. Sirius Trema",
      slug: "neumodel-teens-feat-sirius-trema",
      image: "neumodel-teens-feat-sirius-trema.jpg",
    },
    {
      name: "Zephyr feat Flat",
      slug: "neumodel-zephyr-feat-flat",
      image: "neumodel-zephyr-feat-flat.jpg",
    },
  ],
  "Kyrtz, Lion Ahead": [
    {
      name: "Alive feat Noah",
      slug: "kyrtz-lion-ahead-alive-feat-noah",
      image: "kyrtz-lion-ahead-alive-feat-noah.jpg",
    },
    {
      name: "Keep The Lights feat Noah",
      slug: "kyrtz-lion-ahead-keep-the-lights-feat-noah",
      image: "kyrtz-lion-ahead-keep-the-lights-feat-noah.jpg",
    },
    {
      name: "Own Sound",
      slug: "kyrtz-lion-ahead-own-sound",
      image: "kyrtz-lion-ahead-own-sound.jpg",
    },
  ],
  "Yael Meyer": [
    {
      name: "All Around Me (Instrumental Do Do's)",
      slug: "yael-meyer-all-around-me-instrumental-do-do-s",
      image: "yael-meyer-all-around-me-instrumental-do-do-s.jpg",
    },
    {
      name: "Backbone",
      slug: "yael-meyer-backbone",
      image: "yael-meyer-backbone.jpg",
    },
    {
      name: "Backbone (Instrumental)",
      slug: "yael-meyer-backbone-instrumental",
      image: "yael-meyer-backbone-instrumental.jpg",
    },
    {
      name: "Carry On",
      slug: "yael-meyer-carry-on",
      image: "yael-meyer-carry-on.jpg",
    },
    {
      name: "Everything Will Be Alright",
      slug: "yael-meyer-everything-will-be-alright",
      image: "yael-meyer-everything-will-be-alright.jpg",
    },
    {
      name: "Everything Will Be Alright (Instrumental)",
      slug: "yael-meyer-everything-will-be-alright-instrumental",
      image: "yael-meyer-everything-will-be-alright-instrumental.jpg",
    },
    {
      name: "Favorite Two",
      slug: "yael-meyer-favorite-two",
      image: "yael-meyer-favorite-two.jpg",
    },
    {
      name: "Favorite Two (Instrumental)",
      slug: "yael-meyer-favorite-two-instrumental",
      image: "yael-meyer-favorite-two-instrumental.jpg",
    },
    { name: "Fire", slug: "yael-meyer-fire", image: "yael-meyer-fire.jpg" },
    {
      name: "Fire (Instrumental)",
      slug: "yael-meyer-fire-instrumental",
      image: "yael-meyer-fire-instrumental.jpg",
    },
    {
      name: "Good Things Are Coming My Way",
      slug: "yael-meyer-good-things-are-coming-my-way",
      image: "yael-meyer-good-things-are-coming-my-way.jpg",
    },
    {
      name: "Human Divine",
      slug: "yael-meyer-human-divine",
      image: "yael-meyer-human-divine.jpg",
    },
    {
      name: "I Wonder How",
      slug: "yael-meyer-i-wonder-how",
      image: "yael-meyer-i-wonder-how.jpg",
    },
    {
      name: "I Wonder How (Instrumental)",
      slug: "yael-meyer-i-wonder-how-instrumental",
      image: "yael-meyer-i-wonder-how-instrumental.jpg",
    },
    {
      name: "Que Mas Queda Por Hacer",
      slug: "yael-meyer-que-mas-queda-por-hacer",
      image: "yael-meyer-que-mas-queda-por-hacer.jpg",
    },
    {
      name: "Rain Falling",
      slug: "yael-meyer-rain-falling",
      image: "yael-meyer-rain-falling.jpg",
    },
    {
      name: "Shed Their Fear",
      slug: "yael-meyer-shed-their-fear",
      image: "yael-meyer-shed-their-fear.jpg",
    },
    {
      name: "Shed Their Fear (Instrumental)",
      slug: "yael-meyer-shed-their-fear-instrumental",
      image: "yael-meyer-shed-their-fear-instrumental.jpg",
    },
    {
      name: "Tea For Two",
      slug: "yael-meyer-tea-for-two",
      image: "yael-meyer-tea-for-two.jpg",
    },
    {
      name: "Tea For Two (Instrumental)",
      slug: "yael-meyer-tea-for-two-instrumental",
      image: "yael-meyer-tea-for-two-instrumental.jpg",
    },
    {
      name: "The Night",
      slug: "yael-meyer-the-night",
      image: "yael-meyer-the-night.jpg",
    },
    {
      name: "The Night (Instrumental)",
      slug: "yael-meyer-the-night-instrumental",
      image: "yael-meyer-the-night-instrumental.jpg",
    },
    {
      name: "Tiny Nose",
      slug: "yael-meyer-tiny-nose",
      image: "yael-meyer-tiny-nose.jpg",
    },
    {
      name: "Tiny Nose (Instrumental)",
      slug: "yael-meyer-tiny-nose-instrumental",
      image: "yael-meyer-tiny-nose-instrumental.jpg",
    },
    {
      name: "Used To Be",
      slug: "yael-meyer-used-to-be",
      image: "yael-meyer-used-to-be.jpg",
    },
    {
      name: "Vessel",
      slug: "yael-meyer-vessel",
      image: "yael-meyer-vessel.jpg",
    },
    {
      name: "Warrior Heart",
      slug: "yael-meyer-warrior-heart",
      image: "yael-meyer-warrior-heart.jpg",
    },
    {
      name: "When The Road Ends (Acoustic Version)",
      slug: "yael-meyer-when-the-road-ends-acoustic-version",
      image: "yael-meyer-when-the-road-ends-acoustic-version.jpg",
    },
    {
      name: "When The Roads Ends",
      slug: "yael-meyer-when-the-roads-ends",
      image: "yael-meyer-when-the-roads-ends.jpg",
    },
    {
      name: "Will They Forget",
      slug: "yael-meyer-will-they-forget",
      image: "yael-meyer-will-they-forget.jpg",
    },
    {
      name: "Yo Soy",
      slug: "yael-meyer-yo-soy",
      image: "yael-meyer-yo-soy.jpg",
    },
    {
      name: "Yo Soy (Instrumental)",
      slug: "yael-meyer-yo-soy-instrumental",
      image: "yael-meyer-yo-soy-instrumental.jpg",
    },
  ],
  "Red Eye": [
    {
      name: "All At Once",
      slug: "red-eye-all-at-once",
      image: "red-eye-all-at-once.jpg",
    },
    {
      name: "Cold As Ice",
      slug: "red-eye-cold-as-ice",
      image: "red-eye-cold-as-ice.jpg",
    },
    {
      name: "Cover Me",
      slug: "red-eye-cover-me",
      image: "red-eye-cover-me.jpg",
    },
    {
      name: "Disappear",
      slug: "red-eye-disappear",
      image: "red-eye-disappear.jpg",
    },
    {
      name: "Out Of The Blue",
      slug: "red-eye-out-of-the-blue",
      image: "red-eye-out-of-the-blue.jpg",
    },
    {
      name: "River Road",
      slug: "red-eye-river-road",
      image: "red-eye-river-road.jpg",
    },
    {
      name: "Safe Again",
      slug: "red-eye-safe-again",
      image: "red-eye-safe-again.jpg",
    },
    {
      name: "Season's Ending",
      slug: "red-eye-season-s-ending",
      image: "red-eye-season-s-ending.jpg",
    },
    {
      name: "Sunny Roads",
      slug: "red-eye-sunny-roads",
      image: "red-eye-sunny-roads.jpg",
    },
    {
      name: "The Edge Of The World",
      slug: "red-eye-the-edge-of-the-world",
      image: "red-eye-the-edge-of-the-world.jpg",
    },
  ],
  Vlack: [
    {
      name: "All Decisions Lead To Death",
      slug: "vlack-all-decisions-lead-to-death",
      image: "vlack-all-decisions-lead-to-death.jpg",
    },
    {
      name: "Eagle Ride",
      slug: "vlack-eagle-ride",
      image: "vlack-eagle-ride.jpg",
    },
    {
      name: "Endless Winter",
      slug: "vlack-endless-winter",
      image: "vlack-endless-winter.jpg",
    },
    { name: "Hooked", slug: "vlack-hooked", image: "vlack-hooked.jpg" },
    { name: "I Fell", slug: "vlack-i-fell", image: "vlack-i-fell.jpg" },
    {
      name: "Into The Wind",
      slug: "vlack-into-the-wind",
      image: "vlack-into-the-wind.jpg",
    },
    { name: "Our Trip", slug: "vlack-our-trip", image: "vlack-our-trip.jpg" },
    {
      name: "The Awakening",
      slug: "vlack-the-awakening",
      image: "vlack-the-awakening.jpg",
    },
    {
      name: "The River",
      slug: "vlack-the-river",
      image: "vlack-the-river.jpg",
    },
    {
      name: "Wasteland",
      slug: "vlack-wasteland",
      image: "vlack-wasteland.jpg",
    },
  ],
  Onili: [
    {
      name: "All First Kiss",
      slug: "onili-all-first-kiss",
      image: "onili-all-first-kiss.jpg",
    },
    {
      name: "First Kiss",
      slug: "onili-first-kiss",
      image: "onili-first-kiss.jpg",
    },
    { name: "Games", slug: "onili-games", image: "onili-games.jpg" },
    {
      name: "Games (Kutiman Remix)",
      slug: "onili-games-kutiman-remix",
      image: "onili-games-kutiman-remix.jpg",
    },
    {
      name: "Got To Get",
      slug: "onili-got-to-get",
      image: "onili-got-to-get.jpg",
    },
    { name: "Hadas", slug: "onili-hadas", image: "onili-hadas.jpg" },
    {
      name: "Love Me More",
      slug: "onili-love-me-more",
      image: "onili-love-me-more.jpg",
    },
    { name: "Omizu", slug: "onili-omizu", image: "onili-omizu.jpg" },
    { name: "Pink Ass", slug: "onili-pink-ass", image: "onili-pink-ass.jpg" },
    {
      name: "Sentimental",
      slug: "onili-sentimental",
      image: "onili-sentimental.jpg",
    },
    {
      name: "Sentimental (Alarm & Shochat Vibetown Remix)",
      slug: "onili-sentimental-alarm-and-shochat-vibetown-remix",
      image: "onili-sentimental-alarm-and-shochat-vibetown-remix.jpg",
    },
    {
      name: "Sentimental (Borgore & Onili Body Remix)",
      slug: "onili-sentimental-borgore-and-onili-body-remix",
      image: "onili-sentimental-borgore-and-onili-body-remix.jpg",
    },
    {
      name: "Show Me Your Nipple",
      slug: "onili-show-me-your-nipple",
      image: "onili-show-me-your-nipple.jpg",
    },
    { name: "Sweat", slug: "onili-sweat", image: "onili-sweat.jpg" },
    { name: "Tube Boy", slug: "onili-tube-boy", image: "onili-tube-boy.jpg" },
    {
      name: "Why Did You Go",
      slug: "onili-why-did-you-go",
      image: "onili-why-did-you-go.jpg",
    },
    {
      name: "You Want It I Want It",
      slug: "onili-you-want-it-i-want-it",
      image: "onili-you-want-it-i-want-it.jpg",
    },
  ],
  "Fika and Fabich": [
    {
      name: "All For You",
      slug: "fika-and-fabich-all-for-you",
      image: "fika-and-fabich-all-for-you.jpg",
    },
    {
      name: "Come Over",
      slug: "fika-and-fabich-come-over",
      image: "fika-and-fabich-come-over.jpg",
    },
    {
      name: "Mean",
      slug: "fika-and-fabich-mean",
      image: "fika-and-fabich-mean.jpg",
    },
    {
      name: "Missing Me",
      slug: "fika-and-fabich-missing-me",
      image: "fika-and-fabich-missing-me.jpg",
    },
    {
      name: "PJs In Brazil",
      slug: "fika-and-fabich-pjs-in-brazil",
      image: "fika-and-fabich-pjs-in-brazil.jpg",
    },
  ],
  "Nico de Andrea": [
    {
      name: "All For You",
      slug: "nico-de-andrea-all-for-you",
      image: "nico-de-andrea-all-for-you.jpg",
    },
    {
      name: "Monster feat. Darla Jade (Radio Edit)",
      slug: "nico-de-andrea-monster-feat-darla-jade-radio-edit",
      image: "nico-de-andrea-monster-feat-darla-jade-radio-edit.jpg",
    },
    {
      name: "Wish We Could feat. Darla Jade & Syon",
      slug: "nico-de-andrea-wish-we-could-feat-darla-jade-and-syon",
      image: "nico-de-andrea-wish-we-could-feat-darla-jade-and-syon.jpg",
    },
  ],
  "Wild Animals": [
    {
      name: "All My Friends Are Far Away",
      slug: "wild-animals-all-my-friends-are-far-away",
      image: "wild-animals-all-my-friends-are-far-away.jpg",
    },
    {
      name: "Avocado",
      slug: "wild-animals-avocado",
      image: "wild-animals-avocado.jpg",
    },
    {
      name: "Elevator Boy",
      slug: "wild-animals-elevator-boy",
      image: "wild-animals-elevator-boy.jpg",
    },
    {
      name: "Everybody Loves You When You're Dead",
      slug: "wild-animals-everybody-loves-you-when-you-re-dead",
      image: "wild-animals-everybody-loves-you-when-you-re-dead.jpg",
    },
    {
      name: "Guilty",
      slug: "wild-animals-guilty",
      image: "wild-animals-guilty.jpg",
    },
    {
      name: "Heavy Metal Saved My Life",
      slug: "wild-animals-heavy-metal-saved-my-life",
      image: "wild-animals-heavy-metal-saved-my-life.jpg",
    },
    {
      name: "Logic Makes No Sense",
      slug: "wild-animals-logic-makes-no-sense",
      image: "wild-animals-logic-makes-no-sense.jpg",
    },
    {
      name: "Never Forget",
      slug: "wild-animals-never-forget",
      image: "wild-animals-never-forget.jpg",
    },
    {
      name: "Screaming In Harmony",
      slug: "wild-animals-screaming-in-harmony",
      image: "wild-animals-screaming-in-harmony.jpg",
    },
    {
      name: "Sleeplees Sundays",
      slug: "wild-animals-sleeplees-sundays",
      image: "wild-animals-sleeplees-sundays.jpg",
    },
    {
      name: "Television Blows",
      slug: "wild-animals-television-blows",
      image: "wild-animals-television-blows.jpg",
    },
    {
      name: "The Empires Strikes Back",
      slug: "wild-animals-the-empires-strikes-back",
      image: "wild-animals-the-empires-strikes-back.jpg",
    },
    {
      name: "The Worst Mistake",
      slug: "wild-animals-the-worst-mistake",
      image: "wild-animals-the-worst-mistake.jpg",
    },
    {
      name: "Wave Goodbye Coastline",
      slug: "wild-animals-wave-goodbye-coastline",
      image: "wild-animals-wave-goodbye-coastline.jpg",
    },
  ],
  "Dungeon Acid": [
    {
      name: "All Nighter",
      slug: "dungeon-acid-all-nighter",
      image: "dungeon-acid-all-nighter.jpg",
    },
    {
      name: "Sex Beat",
      slug: "dungeon-acid-sex-beat",
      image: "dungeon-acid-sex-beat.jpg",
    },
  ],
  "It's Not Not": [
    {
      name: "All Vanishes Away",
      slug: "it-s-not-not-all-vanishes-away",
      image: "it-s-not-not-all-vanishes-away.jpg",
    },
    {
      name: "For Sho (Instrumental)",
      slug: "it-s-not-not-for-sho-instrumental",
      image: "it-s-not-not-for-sho-instrumental.jpg",
    },
    {
      name: "For Who Are You Here For",
      slug: "it-s-not-not-for-who-are-you-here-for",
      image: "it-s-not-not-for-who-are-you-here-for.jpg",
    },
    {
      name: "From My Ears (Instrumental)",
      slug: "it-s-not-not-from-my-ears-instrumental",
      image: "it-s-not-not-from-my-ears-instrumental.jpg",
    },
    {
      name: "From My Ears To My Socks",
      slug: "it-s-not-not-from-my-ears-to-my-socks",
      image: "it-s-not-not-from-my-ears-to-my-socks.jpg",
    },
    {
      name: "Golden Rule",
      slug: "it-s-not-not-golden-rule",
      image: "it-s-not-not-golden-rule.jpg",
    },
    {
      name: "Golden Rule (Instrumental)",
      slug: "it-s-not-not-golden-rule-instrumental",
      image: "it-s-not-not-golden-rule-instrumental.jpg",
    },
    {
      name: "Hey Are You Coming Late",
      slug: "it-s-not-not-hey-are-you-coming-late",
      image: "it-s-not-not-hey-are-you-coming-late.jpg",
    },
    {
      name: "Hipnotized",
      slug: "it-s-not-not-hipnotized",
      image: "it-s-not-not-hipnotized.jpg",
    },
    {
      name: "Hipnotized (Instrumental)",
      slug: "it-s-not-not-hipnotized-instrumental",
      image: "it-s-not-not-hipnotized-instrumental.jpg",
    },
    {
      name: "I Wear My Best To Play It With You",
      slug: "it-s-not-not-i-wear-my-best-to-play-it-with-you",
      image: "it-s-not-not-i-wear-my-best-to-play-it-with-you.jpg",
    },
    {
      name: "Pills And Coffees",
      slug: "it-s-not-not-pills-and-coffees",
      image: "it-s-not-not-pills-and-coffees.jpg",
    },
    {
      name: "Psalm 69",
      slug: "it-s-not-not-psalm-69",
      image: "it-s-not-not-psalm-69.jpg",
    },
    {
      name: "Psalm 69 (Instrumental)",
      slug: "it-s-not-not-psalm-69-instrumental",
      image: "it-s-not-not-psalm-69-instrumental.jpg",
    },
    {
      name: "Punch The Belly",
      slug: "it-s-not-not-punch-the-belly",
      image: "it-s-not-not-punch-the-belly.jpg",
    },
    {
      name: "Sacred Meal (Instrumental)",
      slug: "it-s-not-not-sacred-meal-instrumental",
      image: "it-s-not-not-sacred-meal-instrumental.jpg",
    },
    {
      name: "Satellite (Instrumental)",
      slug: "it-s-not-not-satellite-instrumental",
      image: "it-s-not-not-satellite-instrumental.jpg",
    },
    {
      name: "Satellite Of A Satellite",
      slug: "it-s-not-not-satellite-of-a-satellite",
      image: "it-s-not-not-satellite-of-a-satellite.jpg",
    },
    {
      name: "Sharp (Instrumental)",
      slug: "it-s-not-not-sharp-instrumental",
      image: "it-s-not-not-sharp-instrumental.jpg",
    },
    {
      name: "Stop Secuestros (Instrumental)",
      slug: "it-s-not-not-stop-secuestros-instrumental",
      image: "it-s-not-not-stop-secuestros-instrumental.jpg",
    },
    {
      name: "The Time Is Now,The Day Is Today",
      slug: "it-s-not-not-the-time-is-now-the-day-is-today",
      image: "it-s-not-not-the-time-is-now-the-day-is-today.jpg",
    },
    {
      name: "Too Late",
      slug: "it-s-not-not-too-late",
      image: "it-s-not-not-too-late.jpg",
    },
    {
      name: "We're Gonna (Instrumental)",
      slug: "it-s-not-not-we-re-gonna-instrumental",
      image: "it-s-not-not-we-re-gonna-instrumental.jpg",
    },
  ],
  Rodion: [
    {
      name: "Allee Der Kosmonauten",
      slug: "rodion-allee-der-kosmonauten",
      image: "rodion-allee-der-kosmonauten.jpg",
    },
    {
      name: "Alta Marea",
      slug: "rodion-alta-marea",
      image: "rodion-alta-marea.jpg",
    },
    { name: "Aspetta !", slug: "rodion-aspetta", image: "rodion-aspetta.jpg" },
    {
      name: "Bococa Hills",
      slug: "rodion-bococa-hills",
      image: "rodion-bococa-hills.jpg",
    },
    {
      name: "Bosphorus Hippies",
      slug: "rodion-bosphorus-hippies",
      image: "rodion-bosphorus-hippies.jpg",
    },
    {
      name: "Colazione !",
      slug: "rodion-colazione",
      image: "rodion-colazione.jpg",
    },
    {
      name: "Days Like This",
      slug: "rodion-days-like-this",
      image: "rodion-days-like-this.jpg",
    },
    {
      name: "Days Like This (Markus Gibb Remix)",
      slug: "rodion-days-like-this-markus-gibb-remix",
      image: "rodion-days-like-this-markus-gibb-remix.jpg",
    },
    {
      name: "Dimanche Soleil",
      slug: "rodion-dimanche-soleil",
      image: "rodion-dimanche-soleil.jpg",
    },
    {
      name: "Discoteca Romana",
      slug: "rodion-discoteca-romana",
      image: "rodion-discoteca-romana.jpg",
    },
    {
      name: "Discoteca Romana (C90s Remix)",
      slug: "rodion-discoteca-romana-c90s-remix",
      image: "rodion-discoteca-romana-c90s-remix.jpg",
    },
    {
      name: "Discoteca Romana (Instrumental)",
      slug: "rodion-discoteca-romana-instrumental",
      image: "rodion-discoteca-romana-instrumental.jpg",
    },
    { name: "Gamma", slug: "rodion-gamma", image: "rodion-gamma.jpg" },
    {
      name: "If You Wanna Get Higher",
      slug: "rodion-if-you-wanna-get-higher",
      image: "rodion-if-you-wanna-get-higher.jpg",
    },
    {
      name: "Let's Motor",
      slug: "rodion-let-s-motor",
      image: "rodion-let-s-motor.jpg",
    },
    { name: "Medusa", slug: "rodion-medusa", image: "rodion-medusa.jpg" },
    {
      name: "Medusa (Alien Alien Caribbean Remix)",
      slug: "rodion-medusa-alien-alien-caribbean-remix",
      image: "rodion-medusa-alien-alien-caribbean-remix.jpg",
    },
    { name: "Nebula", slug: "rodion-nebula", image: "rodion-nebula.jpg" },
    {
      name: "Nebula (Hugo Sanchez Remix)",
      slug: "rodion-nebula-hugo-sanchez-remix",
      image: "rodion-nebula-hugo-sanchez-remix.jpg",
    },
    { name: "Phobos", slug: "rodion-phobos", image: "rodion-phobos.jpg" },
    { name: "Riposa !", slug: "rodion-riposa", image: "rodion-riposa.jpg" },
    { name: "Run Out", slug: "rodion-run-out", image: "rodion-run-out.jpg" },
    {
      name: "Senza Sesto Senso",
      slug: "rodion-senza-sesto-senso",
      image: "rodion-senza-sesto-senso.jpg",
    },
    { name: "Solenoid", slug: "rodion-solenoid", image: "rodion-solenoid.jpg" },
    {
      name: "Solenoid (Alien Alien Insterstella Dub)",
      slug: "rodion-solenoid-alien-alien-insterstella-dub",
      image: "rodion-solenoid-alien-alien-insterstella-dub.jpg",
    },
    {
      name: "Solenoid (Alien Alien Pluviale Dub)",
      slug: "rodion-solenoid-alien-alien-pluviale-dub",
      image: "rodion-solenoid-alien-alien-pluviale-dub.jpg",
    },
    {
      name: "Teen Age On Jupiter",
      slug: "rodion-teen-age-on-jupiter",
      image: "rodion-teen-age-on-jupiter.jpg",
    },
    {
      name: "Tod und Verklaerung",
      slug: "rodion-tod-und-verklaerung",
      image: "rodion-tod-und-verklaerung.jpg",
    },
    {
      name: "Tornatora",
      slug: "rodion-tornatora",
      image: "rodion-tornatora.jpg",
    },
  ],
  "Ben Bop": [
    { name: "Allou", slug: "ben-bop-allou", image: "ben-bop-allou.jpg" },
    {
      name: "Borom Sarette",
      slug: "ben-bop-borom-sarette",
      image: "ben-bop-borom-sarette.jpg",
    },
    {
      name: "Foumoumé",
      slug: "ben-bop-foumoume",
      image: "ben-bop-foumoume.jpg",
    },
    {
      name: "Petit Frère",
      slug: "ben-bop-petit-frere",
      image: "ben-bop-petit-frere.jpg",
    },
    {
      name: "Punk Is Born In Sénégal",
      slug: "ben-bop-punk-is-born-in-senegal",
      image: "ben-bop-punk-is-born-in-senegal.jpg",
    },
    {
      name: "Warn Dem",
      slug: "ben-bop-warn-dem",
      image: "ben-bop-warn-dem.jpg",
    },
  ],
  Niwel: [{ name: "Alma", slug: "niwel-alma", image: "niwel-alma.jpg" }],
  "9th Cloud": [
    {
      name: "Almost Now Utopia",
      slug: "9th-cloud-almost-now-utopia",
      image: "9th-cloud-almost-now-utopia.jpg",
    },
    {
      name: "Backdrop",
      slug: "9th-cloud-backdrop",
      image: "9th-cloud-backdrop.jpg",
    },
    {
      name: "Cross Resurgences",
      slug: "9th-cloud-cross-resurgences",
      image: "9th-cloud-cross-resurgences.jpg",
    },
    {
      name: "Recommending Silence",
      slug: "9th-cloud-recommending-silence",
      image: "9th-cloud-recommending-silence.jpg",
    },
    {
      name: "Resurgences",
      slug: "9th-cloud-resurgences",
      image: "9th-cloud-resurgences.jpg",
    },
  ],
  "Petit Biscuit": [
    {
      name: "Alone",
      slug: "petit-biscuit-alone",
      image: "petit-biscuit-alone.jpg",
    },
  ],
  Mooders: [
    {
      name: "Alone In My Car",
      slug: "mooders-alone-in-my-car",
      image: "mooders-alone-in-my-car.jpg",
    },
    {
      name: "Bloody Fools",
      slug: "mooders-bloody-fools",
      image: "mooders-bloody-fools.jpg",
    },
    {
      name: "Bloody Fools (Instrumental)",
      slug: "mooders-bloody-fools-instrumental",
      image: "mooders-bloody-fools-instrumental.jpg",
    },
    {
      name: "Brighter Days",
      slug: "mooders-brighter-days",
      image: "mooders-brighter-days.jpg",
    },
    {
      name: "Happy Few",
      slug: "mooders-happy-few",
      image: "mooders-happy-few.jpg",
    },
    {
      name: "Tought It Out (Instrumental)",
      slug: "mooders-tought-it-out-instrumental",
      image: "mooders-tought-it-out-instrumental.jpg",
    },
    {
      name: "You're The One (Instrumental)",
      slug: "mooders-you-re-the-one-instrumental",
      image: "mooders-you-re-the-one-instrumental.jpg",
    },
    {
      name: "You're The One (feat Louise Elliott)",
      slug: "mooders-you-re-the-one-feat-louise-elliott",
      image: "mooders-you-re-the-one-feat-louise-elliott.jpg",
    },
  ],
  Motorama: [
    { name: "Alps", slug: "motorama-alps", image: "motorama-alps.jpg" },
    { name: "Corona", slug: "motorama-corona", image: "motorama-corona.jpg" },
    {
      name: "Dispersed Energy",
      slug: "motorama-dispersed-energy",
      image: "motorama-dispersed-energy.jpg",
    },
    { name: "Eyes", slug: "motorama-eyes", image: "motorama-eyes.jpg" },
    {
      name: "Heavy Wave",
      slug: "motorama-heavy-wave",
      image: "motorama-heavy-wave.jpg",
    },
    {
      name: "Holy Day",
      slug: "motorama-holy-day",
      image: "motorama-holy-day.jpg",
    },
    {
      name: "I See You",
      slug: "motorama-i-see-you",
      image: "motorama-i-see-you.jpg",
    },
    {
      name: "Impratical Advice",
      slug: "motorama-impratical-advice",
      image: "motorama-impratical-advice.jpg",
    },
    {
      name: "Lottery",
      slug: "motorama-lottery",
      image: "motorama-lottery.jpg",
    },
    { name: "Mirror", slug: "motorama-mirror", image: "motorama-mirror.jpg" },
    { name: "Old", slug: "motorama-old", image: "motorama-old.jpg" },
    {
      name: "Red Drop",
      slug: "motorama-red-drop",
      image: "motorama-red-drop.jpg",
    },
    {
      name: "Rose In The Vase",
      slug: "motorama-rose-in-the-vase",
      image: "motorama-rose-in-the-vase.jpg",
    },
    {
      name: "She Is There",
      slug: "motorama-she-is-there",
      image: "motorama-she-is-there.jpg",
    },
    {
      name: "Similar Way",
      slug: "motorama-similar-way",
      image: "motorama-similar-way.jpg",
    },
    {
      name: "Tell Me",
      slug: "motorama-tell-me",
      image: "motorama-tell-me.jpg",
    },
    {
      name: "To The South",
      slug: "motorama-to-the-south",
      image: "motorama-to-the-south.jpg",
    },
    {
      name: "White Light",
      slug: "motorama-white-light",
      image: "motorama-white-light.jpg",
    },
    {
      name: "Wind In Her Hair",
      slug: "motorama-wind-in-her-hair",
      image: "motorama-wind-in-her-hair.jpg",
    },
    {
      name: "Write To Me",
      slug: "motorama-write-to-me",
      image: "motorama-write-to-me.jpg",
    },
  ],
  Stupead: [
    { name: "Alright", slug: "stupead-alright", image: "stupead-alright.jpg" },
    {
      name: "By The Sun",
      slug: "stupead-by-the-sun",
      image: "stupead-by-the-sun.jpg",
    },
    { name: "Dude", slug: "stupead-dude", image: "stupead-dude.jpg" },
    {
      name: "From Up There",
      slug: "stupead-from-up-there",
      image: "stupead-from-up-there.jpg",
    },
    { name: "Get It", slug: "stupead-get-it", image: "stupead-get-it.jpg" },
    { name: "Julani", slug: "stupead-julani", image: "stupead-julani.jpg" },
    {
      name: "Let Me Know",
      slug: "stupead-let-me-know",
      image: "stupead-let-me-know.jpg",
    },
    { name: "Life", slug: "stupead-life", image: "stupead-life.jpg" },
    {
      name: "My Fault",
      slug: "stupead-my-fault",
      image: "stupead-my-fault.jpg",
    },
    {
      name: "Reminder",
      slug: "stupead-reminder",
      image: "stupead-reminder.jpg",
    },
    {
      name: "Viva El Peru",
      slug: "stupead-viva-el-peru",
      image: "stupead-viva-el-peru.jpg",
    },
  ],
  Attom: [{ name: "Always", slug: "attom-always", image: "attom-always.jpg" }],
  "Parlor Snakes": [
    {
      name: "Always You",
      slug: "parlor-snakes-always-you",
      image: "parlor-snakes-always-you.jpg",
    },
    {
      name: "Darkness Rises",
      slug: "parlor-snakes-darkness-rises",
      image: "parlor-snakes-darkness-rises.jpg",
    },
    {
      name: "Das Meer",
      slug: "parlor-snakes-das-meer",
      image: "parlor-snakes-das-meer.jpg",
    },
    {
      name: "Delicates Creatures",
      slug: "parlor-snakes-delicates-creatures",
      image: "parlor-snakes-delicates-creatures.jpg",
    },
    {
      name: "Dirt To Gold",
      slug: "parlor-snakes-dirt-to-gold",
      image: "parlor-snakes-dirt-to-gold.jpg",
    },
    {
      name: "End Of Love",
      slug: "parlor-snakes-end-of-love",
      image: "parlor-snakes-end-of-love.jpg",
    },
    {
      name: "Fade In The Light",
      slug: "parlor-snakes-fade-in-the-light",
      image: "parlor-snakes-fade-in-the-light.jpg",
    },
    {
      name: "Frequency",
      slug: "parlor-snakes-frequency",
      image: "parlor-snakes-frequency.jpg",
    },
    {
      name: "Here Comes The Hell",
      slug: "parlor-snakes-here-comes-the-hell",
      image: "parlor-snakes-here-comes-the-hell.jpg",
    },
    {
      name: "Just Drive",
      slug: "parlor-snakes-just-drive",
      image: "parlor-snakes-just-drive.jpg",
    },
    {
      name: "Man Is The Night",
      slug: "parlor-snakes-man-is-the-night",
      image: "parlor-snakes-man-is-the-night.jpg",
    },
    {
      name: "Marc Bolan's Fifth Dream",
      slug: "parlor-snakes-marc-bolan-s-fifth-dream",
      image: "parlor-snakes-marc-bolan-s-fifth-dream.jpg",
    },
    {
      name: "Nylon And Milk",
      slug: "parlor-snakes-nylon-and-milk",
      image: "parlor-snakes-nylon-and-milk.jpg",
    },
    {
      name: "Same Old Scene",
      slug: "parlor-snakes-same-old-scene",
      image: "parlor-snakes-same-old-scene.jpg",
    },
    {
      name: "Serpent",
      slug: "parlor-snakes-serpent",
      image: "parlor-snakes-serpent.jpg",
    },
    {
      name: "Strangers",
      slug: "parlor-snakes-strangers",
      image: "parlor-snakes-strangers.jpg",
    },
    {
      name: "Sure Shot",
      slug: "parlor-snakes-sure-shot",
      image: "parlor-snakes-sure-shot.jpg",
    },
    {
      name: "The Ritual",
      slug: "parlor-snakes-the-ritual",
      image: "parlor-snakes-the-ritual.jpg",
    },
    {
      name: "Watch Me Live",
      slug: "parlor-snakes-watch-me-live",
      image: "parlor-snakes-watch-me-live.jpg",
    },
    {
      name: "We Are The Moon",
      slug: "parlor-snakes-we-are-the-moon",
      image: "parlor-snakes-we-are-the-moon.jpg",
    },
    {
      name: "Wonderland",
      slug: "parlor-snakes-wonderland",
      image: "parlor-snakes-wonderland.jpg",
    },
  ],
  "Oso Leone": [
    {
      name: "Alçaria",
      slug: "oso-leone-alcaria",
      image: "oso-leone-alcaria.jpg",
    },
    {
      name: "Bornicula",
      slug: "oso-leone-bornicula",
      image: "oso-leone-bornicula.jpg",
    },
    { name: "Cactus", slug: "oso-leone-cactus", image: "oso-leone-cactus.jpg" },
    { name: "Clivia", slug: "oso-leone-clivia", image: "oso-leone-clivia.jpg" },
    {
      name: "Crisantemo",
      slug: "oso-leone-crisantemo",
      image: "oso-leone-crisantemo.jpg",
    },
    { name: "Falco", slug: "oso-leone-falco", image: "oso-leone-falco.jpg" },
    { name: "Ficus", slug: "oso-leone-ficus", image: "oso-leone-ficus.jpg" },
    {
      name: "Ficus II",
      slug: "oso-leone-ficus-ii",
      image: "oso-leone-ficus-ii.jpg",
    },
    { name: "Fire", slug: "oso-leone-fire", image: "oso-leone-fire.jpg" },
    { name: "Lobo", slug: "oso-leone-lobo", image: "oso-leone-lobo.jpg" },
    {
      name: "Love Bird",
      slug: "oso-leone-love-bird",
      image: "oso-leone-love-bird.jpg",
    },
    {
      name: "Monstera",
      slug: "oso-leone-monstera",
      image: "oso-leone-monstera.jpg",
    },
    {
      name: "Papermoon",
      slug: "oso-leone-papermoon",
      image: "oso-leone-papermoon.jpg",
    },
    {
      name: "Rebellion",
      slug: "oso-leone-rebellion",
      image: "oso-leone-rebellion.jpg",
    },
    { name: "Salvia", slug: "oso-leone-salvia", image: "oso-leone-salvia.jpg" },
    {
      name: "Sanseviera",
      slug: "oso-leone-sanseviera",
      image: "oso-leone-sanseviera.jpg",
    },
    {
      name: "The Benden Stone",
      slug: "oso-leone-the-benden-stone",
      image: "oso-leone-the-benden-stone.jpg",
    },
    {
      name: "Trivial",
      slug: "oso-leone-trivial",
      image: "oso-leone-trivial.jpg",
    },
    {
      name: "Trivial (Part II)",
      slug: "oso-leone-trivial-part-ii",
      image: "oso-leone-trivial-part-ii.jpg",
    },
  ],
  "Merryn Jeann": [
    {
      name: "Am I Plastic",
      slug: "merryn-jeann-am-i-plastic",
      image: "merryn-jeann-am-i-plastic.jpg",
    },
    {
      name: "Canopy",
      slug: "merryn-jeann-canopy",
      image: "merryn-jeann-canopy.jpg",
    },
    {
      name: "Dragons",
      slug: "merryn-jeann-dragons",
      image: "merryn-jeann-dragons.jpg",
    },
    {
      name: "Floating Away",
      slug: "merryn-jeann-floating-away",
      image: "merryn-jeann-floating-away.jpg",
    },
    { name: "Home", slug: "merryn-jeann-home", image: "merryn-jeann-home.jpg" },
    {
      name: "Out Of The City (To Find Air)",
      slug: "merryn-jeann-out-of-the-city-to-find-air",
      image: "merryn-jeann-out-of-the-city-to-find-air.jpg",
    },
    {
      name: "See Saw",
      slug: "merryn-jeann-see-saw",
      image: "merryn-jeann-see-saw.jpg",
    },
  ],
  "The Poncho Brothers": [
    {
      name: "Amantes Latinos",
      slug: "the-poncho-brothers-amantes-latinos",
      image: "the-poncho-brothers-amantes-latinos.jpg",
    },
    {
      name: "Amantes Latinos (Zoovox Remix)",
      slug: "the-poncho-brothers-amantes-latinos-zoovox-remix",
      image: "the-poncho-brothers-amantes-latinos-zoovox-remix.jpg",
    },
    {
      name: "Danza Oscuro",
      slug: "the-poncho-brothers-danza-oscuro",
      image: "the-poncho-brothers-danza-oscuro.jpg",
    },
    {
      name: "Oro Liquido",
      slug: "the-poncho-brothers-oro-liquido",
      image: "the-poncho-brothers-oro-liquido.jpg",
    },
  ],
  Alvan: [
    { name: "Amazone", slug: "alvan-amazone", image: "alvan-amazone.jpg" },
    {
      name: "Bodhyanga",
      slug: "alvan-bodhyanga",
      image: "alvan-bodhyanga.jpg",
    },
    {
      name: "Chinatown",
      slug: "alvan-chinatown",
      image: "alvan-chinatown.jpg",
    },
    {
      name: "Dame de Coeur",
      slug: "alvan-dame-de-coeur",
      image: "alvan-dame-de-coeur.jpg",
    },
    { name: "Home", slug: "alvan-home", image: "alvan-home.jpg" },
    { name: "Kangei", slug: "alvan-kangei", image: "alvan-kangei.jpg" },
    { name: "Pure", slug: "alvan-pure", image: "alvan-pure.jpg" },
    { name: "Sanzel", slug: "alvan-sanzel", image: "alvan-sanzel.jpg" },
  ],
  Lerosa: [
    { name: "Amensia", slug: "lerosa-amensia", image: "lerosa-amensia.jpg" },
  ],
  "Front De Cadeaux": [
    {
      name: "Amo Robin",
      slug: "front-de-cadeaux-amo-robin",
      image: "front-de-cadeaux-amo-robin.jpg",
    },
    {
      name: "Infodrogue",
      slug: "front-de-cadeaux-infodrogue",
      image: "front-de-cadeaux-infodrogue.jpg",
    },
    {
      name: "Infodrogue (JD Twitch Remix)",
      slug: "front-de-cadeaux-infodrogue-jd-twitch-remix",
      image: "front-de-cadeaux-infodrogue-jd-twitch-remix.jpg",
    },
    {
      name: "Pédé BPM (Fabrizio Mammarella Remix)",
      slug: "front-de-cadeaux-pede-bpm-fabrizio-mammarella-remix",
      image: "front-de-cadeaux-pede-bpm-fabrizio-mammarella-remix.jpg",
    },
    {
      name: "Something Wrong (Fabrizio Mammarella Remix)",
      slug: "front-de-cadeaux-something-wrong-fabrizio-mammarella-remix",
      image: "front-de-cadeaux-something-wrong-fabrizio-mammarella-remix.jpg",
    },
  ],
  Plou: [
    {
      name: "Amor Acoustic",
      slug: "plou-amor-acoustic",
      image: "plou-amor-acoustic.jpg",
    },
    { name: "Cap Girat", slug: "plou-cap-girat", image: "plou-cap-girat.jpg" },
    {
      name: "Cap Girat (Instrumental)",
      slug: "plou-cap-girat-instrumental",
      image: "plou-cap-girat-instrumental.jpg",
    },
    { name: "Deja Vu", slug: "plou-deja-vu", image: "plou-deja-vu.jpg" },
    { name: "Reach You", slug: "plou-reach-you", image: "plou-reach-you.jpg" },
    { name: "Stockholm", slug: "plou-stockholm", image: "plou-stockholm.jpg" },
    { name: "Summer", slug: "plou-summer", image: "plou-summer.jpg" },
    {
      name: "Where I Am",
      slug: "plou-where-i-am",
      image: "plou-where-i-am.jpg",
    },
  ],
  "The Rodeo": [
    { name: "Amulet", slug: "the-rodeo-amulet", image: "the-rodeo-amulet.jpg" },
    {
      name: "Devil In Me",
      slug: "the-rodeo-devil-in-me",
      image: "the-rodeo-devil-in-me.jpg",
    },
    {
      name: "Please Don't Knock At My Door",
      slug: "the-rodeo-please-don-t-knock-at-my-door",
      image: "the-rodeo-please-don-t-knock-at-my-door.jpg",
    },
    {
      name: "Suzy Blue",
      slug: "the-rodeo-suzy-blue",
      image: "the-rodeo-suzy-blue.jpg",
    },
  ],
  "The Spectre and Sam Douillet": [
    {
      name: "Anastasia",
      slug: "the-spectre-and-sam-douillet-anastasia",
      image: "the-spectre-and-sam-douillet-anastasia.jpg",
    },
    {
      name: "Carry Me Home",
      slug: "the-spectre-and-sam-douillet-carry-me-home",
      image: "the-spectre-and-sam-douillet-carry-me-home.jpg",
    },
    {
      name: "Sacrifice",
      slug: "the-spectre-and-sam-douillet-sacrifice",
      image: "the-spectre-and-sam-douillet-sacrifice.jpg",
    },
  ],
  Fiori: [
    {
      name: "Andiamo (Lou Teti Remix)",
      slug: "fiori-andiamo-lou-teti-remix",
      image: "fiori-andiamo-lou-teti-remix.jpg",
    },
    {
      name: "Andiamo (Mirror People Remix)",
      slug: "fiori-andiamo-mirror-people-remix",
      image: "fiori-andiamo-mirror-people-remix.jpg",
    },
    {
      name: "Andiamo (Original)",
      slug: "fiori-andiamo-original",
      image: "fiori-andiamo-original.jpg",
    },
    {
      name: "Andiamo (Pink Stallone Remix)",
      slug: "fiori-andiamo-pink-stallone-remix",
      image: "fiori-andiamo-pink-stallone-remix.jpg",
    },
    {
      name: "Andiamo (Populette Remix)",
      slug: "fiori-andiamo-populette-remix",
      image: "fiori-andiamo-populette-remix.jpg",
    },
  ],
  "Rebecca Dry": [
    {
      name: "Angel",
      slug: "rebecca-dry-angel",
      image: "rebecca-dry-angel.jpg",
    },
    {
      name: "Bad Thoughts (Instrumental)",
      slug: "rebecca-dry-bad-thoughts-instrumental",
      image: "rebecca-dry-bad-thoughts-instrumental.jpg",
    },
    {
      name: "Didn't I",
      slug: "rebecca-dry-didn-t-i",
      image: "rebecca-dry-didn-t-i.jpg",
    },
    {
      name: "Heartbreak",
      slug: "rebecca-dry-heartbreak",
      image: "rebecca-dry-heartbreak.jpg",
    },
    {
      name: "House Of Cards",
      slug: "rebecca-dry-house-of-cards",
      image: "rebecca-dry-house-of-cards.jpg",
    },
    { name: "I Do", slug: "rebecca-dry-i-do", image: "rebecca-dry-i-do.jpg" },
    {
      name: "I Like It",
      slug: "rebecca-dry-i-like-it",
      image: "rebecca-dry-i-like-it.jpg",
    },
    {
      name: "I Saw You",
      slug: "rebecca-dry-i-saw-you",
      image: "rebecca-dry-i-saw-you.jpg",
    },
    {
      name: "Keep Trying",
      slug: "rebecca-dry-keep-trying",
      image: "rebecca-dry-keep-trying.jpg",
    },
    {
      name: "Life Ain't A Game",
      slug: "rebecca-dry-life-ain-t-a-game",
      image: "rebecca-dry-life-ain-t-a-game.jpg",
    },
    {
      name: "Lovers",
      slug: "rebecca-dry-lovers",
      image: "rebecca-dry-lovers.jpg",
    },
    {
      name: "Magic Stick",
      slug: "rebecca-dry-magic-stick",
      image: "rebecca-dry-magic-stick.jpg",
    },
    {
      name: "Make My Life Right",
      slug: "rebecca-dry-make-my-life-right",
      image: "rebecca-dry-make-my-life-right.jpg",
    },
    {
      name: "Melody In E",
      slug: "rebecca-dry-melody-in-e",
      image: "rebecca-dry-melody-in-e.jpg",
    },
    {
      name: "New World",
      slug: "rebecca-dry-new-world",
      image: "rebecca-dry-new-world.jpg",
    },
    { name: "Over", slug: "rebecca-dry-over", image: "rebecca-dry-over.jpg" },
    {
      name: "Sorry",
      slug: "rebecca-dry-sorry",
      image: "rebecca-dry-sorry.jpg",
    },
    {
      name: "Tell Me",
      slug: "rebecca-dry-tell-me",
      image: "rebecca-dry-tell-me.jpg",
    },
    {
      name: "This World Is All Insane",
      slug: "rebecca-dry-this-world-is-all-insane",
      image: null,
    },
    {
      name: "Waiting For You",
      slug: "rebecca-dry-waiting-for-you",
      image: "rebecca-dry-waiting-for-you.jpg",
    },
    {
      name: "Watch What He Says",
      slug: "rebecca-dry-watch-what-he-says",
      image: "rebecca-dry-watch-what-he-says.jpg",
    },
    {
      name: "What You Gave",
      slug: "rebecca-dry-what-you-gave",
      image: "rebecca-dry-what-you-gave.jpg",
    },
    {
      name: "You Had Your Chance",
      slug: "rebecca-dry-you-had-your-chance",
      image: "rebecca-dry-you-had-your-chance.jpg",
    },
  ],
  "DJ Cam Quartet": [
    {
      name: "Angel Heart",
      slug: "dj-cam-quartet-angel-heart",
      image: "dj-cam-quartet-angel-heart.jpg",
    },
    {
      name: "Boss Guitar",
      slug: "dj-cam-quartet-boss-guitar",
      image: "dj-cam-quartet-boss-guitar.jpg",
    },
    {
      name: "Do For Love",
      slug: "dj-cam-quartet-do-for-love",
      image: "dj-cam-quartet-do-for-love.jpg",
    },
    {
      name: "Everybody Loves The Sunshine feat Inlove",
      slug: "dj-cam-quartet-everybody-loves-the-sunshine-feat-inlove",
      image: "dj-cam-quartet-everybody-loves-the-sunshine-feat-inlove.jpg",
    },
    {
      name: "Funny For Janet",
      slug: "dj-cam-quartet-funny-for-janet",
      image: "dj-cam-quartet-funny-for-janet.jpg",
    },
    {
      name: "Gangsta Shit",
      slug: "dj-cam-quartet-gangsta-shit",
      image: "dj-cam-quartet-gangsta-shit.jpg",
    },
    {
      name: "Herbie",
      slug: "dj-cam-quartet-herbie",
      image: "dj-cam-quartet-herbie.jpg",
    },
    {
      name: "Hold Tight",
      slug: "dj-cam-quartet-hold-tight",
      image: "dj-cam-quartet-hold-tight.jpg",
    },
    {
      name: "It's Yours feat Inlove",
      slug: "dj-cam-quartet-it-s-yours-feat-inlove",
      image: "dj-cam-quartet-it-s-yours-feat-inlove.jpg",
    },
    {
      name: "Litle Sunflower feat Inlove",
      slug: "dj-cam-quartet-litle-sunflower-feat-inlove",
      image: "dj-cam-quartet-litle-sunflower-feat-inlove.jpg",
    },
    {
      name: "Magic Wand",
      slug: "dj-cam-quartet-magic-wand",
      image: "dj-cam-quartet-magic-wand.jpg",
    },
    {
      name: "Mental Invasion",
      slug: "dj-cam-quartet-mental-invasion",
      image: "dj-cam-quartet-mental-invasion.jpg",
    },
    {
      name: "Montara",
      slug: "dj-cam-quartet-montara",
      image: "dj-cam-quartet-montara.jpg",
    },
    {
      name: "Mystic Brew",
      slug: "dj-cam-quartet-mystic-brew",
      image: "dj-cam-quartet-mystic-brew.jpg",
    },
    {
      name: "Nebulosa",
      slug: "dj-cam-quartet-nebulosa",
      image: "dj-cam-quartet-nebulosa.jpg",
    },
    {
      name: "New York New York",
      slug: "dj-cam-quartet-new-york-new-york",
      image: "dj-cam-quartet-new-york-new-york.jpg",
    },
    {
      name: "Quincy",
      slug: "dj-cam-quartet-quincy",
      image: "dj-cam-quartet-quincy.jpg",
    },
    {
      name: "Raise Up",
      slug: "dj-cam-quartet-raise-up",
      image: "dj-cam-quartet-raise-up.jpg",
    },
    {
      name: "Rebirth Of Cool",
      slug: "dj-cam-quartet-rebirth-of-cool",
      image: "dj-cam-quartet-rebirth-of-cool.jpg",
    },
    {
      name: "Saint Germain",
      slug: "dj-cam-quartet-saint-germain",
      image: "dj-cam-quartet-saint-germain.jpg",
    },
    {
      name: "So Sweet",
      slug: "dj-cam-quartet-so-sweet",
      image: "dj-cam-quartet-so-sweet.jpg",
    },
    {
      name: "Stay",
      slug: "dj-cam-quartet-stay",
      image: "dj-cam-quartet-stay.jpg",
    },
    {
      name: "The Sweetest Pain",
      slug: "dj-cam-quartet-the-sweetest-pain",
      image: "dj-cam-quartet-the-sweetest-pain.jpg",
    },
    {
      name: "Think Twice",
      slug: "dj-cam-quartet-think-twice",
      image: "dj-cam-quartet-think-twice.jpg",
    },
    {
      name: "Un Été à Paris",
      slug: "dj-cam-quartet-un-ete-a-paris",
      image: "dj-cam-quartet-un-ete-a-paris.jpg",
    },
    {
      name: "Visions",
      slug: "dj-cam-quartet-visions",
      image: "dj-cam-quartet-visions.jpg",
    },
    {
      name: "You've Got To Have Freedom feat Inlove",
      slug: "dj-cam-quartet-you-ve-got-to-have-freedom-feat-inlove",
      image: "dj-cam-quartet-you-ve-got-to-have-freedom-feat-inlove.jpg",
    },
  ],
  "Kill This Kant": [
    {
      name: "Angels And Heaven",
      slug: "kill-this-kant-angels-and-heaven",
      image: "kill-this-kant-angels-and-heaven.jpg",
    },
    {
      name: "Bitchy Kitten",
      slug: "kill-this-kant-bitchy-kitten",
      image: "kill-this-kant-bitchy-kitten.jpg",
    },
    {
      name: "Medusa Rave",
      slug: "kill-this-kant-medusa-rave",
      image: "kill-this-kant-medusa-rave.jpg",
    },
  ],
  Lukebox: [
    {
      name: "Angola Acid",
      slug: "lukebox-angola-acid",
      image: "lukebox-angola-acid.jpg",
    },
  ],
  "Daniel Melingo": [
    {
      name: "Angurrienta",
      slug: "daniel-melingo-angurrienta",
      image: "daniel-melingo-angurrienta.jpg",
    },
    {
      name: "En Un Bondi Color Humo",
      slug: "daniel-melingo-en-un-bondi-color-humo",
      image: "daniel-melingo-en-un-bondi-color-humo.jpg",
    },
    {
      name: "Julepe En La Tierra",
      slug: "daniel-melingo-julepe-en-la-tierra",
      image: "daniel-melingo-julepe-en-la-tierra.jpg",
    },
    {
      name: "Luisito",
      slug: "daniel-melingo-luisito",
      image: "daniel-melingo-luisito.jpg",
    },
    {
      name: "Montmartre De Hoy",
      slug: "daniel-melingo-montmartre-de-hoy",
      image: "daniel-melingo-montmartre-de-hoy.jpg",
    },
    {
      name: "Narigon",
      slug: "daniel-melingo-narigon",
      image: "daniel-melingo-narigon.jpg",
    },
  ],
  "Rachael Dadd": [
    {
      name: "Animal Mineral",
      slug: "rachael-dadd-animal-mineral",
      image: "rachael-dadd-animal-mineral.jpg",
    },
    {
      name: "Bounce The Ball",
      slug: "rachael-dadd-bounce-the-ball",
      image: "rachael-dadd-bounce-the-ball.jpg",
    },
    {
      name: "Come Together",
      slug: "rachael-dadd-come-together",
      image: "rachael-dadd-come-together.jpg",
    },
    {
      name: "I Am Your Home",
      slug: "rachael-dadd-i-am-your-home",
      image: "rachael-dadd-i-am-your-home.jpg",
    },
    {
      name: "Let It Rise",
      slug: "rachael-dadd-let-it-rise",
      image: "rachael-dadd-let-it-rise.jpg",
    },
    {
      name: "Make A Sentence",
      slug: "rachael-dadd-make-a-sentence",
      image: "rachael-dadd-make-a-sentence.jpg",
    },
    {
      name: "Ours Arms",
      slug: "rachael-dadd-ours-arms",
      image: "rachael-dadd-ours-arms.jpg",
    },
    {
      name: "Strike Our Scythes",
      slug: "rachael-dadd-strike-our-scythes",
      image: "rachael-dadd-strike-our-scythes.jpg",
    },
    {
      name: "Tap The Slap",
      slug: "rachael-dadd-tap-the-slap",
      image: "rachael-dadd-tap-the-slap.jpg",
    },
    {
      name: "Three",
      slug: "rachael-dadd-three",
      image: "rachael-dadd-three.jpg",
    },
    {
      name: "Wake It",
      slug: "rachael-dadd-wake-it",
      image: "rachael-dadd-wake-it.jpg",
    },
    {
      name: "What Have You Made",
      slug: "rachael-dadd-what-have-you-made",
      image: "rachael-dadd-what-have-you-made.jpg",
    },
  ],
  Santoré: [
    {
      name: "Another Man",
      slug: "santore-another-man",
      image: "santore-another-man.jpg",
    },
    {
      name: "Another Man (Instrumental)",
      slug: "santore-another-man-instrumental",
      image: "santore-another-man-instrumental.jpg",
    },
    {
      name: "Firedamp",
      slug: "santore-firedamp",
      image: "santore-firedamp.jpg",
    },
    {
      name: "Firedamp (Instrumental)",
      slug: "santore-firedamp-instrumental",
      image: "santore-firedamp-instrumental.jpg",
    },
    {
      name: "Revoir La Mer",
      slug: "santore-revoir-la-mer",
      image: "santore-revoir-la-mer.jpg",
    },
    {
      name: "Rochefort",
      slug: "santore-rochefort",
      image: "santore-rochefort.jpg",
    },
    {
      name: "That Ball",
      slug: "santore-that-ball",
      image: "santore-that-ball.jpg",
    },
    {
      name: "Transfuge",
      slug: "santore-transfuge",
      image: "santore-transfuge.jpg",
    },
  ],
  "Brighton 64": [
    {
      name: "Antes de la Tormenta",
      slug: "brighton-64-antes-de-la-tormenta",
      image: "brighton-64-antes-de-la-tormenta.jpg",
    },
    {
      name: "Cadena de Transmisión",
      slug: "brighton-64-cadena-de-transmision",
      image: "brighton-64-cadena-de-transmision.jpg",
    },
    {
      name: "Caminos por recorrer (Instrumental)",
      slug: "brighton-64-caminos-por-recorrer-instrumental",
      image: "brighton-64-caminos-por-recorrer-instrumental.jpg",
    },
    {
      name: "Chica",
      slug: "brighton-64-chica",
      image: "brighton-64-chica.jpg",
    },
    {
      name: "Corre un Rumor",
      slug: "brighton-64-corre-un-rumor",
      image: "brighton-64-corre-un-rumor.jpg",
    },
    {
      name: "Duelo al Sol",
      slug: "brighton-64-duelo-al-sol",
      image: "brighton-64-duelo-al-sol.jpg",
    },
    {
      name: "El Agua de los Floreros",
      slug: "brighton-64-el-agua-de-los-floreros",
      image: "brighton-64-el-agua-de-los-floreros.jpg",
    },
    {
      name: "El Estado De La Nacion",
      slug: "brighton-64-el-estado-de-la-nacion",
      image: "brighton-64-el-estado-de-la-nacion.jpg",
    },
    {
      name: "El Mundo No Es Para Mi",
      slug: "brighton-64-el-mundo-no-es-para-mi",
      image: "brighton-64-el-mundo-no-es-para-mi.jpg",
    },
    {
      name: "El Objeto Del Deseo (Instrumental)",
      slug: "brighton-64-el-objeto-del-deseo-instrumental",
      image: "brighton-64-el-objeto-del-deseo-instrumental.jpg",
    },
    {
      name: "El Poster de Samantha Fox",
      slug: "brighton-64-el-poster-de-samantha-fox",
      image: "brighton-64-el-poster-de-samantha-fox.jpg",
    },
    {
      name: "El Regreso (Instrumental)",
      slug: "brighton-64-el-regreso-instrumental",
      image: "brighton-64-el-regreso-instrumental.jpg",
    },
    {
      name: "El Tren de la Bruja",
      slug: "brighton-64-el-tren-de-la-bruja",
      image: "brighton-64-el-tren-de-la-bruja.jpg",
    },
    {
      name: "Elwood & Jake",
      slug: "brighton-64-elwood-and-jake",
      image: "brighton-64-elwood-and-jake.jpg",
    },
    {
      name: "Este Es Un Pais Libre",
      slug: "brighton-64-este-es-un-pais-libre",
      image: "brighton-64-este-es-un-pais-libre.jpg",
    },
    {
      name: "Gato Por Liebre",
      slug: "brighton-64-gato-por-liebre",
      image: "brighton-64-gato-por-liebre.jpg",
    },
    {
      name: "Hot Dog (Instrumental)",
      slug: "brighton-64-hot-dog-instrumental",
      image: "brighton-64-hot-dog-instrumental.jpg",
    },
    {
      name: "Juez y Parte J",
      slug: "brighton-64-juez-y-parte-j",
      image: "brighton-64-juez-y-parte-j.jpg",
    },
    {
      name: "La Balada De Los Perfidos Hermanos Gil",
      slug: "brighton-64-la-balada-de-los-perfidos-hermanos-gil",
      image: "brighton-64-la-balada-de-los-perfidos-hermanos-gil.jpg",
    },
    {
      name: "La Cara Infame Del Poder",
      slug: "brighton-64-la-cara-infame-del-poder",
      image: "brighton-64-la-cara-infame-del-poder.jpg",
    },
    {
      name: "La Flor Que Sostenia En La Mano",
      slug: "brighton-64-la-flor-que-sostenia-en-la-mano",
      image: "brighton-64-la-flor-que-sostenia-en-la-mano.jpg",
    },
    {
      name: "La Manta de Linus (Instrumental)",
      slug: "brighton-64-la-manta-de-linus-instrumental",
      image: "brighton-64-la-manta-de-linus-instrumental.jpg",
    },
    {
      name: "Los Puntos Sobre las íes (Instrumental)",
      slug: "brighton-64-los-puntos-sobre-las-ies-instrumental",
      image: "brighton-64-los-puntos-sobre-las-ies-instrumental.jpg",
    },
    {
      name: "Luces de la cuidad (Instrumental)",
      slug: "brighton-64-luces-de-la-cuidad-instrumental",
      image: "brighton-64-luces-de-la-cuidad-instrumental.jpg",
    },
    {
      name: "Maldición",
      slug: "brighton-64-maldicion",
      image: "brighton-64-maldicion.jpg",
    },
    {
      name: "Mi Mierda Naranja",
      slug: "brighton-64-mi-mierda-naranja",
      image: "brighton-64-mi-mierda-naranja.jpg",
    },
    {
      name: "Modernista (Instrumental)",
      slug: "brighton-64-modernista-instrumental",
      image: "brighton-64-modernista-instrumental.jpg",
    },
    {
      name: "Playas Del Mediterraneo",
      slug: "brighton-64-playas-del-mediterraneo",
      image: "brighton-64-playas-del-mediterraneo.jpg",
    },
    {
      name: "Quien Mato al Gato",
      slug: "brighton-64-quien-mato-al-gato",
      image: "brighton-64-quien-mato-al-gato.jpg",
    },
    {
      name: "Reacciones",
      slug: "brighton-64-reacciones",
      image: "brighton-64-reacciones.jpg",
    },
    {
      name: "Sindrome de Rebeca (Instrumental)",
      slug: "brighton-64-sindrome-de-rebeca-instrumental",
      image: "brighton-64-sindrome-de-rebeca-instrumental.jpg",
    },
    {
      name: "Som Indomables (Instrumental)",
      slug: "brighton-64-som-indomables-instrumental",
      image: "brighton-64-som-indomables-instrumental.jpg",
    },
    {
      name: "Sonar Despierto (Instrumental)",
      slug: "brighton-64-sonar-despierto-instrumental",
      image: "brighton-64-sonar-despierto-instrumental.jpg",
    },
    {
      name: "Todo es lo mismo nada es igual",
      slug: "brighton-64-todo-es-lo-mismo-nada-es-igual",
      image: "brighton-64-todo-es-lo-mismo-nada-es-igual.jpg",
    },
    {
      name: "Tot s'hi val (Instrumental)",
      slug: "brighton-64-tot-s-hi-val-instrumental",
      image: "brighton-64-tot-s-hi-val-instrumental.jpg",
    },
  ],
  "H.A.S": [{ name: "Anti", slug: "h-a-s-anti", image: "h-a-s-anti.jpg" }],
  "Ultra Satan": [
    {
      name: "Anti Clock",
      slug: "ultra-satan-anti-clock",
      image: "ultra-satan-anti-clock.jpg",
    },
    {
      name: "Best Chemicals (Peaking Lights Remix)",
      slug: "ultra-satan-best-chemicals-peaking-lights-remix",
      image: "ultra-satan-best-chemicals-peaking-lights-remix.jpg",
    },
    {
      name: "Freedom Rock",
      slug: "ultra-satan-freedom-rock",
      image: "ultra-satan-freedom-rock.jpg",
    },
    { name: "USB", slug: "ultra-satan-usb", image: "ultra-satan-usb.jpg" },
  ],
  HDS: [
    { name: "Apollo", slug: "hds-apollo", image: "hds-apollo.jpg" },
    {
      name: "Ca Fait Longtemps",
      slug: "hds-ca-fait-longtemps",
      image: "hds-ca-fait-longtemps.jpg",
    },
    {
      name: "Goobye feat G.L.K",
      slug: "hds-goobye-feat-g-l-k",
      image: "hds-goobye-feat-g-l-k.jpg",
    },
  ],
  "Lost Idols": [
    {
      name: "Apples & Pears",
      slug: "lost-idols-apples-and-pears",
      image: "lost-idols-apples-and-pears.jpg",
    },
    { name: "Blood", slug: "lost-idols-blood", image: "lost-idols-blood.jpg" },
    {
      name: "It's All Over Now",
      slug: "lost-idols-it-s-all-over-now",
      image: "lost-idols-it-s-all-over-now.jpg",
    },
    { name: "July", slug: "lost-idols-july", image: "lost-idols-july.jpg" },
    {
      name: "Kill The Empty Sky",
      slug: "lost-idols-kill-the-empty-sky",
      image: "lost-idols-kill-the-empty-sky.jpg",
    },
    {
      name: "Litle Girl",
      slug: "lost-idols-litle-girl",
      image: "lost-idols-litle-girl.jpg",
    },
    {
      name: "Ne m'oubliez pas",
      slug: "lost-idols-ne-m-oubliez-pas",
      image: "lost-idols-ne-m-oubliez-pas.jpg",
    },
    {
      name: "On Your Own",
      slug: "lost-idols-on-your-own",
      image: "lost-idols-on-your-own.jpg",
    },
    {
      name: "The Sound Of Your Skin",
      slug: "lost-idols-the-sound-of-your-skin",
      image: "lost-idols-the-sound-of-your-skin.jpg",
    },
  ],
  "Rickard Jäverling": [
    {
      name: "April April",
      slug: "rickard-jaeverling-april-april",
      image: "rickard-jaeverling-april-april.jpg",
    },
    {
      name: "April Flood",
      slug: "rickard-jaeverling-april-flood",
      image: "rickard-jaeverling-april-flood.jpg",
    },
    {
      name: "Axial Tilt",
      slug: "rickard-jaeverling-axial-tilt",
      image: "rickard-jaeverling-axial-tilt.jpg",
    },
    {
      name: "Bruised Banana",
      slug: "rickard-jaeverling-bruised-banana",
      image: "rickard-jaeverling-bruised-banana.jpg",
    },
    {
      name: "Chasing Dub",
      slug: "rickard-jaeverling-chasing-dub",
      image: "rickard-jaeverling-chasing-dub.jpg",
    },
    {
      name: "Chasing Our Hours",
      slug: "rickard-jaeverling-chasing-our-hours",
      image: "rickard-jaeverling-chasing-our-hours.jpg",
    },
    {
      name: "From Left To Dub",
      slug: "rickard-jaeverling-from-left-to-dub",
      image: "rickard-jaeverling-from-left-to-dub.jpg",
    },
    {
      name: "From Left To Right",
      slug: "rickard-jaeverling-from-left-to-right",
      image: "rickard-jaeverling-from-left-to-right.jpg",
    },
    {
      name: "I Won't Get Your Dub",
      slug: "rickard-jaeverling-i-won-t-get-your-dub",
      image: "rickard-jaeverling-i-won-t-get-your-dub.jpg",
    },
    {
      name: "I Won't Get Your Love",
      slug: "rickard-jaeverling-i-won-t-get-your-love",
      image: "rickard-jaeverling-i-won-t-get-your-love.jpg",
    },
    {
      name: "Insane Pissapes",
      slug: "rickard-jaeverling-insane-pissapes",
      image: "rickard-jaeverling-insane-pissapes.jpg",
    },
    {
      name: "Introduction",
      slug: "rickard-jaeverling-introduction",
      image: "rickard-jaeverling-introduction.jpg",
    },
    {
      name: "Mast",
      slug: "rickard-jaeverling-mast",
      image: "rickard-jaeverling-mast.jpg",
    },
    {
      name: "Radiation",
      slug: "rickard-jaeverling-radiation",
      image: "rickard-jaeverling-radiation.jpg",
    },
    {
      name: "Radiation Dub",
      slug: "rickard-jaeverling-radiation-dub",
      image: "rickard-jaeverling-radiation-dub.jpg",
    },
    {
      name: "Rising Skies",
      slug: "rickard-jaeverling-rising-skies",
      image: "rickard-jaeverling-rising-skies.jpg",
    },
    {
      name: "Road Across Worlds",
      slug: "rickard-jaeverling-road-across-worlds",
      image: "rickard-jaeverling-road-across-worlds.jpg",
    },
    {
      name: "Sapiens Sapiens",
      slug: "rickard-jaeverling-sapiens-sapiens",
      image: "rickard-jaeverling-sapiens-sapiens.jpg",
    },
    {
      name: "Set Piece",
      slug: "rickard-jaeverling-set-piece",
      image: "rickard-jaeverling-set-piece.jpg",
    },
    {
      name: "What Happened In Bowdark",
      slug: "rickard-jaeverling-what-happened-in-bowdark",
      image: "rickard-jaeverling-what-happened-in-bowdark.jpg",
    },
  ],
  Cathedrale: [
    {
      name: "Aquiel",
      slug: "cathedrale-aquiel",
      image: "cathedrale-aquiel.jpg",
    },
    {
      name: "Bloody Cunt",
      slug: "cathedrale-bloody-cunt",
      image: "cathedrale-bloody-cunt.jpg",
    },
    {
      name: "Caught Out Here",
      slug: "cathedrale-caught-out-here",
      image: "cathedrale-caught-out-here.jpg",
    },
    {
      name: "Facing Death",
      slug: "cathedrale-facing-death",
      image: "cathedrale-facing-death.jpg",
    },
    { name: "Games", slug: "cathedrale-games", image: "cathedrale-games.jpg" },
    {
      name: "Genius",
      slug: "cathedrale-genius",
      image: "cathedrale-genius.jpg",
    },
    {
      name: "Gold Rush",
      slug: "cathedrale-gold-rush",
      image: "cathedrale-gold-rush.jpg",
    },
    {
      name: "Hidden Museum",
      slug: "cathedrale-hidden-museum",
      image: "cathedrale-hidden-museum.jpg",
    },
    {
      name: "I Don't Want To Stay At Home",
      slug: "cathedrale-i-don-t-want-to-stay-at-home",
      image: "cathedrale-i-don-t-want-to-stay-at-home.jpg",
    },
    {
      name: "I Think I Can",
      slug: "cathedrale-i-think-i-can",
      image: "cathedrale-i-think-i-can.jpg",
    },
    {
      name: "Institutions",
      slug: "cathedrale-institutions",
      image: "cathedrale-institutions.jpg",
    },
    {
      name: "Interlude",
      slug: "cathedrale-interlude",
      image: "cathedrale-interlude.jpg",
    },
    {
      name: "Is Your Man A Reptile",
      slug: "cathedrale-is-your-man-a-reptile",
      image: "cathedrale-is-your-man-a-reptile.jpg",
    },
    {
      name: "Open Your Eyes",
      slug: "cathedrale-open-your-eyes",
      image: "cathedrale-open-your-eyes.jpg",
    },
    {
      name: "Question",
      slug: "cathedrale-question",
      image: "cathedrale-question.jpg",
    },
    {
      name: "Radioactive Beach",
      slug: "cathedrale-radioactive-beach",
      image: "cathedrale-radioactive-beach.jpg",
    },
    {
      name: "Reverence",
      slug: "cathedrale-reverence",
      image: "cathedrale-reverence.jpg",
    },
    {
      name: "Right Time",
      slug: "cathedrale-right-time",
      image: "cathedrale-right-time.jpg",
    },
    {
      name: "Robin's Help",
      slug: "cathedrale-robin-s-help",
      image: "cathedrale-robin-s-help.jpg",
    },
    {
      name: "Shadow",
      slug: "cathedrale-shadow",
      image: "cathedrale-shadow.jpg",
    },
    {
      name: "She Keeps The Secret I Know",
      slug: "cathedrale-she-keeps-the-secret-i-know",
      image: "cathedrale-she-keeps-the-secret-i-know.jpg",
    },
    {
      name: "Shine The Light",
      slug: "cathedrale-shine-the-light",
      image: "cathedrale-shine-the-light.jpg",
    },
    {
      name: "Signal",
      slug: "cathedrale-signal",
      image: "cathedrale-signal.jpg",
    },
    {
      name: "Sometimes",
      slug: "cathedrale-sometimes",
      image: "cathedrale-sometimes.jpg",
    },
    {
      name: "Supermarket Whore",
      slug: "cathedrale-supermarket-whore",
      image: "cathedrale-supermarket-whore.jpg",
    },
    {
      name: "Taste Good",
      slug: "cathedrale-taste-good",
      image: "cathedrale-taste-good.jpg",
    },
    {
      name: "The Bet",
      slug: "cathedrale-the-bet",
      image: "cathedrale-the-bet.jpg",
    },
    {
      name: "The Knight Is Gone",
      slug: "cathedrale-the-knight-is-gone",
      image: "cathedrale-the-knight-is-gone.jpg",
    },
    {
      name: "Weirdo",
      slug: "cathedrale-weirdo",
      image: "cathedrale-weirdo.jpg",
    },
    {
      name: "Which Way I'll Go",
      slug: "cathedrale-which-way-i-ll-go",
      image: "cathedrale-which-way-i-ll-go.jpg",
    },
    {
      name: "Yet , So Easy",
      slug: "cathedrale-yet-so-easy",
      image: "cathedrale-yet-so-easy.jpg",
    },
    {
      name: "You Can Fall",
      slug: "cathedrale-you-can-fall",
      image: "cathedrale-you-can-fall.jpg",
    },
  ],
  "Pyramid Blue": [
    {
      name: "Aracnido",
      slug: "pyramid-blue-aracnido",
      image: "pyramid-blue-aracnido.jpg",
    },
    {
      name: "Cocodilos Acechando",
      slug: "pyramid-blue-cocodilos-acechando",
      image: "pyramid-blue-cocodilos-acechando.jpg",
    },
    {
      name: "Judias Comen Habas",
      slug: "pyramid-blue-judias-comen-habas",
      image: "pyramid-blue-judias-comen-habas.jpg",
    },
    {
      name: "La Oportunidad",
      slug: "pyramid-blue-la-oportunidad",
      image: "pyramid-blue-la-oportunidad.jpg",
    },
    {
      name: "Pajaritos",
      slug: "pyramid-blue-pajaritos",
      image: "pyramid-blue-pajaritos.jpg",
    },
    {
      name: "Que Bonitas Son Las Flores",
      slug: "pyramid-blue-que-bonitas-son-las-flores",
      image: "pyramid-blue-que-bonitas-son-las-flores.jpg",
    },
  ],
  Frak: [
    { name: "Arcitect", slug: "frak-arcitect", image: "frak-arcitect.jpg" },
    { name: "Corridor", slug: "frak-corridor", image: "frak-corridor.jpg" },
    {
      name: "Micro Fisson",
      slug: "frak-micro-fisson",
      image: "frak-micro-fisson.jpg",
    },
    { name: "Stetoskop", slug: "frak-stetoskop", image: "frak-stetoskop.jpg" },
  ],
  "Alberto Montero": [
    {
      name: "Arco Mediterraneo II",
      slug: "alberto-montero-arco-mediterraneo-ii",
      image: "alberto-montero-arco-mediterraneo-ii.jpg",
    },
    {
      name: "Arco Mediterraneo III (Instrumental)",
      slug: "alberto-montero-arco-mediterraneo-iii-instrumental",
      image: "alberto-montero-arco-mediterraneo-iii-instrumental.jpg",
    },
    {
      name: "Autoequilibrio",
      slug: "alberto-montero-autoequilibrio",
      image: "alberto-montero-autoequilibrio.jpg",
    },
    {
      name: "Aves del Amanecer (Instrumental)",
      slug: "alberto-montero-aves-del-amanecer-instrumental",
      image: "alberto-montero-aves-del-amanecer-instrumental.jpg",
    },
    {
      name: "Ayer de la Tierra (Instrumental)",
      slug: "alberto-montero-ayer-de-la-tierra-instrumental",
      image: "alberto-montero-ayer-de-la-tierra-instrumental.jpg",
    },
    {
      name: "Cuando el Aire Resuena (Instrumental)",
      slug: "alberto-montero-cuando-el-aire-resuena-instrumental",
      image: "alberto-montero-cuando-el-aire-resuena-instrumental.jpg",
    },
    {
      name: "Dentro Del Mar",
      slug: "alberto-montero-dentro-del-mar",
      image: "alberto-montero-dentro-del-mar.jpg",
    },
    {
      name: "El Indeciso",
      slug: "alberto-montero-el-indeciso",
      image: "alberto-montero-el-indeciso.jpg",
    },
    {
      name: "El Juego Del Olvido",
      slug: "alberto-montero-el-juego-del-olvido",
      image: "alberto-montero-el-juego-del-olvido.jpg",
    },
    {
      name: "En El Camino",
      slug: "alberto-montero-en-el-camino",
      image: "alberto-montero-en-el-camino.jpg",
    },
    {
      name: "Flor de Naranjo (Instrumental)",
      slug: "alberto-montero-flor-de-naranjo-instrumental",
      image: "alberto-montero-flor-de-naranjo-instrumental.jpg",
    },
    {
      name: "Hoy Ayer",
      slug: "alberto-montero-hoy-ayer",
      image: "alberto-montero-hoy-ayer.jpg",
    },
    {
      name: "La Sal (Instrumental)",
      slug: "alberto-montero-la-sal-instrumental",
      image: "alberto-montero-la-sal-instrumental.jpg",
    },
    {
      name: "Madera Muerta (Instrumental)",
      slug: "alberto-montero-madera-muerta-instrumental",
      image: "alberto-montero-madera-muerta-instrumental.jpg",
    },
    {
      name: "Noche De Verano",
      slug: "alberto-montero-noche-de-verano",
      image: "alberto-montero-noche-de-verano.jpg",
    },
    {
      name: "Olvidado Rey Monkiki",
      slug: "alberto-montero-olvidado-rey-monkiki",
      image: "alberto-montero-olvidado-rey-monkiki.jpg",
    },
    {
      name: "Para Nada",
      slug: "alberto-montero-para-nada",
      image: "alberto-montero-para-nada.jpg",
    },
    {
      name: "Santiago de Chile (Instrumental)",
      slug: "alberto-montero-santiago-de-chile-instrumental",
      image: "alberto-montero-santiago-de-chile-instrumental.jpg",
    },
    {
      name: "Tormenta Circular (Instrumental)",
      slug: "alberto-montero-tormenta-circular-instrumental",
      image: "alberto-montero-tormenta-circular-instrumental.jpg",
    },
    {
      name: "Vendaval (Instrumental)",
      slug: "alberto-montero-vendaval-instrumental",
      image: "alberto-montero-vendaval-instrumental.jpg",
    },
    {
      name: "Viajeros (Instrumental)",
      slug: "alberto-montero-viajeros-instrumental",
      image: "alberto-montero-viajeros-instrumental.jpg",
    },
    {
      name: "Vuelve a Empezar (Instrumental)",
      slug: "alberto-montero-vuelve-a-empezar-instrumental",
      image: "alberto-montero-vuelve-a-empezar-instrumental.jpg",
    },
  ],
  Offramp: [
    {
      name: "Aria feat. Velvet",
      slug: "offramp-aria-feat-velvet",
      image: "offramp-aria-feat-velvet.jpg",
    },
  ],
  "Solaris DJ": [
    {
      name: "Around The Sun (Radio Edit)",
      slug: "solaris-dj-around-the-sun-radio-edit",
      image: "solaris-dj-around-the-sun-radio-edit.jpg",
    },
    {
      name: "Come On Come On",
      slug: "solaris-dj-come-on-come-on",
      image: "solaris-dj-come-on-come-on.jpg",
    },
  ],
  "The Secret Project": [
    {
      name: "Around You",
      slug: "the-secret-project-around-you",
      image: "the-secret-project-around-you.jpg",
    },
    {
      name: "Around You (Instrumental)",
      slug: "the-secret-project-around-you-instrumental",
      image: "the-secret-project-around-you-instrumental.jpg",
    },
    {
      name: "Climb",
      slug: "the-secret-project-climb",
      image: "the-secret-project-climb.jpg",
    },
    {
      name: "Climb (Instrumental)",
      slug: "the-secret-project-climb-instrumental",
      image: "the-secret-project-climb-instrumental.jpg",
    },
    {
      name: "Come On Doll",
      slug: "the-secret-project-come-on-doll",
      image: "the-secret-project-come-on-doll.jpg",
    },
    {
      name: "Come On Doll (Instrumental)",
      slug: "the-secret-project-come-on-doll-instrumental",
      image: "the-secret-project-come-on-doll-instrumental.jpg",
    },
    {
      name: "Dreamy Dreams",
      slug: "the-secret-project-dreamy-dreams",
      image: "the-secret-project-dreamy-dreams.jpg",
    },
    {
      name: "Dreamy Dreams (Instrumental)",
      slug: "the-secret-project-dreamy-dreams-instrumental",
      image: "the-secret-project-dreamy-dreams-instrumental.jpg",
    },
    {
      name: "I Fall For You",
      slug: "the-secret-project-i-fall-for-you",
      image: "the-secret-project-i-fall-for-you.jpg",
    },
    {
      name: "I Fall For You (Instrumental)",
      slug: "the-secret-project-i-fall-for-you-instrumental",
      image: "the-secret-project-i-fall-for-you-instrumental.jpg",
    },
    {
      name: "It's Alright Now (Instrumental)",
      slug: "the-secret-project-it-s-alright-now-instrumental",
      image: "the-secret-project-it-s-alright-now-instrumental.jpg",
    },
    {
      name: "Its Alright Now",
      slug: "the-secret-project-its-alright-now",
      image: "the-secret-project-its-alright-now.jpg",
    },
    {
      name: "Mellow Child",
      slug: "the-secret-project-mellow-child",
      image: "the-secret-project-mellow-child.jpg",
    },
    {
      name: "Mellow Child (Instrumental)",
      slug: "the-secret-project-mellow-child-instrumental",
      image: "the-secret-project-mellow-child-instrumental.jpg",
    },
    {
      name: "My Secret Life",
      slug: "the-secret-project-my-secret-life",
      image: "the-secret-project-my-secret-life.jpg",
    },
    {
      name: "My Secret Life (Instrumental)",
      slug: "the-secret-project-my-secret-life-instrumental",
      image: "the-secret-project-my-secret-life-instrumental.jpg",
    },
    {
      name: "Now You Have To Go",
      slug: "the-secret-project-now-you-have-to-go",
      image: "the-secret-project-now-you-have-to-go.jpg",
    },
    {
      name: "Now You Have To Go (Instrumental)",
      slug: "the-secret-project-now-you-have-to-go-instrumental",
      image: "the-secret-project-now-you-have-to-go-instrumental.jpg",
    },
    {
      name: "Secret Key",
      slug: "the-secret-project-secret-key",
      image: "the-secret-project-secret-key.jpg",
    },
    {
      name: "Secret Key (Instrumental)",
      slug: "the-secret-project-secret-key-instrumental",
      image: "the-secret-project-secret-key-instrumental.jpg",
    },
    {
      name: "Shoshana",
      slug: "the-secret-project-shoshana",
      image: "the-secret-project-shoshana.jpg",
    },
    {
      name: "Singing To You",
      slug: "the-secret-project-singing-to-you",
      image: "the-secret-project-singing-to-you.jpg",
    },
    {
      name: "Singing To You (Instrumental)",
      slug: "the-secret-project-singing-to-you-instrumental",
      image: "the-secret-project-singing-to-you-instrumental.jpg",
    },
    {
      name: "Violence",
      slug: "the-secret-project-violence",
      image: "the-secret-project-violence.jpg",
    },
    {
      name: "Violence (Instrumental)",
      slug: "the-secret-project-violence-instrumental",
      image: "the-secret-project-violence-instrumental.jpg",
    },
  ],
  Francisco: [
    {
      name: "Arpeggio",
      slug: "francisco-arpeggio",
      image: "francisco-arpeggio.jpg",
    },
    {
      name: "Disco Wizard (Dub Version)",
      slug: "francisco-disco-wizard-dub-version",
      image: "francisco-disco-wizard-dub-version.jpg",
    },
    {
      name: "Disco Wizzard (Space Mix)",
      slug: "francisco-disco-wizzard-space-mix",
      image: "francisco-disco-wizzard-space-mix.jpg",
    },
    { name: "Giuno", slug: "francisco-giuno", image: "francisco-giuno.jpg" },
    {
      name: "Introduzione",
      slug: "francisco-introduzione",
      image: "francisco-introduzione.jpg",
    },
    { name: "Music", slug: "francisco-music", image: "francisco-music.jpg" },
    {
      name: "Music (Passarani Remix)",
      slug: "francisco-music-passarani-remix",
      image: "francisco-music-passarani-remix.jpg",
    },
    {
      name: "Notte Horror",
      slug: "francisco-notte-horror",
      image: "francisco-notte-horror.jpg",
    },
    {
      name: "Senza Ritorno",
      slug: "francisco-senza-ritorno",
      image: "francisco-senza-ritorno.jpg",
    },
    {
      name: "Sequenza Basso",
      slug: "francisco-sequenza-basso",
      image: "francisco-sequenza-basso.jpg",
    },
    {
      name: "Voodoo Nero",
      slug: "francisco-voodoo-nero",
      image: "francisco-voodoo-nero.jpg",
    },
  ],
  "Jonjo Jury": [
    {
      name: "Art Bucket",
      slug: "jonjo-jury-art-bucket",
      image: "jonjo-jury-art-bucket.jpg",
    },
    {
      name: "Art Bucket (In Flagranti Remix)",
      slug: "jonjo-jury-art-bucket-in-flagranti-remix",
      image: "jonjo-jury-art-bucket-in-flagranti-remix.jpg",
    },
    {
      name: "Art Bucket (Xinobi Remix)",
      slug: "jonjo-jury-art-bucket-xinobi-remix",
      image: "jonjo-jury-art-bucket-xinobi-remix.jpg",
    },
    {
      name: "If You Break It (Bufi Remix)",
      slug: "jonjo-jury-if-you-break-it-bufi-remix",
      image: "jonjo-jury-if-you-break-it-bufi-remix.jpg",
    },
    {
      name: "If You Break It (Original)",
      slug: "jonjo-jury-if-you-break-it-original",
      image: "jonjo-jury-if-you-break-it-original.jpg",
    },
  ],
  "Jim Henderson": [
    {
      name: "Artificial Freedom",
      slug: "jim-henderson-artificial-freedom",
      image: "jim-henderson-artificial-freedom.jpg",
    },
    {
      name: "Birdsong",
      slug: "jim-henderson-birdsong",
      image: "jim-henderson-birdsong.jpg",
    },
    {
      name: "Breathing Underwater",
      slug: "jim-henderson-breathing-underwater",
      image: "jim-henderson-breathing-underwater.jpg",
    },
    {
      name: "Chronical",
      slug: "jim-henderson-chronical",
      image: "jim-henderson-chronical.jpg",
    },
    {
      name: "Controversial",
      slug: "jim-henderson-controversial",
      image: "jim-henderson-controversial.jpg",
    },
    {
      name: "Mississipi",
      slug: "jim-henderson-mississipi",
      image: "jim-henderson-mississipi.jpg",
    },
    {
      name: "Nighfall",
      slug: "jim-henderson-nighfall",
      image: "jim-henderson-nighfall.jpg",
    },
    {
      name: "Nightlife",
      slug: "jim-henderson-nightlife",
      image: "jim-henderson-nightlife.jpg",
    },
    {
      name: "Rebellion",
      slug: "jim-henderson-rebellion",
      image: "jim-henderson-rebellion.jpg",
    },
    {
      name: "Winter",
      slug: "jim-henderson-winter",
      image: "jim-henderson-winter.jpg",
    },
  ],
  Delorean: [
    {
      name: "As Time Break Off",
      slug: "delorean-as-time-break-off",
      image: "delorean-as-time-break-off.jpg",
    },
  ],
  Pikku: [
    {
      name: "As Your Arms Unfold",
      slug: "pikku-as-your-arms-unfold",
      image: "pikku-as-your-arms-unfold.jpg",
    },
    {
      name: "As Your Arms Unfold (Instrumental)",
      slug: "pikku-as-your-arms-unfold-instrumental",
      image: null,
    },
    {
      name: "Daj Mi Tego Jednego",
      slug: "pikku-daj-mi-tego-jednego",
      image: "pikku-daj-mi-tego-jednego.jpg",
    },
    {
      name: "Daj Mi Tego Jednego (Instrumental)",
      slug: "pikku-daj-mi-tego-jednego-instrumental",
      image: null,
    },
    {
      name: "Eggshells",
      slug: "pikku-eggshells",
      image: "pikku-eggshells.jpg",
    },
    {
      name: "Eggshells (Instrumental)",
      slug: "pikku-eggshells-instrumental",
      image: null,
    },
    {
      name: "Heartbreak",
      slug: "pikku-heartbreak",
      image: "pikku-heartbreak.jpg",
    },
    {
      name: "Heartbreak (Instrumental)",
      slug: "pikku-heartbreak-instrumental",
      image: null,
    },
    {
      name: "J' Ai Connu La Neige",
      slug: "pikku-j-ai-connu-la-neige",
      image: null,
    },
    {
      name: "J'ai Connu La Neige (Instrumental)",
      slug: "pikku-j-ai-connu-la-neige-instrumental",
      image: null,
    },
    {
      name: "Les Brou Brou Brou",
      slug: "pikku-les-brou-brou-brou",
      image: "pikku-les-brou-brou-brou.jpg",
    },
    {
      name: "Les Brou Brou Brou (Instrumental)",
      slug: "pikku-les-brou-brou-brou-instrumental",
      image: null,
    },
    {
      name: "Madame Raymonde",
      slug: "pikku-madame-raymonde",
      image: "pikku-madame-raymonde.jpg",
    },
    {
      name: "Madame Raymonde (Instrumental)",
      slug: "pikku-madame-raymonde-instrumental",
      image: null,
    },
    {
      name: "Niewiniatko",
      slug: "pikku-niewiniatko",
      image: "pikku-niewiniatko.jpg",
    },
    {
      name: "Niewiniatko (Instrumental)",
      slug: "pikku-niewiniatko-instrumental",
      image: null,
    },
    {
      name: "Nuku Nuku II",
      slug: "pikku-nuku-nuku-ii",
      image: "pikku-nuku-nuku-ii.jpg",
    },
    {
      name: "Nuku Nuku II (Instrumental)",
      slug: "pikku-nuku-nuku-ii-instrumental",
      image: null,
    },
    {
      name: "Pillow Sessions",
      slug: "pikku-pillow-sessions",
      image: "pikku-pillow-sessions.jpg",
    },
    {
      name: "Pillow Sessions (Instrumental)",
      slug: "pikku-pillow-sessions-instrumental",
      image: null,
    },
    {
      name: "Scarecrow",
      slug: "pikku-scarecrow",
      image: "pikku-scarecrow.jpg",
    },
    {
      name: "Scarecrow (Instrumental)",
      slug: "pikku-scarecrow-instrumental",
      image: null,
    },
  ],
  "Mytron and Ofofo": [
    {
      name: "Asante Sana",
      slug: "mytron-and-ofofo-asante-sana",
      image: "mytron-and-ofofo-asante-sana.jpg",
    },
  ],
  "Jupiter Lion": [
    {
      name: "Ashes",
      slug: "jupiter-lion-ashes",
      image: "jupiter-lion-ashes.jpg",
    },
    {
      name: "Bellicec",
      slug: "jupiter-lion-bellicec",
      image: "jupiter-lion-bellicec.jpg",
    },
    {
      name: "Black Mouth",
      slug: "jupiter-lion-black-mouth",
      image: "jupiter-lion-black-mouth.jpg",
    },
    {
      name: "Brighter",
      slug: "jupiter-lion-brighter",
      image: "jupiter-lion-brighter.jpg",
    },
    {
      name: "Capital Devotion",
      slug: "jupiter-lion-capital-devotion",
      image: "jupiter-lion-capital-devotion.jpg",
    },
    {
      name: "Delpasse Effect",
      slug: "jupiter-lion-delpasse-effect",
      image: "jupiter-lion-delpasse-effect.jpg",
    },
    {
      name: "DoppelgÑnger",
      slug: "jupiter-lion-doppelgnnger",
      image: "jupiter-lion-doppelgnnger.jpg",
    },
    {
      name: "Krokodil",
      slug: "jupiter-lion-krokodil",
      image: "jupiter-lion-krokodil.jpg",
    },
    {
      name: "Lost Cannibal",
      slug: "jupiter-lion-lost-cannibal",
      image: "jupiter-lion-lost-cannibal.jpg",
    },
    {
      name: "No Easy Subject",
      slug: "jupiter-lion-no-easy-subject",
      image: "jupiter-lion-no-easy-subject.jpg",
    },
    {
      name: "Past Is Today",
      slug: "jupiter-lion-past-is-today",
      image: "jupiter-lion-past-is-today.jpg",
    },
    {
      name: "Silver Constellation",
      slug: "jupiter-lion-silver-constellation",
      image: "jupiter-lion-silver-constellation.jpg",
    },
    {
      name: "The Death Of Dallas",
      slug: "jupiter-lion-the-death-of-dallas",
      image: "jupiter-lion-the-death-of-dallas.jpg",
    },
    {
      name: "The Golden Emperor",
      slug: "jupiter-lion-the-golden-emperor",
      image: "jupiter-lion-the-golden-emperor.jpg",
    },
    {
      name: "Transhuman Step",
      slug: "jupiter-lion-transhuman-step",
      image: "jupiter-lion-transhuman-step.jpg",
    },
    {
      name: "Un Sol Extraño",
      slug: "jupiter-lion-un-sol-extrano",
      image: "jupiter-lion-un-sol-extrano.jpg",
    },
    {
      name: "Venus And Uranus",
      slug: "jupiter-lion-venus-and-uranus",
      image: "jupiter-lion-venus-and-uranus.jpg",
    },
    {
      name: "Walking In Circles",
      slug: "jupiter-lion-walking-in-circles",
      image: "jupiter-lion-walking-in-circles.jpg",
    },
    {
      name: "We Will Lose Gracefully",
      slug: "jupiter-lion-we-will-lose-gracefully",
      image: "jupiter-lion-we-will-lose-gracefully.jpg",
    },
    {
      name: "Your God Is Human",
      slug: "jupiter-lion-your-god-is-human",
      image: "jupiter-lion-your-god-is-human.jpg",
    },
  ],
  Begun: [
    { name: "Asilah", slug: "begun-asilah", image: "begun-asilah.jpg" },
    {
      name: "Asilah (BSN Posse Remix)",
      slug: "begun-asilah-bsn-posse-remix",
      image: "begun-asilah-bsn-posse-remix.jpg",
    },
    { name: "Beni", slug: "begun-beni", image: "begun-beni.jpg" },
    {
      name: "Beni feat One Path (Julio Victoria Remix)",
      slug: "begun-beni-feat-one-path-julio-victoria-remix",
      image: "begun-beni-feat-one-path-julio-victoria-remix.jpg",
    },
    { name: "Dora", slug: "begun-dora", image: "begun-dora.jpg" },
    {
      name: "Dora (Applescal Remix)",
      slug: "begun-dora-applescal-remix",
      image: "begun-dora-applescal-remix.jpg",
    },
    {
      name: "Dora (Blackbird Remix)",
      slug: "begun-dora-blackbird-remix",
      image: "begun-dora-blackbird-remix.jpg",
    },
    {
      name: "Dora (feat Ela Minus)",
      slug: "begun-dora-feat-ela-minus",
      image: "begun-dora-feat-ela-minus.jpg",
    },
    { name: "Kelle", slug: "begun-kelle", image: "begun-kelle.jpg" },
    {
      name: "Kelle feat We Are Enfant Terrible",
      slug: "begun-kelle-feat-we-are-enfant-terrible",
      image: "begun-kelle-feat-we-are-enfant-terrible.jpg",
    },
    { name: "Libok", slug: "begun-libok", image: "begun-libok.jpg" },
    {
      name: "Libok feat Kate Havnevik",
      slug: "begun-libok-feat-kate-havnevik",
      image: "begun-libok-feat-kate-havnevik.jpg",
    },
    {
      name: "Mobasi Part 1",
      slug: "begun-mobasi-part-1",
      image: "begun-mobasi-part-1.jpg",
    },
    {
      name: "Mobasi Part 1 (Nicolas Cruz Remix)",
      slug: "begun-mobasi-part-1-nicolas-cruz-remix",
      image: "begun-mobasi-part-1-nicolas-cruz-remix.jpg",
    },
    {
      name: "Mobasi Part 2",
      slug: "begun-mobasi-part-2",
      image: "begun-mobasi-part-2.jpg",
    },
    { name: "Nari", slug: "begun-nari", image: "begun-nari.jpg" },
    {
      name: "Nari (Boreals Remix)",
      slug: "begun-nari-boreals-remix",
      image: "begun-nari-boreals-remix.jpg",
    },
    { name: "Shama", slug: "begun-shama", image: "begun-shama.jpg" },
    {
      name: "Shama (Pommez Internacional Remix)",
      slug: "begun-shama-pommez-internacional-remix",
      image: "begun-shama-pommez-internacional-remix.jpg",
    },
    { name: "The Wall", slug: "begun-the-wall", image: "begun-the-wall.jpg" },
    { name: "Whindo", slug: "begun-whindo", image: "begun-whindo.jpg" },
    {
      name: "Whindo (Sau Poler Remix)",
      slug: "begun-whindo-sau-poler-remix",
      image: "begun-whindo-sau-poler-remix.jpg",
    },
    { name: "Yoko", slug: "begun-yoko", image: "begun-yoko.jpg" },
    {
      name: "Yoko (Reykjavik 606 Remix)",
      slug: "begun-yoko-reykjavik-606-remix",
      image: "begun-yoko-reykjavik-606-remix.jpg",
    },
  ],
  "Bart and Baker": [
    {
      name: "Ask My Agent (Jazz Version)",
      slug: "bart-and-baker-ask-my-agent-jazz-version",
      image: "bart-and-baker-ask-my-agent-jazz-version.jpg",
    },
    {
      name: "Badaboum (Club Mix)",
      slug: "bart-and-baker-badaboum-club-mix",
      image: "bart-and-baker-badaboum-club-mix.jpg",
    },
    {
      name: "Badaboum (Instrumental)",
      slug: "bart-and-baker-badaboum-instrumental",
      image: "bart-and-baker-badaboum-instrumental.jpg",
    },
    {
      name: "Christopher Columbus (Squirrels and Onions Remix)",
      slug: "bart-and-baker-christopher-columbus-squirrels-and-onions-remix",
      image:
        "bart-and-baker-christopher-columbus-squirrels-and-onions-remix.jpg",
    },
    {
      name: "Dead Air (Chris Coco Intrumental Radio Edit)",
      slug: "bart-and-baker-dead-air-chris-coco-intrumental-radio-edit",
      image: "bart-and-baker-dead-air-chris-coco-intrumental-radio-edit.jpg",
    },
    {
      name: "Der Tag",
      slug: "bart-and-baker-der-tag",
      image: "bart-and-baker-der-tag.jpg",
    },
    {
      name: "Der Tag (Extra Medium Remix)",
      slug: "bart-and-baker-der-tag-extra-medium-remix",
      image: "bart-and-baker-der-tag-extra-medium-remix.jpg",
    },
    {
      name: "Dough Ray Mi (Radio Edit)",
      slug: "bart-and-baker-dough-ray-mi-radio-edit",
      image: "bart-and-baker-dough-ray-mi-radio-edit.jpg",
    },
    {
      name: "Downloaded (Dimitri From Paris Instrumental Remix)",
      slug: "bart-and-baker-downloaded-dimitri-from-paris-instrumental-remix",
      image:
        "bart-and-baker-downloaded-dimitri-from-paris-instrumental-remix.jpg",
    },
    {
      name: "Downloaded (Jon Kennedy Remix)",
      slug: "bart-and-baker-downloaded-jon-kennedy-remix",
      image: "bart-and-baker-downloaded-jon-kennedy-remix.jpg",
    },
    {
      name: "Downloaded (Original Version)",
      slug: "bart-and-baker-downloaded-original-version",
      image: "bart-and-baker-downloaded-original-version.jpg",
    },
    {
      name: "Downloaded (Rogan Remix)",
      slug: "bart-and-baker-downloaded-rogan-remix",
      image: "bart-and-baker-downloaded-rogan-remix.jpg",
    },
    {
      name: "Everybody's Beautiful",
      slug: "bart-and-baker-everybody-s-beautiful",
      image: "bart-and-baker-everybody-s-beautiful.jpg",
    },
    {
      name: "Experience Relax Ay Voo",
      slug: "bart-and-baker-experience-relax-ay-voo",
      image: "bart-and-baker-experience-relax-ay-voo.jpg",
    },
    {
      name: "Faux Cul",
      slug: "bart-and-baker-faux-cul",
      image: "bart-and-baker-faux-cul.jpg",
    },
    {
      name: "Hello Stranger (Instrumental)",
      slug: "bart-and-baker-hello-stranger-instrumental",
      image: "bart-and-baker-hello-stranger-instrumental.jpg",
    },
    {
      name: "Hello Stranger (Kid Loco Mix)",
      slug: "bart-and-baker-hello-stranger-kid-loco-mix",
      image: "bart-and-baker-hello-stranger-kid-loco-mix.jpg",
    },
    {
      name: "It's Happening (AK Remix)",
      slug: "bart-and-baker-it-s-happening-ak-remix",
      image: "bart-and-baker-it-s-happening-ak-remix.jpg",
    },
    {
      name: "It's Happening (Radio Edit)",
      slug: "bart-and-baker-it-s-happening-radio-edit",
      image: "bart-and-baker-it-s-happening-radio-edit.jpg",
    },
    {
      name: "Just Click",
      slug: "bart-and-baker-just-click",
      image: "bart-and-baker-just-click.jpg",
    },
    {
      name: "Just Click (Instrumental)",
      slug: "bart-and-baker-just-click-instrumental",
      image: "bart-and-baker-just-click-instrumental.jpg",
    },
    {
      name: "Mr Hype (Aleksey Kraft Instrumental Remix)",
      slug: "bart-and-baker-mr-hype-aleksey-kraft-instrumental-remix",
      image: "bart-and-baker-mr-hype-aleksey-kraft-instrumental-remix.jpg",
    },
    {
      name: "Mr Hype (Instrumental)",
      slug: "bart-and-baker-mr-hype-instrumental",
      image: "bart-and-baker-mr-hype-instrumental.jpg",
    },
    {
      name: "One Sided Life (Aleksey Kraft Radio Mix)",
      slug: "bart-and-baker-one-sided-life-aleksey-kraft-radio-mix",
      image: "bart-and-baker-one-sided-life-aleksey-kraft-radio-mix.jpg",
    },
    {
      name: "One Sided Life (Aleksey Kraft Remix Instrumental)",
      slug: "bart-and-baker-one-sided-life-aleksey-kraft-remix-instrumental",
      image:
        "bart-and-baker-one-sided-life-aleksey-kraft-remix-instrumental.jpg",
    },
    {
      name: "Right Now feat. Jude Todd",
      slug: "bart-and-baker-right-now-feat-jude-todd",
      image: "bart-and-baker-right-now-feat-jude-todd.jpg",
    },
    {
      name: "Right Now feat. Jude Todd (AK DB Dub Version)",
      slug: "bart-and-baker-right-now-feat-jude-todd-ak-db-dub-version",
      image: "bart-and-baker-right-now-feat-jude-todd-ak-db-dub-version.jpg",
    },
    {
      name: "Right Now feat. Jude Todd (AK DB Remix)",
      slug: "bart-and-baker-right-now-feat-jude-todd-ak-db-remix",
      image: "bart-and-baker-right-now-feat-jude-todd-ak-db-remix.jpg",
    },
    {
      name: "Right Now feat. Jude Todd (Instrumental Version)",
      slug: "bart-and-baker-right-now-feat-jude-todd-instrumental-version",
      image: "bart-and-baker-right-now-feat-jude-todd-instrumental-version.jpg",
    },
    {
      name: "Right Now feat. Jude Todd (Unplugged Version)",
      slug: "bart-and-baker-right-now-feat-jude-todd-unplugged-version",
      image: "bart-and-baker-right-now-feat-jude-todd-unplugged-version.jpg",
    },
    {
      name: "Somehow I Made The Fog",
      slug: "bart-and-baker-somehow-i-made-the-fog",
      image: "bart-and-baker-somehow-i-made-the-fog.jpg",
    },
    {
      name: "Sono Felice Che Tu Esista (AK Dabadabadub Remix)",
      slug: "bart-and-baker-sono-felice-che-tu-esista-ak-dabadabadub-remix",
      image:
        "bart-and-baker-sono-felice-che-tu-esista-ak-dabadabadub-remix.jpg",
    },
    {
      name: "Stop Googlin Me (Bost and Bim Remix)",
      slug: "bart-and-baker-stop-googlin-me-bost-and-bim-remix",
      image: "bart-and-baker-stop-googlin-me-bost-and-bim-remix.jpg",
    },
    {
      name: "Stop Googlin' Me (Instrumental)",
      slug: "bart-and-baker-stop-googlin-me-instrumental",
      image: "bart-and-baker-stop-googlin-me-instrumental.jpg",
    },
    {
      name: "Stop Googling Me! (Rogan Remix)",
      slug: "bart-and-baker-stop-googling-me-rogan-remix",
      image: "bart-and-baker-stop-googling-me-rogan-remix.jpg",
    },
    {
      name: "Supermarket (Aleksey Kraft Instrumental)",
      slug: "bart-and-baker-supermarket-aleksey-kraft-instrumental",
      image: "bart-and-baker-supermarket-aleksey-kraft-instrumental.jpg",
    },
    {
      name: "Supermarket (Aleksey Kraft Radio Edit)",
      slug: "bart-and-baker-supermarket-aleksey-kraft-radio-edit",
      image: "bart-and-baker-supermarket-aleksey-kraft-radio-edit.jpg",
    },
    {
      name: "Supermarket (Dj Mibor Remix)",
      slug: "bart-and-baker-supermarket-dj-mibor-remix",
      image: "bart-and-baker-supermarket-dj-mibor-remix.jpg",
    },
    {
      name: "Supermarket (Dj Mibor Tropical Remix)",
      slug: "bart-and-baker-supermarket-dj-mibor-tropical-remix",
      image: "bart-and-baker-supermarket-dj-mibor-tropical-remix.jpg",
    },
    {
      name: "Swingtonic (Radio Edit)",
      slug: "bart-and-baker-swingtonic-radio-edit",
      image: "bart-and-baker-swingtonic-radio-edit.jpg",
    },
    {
      name: "Take A Second Look (Radio Remix)",
      slug: "bart-and-baker-take-a-second-look-radio-remix",
      image: "bart-and-baker-take-a-second-look-radio-remix.jpg",
    },
    {
      name: "The Plug",
      slug: "bart-and-baker-the-plug",
      image: "bart-and-baker-the-plug.jpg",
    },
    {
      name: "The Swing Phenomenon",
      slug: "bart-and-baker-the-swing-phenomenon",
      image: "bart-and-baker-the-swing-phenomenon.jpg",
    },
    {
      name: "The Swing Phenomenon (Dj Mibor Remix)",
      slug: "bart-and-baker-the-swing-phenomenon-dj-mibor-remix",
      image: "bart-and-baker-the-swing-phenomenon-dj-mibor-remix.jpg",
    },
    {
      name: "Trouble Some Trumpet (Dj Mibor Remix)",
      slug: "bart-and-baker-trouble-some-trumpet-dj-mibor-remix",
      image: "bart-and-baker-trouble-some-trumpet-dj-mibor-remix.jpg",
    },
    {
      name: "Trouble Some Trumpet (James Copeland Remix)",
      slug: "bart-and-baker-trouble-some-trumpet-james-copeland-remix",
      image: "bart-and-baker-trouble-some-trumpet-james-copeland-remix.jpg",
    },
    {
      name: "We Are What We Are Feat. Billy Bros Orchestra",
      slug: "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra",
      image: "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra.jpg",
    },
    {
      name:
        "We Are What We Are Feat. Billy Bros Orchestra (Pep's Show Boys Remix)",
      slug:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-pep-s-show-boys-remix",
      image:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-pep-s-show-boys-remix.jpg",
    },
    {
      name:
        "We Are What We Are Feat. Billy Bros Orchestra (Wolfgang Lohr Remix )",
      slug:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-wolfgang-lohr-remix",
      image:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-wolfgang-lohr-remix.jpg",
    },
    {
      name:
        "We Are What We Are Feat. Billy Bros Orchestra (Wolfgang Lohr Remix Instrumental)",
      slug:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-wolfgang-lohr-remix-instrumental",
      image:
        "bart-and-baker-we-are-what-we-are-feat-billy-bros-orchestra-wolfgang-lohr-remix-instrumental.jpg",
    },
    {
      name: "What Can I Do For You (Instrumental)",
      slug: "bart-and-baker-what-can-i-do-for-you-instrumental",
      image: "bart-and-baker-what-can-i-do-for-you-instrumental.jpg",
    },
    {
      name: "What Can I Do For You (Nicolas Conte Instrumental Remix)",
      slug:
        "bart-and-baker-what-can-i-do-for-you-nicolas-conte-instrumental-remix",
      image:
        "bart-and-baker-what-can-i-do-for-you-nicolas-conte-instrumental-remix.jpg",
    },
    {
      name: "What Can I Do For You (Nicolas Conte Radio Remix)",
      slug: "bart-and-baker-what-can-i-do-for-you-nicolas-conte-radio-remix",
      image:
        "bart-and-baker-what-can-i-do-for-you-nicolas-conte-radio-remix.jpg",
    },
    {
      name: "What Can I Do For You (Original Version)",
      slug: "bart-and-baker-what-can-i-do-for-you-original-version",
      image: "bart-and-baker-what-can-i-do-for-you-original-version.jpg",
    },
    {
      name: "Whoopee (Instrumental PB)",
      slug: "bart-and-baker-whoopee-instrumental-pb",
      image: "bart-and-baker-whoopee-instrumental-pb.jpg",
    },
    {
      name: "Whoopee (Instrumental)",
      slug: "bart-and-baker-whoopee-instrumental",
      image: "bart-and-baker-whoopee-instrumental.jpg",
    },
    {
      name: "Whoopee (Radio Edit)",
      slug: "bart-and-baker-whoopee-radio-edit",
      image: "bart-and-baker-whoopee-radio-edit.jpg",
    },
  ],
  "Pistol Disco": [
    {
      name: "Assault Part II",
      slug: "pistol-disco-assault-part-ii",
      image: "pistol-disco-assault-part-ii.jpg",
    },
    {
      name: "Bad Wiston",
      slug: "pistol-disco-bad-wiston",
      image: "pistol-disco-bad-wiston.jpg",
    },
    {
      name: "Beat Of The Tune",
      slug: "pistol-disco-beat-of-the-tune",
      image: "pistol-disco-beat-of-the-tune.jpg",
    },
    {
      name: "Egypt",
      slug: "pistol-disco-egypt",
      image: "pistol-disco-egypt.jpg",
    },
    { name: "Pool", slug: "pistol-disco-pool", image: "pistol-disco-pool.jpg" },
  ],
  "Yuma Guma": [
    {
      name: "Astrolab",
      slug: "yuma-guma-astrolab",
      image: "yuma-guma-astrolab.jpg",
    },
    {
      name: "Coming For You feat. Rhyme",
      slug: "yuma-guma-coming-for-you-feat-rhyme",
      image: "yuma-guma-coming-for-you-feat-rhyme.jpg",
    },
    {
      name: "Delusion",
      slug: "yuma-guma-delusion",
      image: "yuma-guma-delusion.jpg",
    },
    {
      name: "Level Up",
      slug: "yuma-guma-level-up",
      image: "yuma-guma-level-up.jpg",
    },
  ],
  Mugwump: [
    {
      name: "At The Front",
      slug: "mugwump-at-the-front",
      image: "mugwump-at-the-front.jpg",
    },
    {
      name: "Brundlefly",
      slug: "mugwump-brundlefly",
      image: "mugwump-brundlefly.jpg",
    },
    {
      name: "Convenenient Mask (Hard Version)",
      slug: "mugwump-convenenient-mask-hard-version",
      image: "mugwump-convenenient-mask-hard-version.jpg",
    },
    {
      name: "Convenenient Mask (Soft Version)",
      slug: "mugwump-convenenient-mask-soft-version",
      image: "mugwump-convenenient-mask-soft-version.jpg",
    },
    {
      name: "God Is Gracious",
      slug: "mugwump-god-is-gracious",
      image: "mugwump-god-is-gracious.jpg",
    },
    {
      name: "Halo (Dub Version)",
      slug: "mugwump-halo-dub-version",
      image: "mugwump-halo-dub-version.jpg",
    },
    {
      name: "Halo (Jack Savidge Remix)",
      slug: "mugwump-halo-jack-savidge-remix",
      image: "mugwump-halo-jack-savidge-remix.jpg",
    },
    {
      name: "Hinterlands",
      slug: "mugwump-hinterlands",
      image: "mugwump-hinterlands.jpg",
    },
    {
      name: "School's Out",
      slug: "mugwump-school-s-out",
      image: "mugwump-school-s-out.jpg",
    },
    {
      name: "Until Your Worth It (Andrew Weatherall Remix)",
      slug: "mugwump-until-your-worth-it-andrew-weatherall-remix",
      image: "mugwump-until-your-worth-it-andrew-weatherall-remix.jpg",
    },
  ],
  "Fabulous Sheep": [
    {
      name: "Athenian Streets",
      slug: "fabulous-sheep-athenian-streets",
      image: "fabulous-sheep-athenian-streets.jpg",
    },
    {
      name: "Dehors",
      slug: "fabulous-sheep-dehors",
      image: "fabulous-sheep-dehors.jpg",
    },
    {
      name: "Different ways , Same World",
      slug: "fabulous-sheep-different-ways-same-world",
      image: "fabulous-sheep-different-ways-same-world.jpg",
    },
    {
      name: "Hotel",
      slug: "fabulous-sheep-hotel",
      image: "fabulous-sheep-hotel.jpg",
    },
    {
      name: "In This World",
      slug: "fabulous-sheep-in-this-world",
      image: "fabulous-sheep-in-this-world.jpg",
    },
    {
      name: "Kids Are Back",
      slug: "fabulous-sheep-kids-are-back",
      image: "fabulous-sheep-kids-are-back.jpg",
    },
    {
      name: "Kills Me Slowly",
      slug: "fabulous-sheep-kills-me-slowly",
      image: "fabulous-sheep-kills-me-slowly.jpg",
    },
    {
      name: "L'Entreprise",
      slug: "fabulous-sheep-l-entreprise",
      image: "fabulous-sheep-l-entreprise.jpg",
    },
    {
      name: "Law Number 1",
      slug: "fabulous-sheep-law-number-1",
      image: "fabulous-sheep-law-number-1.jpg",
    },
    {
      name: "Lose Control",
      slug: "fabulous-sheep-lose-control",
      image: "fabulous-sheep-lose-control.jpg",
    },
    {
      name: "Marijuana Blues",
      slug: "fabulous-sheep-marijuana-blues",
      image: "fabulous-sheep-marijuana-blues.jpg",
    },
    {
      name: "No More Crazy Sound",
      slug: "fabulous-sheep-no-more-crazy-sound",
      image: "fabulous-sheep-no-more-crazy-sound.jpg",
    },
    {
      name: "Our Generation",
      slug: "fabulous-sheep-our-generation",
      image: "fabulous-sheep-our-generation.jpg",
    },
    {
      name: "People Around Me",
      slug: "fabulous-sheep-people-around-me",
      image: "fabulous-sheep-people-around-me.jpg",
    },
    {
      name: "Suicide",
      slug: "fabulous-sheep-suicide",
      image: "fabulous-sheep-suicide.jpg",
    },
    {
      name: "The Souls We Carry In Our Heart",
      slug: "fabulous-sheep-the-souls-we-carry-in-our-heart",
      image: "fabulous-sheep-the-souls-we-carry-in-our-heart.jpg",
    },
    {
      name: "Wandering Souls",
      slug: "fabulous-sheep-wandering-souls",
      image: "fabulous-sheep-wandering-souls.jpg",
    },
    {
      name: "Wasting Time",
      slug: "fabulous-sheep-wasting-time",
      image: "fabulous-sheep-wasting-time.jpg",
    },
    {
      name: "Zoo",
      slug: "fabulous-sheep-zoo",
      image: "fabulous-sheep-zoo.jpg",
    },
  ],
  Tross: [
    {
      name: "Atlantic Tariff",
      slug: "tross-atlantic-tariff",
      image: "tross-atlantic-tariff.jpg",
    },
    {
      name: "Colonization",
      slug: "tross-colonization",
      image: "tross-colonization.jpg",
    },
    {
      name: "Jewelries",
      slug: "tross-jewelries",
      image: "tross-jewelries.jpg",
    },
    { name: "Knockout", slug: "tross-knockout", image: "tross-knockout.jpg" },
    {
      name: "Kumla Revisited",
      slug: "tross-kumla-revisited",
      image: "tross-kumla-revisited.jpg",
    },
    {
      name: "Norwegian Rig",
      slug: "tross-norwegian-rig",
      image: "tross-norwegian-rig.jpg",
    },
    { name: "Olive", slug: "tross-olive", image: "tross-olive.jpg" },
    { name: "On Board", slug: "tross-on-board", image: "tross-on-board.jpg" },
    { name: "Pyramid", slug: "tross-pyramid", image: "tross-pyramid.jpg" },
    {
      name: "Qvist Mill",
      slug: "tross-qvist-mill",
      image: "tross-qvist-mill.jpg",
    },
    {
      name: "Red Reverce Cruiser",
      slug: "tross-red-reverce-cruiser",
      image: "tross-red-reverce-cruiser.jpg",
    },
    {
      name: "Reverse Pyramid",
      slug: "tross-reverse-pyramid",
      image: "tross-reverse-pyramid.jpg",
    },
    {
      name: "Samsa's Escape",
      slug: "tross-samsa-s-escape",
      image: "tross-samsa-s-escape.jpg",
    },
    {
      name: "Stig Berglings Saga",
      slug: "tross-stig-berglings-saga",
      image: "tross-stig-berglings-saga.jpg",
    },
    {
      name: "Synthesis",
      slug: "tross-synthesis",
      image: "tross-synthesis.jpg",
    },
    {
      name: "Time Leaves Us",
      slug: "tross-time-leaves-us",
      image: "tross-time-leaves-us.jpg",
    },
    {
      name: "Under The Kittens Furr",
      slug: "tross-under-the-kittens-furr",
      image: "tross-under-the-kittens-furr.jpg",
    },
    { name: "Zu Spät", slug: "tross-zu-spaet", image: "tross-zu-spaet.jpg" },
  ],
  "Ma Spaventi": [
    {
      name: "Attacco",
      slug: "ma-spaventi-attacco",
      image: "ma-spaventi-attacco.jpg",
    },
    {
      name: "Cinema",
      slug: "ma-spaventi-cinema",
      image: "ma-spaventi-cinema.jpg",
    },
    {
      name: "Dilemma",
      slug: "ma-spaventi-dilemma",
      image: "ma-spaventi-dilemma.jpg",
    },
    {
      name: "Dreaming Egyptus",
      slug: "ma-spaventi-dreaming-egyptus",
      image: "ma-spaventi-dreaming-egyptus.jpg",
    },
    {
      name: "La Gotta",
      slug: "ma-spaventi-la-gotta",
      image: "ma-spaventi-la-gotta.jpg",
    },
  ],
  "Ralfe Band": [
    {
      name: "Attics",
      slug: "ralfe-band-attics",
      image: "ralfe-band-attics.jpg",
    },
    {
      name: "Big Head",
      slug: "ralfe-band-big-head",
      image: "ralfe-band-big-head.jpg",
    },
    { name: "Moths", slug: "ralfe-band-moths", image: "ralfe-band-moths.jpg" },
    {
      name: "Siberia",
      slug: "ralfe-band-siberia",
      image: "ralfe-band-siberia.jpg",
    },
  ],
  Verlatour: [
    {
      name: "Au delà",
      slug: "verlatour-au-dela",
      image: "verlatour-au-dela.jpg",
    },
    { name: "Elixir", slug: "verlatour-elixir", image: "verlatour-elixir.jpg" },
    {
      name: "Extatique feat. Awir Leon",
      slug: "verlatour-extatique-feat-awir-leon",
      image: "verlatour-extatique-feat-awir-leon.jpg",
    },
    {
      name: "Meurtrière",
      slug: "verlatour-meurtriere",
      image: "verlatour-meurtriere.jpg",
    },
    {
      name: "Nyctalope",
      slug: "verlatour-nyctalope",
      image: "verlatour-nyctalope.jpg",
    },
    {
      name: "Récidive",
      slug: "verlatour-recidive",
      image: "verlatour-recidive.jpg",
    },
    {
      name: "Sur Tes Lèvres feat. Richard Allen",
      slug: "verlatour-sur-tes-levres-feat-richard-allen",
      image: "verlatour-sur-tes-levres-feat-richard-allen.jpg",
    },
  ],
  Undo: [
    {
      name: "Autamatas (Inigo Pontier Remix)",
      slug: "undo-autamatas-inigo-pontier-remix",
      image: "undo-autamatas-inigo-pontier-remix.jpg",
    },
    {
      name: "Computer Friends (Dimitri Veimar's Dub Remix)",
      slug: "undo-computer-friends-dimitri-veimar-s-dub-remix",
      image: "undo-computer-friends-dimitri-veimar-s-dub-remix.jpg",
    },
    {
      name: "I Need A Break",
      slug: "undo-i-need-a-break",
      image: "undo-i-need-a-break.jpg",
    },
    {
      name: "The Arptist",
      slug: "undo-the-arptist",
      image: "undo-the-arptist.jpg",
    },
  ],
  Västlänken: [
    {
      name: "Autobaba",
      slug: "vaestlaenken-autobaba",
      image: "vaestlaenken-autobaba.jpg",
    },
  ],
  "Niki Moss": [
    {
      name: "Avalanches",
      slug: "niki-moss-avalanches",
      image: "niki-moss-avalanches.jpg",
    },
    {
      name: "Brainman",
      slug: "niki-moss-brainman",
      image: "niki-moss-brainman.jpg",
    },
    {
      name: "Dynofiler",
      slug: "niki-moss-dynofiler",
      image: "niki-moss-dynofiler.jpg",
    },
    {
      name: "GP Motorcycle Racing",
      slug: "niki-moss-gp-motorcycle-racing",
      image: "niki-moss-gp-motorcycle-racing.jpg",
    },
    {
      name: "Soylent Green",
      slug: "niki-moss-soylent-green",
      image: "niki-moss-soylent-green.jpg",
    },
    {
      name: "Standing In The Dark",
      slug: "niki-moss-standing-in-the-dark",
      image: "niki-moss-standing-in-the-dark.jpg",
    },
    {
      name: "Standing In The Dark II",
      slug: "niki-moss-standing-in-the-dark-ii",
      image: "niki-moss-standing-in-the-dark-ii.jpg",
    },
    {
      name: "Standing In The Dark III",
      slug: "niki-moss-standing-in-the-dark-iii",
      image: "niki-moss-standing-in-the-dark-iii.jpg",
    },
    {
      name: "Standing In The Dark IV",
      slug: "niki-moss-standing-in-the-dark-iv",
      image: "niki-moss-standing-in-the-dark-iv.jpg",
    },
    {
      name: "Standing In The Dark V",
      slug: "niki-moss-standing-in-the-dark-v",
      image: "niki-moss-standing-in-the-dark-v.jpg",
    },
    {
      name: "The Bend Of The World",
      slug: "niki-moss-the-bend-of-the-world",
      image: "niki-moss-the-bend-of-the-world.jpg",
    },
    {
      name: "The Rites Of Spring",
      slug: "niki-moss-the-rites-of-spring",
      image: "niki-moss-the-rites-of-spring.jpg",
    },
    {
      name: "There Must Be Something In The Water",
      slug: "niki-moss-there-must-be-something-in-the-water",
      image: "niki-moss-there-must-be-something-in-the-water.jpg",
    },
    {
      name: "Watching The Paint Dry",
      slug: "niki-moss-watching-the-paint-dry",
      image: "niki-moss-watching-the-paint-dry.jpg",
    },
  ],
  "Rui Maia": [
    { name: "Avesso", slug: "rui-maia-avesso", image: "rui-maia-avesso.jpg" },
    {
      name: "Captain Frozen Arpegio",
      slug: "rui-maia-captain-frozen-arpegio",
      image: "rui-maia-captain-frozen-arpegio.jpg",
    },
    {
      name: "Don't Give Up On Dreaming",
      slug: "rui-maia-don-t-give-up-on-dreaming",
      image: "rui-maia-don-t-give-up-on-dreaming.jpg",
    },
    {
      name: "Espiral",
      slug: "rui-maia-espiral",
      image: "rui-maia-espiral.jpg",
    },
    {
      name: "Everything Is Changing",
      slug: "rui-maia-everything-is-changing",
      image: "rui-maia-everything-is-changing.jpg",
    },
    {
      name: "Into The Woods",
      slug: "rui-maia-into-the-woods",
      image: "rui-maia-into-the-woods.jpg",
    },
    {
      name: "Means Of Escape",
      slug: "rui-maia-means-of-escape",
      image: "rui-maia-means-of-escape.jpg",
    },
    { name: "Metade", slug: "rui-maia-metade", image: "rui-maia-metade.jpg" },
    { name: "Okino", slug: "rui-maia-okino", image: "rui-maia-okino.jpg" },
    { name: "Otis", slug: "rui-maia-otis", image: "rui-maia-otis.jpg" },
    {
      name: "Silverscreen Factory",
      slug: "rui-maia-silverscreen-factory",
      image: "rui-maia-silverscreen-factory.jpg",
    },
    {
      name: "Subvert Normality",
      slug: "rui-maia-subvert-normality",
      image: "rui-maia-subvert-normality.jpg",
    },
    { name: "Sune", slug: "rui-maia-sune", image: "rui-maia-sune.jpg" },
    { name: "Torsqe", slug: "rui-maia-torsqe", image: "rui-maia-torsqe.jpg" },
    {
      name: "Walking For Days",
      slug: "rui-maia-walking-for-days",
      image: "rui-maia-walking-for-days.jpg",
    },
    {
      name: "What You Wanted",
      slug: "rui-maia-what-you-wanted",
      image: "rui-maia-what-you-wanted.jpg",
    },
  ],
  "Fuzzy Danger": [
    {
      name: "Awake Like Always",
      slug: "fuzzy-danger-awake-like-always",
      image: null,
    },
    {
      name: "Isn't It Wonderful",
      slug: "fuzzy-danger-isn-t-it-wonderful",
      image: null,
    },
    {
      name: "Slow Mo Western",
      slug: "fuzzy-danger-slow-mo-western",
      image: null,
    },
  ],
  Akkan: [
    { name: "Ayuca", slug: "akkan-ayuca", image: "akkan-ayuca.jpg" },
    { name: "Bananat", slug: "akkan-bananat", image: "akkan-bananat.jpg" },
    {
      name: "Bananat (Naduve Remix)",
      slug: "akkan-bananat-naduve-remix",
      image: "akkan-bananat-naduve-remix.jpg",
    },
    { name: "El Mutal", slug: "akkan-el-mutal", image: "akkan-el-mutal.jpg" },
    { name: "Kai", slug: "akkan-kai", image: "akkan-kai.jpg" },
    {
      name: "Kai (El Buho Remix)",
      slug: "akkan-kai-el-buho-remix",
      image: "akkan-kai-el-buho-remix.jpg",
    },
    {
      name: "Kai (Iñigo Vontier Remix)",
      slug: "akkan-kai-inigo-vontier-remix",
      image: "akkan-kai-inigo-vontier-remix.jpg",
    },
    {
      name: "La Tramuntana",
      slug: "akkan-la-tramuntana",
      image: "akkan-la-tramuntana.jpg",
    },
    { name: "Papayah", slug: "akkan-papayah", image: "akkan-papayah.jpg" },
    { name: "Regaliu", slug: "akkan-regaliu", image: "akkan-regaliu.jpg" },
    {
      name: "Regaliu (Dj Raff Remix)",
      slug: "akkan-regaliu-dj-raff-remix",
      image: "akkan-regaliu-dj-raff-remix.jpg",
    },
    { name: "Salvia", slug: "akkan-salvia", image: "akkan-salvia.jpg" },
    { name: "Yuri", slug: "akkan-yuri", image: "akkan-yuri.jpg" },
  ],
  "Dame Area": [
    {
      name: "Azione Azione",
      slug: "dame-area-azione-azione",
      image: "dame-area-azione-azione.jpg",
    },
    { name: "Camur", slug: "dame-area-camur", image: "dame-area-camur.jpg" },
    {
      name: "Centro Di Gravitá",
      slug: "dame-area-centro-di-gravita",
      image: "dame-area-centro-di-gravita.jpg",
    },
    {
      name: "Conflictos",
      slug: "dame-area-conflictos",
      image: "dame-area-conflictos.jpg",
    },
    {
      name: "Despierta",
      slug: "dame-area-despierta",
      image: "dame-area-despierta.jpg",
    },
    {
      name: "Dicevi A Me",
      slug: "dame-area-dicevi-a-me",
      image: "dame-area-dicevi-a-me.jpg",
    },
    {
      name: "Dis-Umani",
      slug: "dame-area-dis-umani",
      image: "dame-area-dis-umani.jpg",
    },
    {
      name: "Estás En Un Sueño",
      slug: "dame-area-estas-en-un-sueno",
      image: "dame-area-estas-en-un-sueno.jpg",
    },
    {
      name: "Gioco Dell'oca",
      slug: "dame-area-gioco-dell-oca",
      image: "dame-area-gioco-dell-oca.jpg",
    },
    {
      name: "Il Ciclo Ritorna",
      slug: "dame-area-il-ciclo-ritorna",
      image: "dame-area-il-ciclo-ritorna.jpg",
    },
    {
      name: "Immagina Il Passato , Ricorda Il Futuro",
      slug: "dame-area-immagina-il-passato-ricorda-il-futuro",
      image: "dame-area-immagina-il-passato-ricorda-il-futuro.jpg",
    },
    {
      name: "Incertezza Maniacale",
      slug: "dame-area-incertezza-maniacale",
      image: "dame-area-incertezza-maniacale.jpg",
    },
    {
      name: "Innamorata Del Tuo Controllo",
      slug: "dame-area-innamorata-del-tuo-controllo",
      image: "dame-area-innamorata-del-tuo-controllo.jpg",
    },
    {
      name: "La Notte E Oscura",
      slug: "dame-area-la-notte-e-oscura",
      image: "dame-area-la-notte-e-oscura.jpg",
    },
    {
      name: "La Soluzione E Una",
      slug: "dame-area-la-soluzione-e-una",
      image: "dame-area-la-soluzione-e-una.jpg",
    },
    { name: "Luce", slug: "dame-area-luce", image: "dame-area-luce.jpg" },
    {
      name: "No Todo Lo Que Brilla Está En El Cielo",
      slug: "dame-area-no-todo-lo-que-brilla-esta-en-el-cielo",
      image: "dame-area-no-todo-lo-que-brilla-esta-en-el-cielo.jpg",
    },
    {
      name: "Nube D'Eccitazione",
      slug: "dame-area-nube-d-eccitazione",
      image: "dame-area-nube-d-eccitazione.jpg",
    },
    {
      name: "Sdoppiatrice Di Anime",
      slug: "dame-area-sdoppiatrice-di-anime",
      image: "dame-area-sdoppiatrice-di-anime.jpg",
    },
    {
      name: "Sorprendimi",
      slug: "dame-area-sorprendimi",
      image: "dame-area-sorprendimi.jpg",
    },
    {
      name: "Spazio Universo",
      slug: "dame-area-spazio-universo",
      image: "dame-area-spazio-universo.jpg",
    },
    {
      name: "Teléfono , Efendim",
      slug: "dame-area-telefono-efendim",
      image: "dame-area-telefono-efendim.jpg",
    },
    {
      name: "Vivo E Credo",
      slug: "dame-area-vivo-e-credo",
      image: "dame-area-vivo-e-credo.jpg",
    },
    {
      name: "Zaman Cabuk Geçiyor",
      slug: "dame-area-zaman-cabuk-geciyor",
      image: "dame-area-zaman-cabuk-geciyor.jpg",
    },
  ],
  "Moullinex and Xinobi": [
    {
      name: "Azul",
      slug: "moullinex-and-xinobi-azul",
      image: "moullinex-and-xinobi-azul.jpg",
    },
  ],
  Fontän: [
    { name: "Babylon", slug: "fontaen-babylon", image: "fontaen-babylon.jpg" },
    { name: "Bardo", slug: "fontaen-bardo", image: "fontaen-bardo.jpg" },
    { name: "Earth", slug: "fontaen-earth", image: "fontaen-earth.jpg" },
    { name: "Gangri", slug: "fontaen-gangri", image: "fontaen-gangri.jpg" },
    { name: "Greven", slug: "fontaen-greven", image: "fontaen-greven.jpg" },
    {
      name: "Machines",
      slug: "fontaen-machines",
      image: "fontaen-machines.jpg",
    },
    {
      name: "Mangsebung",
      slug: "fontaen-mangsebung",
      image: "fontaen-mangsebung.jpg",
    },
    { name: "Meh Teh", slug: "fontaen-meh-teh", image: "fontaen-meh-teh.jpg" },
    {
      name: "Nautilus",
      slug: "fontaen-nautilus",
      image: "fontaen-nautilus.jpg",
    },
    {
      name: "Polar Star",
      slug: "fontaen-polar-star",
      image: "fontaen-polar-star.jpg",
    },
    {
      name: "Sen Sen No Sen",
      slug: "fontaen-sen-sen-no-sen",
      image: "fontaen-sen-sen-no-sen.jpg",
    },
    { name: "Shadows", slug: "fontaen-shadows", image: "fontaen-shadows.jpg" },
  ],
  "Di Giusto": [
    {
      name: "Bach Ensen",
      slug: "di-giusto-bach-ensen",
      image: "di-giusto-bach-ensen.jpg",
    },
    {
      name: "Bailecito",
      slug: "di-giusto-bailecito",
      image: "di-giusto-bailecito.jpg",
    },
    {
      name: "De Taquito",
      slug: "di-giusto-de-taquito",
      image: "di-giusto-de-taquito.jpg",
    },
    {
      name: "El Vals",
      slug: "di-giusto-el-vals",
      image: "di-giusto-el-vals.jpg",
    },
    {
      name: "Endeveras",
      slug: "di-giusto-endeveras",
      image: "di-giusto-endeveras.jpg",
    },
    {
      name: "Habanera",
      slug: "di-giusto-habanera",
      image: "di-giusto-habanera.jpg",
    },
    {
      name: "Huayno 5",
      slug: "di-giusto-huayno-5",
      image: "di-giusto-huayno-5.jpg",
    },
    {
      name: "Huayno 7",
      slug: "di-giusto-huayno-7",
      image: "di-giusto-huayno-7.jpg",
    },
    {
      name: "Huayno 8",
      slug: "di-giusto-huayno-8",
      image: "di-giusto-huayno-8.jpg",
    },
    {
      name: "Imaginario",
      slug: "di-giusto-imaginario",
      image: "di-giusto-imaginario.jpg",
    },
    { name: "Invito", slug: "di-giusto-invito", image: "di-giusto-invito.jpg" },
    {
      name: "Jugadeta",
      slug: "di-giusto-jugadeta",
      image: "di-giusto-jugadeta.jpg",
    },
    {
      name: "La Recordaba",
      slug: "di-giusto-la-recordaba",
      image: "di-giusto-la-recordaba.jpg",
    },
    { name: "Leve", slug: "di-giusto-leve", image: "di-giusto-leve.jpg" },
    { name: "Nada", slug: "di-giusto-nada", image: "di-giusto-nada.jpg" },
    {
      name: "Peruano",
      slug: "di-giusto-peruano",
      image: "di-giusto-peruano.jpg",
    },
    {
      name: "Revuelta",
      slug: "di-giusto-revuelta",
      image: "di-giusto-revuelta.jpg",
    },
    { name: "Yendo", slug: "di-giusto-yendo", image: "di-giusto-yendo.jpg" },
  ],
  "Leo Justi and DeeWunn": [
    {
      name: "Back It Up, Drop It",
      slug: "leo-justi-and-deewunn-back-it-up-drop-it",
      image: "leo-justi-and-deewunn-back-it-up-drop-it.jpg",
    },
    {
      name: "Back It Up, Drop It (Instrumental)",
      slug: "leo-justi-and-deewunn-back-it-up-drop-it-instrumental",
      image: "leo-justi-and-deewunn-back-it-up-drop-it-instrumental.jpg",
    },
  ],
  Chromatik: [
    {
      name: "Back Me Up",
      slug: "chromatik-back-me-up",
      image: "chromatik-back-me-up.jpg",
    },
    {
      name: "Blue Tears",
      slug: "chromatik-blue-tears",
      image: "chromatik-blue-tears.jpg",
    },
    {
      name: "Full Mojo",
      slug: "chromatik-full-mojo",
      image: "chromatik-full-mojo.jpg",
    },
    {
      name: "Galapagos",
      slug: "chromatik-galapagos",
      image: "chromatik-galapagos.jpg",
    },
    {
      name: "Hope Is Gone",
      slug: "chromatik-hope-is-gone",
      image: "chromatik-hope-is-gone.jpg",
    },
    {
      name: "Hot Flu",
      slug: "chromatik-hot-flu",
      image: "chromatik-hot-flu.jpg",
    },
    { name: "I Need", slug: "chromatik-i-need", image: "chromatik-i-need.jpg" },
    {
      name: "Interlude",
      slug: "chromatik-interlude",
      image: "chromatik-interlude.jpg",
    },
    {
      name: "Lighter Days",
      slug: "chromatik-lighter-days",
      image: "chromatik-lighter-days.jpg",
    },
    {
      name: "Out Of Luck",
      slug: "chromatik-out-of-luck",
      image: "chromatik-out-of-luck.jpg",
    },
    {
      name: "Rap Jazz",
      slug: "chromatik-rap-jazz",
      image: "chromatik-rap-jazz.jpg",
    },
    {
      name: "Straight Outta Deva",
      slug: "chromatik-straight-outta-deva",
      image: "chromatik-straight-outta-deva.jpg",
    },
    {
      name: "Tales From The Mist",
      slug: "chromatik-tales-from-the-mist",
      image: "chromatik-tales-from-the-mist.jpg",
    },
    {
      name: "Zawichick",
      slug: "chromatik-zawichick",
      image: "chromatik-zawichick.jpg",
    },
  ],
  "K!MŦU": [
    {
      name: "Bad Banja",
      slug: "k-m-u-bad-banja",
      image: "k-m-u-bad-banja.jpg",
    },
    {
      name: "Bouteille de Rhum (Josh Remix)",
      slug: "k-m-u-bouteille-de-rhum-josh-remix",
      image: "k-m-u-bouteille-de-rhum-josh-remix.jpg",
    },
    {
      name: "Clap Clap",
      slug: "k-m-u-clap-clap",
      image: "k-m-u-clap-clap.jpg",
    },
    {
      name: "Everybody Got Time For It",
      slug: "k-m-u-everybody-got-time-for-it",
      image: "k-m-u-everybody-got-time-for-it.jpg",
    },
    { name: "Trombone", slug: "k-m-u-trombone", image: "k-m-u-trombone.jpg" },
    {
      name: "Twerk Like Miley (Instrumental)",
      slug: "k-m-u-twerk-like-miley-instrumental",
      image: "k-m-u-twerk-like-miley-instrumental.jpg",
    },
    {
      name: "Wild Eyes (Kimfu Remix)",
      slug: "k-m-u-wild-eyes-kimfu-remix",
      image: "k-m-u-wild-eyes-kimfu-remix.jpg",
    },
  ],
  Charlene: [
    {
      name: "Bad News",
      slug: "charlene-bad-news",
      image: "charlene-bad-news.jpg",
    },
    {
      name: "You Should Know",
      slug: "charlene-you-should-know",
      image: "charlene-you-should-know.jpg",
    },
  ],
  "Principles Of Joy": [
    {
      name: "Bad News",
      slug: "principles-of-joy-bad-news",
      image: "principles-of-joy-bad-news.jpg",
    },
    {
      name: "Day Off",
      slug: "principles-of-joy-day-off",
      image: "principles-of-joy-day-off.jpg",
    },
    {
      name: "Everything Was Wrong",
      slug: "principles-of-joy-everything-was-wrong",
      image: "principles-of-joy-everything-was-wrong.jpg",
    },
    {
      name: "First Times",
      slug: "principles-of-joy-first-times",
      image: "principles-of-joy-first-times.jpg",
    },
    {
      name: "Ill at Ease",
      slug: "principles-of-joy-ill-at-ease",
      image: "principles-of-joy-ill-at-ease.jpg",
    },
    {
      name: "Mercy",
      slug: "principles-of-joy-mercy",
      image: "principles-of-joy-mercy.jpg",
    },
    {
      name: "Money",
      slug: "principles-of-joy-money",
      image: "principles-of-joy-money.jpg",
    },
    {
      name: "Never Gonna Be The Same",
      slug: "principles-of-joy-never-gonna-be-the-same",
      image: "principles-of-joy-never-gonna-be-the-same.jpg",
    },
    {
      name: "Possibly Me",
      slug: "principles-of-joy-possibly-me",
      image: "principles-of-joy-possibly-me.jpg",
    },
    {
      name: "You",
      slug: "principles-of-joy-you",
      image: "principles-of-joy-you.jpg",
    },
    {
      name: "You Should Know",
      slug: "principles-of-joy-you-should-know",
      image: "principles-of-joy-you-should-know.jpg",
    },
  ],
  Garciaphone: [
    {
      name: "Bad Sheperd",
      slug: "garciaphone-bad-sheperd",
      image: "garciaphone-bad-sheperd.jpg",
    },
    {
      name: "Constancia",
      slug: "garciaphone-constancia",
      image: "garciaphone-constancia.jpg",
    },
    {
      name: "Forgotter",
      slug: "garciaphone-forgotter",
      image: "garciaphone-forgotter.jpg",
    },
    {
      name: "Lukoie",
      slug: "garciaphone-lukoie",
      image: "garciaphone-lukoie.jpg",
    },
    {
      name: "Pantomime",
      slug: "garciaphone-pantomime",
      image: "garciaphone-pantomime.jpg",
    },
    {
      name: "Patience",
      slug: "garciaphone-patience",
      image: "garciaphone-patience.jpg",
    },
    {
      name: "Play Messiah",
      slug: "garciaphone-play-messiah",
      image: "garciaphone-play-messiah.jpg",
    },
    {
      name: "Pt Cabrillo",
      slug: "garciaphone-pt-cabrillo",
      image: "garciaphone-pt-cabrillo.jpg",
    },
    {
      name: "Thou Shall Not Talk Shit",
      slug: "garciaphone-thou-shall-not-talk-shit",
      image: "garciaphone-thou-shall-not-talk-shit.jpg",
    },
    {
      name: "Tornadoes",
      slug: "garciaphone-tornadoes",
      image: "garciaphone-tornadoes.jpg",
    },
    {
      name: "Two Wounded Hearts",
      slug: "garciaphone-two-wounded-hearts",
      image: "garciaphone-two-wounded-hearts.jpg",
    },
  ],
  "Jules & Jim": [
    { name: "Bag", slug: "jules-and-jim-bag", image: "jules-and-jim-bag.jpg" },
    {
      name: "The day i knew truth was a lie",
      slug: "jules-and-jim-the-day-i-knew-truth-was-a-lie",
      image: "jules-and-jim-the-day-i-knew-truth-was-a-lie.jpg",
    },
  ],
  Quiz: [
    {
      name: "Bag U Should feat.Emilie Chick",
      slug: "quiz-bag-u-should-feat-emilie-chick",
      image: "quiz-bag-u-should-feat-emilie-chick.jpg",
    },
  ],
  "The Exorcist GBG": [
    {
      name: "Bahnhof",
      slug: "the-exorcist-gbg-bahnhof",
      image: "the-exorcist-gbg-bahnhof.jpg",
    },
    {
      name: "Duck Juice",
      slug: "the-exorcist-gbg-duck-juice",
      image: "the-exorcist-gbg-duck-juice.jpg",
    },
    {
      name: "Electric Wine",
      slug: "the-exorcist-gbg-electric-wine",
      image: "the-exorcist-gbg-electric-wine.jpg",
    },
    {
      name: "Lyrica",
      slug: "the-exorcist-gbg-lyrica",
      image: "the-exorcist-gbg-lyrica.jpg",
    },
    {
      name: "Pusher",
      slug: "the-exorcist-gbg-pusher",
      image: "the-exorcist-gbg-pusher.jpg",
    },
    {
      name: "Stonerdisco",
      slug: "the-exorcist-gbg-stonerdisco",
      image: "the-exorcist-gbg-stonerdisco.jpg",
    },
    {
      name: "Superstandard",
      slug: "the-exorcist-gbg-superstandard",
      image: "the-exorcist-gbg-superstandard.jpg",
    },
    {
      name: "X Theme",
      slug: "the-exorcist-gbg-x-theme",
      image: "the-exorcist-gbg-x-theme.jpg",
    },
  ],
  "Los Tiki Phantoms": [
    {
      name: "Bala De Plata",
      slug: "los-tiki-phantoms-bala-de-plata",
      image: "los-tiki-phantoms-bala-de-plata.jpg",
    },
    {
      name: "Biarritz",
      slug: "los-tiki-phantoms-biarritz",
      image: "los-tiki-phantoms-biarritz.jpg",
    },
    {
      name: "Cuerpo Que Explota",
      slug: "los-tiki-phantoms-cuerpo-que-explota",
      image: "los-tiki-phantoms-cuerpo-que-explota.jpg",
    },
    {
      name: "Ecos De Venganza",
      slug: "los-tiki-phantoms-ecos-de-venganza",
      image: "los-tiki-phantoms-ecos-de-venganza.jpg",
    },
    {
      name: "El Banquete",
      slug: "los-tiki-phantoms-el-banquete",
      image: "los-tiki-phantoms-el-banquete.jpg",
    },
    {
      name: "El Flechazo",
      slug: "los-tiki-phantoms-el-flechazo",
      image: "los-tiki-phantoms-el-flechazo.jpg",
    },
    {
      name: "El Hombre Gamba",
      slug: "los-tiki-phantoms-el-hombre-gamba",
      image: "los-tiki-phantoms-el-hombre-gamba.jpg",
    },
    {
      name: "El Pulpo",
      slug: "los-tiki-phantoms-el-pulpo",
      image: "los-tiki-phantoms-el-pulpo.jpg",
    },
    {
      name: "El Ricon",
      slug: "los-tiki-phantoms-el-ricon",
      image: "los-tiki-phantoms-el-ricon.jpg",
    },
    {
      name: "Estampida Ejercito De Las Calaveras",
      slug: "los-tiki-phantoms-estampida-ejercito-de-las-calaveras",
      image: "los-tiki-phantoms-estampida-ejercito-de-las-calaveras.jpg",
    },
    {
      name: "Fuego",
      slug: "los-tiki-phantoms-fuego",
      image: "los-tiki-phantoms-fuego.jpg",
    },
    {
      name: "Gondola",
      slug: "los-tiki-phantoms-gondola",
      image: "los-tiki-phantoms-gondola.jpg",
    },
    {
      name: "Guatiki",
      slug: "los-tiki-phantoms-guatiki",
      image: "los-tiki-phantoms-guatiki.jpg",
    },
    {
      name: "Heavy Surfer",
      slug: "los-tiki-phantoms-heavy-surfer",
      image: "los-tiki-phantoms-heavy-surfer.jpg",
    },
    {
      name: "Justicia",
      slug: "los-tiki-phantoms-justicia",
      image: "los-tiki-phantoms-justicia.jpg",
    },
    {
      name: "Kalifornia",
      slug: "los-tiki-phantoms-kalifornia",
      image: "los-tiki-phantoms-kalifornia.jpg",
    },
    {
      name: "Kilahuea",
      slug: "los-tiki-phantoms-kilahuea",
      image: "los-tiki-phantoms-kilahuea.jpg",
    },
    {
      name: "La Colonial",
      slug: "los-tiki-phantoms-la-colonial",
      image: "los-tiki-phantoms-la-colonial.jpg",
    },
    {
      name: "La Conga",
      slug: "los-tiki-phantoms-la-conga",
      image: "los-tiki-phantoms-la-conga.jpg",
    },
    {
      name: "La Cuerda Floja",
      slug: "los-tiki-phantoms-la-cuerda-floja",
      image: "los-tiki-phantoms-la-cuerda-floja.jpg",
    },
    {
      name: "La Mosca",
      slug: "los-tiki-phantoms-la-mosca",
      image: "los-tiki-phantoms-la-mosca.jpg",
    },
    {
      name: "La Pequena Emma",
      slug: "los-tiki-phantoms-la-pequena-emma",
      image: "los-tiki-phantoms-la-pequena-emma.jpg",
    },
    {
      name: "Los Jibaros",
      slug: "los-tiki-phantoms-los-jibaros",
      image: "los-tiki-phantoms-los-jibaros.jpg",
    },
    {
      name: "Mar Cel",
      slug: "los-tiki-phantoms-mar-cel",
      image: "los-tiki-phantoms-mar-cel.jpg",
    },
    {
      name: "Mar De Plata",
      slug: "los-tiki-phantoms-mar-de-plata",
      image: "los-tiki-phantoms-mar-de-plata.jpg",
    },
    {
      name: "Muertos Y Furiosos",
      slug: "los-tiki-phantoms-muertos-y-furiosos",
      image: "los-tiki-phantoms-muertos-y-furiosos.jpg",
    },
    {
      name: "Mundaka",
      slug: "los-tiki-phantoms-mundaka",
      image: "los-tiki-phantoms-mundaka.jpg",
    },
    {
      name: "Ojos Verdes",
      slug: "los-tiki-phantoms-ojos-verdes",
      image: "los-tiki-phantoms-ojos-verdes.jpg",
    },
    {
      name: "Phantom's Theme",
      slug: "los-tiki-phantoms-phantom-s-theme",
      image: "los-tiki-phantoms-phantom-s-theme.jpg",
    },
    {
      name: "Qué Mujer",
      slug: "los-tiki-phantoms-que-mujer",
      image: "los-tiki-phantoms-que-mujer.jpg",
    },
    {
      name: "Rescate",
      slug: "los-tiki-phantoms-rescate",
      image: "los-tiki-phantoms-rescate.jpg",
    },
    {
      name: "Satan's",
      slug: "los-tiki-phantoms-satan-s",
      image: "los-tiki-phantoms-satan-s.jpg",
    },
    {
      name: "Siberia",
      slug: "los-tiki-phantoms-siberia",
      image: "los-tiki-phantoms-siberia.jpg",
    },
    {
      name: "Sombras",
      slug: "los-tiki-phantoms-sombras",
      image: "los-tiki-phantoms-sombras.jpg",
    },
    {
      name: "Spaguetti",
      slug: "los-tiki-phantoms-spaguetti",
      image: "los-tiki-phantoms-spaguetti.jpg",
    },
    {
      name: "Tiki Please Me",
      slug: "los-tiki-phantoms-tiki-please-me",
      image: "los-tiki-phantoms-tiki-please-me.jpg",
    },
    {
      name: "Tridente",
      slug: "los-tiki-phantoms-tridente",
      image: "los-tiki-phantoms-tridente.jpg",
    },
    {
      name: "Vulcan",
      slug: "los-tiki-phantoms-vulcan",
      image: "los-tiki-phantoms-vulcan.jpg",
    },
  ],
  "Sheetah et les Weissmüller": [
    {
      name: "Balade en Chrysler",
      slug: "sheetah-et-les-weissmueller-balade-en-chrysler",
      image: "sheetah-et-les-weissmueller-balade-en-chrysler.jpg",
    },
    {
      name: "Comme une fille",
      slug: "sheetah-et-les-weissmueller-comme-une-fille",
      image: "sheetah-et-les-weissmueller-comme-une-fille.jpg",
    },
    {
      name: "Je t'ai menti",
      slug: "sheetah-et-les-weissmueller-je-t-ai-menti",
      image: "sheetah-et-les-weissmueller-je-t-ai-menti.jpg",
    },
    {
      name: "Je veux que tu l'avoue",
      slug: "sheetah-et-les-weissmueller-je-veux-que-tu-l-avoue",
      image: "sheetah-et-les-weissmueller-je-veux-que-tu-l-avoue.jpg",
    },
    {
      name: "L'homme de la situation",
      slug: "sheetah-et-les-weissmueller-l-homme-de-la-situation",
      image: "sheetah-et-les-weissmueller-l-homme-de-la-situation.jpg",
    },
    {
      name: "La Rage",
      slug: "sheetah-et-les-weissmueller-la-rage",
      image: "sheetah-et-les-weissmueller-la-rage.jpg",
    },
    {
      name: "Le Foulard",
      slug: "sheetah-et-les-weissmueller-le-foulard",
      image: "sheetah-et-les-weissmueller-le-foulard.jpg",
    },
    {
      name: "Ne dis rien",
      slug: "sheetah-et-les-weissmueller-ne-dis-rien",
      image: "sheetah-et-les-weissmueller-ne-dis-rien.jpg",
    },
    {
      name: "Tu sais",
      slug: "sheetah-et-les-weissmueller-tu-sais",
      image: "sheetah-et-les-weissmueller-tu-sais.jpg",
    },
    {
      name: "Voodootez",
      slug: "sheetah-et-les-weissmueller-voodootez",
      image: "sheetah-et-les-weissmueller-voodootez.jpg",
    },
  ],
  GAF: [
    {
      name: "Balayo Sunrise",
      slug: "gaf-balayo-sunrise",
      image: "gaf-balayo-sunrise.jpg",
    },
    { name: "Da14", slug: "gaf-da14", image: "gaf-da14.jpg" },
    {
      name: "Decata Na Sunceto",
      slug: "gaf-decata-na-sunceto",
      image: "gaf-decata-na-sunceto.jpg",
    },
    {
      name: "House Of Thousand Chandeliers",
      slug: "gaf-house-of-thousand-chandeliers",
      image: "gaf-house-of-thousand-chandeliers.jpg",
    },
    { name: "Oyalab", slug: "gaf-oyalab", image: "gaf-oyalab.jpg" },
    { name: "Sunday", slug: "gaf-sunday", image: "gaf-sunday.jpg" },
    { name: "Yannakis", slug: "gaf-yannakis", image: "gaf-yannakis.jpg" },
  ],
  "Red Squad": [
    {
      name: "Ball Out feat. Trarius",
      slug: "red-squad-ball-out-feat-trarius",
      image: "red-squad-ball-out-feat-trarius.jpg",
    },
    {
      name: "Ball Out feat. Trarius (Instrumental)",
      slug: "red-squad-ball-out-feat-trarius-instrumental",
      image: "red-squad-ball-out-feat-trarius-instrumental.jpg",
    },
    {
      name: "Ball Out feat. Trarius (Remix Instrumental)",
      slug: "red-squad-ball-out-feat-trarius-remix-instrumental",
      image: "red-squad-ball-out-feat-trarius-remix-instrumental.jpg",
    },
    {
      name: "Ball Out feat.Trarius (Remix)",
      slug: "red-squad-ball-out-feat-trarius-remix",
      image: "red-squad-ball-out-feat-trarius-remix.jpg",
    },
  ],
  Burga: [
    { name: "Balsa", slug: "burga-balsa", image: "burga-balsa.jpg" },
    {
      name: "La Ultima Vez Que Tocamos Esta Cancion",
      slug: "burga-la-ultima-vez-que-tocamos-esta-cancion",
      image: "burga-la-ultima-vez-que-tocamos-esta-cancion.jpg",
    },
    { name: "Lana", slug: "burga-lana", image: "burga-lana.jpg" },
    { name: "Motel", slug: "burga-motel", image: "burga-motel.jpg" },
  ],
  Roommates: [
    {
      name: "Bangala",
      slug: "roommates-bangala",
      image: "roommates-bangala.jpg",
    },
    { name: "Raaw", slug: "roommates-raaw", image: "roommates-raaw.jpg" },
    { name: "Sativa", slug: "roommates-sativa", image: "roommates-sativa.jpg" },
  ],
  Oso: [
    { name: "Barbazul", slug: "oso-barbazul", image: "oso-barbazul.jpg" },
    {
      name: "Hide & Seek",
      slug: "oso-hide-and-seek",
      image: "oso-hide-and-seek.jpg",
    },
    { name: "Mountains", slug: "oso-mountains", image: "oso-mountains.jpg" },
    {
      name: "Superman's Last Words",
      slug: "oso-superman-s-last-words",
      image: "oso-superman-s-last-words.jpg",
    },
    {
      name: "The End Of Whales",
      slug: "oso-the-end-of-whales",
      image: "oso-the-end-of-whales.jpg",
    },
    {
      name: "The Walking Dead",
      slug: "oso-the-walking-dead",
      image: "oso-the-walking-dead.jpg",
    },
  ],
  "Chip Wickham": [
    {
      name: "Barrio 71",
      slug: "chip-wickham-barrio-71",
      image: "chip-wickham-barrio-71.jpg",
    },
    {
      name: "La Sombra (Spaceways Radio Edit)",
      slug: "chip-wickham-la-sombra-spaceways-radio-edit",
      image: "chip-wickham-la-sombra-spaceways-radio-edit.jpg",
    },
    {
      name: "Rebel No.23",
      slug: "chip-wickham-rebel-no-23",
      image: "chip-wickham-rebel-no-23.jpg",
    },
    {
      name: "Red Planet",
      slug: "chip-wickham-red-planet",
      image: "chip-wickham-red-planet.jpg",
    },
    {
      name: "Red Planet (Andrés Remix)",
      slug: "chip-wickham-red-planet-andres-remix",
      image: "chip-wickham-red-planet-andres-remix.jpg",
    },
    {
      name: "Shama Wind",
      slug: "chip-wickham-shama-wind",
      image: "chip-wickham-shama-wind.jpg",
    },
    {
      name: "Snake Eyes",
      slug: "chip-wickham-snake-eyes",
      image: "chip-wickham-snake-eyes.jpg",
    },
    {
      name: "Soho Strut",
      slug: "chip-wickham-soho-strut",
      image: "chip-wickham-soho-strut.jpg",
    },
    {
      name: "The Mirage feat. Matthew Halsall",
      slug: "chip-wickham-the-mirage-feat-matthew-halsall",
      image: "chip-wickham-the-mirage-feat-matthew-halsall.jpg",
    },
  ],
  "Why Mud": [
    { name: "Basilic", slug: "why-mud-basilic", image: "why-mud-basilic.jpg" },
    {
      name: "Eager To Burn",
      slug: "why-mud-eager-to-burn",
      image: "why-mud-eager-to-burn.jpg",
    },
    { name: "Fugue", slug: "why-mud-fugue", image: "why-mud-fugue.jpg" },
    {
      name: "Ketchup To Get In Shape",
      slug: "why-mud-ketchup-to-get-in-shape",
      image: "why-mud-ketchup-to-get-in-shape.jpg",
    },
    { name: "Savage", slug: "why-mud-savage", image: "why-mud-savage.jpg" },
    {
      name: "Seven Tides",
      slug: "why-mud-seven-tides",
      image: "why-mud-seven-tides.jpg",
    },
    {
      name: "Shush Shelter",
      slug: "why-mud-shush-shelter",
      image: "why-mud-shush-shelter.jpg",
    },
  ],
  Triomphe: [
    {
      name: "Bastille",
      slug: "triomphe-bastille",
      image: "triomphe-bastille.jpg",
    },
    {
      name: "Notre Dame",
      slug: "triomphe-notre-dame",
      image: "triomphe-notre-dame.jpg",
    },
    {
      name: "Palais Royal",
      slug: "triomphe-palais-royal",
      image: "triomphe-palais-royal.jpg",
    },
    {
      name: "Place De L'Etoile",
      slug: "triomphe-place-de-l-etoile",
      image: "triomphe-place-de-l-etoile.jpg",
    },
    {
      name: "Pont Des Arts",
      slug: "triomphe-pont-des-arts",
      image: "triomphe-pont-des-arts.jpg",
    },
    {
      name: "Sacré Coeur",
      slug: "triomphe-sacre-coeur",
      image: "triomphe-sacre-coeur.jpg",
    },
  ],
  Win2Win: [
    {
      name: "Battle Horse",
      slug: "win2win-battle-horse",
      image: "win2win-battle-horse.jpg",
    },
    {
      name: "Industriale",
      slug: "win2win-industriale",
      image: "win2win-industriale.jpg",
    },
  ],
  Digikid84: [
    {
      name: "Bboy Underground",
      slug: "digikid84-bboy-underground",
      image: "digikid84-bboy-underground.jpg",
    },
    {
      name: "Supernature Love",
      slug: "digikid84-supernature-love",
      image: "digikid84-supernature-love.jpg",
    },
  ],
  "Los Negros": [
    {
      name: "Be Bop",
      slug: "los-negros-be-bop",
      image: "los-negros-be-bop.jpg",
    },
    {
      name: "Go Duke",
      slug: "los-negros-go-duke",
      image: "los-negros-go-duke.jpg",
    },
    {
      name: "Jazzy ways",
      slug: "los-negros-jazzy-ways",
      image: "los-negros-jazzy-ways.jpg",
    },
    {
      name: "Le Nil",
      slug: "los-negros-le-nil",
      image: "los-negros-le-nil.jpg",
    },
  ],
  "Wild and Free": [
    {
      name: "Be Gone",
      slug: "wild-and-free-be-gone",
      image: "wild-and-free-be-gone.jpg",
    },
    {
      name: "Ferns and Stuff",
      slug: "wild-and-free-ferns-and-stuff",
      image: "wild-and-free-ferns-and-stuff.jpg",
    },
    {
      name: "Hiding Behind The Sun",
      slug: "wild-and-free-hiding-behind-the-sun",
      image: "wild-and-free-hiding-behind-the-sun.jpg",
    },
    {
      name: "Low Pressure",
      slug: "wild-and-free-low-pressure",
      image: "wild-and-free-low-pressure.jpg",
    },
    {
      name: "Moment",
      slug: "wild-and-free-moment",
      image: "wild-and-free-moment.jpg",
    },
    {
      name: "River Of Nilé",
      slug: "wild-and-free-river-of-nile",
      image: "wild-and-free-river-of-nile.jpg",
    },
    {
      name: "Shapes On Shapes",
      slug: "wild-and-free-shapes-on-shapes",
      image: "wild-and-free-shapes-on-shapes.jpg",
    },
    {
      name: "So Many Colors",
      slug: "wild-and-free-so-many-colors",
      image: "wild-and-free-so-many-colors.jpg",
    },
    {
      name: "The Moonhowler",
      slug: "wild-and-free-the-moonhowler",
      image: "wild-and-free-the-moonhowler.jpg",
    },
    {
      name: "Trippin On You",
      slug: "wild-and-free-trippin-on-you",
      image: "wild-and-free-trippin-on-you.jpg",
    },
    {
      name: "Tropique",
      slug: "wild-and-free-tropique",
      image: "wild-and-free-tropique.jpg",
    },
  ],
  "Natty Fensie": [
    {
      name: "Be Lieve (BRCKNR Remix)",
      slug: "natty-fensie-be-lieve-brcknr-remix",
      image: "natty-fensie-be-lieve-brcknr-remix.jpg",
    },
    {
      name: "Be Lieve (Neumodel Remix)",
      slug: "natty-fensie-be-lieve-neumodel-remix",
      image: "natty-fensie-be-lieve-neumodel-remix.jpg",
    },
  ],
  "Yes IM": [
    {
      name: "Be Ma Pulu",
      slug: "yes-im-be-ma-pulu",
      image: "yes-im-be-ma-pulu.jpg",
    },
    {
      name: "Be Ma Pulu Two",
      slug: "yes-im-be-ma-pulu-two",
      image: "yes-im-be-ma-pulu-two.jpg",
    },
    {
      name: "Beautiful Girl",
      slug: "yes-im-beautiful-girl",
      image: "yes-im-beautiful-girl.jpg",
    },
    { name: "Downtown", slug: "yes-im-downtown", image: "yes-im-downtown.jpg" },
    { name: "Enemasea", slug: "yes-im-enemasea", image: "yes-im-enemasea.jpg" },
    {
      name: "Happy Life",
      slug: "yes-im-happy-life",
      image: "yes-im-happy-life.jpg",
    },
    { name: "Hello", slug: "yes-im-hello", image: "yes-im-hello.jpg" },
    {
      name: "Human Diamonds",
      slug: "yes-im-human-diamonds",
      image: "yes-im-human-diamonds.jpg",
    },
    {
      name: "Known By Heart",
      slug: "yes-im-known-by-heart",
      image: "yes-im-known-by-heart.jpg",
    },
    { name: "Maldives", slug: "yes-im-maldives", image: "yes-im-maldives.jpg" },
    {
      name: "Mama Soul",
      slug: "yes-im-mama-soul",
      image: "yes-im-mama-soul.jpg",
    },
    { name: "Mirrors", slug: "yes-im-mirrors", image: "yes-im-mirrors.jpg" },
    { name: "New Year", slug: "yes-im-new-year", image: "yes-im-new-year.jpg" },
    {
      name: "Price Of Love",
      slug: "yes-im-price-of-love",
      image: "yes-im-price-of-love.jpg",
    },
    { name: "Runaway", slug: "yes-im-runaway", image: "yes-im-runaway.jpg" },
    { name: "Teahupoo", slug: "yes-im-teahupoo", image: "yes-im-teahupoo.jpg" },
    {
      name: "The North Of Sound",
      slug: "yes-im-the-north-of-sound",
      image: "yes-im-the-north-of-sound.jpg",
    },
    {
      name: "Travel Song",
      slug: "yes-im-travel-song",
      image: "yes-im-travel-song.jpg",
    },
    {
      name: "Udale Bay",
      slug: "yes-im-udale-bay",
      image: "yes-im-udale-bay.jpg",
    },
    {
      name: "Vacation In Japan",
      slug: "yes-im-vacation-in-japan",
      image: "yes-im-vacation-in-japan.jpg",
    },
    { name: "Vietnam", slug: "yes-im-vietnam", image: "yes-im-vietnam.jpg" },
    {
      name: "Vietnam (Instrumental)",
      slug: "yes-im-vietnam-instrumental",
      image: "yes-im-vietnam-instrumental.jpg",
    },
    { name: "Winter", slug: "yes-im-winter", image: "yes-im-winter.jpg" },
  ],
  "Forever Preach": [
    { name: "Be Strong", slug: "forever-preach-be-strong", image: null },
  ],
  "Bad Mongos": [
    {
      name: "Be The Motherfucker",
      slug: "bad-mongos-be-the-motherfucker",
      image: "bad-mongos-be-the-motherfucker.jpg",
    },
    {
      name: "Dark Love",
      slug: "bad-mongos-dark-love",
      image: "bad-mongos-dark-love.jpg",
    },
    {
      name: "Dirty Pifa",
      slug: "bad-mongos-dirty-pifa",
      image: "bad-mongos-dirty-pifa.jpg",
    },
    {
      name: "Get Out Of My Way",
      slug: "bad-mongos-get-out-of-my-way",
      image: "bad-mongos-get-out-of-my-way.jpg",
    },
    {
      name: "Got Love Got It All",
      slug: "bad-mongos-got-love-got-it-all",
      image: "bad-mongos-got-love-got-it-all.jpg",
    },
    {
      name: "Got To Lose",
      slug: "bad-mongos-got-to-lose",
      image: "bad-mongos-got-to-lose.jpg",
    },
    {
      name: "Hot Like Rock'n'Roll",
      slug: "bad-mongos-hot-like-rock-n-roll",
      image: "bad-mongos-hot-like-rock-n-roll.jpg",
    },
    {
      name: "Hot and Excited",
      slug: "bad-mongos-hot-and-excited",
      image: "bad-mongos-hot-and-excited.jpg",
    },
    {
      name: "I Fuck",
      slug: "bad-mongos-i-fuck",
      image: "bad-mongos-i-fuck.jpg",
    },
    {
      name: "Rocking Shoes",
      slug: "bad-mongos-rocking-shoes",
      image: "bad-mongos-rocking-shoes.jpg",
    },
    {
      name: "Shoot The Bullet",
      slug: "bad-mongos-shoot-the-bullet",
      image: "bad-mongos-shoot-the-bullet.jpg",
    },
    {
      name: "Up In The Sky",
      slug: "bad-mongos-up-in-the-sky",
      image: "bad-mongos-up-in-the-sky.jpg",
    },
  ],
  "Xavier Calvet": [
    {
      name: "Be With You",
      slug: "xavier-calvet-be-with-you",
      image: "xavier-calvet-be-with-you.jpg",
    },
    {
      name: "Fall Out Boy",
      slug: "xavier-calvet-fall-out-boy",
      image: "xavier-calvet-fall-out-boy.jpg",
    },
    {
      name: "Honolulu",
      slug: "xavier-calvet-honolulu",
      image: "xavier-calvet-honolulu.jpg",
    },
    {
      name: "In My Dreams",
      slug: "xavier-calvet-in-my-dreams",
      image: "xavier-calvet-in-my-dreams.jpg",
    },
    {
      name: "Litle Girl",
      slug: "xavier-calvet-litle-girl",
      image: "xavier-calvet-litle-girl.jpg",
    },
    {
      name: "Lovelight",
      slug: "xavier-calvet-lovelight",
      image: "xavier-calvet-lovelight.jpg",
    },
    {
      name: "Say Stop",
      slug: "xavier-calvet-say-stop",
      image: "xavier-calvet-say-stop.jpg",
    },
    {
      name: "Summer Promotion",
      slug: "xavier-calvet-summer-promotion",
      image: "xavier-calvet-summer-promotion.jpg",
    },
    {
      name: "The Ballad Of Ferm",
      slug: "xavier-calvet-the-ballad-of-ferm",
      image: "xavier-calvet-the-ballad-of-ferm.jpg",
    },
    {
      name: "The Grey Lane",
      slug: "xavier-calvet-the-grey-lane",
      image: "xavier-calvet-the-grey-lane.jpg",
    },
    {
      name: "Time To Go",
      slug: "xavier-calvet-time-to-go",
      image: "xavier-calvet-time-to-go.jpg",
    },
    {
      name: "Up All Night",
      slug: "xavier-calvet-up-all-night",
      image: "xavier-calvet-up-all-night.jpg",
    },
  ],
  Teemid: [
    {
      name: "Be With You",
      slug: "teemid-be-with-you",
      image: "teemid-be-with-you.jpg",
    },
    {
      name: "Golden Record",
      slug: "teemid-golden-record",
      image: "teemid-golden-record.jpg",
    },
  ],
  "Ina Escobar": [
    {
      name: "Beat My Drum",
      slug: "ina-escobar-beat-my-drum",
      image: "ina-escobar-beat-my-drum.jpg",
    },
    {
      name: "La Luna",
      slug: "ina-escobar-la-luna",
      image: "ina-escobar-la-luna.jpg",
    },
    {
      name: "Official",
      slug: "ina-escobar-official",
      image: "ina-escobar-official.jpg",
    },
  ],
  "The 5 Jackals": [
    {
      name: "Beautiful Blue Sky",
      slug: "the-5-jackals-beautiful-blue-sky",
      image: "the-5-jackals-beautiful-blue-sky.jpg",
    },
    {
      name: "Bloody",
      slug: "the-5-jackals-bloody",
      image: "the-5-jackals-bloody.jpg",
    },
    {
      name: "Empty World",
      slug: "the-5-jackals-empty-world",
      image: "the-5-jackals-empty-world.jpg",
    },
    {
      name: "Grey Bird",
      slug: "the-5-jackals-grey-bird",
      image: "the-5-jackals-grey-bird.jpg",
    },
    {
      name: "Hustlin",
      slug: "the-5-jackals-hustlin",
      image: "the-5-jackals-hustlin.jpg",
    },
    {
      name: "Keep My Soul",
      slug: "the-5-jackals-keep-my-soul",
      image: "the-5-jackals-keep-my-soul.jpg",
    },
    {
      name: "Lost Heroes",
      slug: "the-5-jackals-lost-heroes",
      image: "the-5-jackals-lost-heroes.jpg",
    },
    {
      name: "Love My Girl",
      slug: "the-5-jackals-love-my-girl",
      image: "the-5-jackals-love-my-girl.jpg",
    },
    {
      name: "Make Me Believe",
      slug: "the-5-jackals-make-me-believe",
      image: "the-5-jackals-make-me-believe.jpg",
    },
    {
      name: "No Direction",
      slug: "the-5-jackals-no-direction",
      image: "the-5-jackals-no-direction.jpg",
    },
    {
      name: "Play Some Funk",
      slug: "the-5-jackals-play-some-funk",
      image: "the-5-jackals-play-some-funk.jpg",
    },
    {
      name: "That's Life",
      slug: "the-5-jackals-that-s-life",
      image: "the-5-jackals-that-s-life.jpg",
    },
    {
      name: "Uprising",
      slug: "the-5-jackals-uprising",
      image: "the-5-jackals-uprising.jpg",
    },
  ],
  "Peachy Joke": [
    {
      name: "Beautiful Lips (Acoustic Version)",
      slug: "peachy-joke-beautiful-lips-acoustic-version",
      image: "peachy-joke-beautiful-lips-acoustic-version.jpg",
    },
    {
      name: "Forked Tongue",
      slug: "peachy-joke-forked-tongue",
      image: "peachy-joke-forked-tongue.jpg",
    },
    {
      name: "Octopus (Acoustic Version)",
      slug: "peachy-joke-octopus-acoustic-version",
      image: "peachy-joke-octopus-acoustic-version.jpg",
    },
    {
      name: "The Papas and The Mamas",
      slug: "peachy-joke-the-papas-and-the-mamas",
      image: "peachy-joke-the-papas-and-the-mamas.jpg",
    },
    {
      name: "The Papas and The Mamas (Acoustic Version)",
      slug: "peachy-joke-the-papas-and-the-mamas-acoustic-version",
      image: "peachy-joke-the-papas-and-the-mamas-acoustic-version.jpg",
    },
    {
      name: "You Showed Me",
      slug: "peachy-joke-you-showed-me",
      image: "peachy-joke-you-showed-me.jpg",
    },
    {
      name: "You Showed Me How To Do (Acoustic Version)",
      slug: "peachy-joke-you-showed-me-how-to-do-acoustic-version",
      image: "peachy-joke-you-showed-me-how-to-do-acoustic-version.jpg",
    },
  ],
  "Idem Colony": [
    {
      name: "Beautiful Mistake",
      slug: "idem-colony-beautiful-mistake",
      image: "idem-colony-beautiful-mistake.jpg",
    },
    {
      name: "Beautiful Mistake (Instrumental)",
      slug: "idem-colony-beautiful-mistake-instrumental",
      image: "idem-colony-beautiful-mistake-instrumental.jpg",
    },
    {
      name: "Everything I Hear",
      slug: "idem-colony-everything-i-hear",
      image: "idem-colony-everything-i-hear.jpg",
    },
    {
      name: "Everything I Hear (Instrumental)",
      slug: "idem-colony-everything-i-hear-instrumental",
      image: "idem-colony-everything-i-hear-instrumental.jpg",
    },
    {
      name: "Everything I Hear (Shades Remix)",
      slug: "idem-colony-everything-i-hear-shades-remix",
      image: "idem-colony-everything-i-hear-shades-remix.jpg",
    },
    {
      name: "If I Love",
      slug: "idem-colony-if-i-love",
      image: "idem-colony-if-i-love.jpg",
    },
    {
      name: "If I Love (Instrumental)",
      slug: "idem-colony-if-i-love-instrumental",
      image: "idem-colony-if-i-love-instrumental.jpg",
    },
    {
      name: "Remember",
      slug: "idem-colony-remember",
      image: "idem-colony-remember.jpg",
    },
    {
      name: "Remember (Instrumental)",
      slug: "idem-colony-remember-instrumental",
      image: "idem-colony-remember-instrumental.jpg",
    },
    {
      name: "Signs",
      slug: "idem-colony-signs",
      image: "idem-colony-signs.jpg",
    },
    {
      name: "Signs (Instrumental)",
      slug: "idem-colony-signs-instrumental",
      image: "idem-colony-signs-instrumental.jpg",
    },
    {
      name: "The Bay",
      slug: "idem-colony-the-bay",
      image: "idem-colony-the-bay.jpg",
    },
    {
      name: "The Bay (Instrumental)",
      slug: "idem-colony-the-bay-instrumental",
      image: "idem-colony-the-bay-instrumental.jpg",
    },
    {
      name: "There Is A Fire",
      slug: "idem-colony-there-is-a-fire",
      image: "idem-colony-there-is-a-fire.jpg",
    },
    {
      name: "There's A Fire (Instrumental)",
      slug: "idem-colony-there-s-a-fire-instrumental",
      image: "idem-colony-there-s-a-fire-instrumental.jpg",
    },
    {
      name: "Thirty Three",
      slug: "idem-colony-thirty-three",
      image: "idem-colony-thirty-three.jpg",
    },
    {
      name: "Thirty Three (Instrumental)",
      slug: "idem-colony-thirty-three-instrumental",
      image: "idem-colony-thirty-three-instrumental.jpg",
    },
    {
      name: "Tribes",
      slug: "idem-colony-tribes",
      image: "idem-colony-tribes.jpg",
    },
    {
      name: "We Never Met",
      slug: "idem-colony-we-never-met",
      image: "idem-colony-we-never-met.jpg",
    },
    {
      name: "We Never Met (Instrumental)",
      slug: "idem-colony-we-never-met-instrumental",
      image: "idem-colony-we-never-met-instrumental.jpg",
    },
  ],
  "Dennis Brown": [
    {
      name: "Beautiful World",
      slug: "dennis-brown-beautiful-world",
      image: "dennis-brown-beautiful-world.jpg",
    },
    {
      name: "Candy Dub (Instrumental)",
      slug: "dennis-brown-candy-dub-instrumental",
      image: "dennis-brown-candy-dub-instrumental.jpg",
    },
    {
      name: "Candy Girl",
      slug: "dennis-brown-candy-girl",
      image: "dennis-brown-candy-girl.jpg",
    },
    {
      name: "Cheri Amour",
      slug: "dennis-brown-cheri-amour",
      image: "dennis-brown-cheri-amour.jpg",
    },
    {
      name: "Cheri Amour (Instrumental)",
      slug: "dennis-brown-cheri-amour-instrumental",
      image: "dennis-brown-cheri-amour-instrumental.jpg",
    },
    {
      name: "Have A Heart",
      slug: "dennis-brown-have-a-heart",
      image: "dennis-brown-have-a-heart.jpg",
    },
    {
      name: "Have a Dub (Instrumental)",
      slug: "dennis-brown-have-a-dub-instrumental",
      image: "dennis-brown-have-a-dub-instrumental.jpg",
    },
    {
      name: "Hip Hip Hooray",
      slug: "dennis-brown-hip-hip-hooray",
      image: "dennis-brown-hip-hip-hooray.jpg",
    },
    {
      name: "Hip Hip Hooray (Instrumental)",
      slug: "dennis-brown-hip-hip-hooray-instrumental",
      image: "dennis-brown-hip-hip-hooray-instrumental.jpg",
    },
    {
      name: "Love Me Tender",
      slug: "dennis-brown-love-me-tender",
      image: "dennis-brown-love-me-tender.jpg",
    },
    {
      name: "Love Me Tender (Instrumental)",
      slug: "dennis-brown-love-me-tender-instrumental",
      image: "dennis-brown-love-me-tender-instrumental.jpg",
    },
    {
      name: "My My",
      slug: "dennis-brown-my-my",
      image: "dennis-brown-my-my.jpg",
    },
    {
      name: "Overjoyed",
      slug: "dennis-brown-overjoyed",
      image: "dennis-brown-overjoyed.jpg",
    },
    {
      name: "Rebel With Is Willing",
      slug: "dennis-brown-rebel-with-is-willing",
      image: "dennis-brown-rebel-with-is-willing.jpg",
    },
    {
      name: "Take Me There",
      slug: "dennis-brown-take-me-there",
      image: "dennis-brown-take-me-there.jpg",
    },
    {
      name: "Take Me There (Instrumental)",
      slug: "dennis-brown-take-me-there-instrumental",
      image: "dennis-brown-take-me-there-instrumental.jpg",
    },
    {
      name: "Token for Tow",
      slug: "dennis-brown-token-for-tow",
      image: "dennis-brown-token-for-tow.jpg",
    },
  ],
  Octav: [
    { name: "Because", slug: "octav-because", image: "octav-because.jpg" },
    {
      name: "Driving At Night",
      slug: "octav-driving-at-night",
      image: "octav-driving-at-night.jpg",
    },
    {
      name: "Fantomatique",
      slug: "octav-fantomatique",
      image: "octav-fantomatique.jpg",
    },
    { name: "Glaçon", slug: "octav-glacon", image: "octav-glacon.jpg" },
    { name: "Gravity", slug: "octav-gravity", image: "octav-gravity.jpg" },
    { name: "Insomnie", slug: "octav-insomnie", image: "octav-insomnie.jpg" },
    {
      name: "J'ai Un Secret",
      slug: "octav-j-ai-un-secret",
      image: "octav-j-ai-un-secret.jpg",
    },
    {
      name: "Love On The Beach",
      slug: "octav-love-on-the-beach",
      image: "octav-love-on-the-beach.jpg",
    },
    {
      name: "Man From The Stars (Radio Edit)",
      slug: "octav-man-from-the-stars-radio-edit",
      image: "octav-man-from-the-stars-radio-edit.jpg",
    },
    { name: "Stranger", slug: "octav-stranger", image: "octav-stranger.jpg" },
  ],
  Rivulets: [
    {
      name: "Because I Don't Care",
      slug: "rivulets-because-i-don-t-care",
      image: "rivulets-because-i-don-t-care.jpg",
    },
    {
      name: "Dark Days",
      slug: "rivulets-dark-days",
      image: "rivulets-dark-days.jpg",
    },
    {
      name: "Everything Goes",
      slug: "rivulets-everything-goes",
      image: "rivulets-everything-goes.jpg",
    },
    {
      name: "I Was Lost Before I Met You",
      slug: "rivulets-i-was-lost-before-i-met-you",
      image: "rivulets-i-was-lost-before-i-met-you.jpg",
    },
    { name: "Lucky", slug: "rivulets-lucky", image: "rivulets-lucky.jpg" },
    {
      name: "Not Today",
      slug: "rivulets-not-today",
      image: "rivulets-not-today.jpg",
    },
    { name: "Sirens", slug: "rivulets-sirens", image: "rivulets-sirens.jpg" },
    { name: "Wire", slug: "rivulets-wire", image: "rivulets-wire.jpg" },
    {
      name: "Won't Be Long Now",
      slug: "rivulets-won-t-be-long-now",
      image: "rivulets-won-t-be-long-now.jpg",
    },
    {
      name: "You Can Never Come Back",
      slug: "rivulets-you-can-never-come-back",
      image: "rivulets-you-can-never-come-back.jpg",
    },
  ],
  Kedam: [
    {
      name: "Before I Go",
      slug: "kedam-before-i-go",
      image: "kedam-before-i-go.jpg",
    },
    { name: "Carmen", slug: "kedam-carmen", image: "kedam-carmen.jpg" },
    {
      name: "Garden Roses",
      slug: "kedam-garden-roses",
      image: "kedam-garden-roses.jpg",
    },
    {
      name: "Jaded Boy",
      slug: "kedam-jaded-boy",
      image: "kedam-jaded-boy.jpg",
    },
    { name: "Maria", slug: "kedam-maria", image: "kedam-maria.jpg" },
    { name: "Shy Girl", slug: "kedam-shy-girl", image: "kedam-shy-girl.jpg" },
    {
      name: "Takes A Call",
      slug: "kedam-takes-a-call",
      image: "kedam-takes-a-call.jpg",
    },
    { name: "Too Good", slug: "kedam-too-good", image: "kedam-too-good.jpg" },
  ],
  "Jeremy Smith": [
    {
      name: "Before The Rapture",
      slug: "jeremy-smith-before-the-rapture",
      image: "jeremy-smith-before-the-rapture.jpg",
    },
    {
      name: "Damned",
      slug: "jeremy-smith-damned",
      image: "jeremy-smith-damned.jpg",
    },
    { name: "Grey", slug: "jeremy-smith-grey", image: "jeremy-smith-grey.jpg" },
    { name: "Home", slug: "jeremy-smith-home", image: "jeremy-smith-home.jpg" },
    {
      name: "Judgment Day",
      slug: "jeremy-smith-judgment-day",
      image: "jeremy-smith-judgment-day.jpg",
    },
    { name: "Kali", slug: "jeremy-smith-kali", image: "jeremy-smith-kali.jpg" },
    {
      name: "Loving River",
      slug: "jeremy-smith-loving-river",
      image: "jeremy-smith-loving-river.jpg",
    },
    {
      name: "My Raelian Vacation",
      slug: "jeremy-smith-my-raelian-vacation",
      image: "jeremy-smith-my-raelian-vacation.jpg",
    },
    {
      name: "Nobody's Home",
      slug: "jeremy-smith-nobody-s-home",
      image: "jeremy-smith-nobody-s-home.jpg",
    },
    {
      name: "Paradise Sleeps",
      slug: "jeremy-smith-paradise-sleeps",
      image: "jeremy-smith-paradise-sleeps.jpg",
    },
    {
      name: "Saved",
      slug: "jeremy-smith-saved",
      image: "jeremy-smith-saved.jpg",
    },
    {
      name: "Sunshine Fellow",
      slug: "jeremy-smith-sunshine-fellow",
      image: "jeremy-smith-sunshine-fellow.jpg",
    },
    {
      name: "Time Of Your Life",
      slug: "jeremy-smith-time-of-your-life",
      image: "jeremy-smith-time-of-your-life.jpg",
    },
    {
      name: "Waiting For Me",
      slug: "jeremy-smith-waiting-for-me",
      image: "jeremy-smith-waiting-for-me.jpg",
    },
  ],
  Anoraak: [
    {
      name: "Behind Your Shades",
      slug: "anoraak-behind-your-shades",
      image: "anoraak-behind-your-shades.jpg",
    },
    {
      name: "Falling Apart",
      slug: "anoraak-falling-apart",
      image: "anoraak-falling-apart.jpg",
    },
    {
      name: "Guest Star",
      slug: "anoraak-guest-star",
      image: "anoraak-guest-star.jpg",
    },
    {
      name: "Living On A Tape",
      slug: "anoraak-living-on-a-tape",
      image: "anoraak-living-on-a-tape.jpg",
    },
    { name: "Made Up", slug: "anoraak-made-up", image: "anoraak-made-up.jpg" },
    {
      name: "Morning Light",
      slug: "anoraak-morning-light",
      image: "anoraak-morning-light.jpg",
    },
    {
      name: "Nightdrive With You (Grum Remix)",
      slug: "anoraak-nightdrive-with-you-grum-remix",
      image: "anoraak-nightdrive-with-you-grum-remix.jpg",
    },
    {
      name: "Nightdrive With You (Jupiter Remix)",
      slug: "anoraak-nightdrive-with-you-jupiter-remix",
      image: "anoraak-nightdrive-with-you-jupiter-remix.jpg",
    },
    { name: "Remote", slug: "anoraak-remote", image: "anoraak-remote.jpg" },
    {
      name: "Summer Is Over",
      slug: "anoraak-summer-is-over",
      image: "anoraak-summer-is-over.jpg",
    },
    {
      name: "Sunrise To Sunset",
      slug: "anoraak-sunrise-to-sunset",
      image: "anoraak-sunrise-to-sunset.jpg",
    },
    {
      name: "Under The Sea",
      slug: "anoraak-under-the-sea",
      image: "anoraak-under-the-sea.jpg",
    },
    {
      name: "Waiting For Your Phone Call",
      slug: "anoraak-waiting-for-your-phone-call",
      image: "anoraak-waiting-for-your-phone-call.jpg",
    },
  ],
  "Yoke Lore": [
    { name: "Beige", slug: "yoke-lore-beige", image: "yoke-lore-beige.jpg" },
    {
      name: "Good Pain (Radio Edit)",
      slug: "yoke-lore-good-pain-radio-edit",
      image: "yoke-lore-good-pain-radio-edit.jpg",
    },
    {
      name: "Level Tools",
      slug: "yoke-lore-level-tools",
      image: "yoke-lore-level-tools.jpg",
    },
    {
      name: "Only You",
      slug: "yoke-lore-only-you",
      image: "yoke-lore-only-you.jpg",
    },
    {
      name: "World Wings",
      slug: "yoke-lore-world-wings",
      image: "yoke-lore-world-wings.jpg",
    },
  ],
  "Time for T": [
    {
      name: "Best Behaviour",
      slug: "time-for-t-best-behaviour",
      image: "time-for-t-best-behaviour.jpg",
    },
    {
      name: "Brighton (Clumsy)",
      slug: "time-for-t-brighton-clumsy",
      image: "time-for-t-brighton-clumsy.jpg",
    },
    {
      name: "Calling Back",
      slug: "time-for-t-calling-back",
      image: "time-for-t-calling-back.jpg",
    },
    {
      name: "Captivity",
      slug: "time-for-t-captivity",
      image: "time-for-t-captivity.jpg",
    },
    { name: "Eyes", slug: "time-for-t-eyes", image: "time-for-t-eyes.jpg" },
    {
      name: "Fire On The Mountain feat. Club del Rio",
      slug: "time-for-t-fire-on-the-mountain-feat-club-del-rio",
      image: null,
    },
    {
      name: "Manteiga",
      slug: "time-for-t-manteiga",
      image: "time-for-t-manteiga.jpg",
    },
    { name: "Naima", slug: "time-for-t-naima", image: "time-for-t-naima.jpg" },
    {
      name: "Pink Marshmallows",
      slug: "time-for-t-pink-marshmallows",
      image: "time-for-t-pink-marshmallows.jpg",
    },
    {
      name: "Practicality",
      slug: "time-for-t-practicality",
      image: "time-for-t-practicality.jpg",
    },
    {
      name: "Qualquer Coisa",
      slug: "time-for-t-qualquer-coisa",
      image: "time-for-t-qualquer-coisa.jpg",
    },
    {
      name: "Screenshot",
      slug: "time-for-t-screenshot",
      image: "time-for-t-screenshot.jpg",
    },
    {
      name: "You Seem Intelligent",
      slug: "time-for-t-you-seem-intelligent",
      image: "time-for-t-you-seem-intelligent.jpg",
    },
  ],
  "Sugar Minott": [
    {
      name: "Betcha By Golly",
      slug: "sugar-minott-betcha-by-golly",
      image: "sugar-minott-betcha-by-golly.jpg",
    },
    {
      name: "Easy Squeeze",
      slug: "sugar-minott-easy-squeeze",
      image: "sugar-minott-easy-squeeze.jpg",
    },
  ],
  "The Temple": [
    {
      name: "Better Life",
      slug: "the-temple-better-life",
      image: "the-temple-better-life.jpg",
    },
    {
      name: "Keep The Control",
      slug: "the-temple-keep-the-control",
      image: "the-temple-keep-the-control.jpg",
    },
    {
      name: "No Afraid To Love You",
      slug: "the-temple-no-afraid-to-love-you",
      image: "the-temple-no-afraid-to-love-you.jpg",
    },
  ],
  "Gentle Republic": [
    {
      name: "Better Run",
      slug: "gentle-republic-better-run",
      image: "gentle-republic-better-run.jpg",
    },
    {
      name: "Death Of Thotsakan",
      slug: "gentle-republic-death-of-thotsakan",
      image: "gentle-republic-death-of-thotsakan.jpg",
    },
    {
      name: "Silverhawks",
      slug: "gentle-republic-silverhawks",
      image: "gentle-republic-silverhawks.jpg",
    },
    {
      name: "The River",
      slug: "gentle-republic-the-river",
      image: "gentle-republic-the-river.jpg",
    },
    {
      name: "Triangular",
      slug: "gentle-republic-triangular",
      image: "gentle-republic-triangular.jpg",
    },
  ],
  "Carpenter Brut": [
    {
      name: "Beware The Beast",
      slug: "carpenter-brut-beware-the-beast",
      image: "carpenter-brut-beware-the-beast.jpg",
    },
    {
      name: "Cheerleader Effect",
      slug: "carpenter-brut-cheerleader-effect",
      image: "carpenter-brut-cheerleader-effect.jpg",
    },
    {
      name: "Fab Tool",
      slug: "carpenter-brut-fab-tool",
      image: "carpenter-brut-fab-tool.jpg",
    },
    {
      name: "Hairspray Hurricane",
      slug: "carpenter-brut-hairspray-hurricane",
      image: "carpenter-brut-hairspray-hurricane.jpg",
    },
    {
      name: "Inferno Galore",
      slug: "carpenter-brut-inferno-galore",
      image: "carpenter-brut-inferno-galore.jpg",
    },
    {
      name: "Leather Teeth",
      slug: "carpenter-brut-leather-teeth",
      image: "carpenter-brut-leather-teeth.jpg",
    },
    {
      name: "Monday Hunt",
      slug: "carpenter-brut-monday-hunt",
      image: "carpenter-brut-monday-hunt.jpg",
    },
    {
      name: "Roller Mobster",
      slug: "carpenter-brut-roller-mobster",
      image: "carpenter-brut-roller-mobster.jpg",
    },
    {
      name: "Turbo Killer",
      slug: "carpenter-brut-turbo-killer",
      image: "carpenter-brut-turbo-killer.jpg",
    },
  ],
  Armonics: [
    {
      name: "Beyond The Walls",
      slug: "armonics-beyond-the-walls",
      image: "armonics-beyond-the-walls.jpg",
    },
    {
      name: "Cyber Space",
      slug: "armonics-cyber-space",
      image: "armonics-cyber-space.jpg",
    },
    {
      name: "Inner Flame",
      slug: "armonics-inner-flame",
      image: "armonics-inner-flame.jpg",
    },
  ],
  Perlita: [
    { name: "Bichos", slug: "perlita-bichos", image: "perlita-bichos.jpg" },
    { name: "Birds", slug: "perlita-birds", image: "perlita-birds.jpg" },
    {
      name: "Caballo Rojo",
      slug: "perlita-caballo-rojo",
      image: "perlita-caballo-rojo.jpg",
    },
    {
      name: "Compromise",
      slug: "perlita-compromise",
      image: "perlita-compromise.jpg",
    },
    {
      name: "Donde Las Lunas",
      slug: "perlita-donde-las-lunas",
      image: "perlita-donde-las-lunas.jpg",
    },
    {
      name: "Flash Your Ass",
      slug: "perlita-flash-your-ass",
      image: "perlita-flash-your-ass.jpg",
    },
    {
      name: "Galera De Coral",
      slug: "perlita-galera-de-coral",
      image: "perlita-galera-de-coral.jpg",
    },
    {
      name: "King Pink Elephant",
      slug: "perlita-king-pink-elephant",
      image: "perlita-king-pink-elephant.jpg",
    },
    {
      name: "La Resistencia",
      slug: "perlita-la-resistencia",
      image: "perlita-la-resistencia.jpg",
    },
    {
      name: "Luna Grande",
      slug: "perlita-luna-grande",
      image: "perlita-luna-grande.jpg",
    },
    {
      name: "Minimúsculo",
      slug: "perlita-minimusculo",
      image: "perlita-minimusculo.jpg",
    },
    { name: "Okapi", slug: "perlita-okapi", image: "perlita-okapi.jpg" },
    { name: "Romance", slug: "perlita-romance", image: "perlita-romance.jpg" },
    {
      name: "Timanfaya",
      slug: "perlita-timanfaya",
      image: "perlita-timanfaya.jpg",
    },
    { name: "Ypsilom", slug: "perlita-ypsilom", image: "perlita-ypsilom.jpg" },
  ],
  "O Terno": [
    {
      name: "Bielzinho  (Xinobi Remix)",
      slug: "o-terno-bielzinho-xinobi-remix",
      image: "o-terno-bielzinho-xinobi-remix.jpg",
    },
    {
      name: "Bielzinho (Radio Edit)",
      slug: "o-terno-bielzinho-radio-edit",
      image: "o-terno-bielzinho-radio-edit.jpg",
    },
  ],
  "Billy Bats": [
    {
      name: "Bien et Mal",
      slug: "billy-bats-bien-et-mal",
      image: "billy-bats-bien-et-mal.jpg",
    },
    {
      name: "Butterfly",
      slug: "billy-bats-butterfly",
      image: "billy-bats-butterfly.jpg",
    },
    {
      name: "Classe C",
      slug: "billy-bats-classe-c",
      image: "billy-bats-classe-c.jpg",
    },
    {
      name: "Gogeta",
      slug: "billy-bats-gogeta",
      image: "billy-bats-gogeta.jpg",
    },
    {
      name: "Hoody Melo",
      slug: "billy-bats-hoody-melo",
      image: "billy-bats-hoody-melo.jpg",
    },
    {
      name: "Plus De Weed",
      slug: "billy-bats-plus-de-weed",
      image: "billy-bats-plus-de-weed.jpg",
    },
  ],
  Karmento: [
    {
      name: "Bienmesabe",
      slug: "karmento-bienmesabe",
      image: "karmento-bienmesabe.jpg",
    },
    {
      name: "Cri Cri",
      slug: "karmento-cri-cri",
      image: "karmento-cri-cri.jpg",
    },
    {
      name: "Danzar Sobre La Tierra",
      slug: "karmento-danzar-sobre-la-tierra",
      image: "karmento-danzar-sobre-la-tierra.jpg",
    },
    {
      name: "El Amor y La Esfera",
      slug: "karmento-el-amor-y-la-esfera",
      image: "karmento-el-amor-y-la-esfera.jpg",
    },
    {
      name: "La Jornada",
      slug: "karmento-la-jornada",
      image: "karmento-la-jornada.jpg",
    },
    { name: "La M", slug: "karmento-la-m", image: "karmento-la-m.jpg" },
    {
      name: "La Manchega En La Azotea",
      slug: "karmento-la-manchega-en-la-azotea",
      image: "karmento-la-manchega-en-la-azotea.jpg",
    },
    { name: "Marea", slug: "karmento-marea", image: "karmento-marea.jpg" },
    {
      name: "Que Vuelva La Magia",
      slug: "karmento-que-vuelva-la-magia",
      image: "karmento-que-vuelva-la-magia.jpg",
    },
    {
      name: "Qué Feo",
      slug: "karmento-que-feo",
      image: "karmento-que-feo.jpg",
    },
  ],
  "Brigitte Laverne": [
    {
      name: "Bienvenidos Al Realismo",
      slug: "brigitte-laverne-bienvenidos-al-realismo",
      image: "brigitte-laverne-bienvenidos-al-realismo.jpg",
    },
    {
      name: "Can't Take It No More",
      slug: "brigitte-laverne-can-t-take-it-no-more",
      image: "brigitte-laverne-can-t-take-it-no-more.jpg",
    },
    {
      name: "Can't Take It No More (Instrumental)",
      slug: "brigitte-laverne-can-t-take-it-no-more-instrumental",
      image: "brigitte-laverne-can-t-take-it-no-more-instrumental.jpg",
    },
    {
      name: "Cities",
      slug: "brigitte-laverne-cities",
      image: "brigitte-laverne-cities.jpg",
    },
    {
      name: "Cities (Instrumental)",
      slug: "brigitte-laverne-cities-instrumental",
      image: "brigitte-laverne-cities-instrumental.jpg",
    },
    {
      name: "Crush On You",
      slug: "brigitte-laverne-crush-on-you",
      image: "brigitte-laverne-crush-on-you.jpg",
    },
    {
      name: "Crush On You (Instrumental)",
      slug: "brigitte-laverne-crush-on-you-instrumental",
      image: "brigitte-laverne-crush-on-you-instrumental.jpg",
    },
    {
      name: "Culpable y Feliz",
      slug: "brigitte-laverne-culpable-y-feliz",
      image: "brigitte-laverne-culpable-y-feliz.jpg",
    },
    {
      name: "Dejame En Paz",
      slug: "brigitte-laverne-dejame-en-paz",
      image: "brigitte-laverne-dejame-en-paz.jpg",
    },
    {
      name: "Disco China",
      slug: "brigitte-laverne-disco-china",
      image: "brigitte-laverne-disco-china.jpg",
    },
    {
      name: "Night Feeling (Instrumental)",
      slug: "brigitte-laverne-night-feeling-instrumental",
      image: "brigitte-laverne-night-feeling-instrumental.jpg",
    },
    {
      name: "Night Feelings",
      slug: "brigitte-laverne-night-feelings",
      image: "brigitte-laverne-night-feelings.jpg",
    },
    {
      name: "No Lo Haces Nada Mal",
      slug: "brigitte-laverne-no-lo-haces-nada-mal",
      image: "brigitte-laverne-no-lo-haces-nada-mal.jpg",
    },
    {
      name: "Not Always",
      slug: "brigitte-laverne-not-always",
      image: "brigitte-laverne-not-always.jpg",
    },
    {
      name: "Phoebe's Room",
      slug: "brigitte-laverne-phoebe-s-room",
      image: "brigitte-laverne-phoebe-s-room.jpg",
    },
    {
      name: "Phoebe's Room (Instrumental)",
      slug: "brigitte-laverne-phoebe-s-room-instrumental",
      image: "brigitte-laverne-phoebe-s-room-instrumental.jpg",
    },
    {
      name: "Que Gane El Mejor",
      slug: "brigitte-laverne-que-gane-el-mejor",
      image: "brigitte-laverne-que-gane-el-mejor.jpg",
    },
    {
      name: "Te Crees Muy Eterno",
      slug: "brigitte-laverne-te-crees-muy-eterno",
      image: "brigitte-laverne-te-crees-muy-eterno.jpg",
    },
    {
      name: "Tindr Love",
      slug: "brigitte-laverne-tindr-love",
      image: "brigitte-laverne-tindr-love.jpg",
    },
    {
      name: "Tokyo",
      slug: "brigitte-laverne-tokyo",
      image: "brigitte-laverne-tokyo.jpg",
    },
    {
      name: "Touch",
      slug: "brigitte-laverne-touch",
      image: "brigitte-laverne-touch.jpg",
    },
    {
      name: "Touch (Instrumental)",
      slug: "brigitte-laverne-touch-instrumental",
      image: "brigitte-laverne-touch-instrumental.jpg",
    },
    {
      name: "Your Tonight",
      slug: "brigitte-laverne-your-tonight",
      image: "brigitte-laverne-your-tonight.jpg",
    },
    {
      name: "Youth (Warriors)",
      slug: "brigitte-laverne-youth-warriors",
      image: "brigitte-laverne-youth-warriors.jpg",
    },
  ],
  Ocellot: [
    {
      name: "Big Fat Bird",
      slug: "ocellot-big-fat-bird",
      image: "ocellot-big-fat-bird.jpg",
    },
    {
      name: "Blue Pine",
      slug: "ocellot-blue-pine",
      image: "ocellot-blue-pine.jpg",
    },
    {
      name: "Coco Farm Frogs",
      slug: "ocellot-coco-farm-frogs",
      image: "ocellot-coco-farm-frogs.jpg",
    },
    {
      name: "Fake Fat Jar",
      slug: "ocellot-fake-fat-jar",
      image: "ocellot-fake-fat-jar.jpg",
    },
    {
      name: "Jelly Soul",
      slug: "ocellot-jelly-soul",
      image: "ocellot-jelly-soul.jpg",
    },
    {
      name: "Let Me Help",
      slug: "ocellot-let-me-help",
      image: "ocellot-let-me-help.jpg",
    },
    {
      name: "Magic Calamansi",
      slug: "ocellot-magic-calamansi",
      image: "ocellot-magic-calamansi.jpg",
    },
    {
      name: "Slow Dream",
      slug: "ocellot-slow-dream",
      image: "ocellot-slow-dream.jpg",
    },
    {
      name: "Sun Is Up",
      slug: "ocellot-sun-is-up",
      image: "ocellot-sun-is-up.jpg",
    },
    { name: "Tama", slug: "ocellot-tama", image: "ocellot-tama.jpg" },
    {
      name: "To Be Fare",
      slug: "ocellot-to-be-fare",
      image: "ocellot-to-be-fare.jpg",
    },
    {
      name: "To The Light Lealan",
      slug: "ocellot-to-the-light-lealan",
      image: "ocellot-to-the-light-lealan.jpg",
    },
  ],
  Boa: [
    {
      name: "Bike Ride Part II",
      slug: "boa-bike-ride-part-ii",
      image: "boa-bike-ride-part-ii.jpg",
    },
    {
      name: "Gotta Go I Know",
      slug: "boa-gotta-go-i-know",
      image: "boa-gotta-go-i-know.jpg",
    },
    {
      name: "In The Morning",
      slug: "boa-in-the-morning",
      image: "boa-in-the-morning.jpg",
    },
    { name: "Timelapse", slug: "boa-timelapse", image: "boa-timelapse.jpg" },
  ],
  "Joy Boy": [
    { name: "Bimbi", slug: "joy-boy-bimbi", image: "joy-boy-bimbi.jpg" },
    {
      name: "Bimbi (Chamber Version)",
      slug: "joy-boy-bimbi-chamber-version",
      image: "joy-boy-bimbi-chamber-version.jpg",
    },
    {
      name: "Bunny Tron",
      slug: "joy-boy-bunny-tron",
      image: "joy-boy-bunny-tron.jpg",
    },
    { name: "Main", slug: "joy-boy-main", image: "joy-boy-main.jpg" },
    {
      name: "Nut Tracker",
      slug: "joy-boy-nut-tracker",
      image: "joy-boy-nut-tracker.jpg",
    },
    {
      name: "Penguin Sushi",
      slug: "joy-boy-penguin-sushi",
      image: "joy-boy-penguin-sushi.jpg",
    },
    {
      name: "Penguin Vegas",
      slug: "joy-boy-penguin-vegas",
      image: "joy-boy-penguin-vegas.jpg",
    },
    {
      name: "Penguin Venice",
      slug: "joy-boy-penguin-venice",
      image: "joy-boy-penguin-venice.jpg",
    },
    {
      name: "Penguin Zoo",
      slug: "joy-boy-penguin-zoo",
      image: "joy-boy-penguin-zoo.jpg",
    },
    {
      name: "Santa Ride",
      slug: "joy-boy-santa-ride",
      image: "joy-boy-santa-ride.jpg",
    },
  ],
  "Komodo Kolektif": [
    {
      name: "Binaural Bintaro",
      slug: "komodo-kolektif-binaural-bintaro",
      image: "komodo-kolektif-binaural-bintaro.jpg",
    },
    {
      name: "Disciple of the Drone",
      slug: "komodo-kolektif-disciple-of-the-drone",
      image: "komodo-kolektif-disciple-of-the-drone.jpg",
    },
    {
      name: "Djakarta 3001",
      slug: "komodo-kolektif-djakarta-3001",
      image: "komodo-kolektif-djakarta-3001.jpg",
    },
    {
      name: "Festival of the Black Sun (Parts 1 & 2)",
      slug: "komodo-kolektif-festival-of-the-black-sun-parts-1-and-2",
      image: "komodo-kolektif-festival-of-the-black-sun-parts-1-and-2.jpg",
    },
    {
      name: "Festival of the Black Sun (Parts 3 & 4)",
      slug: "komodo-kolektif-festival-of-the-black-sun-parts-3-and-4",
      image: "komodo-kolektif-festival-of-the-black-sun-parts-3-and-4.jpg",
    },
    {
      name: "Forever Lost",
      slug: "komodo-kolektif-forever-lost",
      image: "komodo-kolektif-forever-lost.jpg",
    },
    {
      name: "Night of the Leyak",
      slug: "komodo-kolektif-night-of-the-leyak",
      image: "komodo-kolektif-night-of-the-leyak.jpg",
    },
    {
      name: "Sun And Water",
      slug: "komodo-kolektif-sun-and-water",
      image: "komodo-kolektif-sun-and-water.jpg",
    },
    {
      name: "Temple Ball",
      slug: "komodo-kolektif-temple-ball",
      image: "komodo-kolektif-temple-ball.jpg",
    },
  ],
  Entertainment: [
    {
      name: "Birds",
      slug: "entertainment-birds",
      image: "entertainment-birds.jpg",
    },
    {
      name: "Breathing",
      slug: "entertainment-breathing",
      image: "entertainment-breathing.jpg",
    },
    {
      name: "For Sure",
      slug: "entertainment-for-sure",
      image: "entertainment-for-sure.jpg",
    },
    {
      name: "For You",
      slug: "entertainment-for-you",
      image: "entertainment-for-you.jpg",
    },
    {
      name: "Human Fiction",
      slug: "entertainment-human-fiction",
      image: "entertainment-human-fiction.jpg",
    },
    {
      name: "Sandy",
      slug: "entertainment-sandy",
      image: "entertainment-sandy.jpg",
    },
    {
      name: "Vulture",
      slug: "entertainment-vulture",
      image: "entertainment-vulture.jpg",
    },
    {
      name: "Yeah Yeah Yeah",
      slug: "entertainment-yeah-yeah-yeah",
      image: "entertainment-yeah-yeah-yeah.jpg",
    },
  ],
  Maik: [
    { name: "Birds", slug: "maik-birds", image: "maik-birds.jpg" },
    {
      name: "Birds Part 2",
      slug: "maik-birds-part-2",
      image: "maik-birds-part-2.jpg",
    },
    { name: "Epico", slug: "maik-epico", image: "maik-epico.jpg" },
    {
      name: "Summer Time",
      slug: "maik-summer-time",
      image: "maik-summer-time.jpg",
    },
  ],
  Drum: [{ name: "Bit It", slug: "drum-bit-it", image: "drum-bit-it.jpg" }],
  Publicist: [
    {
      name: "Bite (Original)",
      slug: "publicist-bite-original",
      image: "publicist-bite-original.jpg",
    },
    {
      name: "Unnecessary Roughness (Original Mix)",
      slug: "publicist-unnecessary-roughness-original-mix",
      image: "publicist-unnecessary-roughness-original-mix.jpg",
    },
  ],
  "FK Club": [
    { name: "Bizmark", slug: "fk-club-bizmark", image: "fk-club-bizmark.jpg" },
    { name: "Breeze", slug: "fk-club-breeze", image: "fk-club-breeze.jpg" },
    {
      name: "Brutalism",
      slug: "fk-club-brutalism",
      image: "fk-club-brutalism.jpg",
    },
    {
      name: "Brutalism 2",
      slug: "fk-club-brutalism-2",
      image: "fk-club-brutalism-2.jpg",
    },
    {
      name: "See Me Now",
      slug: "fk-club-see-me-now",
      image: "fk-club-see-me-now.jpg",
    },
    {
      name: "Strange Art",
      slug: "fk-club-strange-art",
      image: "fk-club-strange-art.jpg",
    },
    {
      name: "Strange Art (Dj Steef Remix)",
      slug: "fk-club-strange-art-dj-steef-remix",
      image: "fk-club-strange-art-dj-steef-remix.jpg",
    },
    {
      name: "Strange Art (Inflagranti Remix)",
      slug: "fk-club-strange-art-inflagranti-remix",
      image: "fk-club-strange-art-inflagranti-remix.jpg",
    },
    {
      name: "Strange Art (Nasser Remix)",
      slug: "fk-club-strange-art-nasser-remix",
      image: "fk-club-strange-art-nasser-remix.jpg",
    },
    {
      name: "Strange Art (Richard Sen Remix)",
      slug: "fk-club-strange-art-richard-sen-remix",
      image: "fk-club-strange-art-richard-sen-remix.jpg",
    },
    {
      name: "Superamerica",
      slug: "fk-club-superamerica",
      image: "fk-club-superamerica.jpg",
    },
    { name: "Volta", slug: "fk-club-volta", image: "fk-club-volta.jpg" },
  ],
  "Terminal Twilight": [
    {
      name: "Black And Blue (Dub Version)",
      slug: "terminal-twilight-black-and-blue-dub-version",
      image: "terminal-twilight-black-and-blue-dub-version.jpg",
    },
    {
      name: "Black And Blue (Original)",
      slug: "terminal-twilight-black-and-blue-original",
      image: "terminal-twilight-black-and-blue-original.jpg",
    },
  ],
  OKO: [
    {
      name: "Black Bowie",
      slug: "oko-black-bowie",
      image: "oko-black-bowie.jpg",
    },
    {
      name: "Black Bowie (Instrumental)",
      slug: "oko-black-bowie-instrumental",
      image: "oko-black-bowie-instrumental.jpg",
    },
    {
      name: "Feelings (Instrumental)",
      slug: "oko-feelings-instrumental",
      image: "oko-feelings-instrumental.jpg",
    },
    { name: "Iro", slug: "oko-iro", image: "oko-iro.jpg" },
    {
      name: "Iro (Instrumental)",
      slug: "oko-iro-instrumental",
      image: "oko-iro-instrumental.jpg",
    },
    { name: "Naked Life", slug: "oko-naked-life", image: "oko-naked-life.jpg" },
    {
      name: "Naked Life (Instrumental)",
      slug: "oko-naked-life-instrumental",
      image: "oko-naked-life-instrumental.jpg",
    },
    {
      name: "Niggality (Instrumental)",
      slug: "oko-niggality-instrumental",
      image: "oko-niggality-instrumental.jpg",
    },
  ],
  Yori: [
    {
      name: "Black Hole",
      slug: "yori-black-hole",
      image: "yori-black-hole.jpg",
    },
    {
      name: "Only God Forgives",
      slug: "yori-only-god-forgives",
      image: "yori-only-god-forgives.jpg",
    },
    {
      name: "The Walking Puppets",
      slug: "yori-the-walking-puppets",
      image: "yori-the-walking-puppets.jpg",
    },
    {
      name: "Unconsciousness",
      slug: "yori-unconsciousness",
      image: "yori-unconsciousness.jpg",
    },
    {
      name: "Violent Ways",
      slug: "yori-violent-ways",
      image: "yori-violent-ways.jpg",
    },
  ],
  Xinobi: [
    {
      name: "Black Holes In The Sky",
      slug: "xinobi-black-holes-in-the-sky",
      image: "xinobi-black-holes-in-the-sky.jpg",
    },
    {
      name: "Bogota (Psychemagik Remix)",
      slug: "xinobi-bogota-psychemagik-remix",
      image: "xinobi-bogota-psychemagik-remix.jpg",
    },
    {
      name: "Crime (Munk Remix)",
      slug: "xinobi-crime-munk-remix",
      image: "xinobi-crime-munk-remix.jpg",
    },
    {
      name: "Dance To Hits",
      slug: "xinobi-dance-to-hits",
      image: "xinobi-dance-to-hits.jpg",
    },
    {
      name: "Fado Para Esta Noite feat. Gisela Joao",
      slug: "xinobi-fado-para-esta-noite-feat-gisela-joao",
      image: "xinobi-fado-para-esta-noite-feat-gisela-joao.jpg",
    },
    {
      name: "Far Away Place",
      slug: "xinobi-far-away-place",
      image: "xinobi-far-away-place.jpg",
    },
    {
      name: "Far Away Place (Dub Version)",
      slug: "xinobi-far-away-place-dub-version",
      image: "xinobi-far-away-place-dub-version.jpg",
    },
    {
      name: "Far Away Place (Instrumental)",
      slug: "xinobi-far-away-place-instrumental",
      image: "xinobi-far-away-place-instrumental.jpg",
    },
    {
      name: "Far Away Place (Jody Wisternoff & James Grant Remix)",
      slug: "xinobi-far-away-place-jody-wisternoff-and-james-grant-remix",
      image: "xinobi-far-away-place-jody-wisternoff-and-james-grant-remix.jpg",
    },
    {
      name: "Far Away Place (Pete Herbert Dub Remix)",
      slug: "xinobi-far-away-place-pete-herbert-dub-remix",
      image: "xinobi-far-away-place-pete-herbert-dub-remix.jpg",
    },
    {
      name: "Far Away Place (Pete Herbert Remix)",
      slug: "xinobi-far-away-place-pete-herbert-remix",
      image: "xinobi-far-away-place-pete-herbert-remix.jpg",
    },
    {
      name: "Far Away Place (Tensnake Remix)",
      slug: "xinobi-far-away-place-tensnake-remix",
      image: "xinobi-far-away-place-tensnake-remix.jpg",
    },
    { name: "Fire", slug: "xinobi-fire", image: "xinobi-fire.jpg" },
    {
      name: "Gili Meno",
      slug: "xinobi-gili-meno",
      image: "xinobi-gili-meno.jpg",
    },
    {
      name: "I Hate The Sound Of Guitar",
      slug: "xinobi-i-hate-the-sound-of-guitar",
      image: "xinobi-i-hate-the-sound-of-guitar.jpg",
    },
    {
      name: "Mom and Dad",
      slug: "xinobi-mom-and-dad",
      image: "xinobi-mom-and-dad.jpg",
    },
    {
      name: "Mom and Dad (Richie Hell Clean Remix)",
      slug: "xinobi-mom-and-dad-richie-hell-clean-remix",
      image: "xinobi-mom-and-dad-richie-hell-clean-remix.jpg",
    },
    {
      name: "Mom and Dad (Richie Hell Dirty Remix)",
      slug: "xinobi-mom-and-dad-richie-hell-dirty-remix",
      image: "xinobi-mom-and-dad-richie-hell-dirty-remix.jpg",
    },
    {
      name: "Morning Fix",
      slug: "xinobi-morning-fix",
      image: "xinobi-morning-fix.jpg",
    },
    {
      name: "Morning Fix (Fake Money Remix Dub)",
      slug: "xinobi-morning-fix-fake-money-remix-dub",
      image: "xinobi-morning-fix-fake-money-remix-dub.jpg",
    },
    {
      name: "Morning Fix (Fake Money Remix)",
      slug: "xinobi-morning-fix-fake-money-remix",
      image: "xinobi-morning-fix-fake-money-remix.jpg",
    },
    {
      name: "Morning Fix (Wild & Free Remix)",
      slug: "xinobi-morning-fix-wild-and-free-remix",
      image: "xinobi-morning-fix-wild-and-free-remix.jpg",
    },
    {
      name: "People (Discoholycs and Felipe Gordon Remix)",
      slug: "xinobi-people-discoholycs-and-felipe-gordon-remix",
      image: "xinobi-people-discoholycs-and-felipe-gordon-remix.jpg",
    },
    {
      name: "Piano Lessions",
      slug: "xinobi-piano-lessions",
      image: "xinobi-piano-lessions.jpg",
    },
    {
      name: "Polana (Switch Dance Remix)",
      slug: "xinobi-polana-switch-dance-remix",
      image: "xinobi-polana-switch-dance-remix.jpg",
    },
    {
      name: "Puma (Moullinex Remix)",
      slug: "xinobi-puma-moullinex-remix",
      image: "xinobi-puma-moullinex-remix.jpg",
    },
    {
      name: "Real Fake (Cut Slack Remix)",
      slug: "xinobi-real-fake-cut-slack-remix",
      image: "xinobi-real-fake-cut-slack-remix.jpg",
    },
    {
      name: "Real Fake (Dark Version)",
      slug: "xinobi-real-fake-dark-version",
      image: "xinobi-real-fake-dark-version.jpg",
    },
    {
      name: "Real Fake (Jonjo Jury Remix)",
      slug: "xinobi-real-fake-jonjo-jury-remix",
      image: "xinobi-real-fake-jonjo-jury-remix.jpg",
    },
    {
      name: "Searching For",
      slug: "xinobi-searching-for",
      image: "xinobi-searching-for.jpg",
    },
    { name: "See Me", slug: "xinobi-see-me", image: "xinobi-see-me.jpg" },
    {
      name: "See Me (Ali Kuru Remix)",
      slug: "xinobi-see-me-ali-kuru-remix",
      image: "xinobi-see-me-ali-kuru-remix.jpg",
    },
    {
      name: "Skateboarding",
      slug: "xinobi-skateboarding",
      image: "xinobi-skateboarding.jpg",
    },
    {
      name: "Skateboarding (Kraak & Smaak Remix)",
      slug: "xinobi-skateboarding-kraak-and-smaak-remix",
      image: "xinobi-skateboarding-kraak-and-smaak-remix.jpg",
    },
    {
      name: "Tonic Clonic",
      slug: "xinobi-tonic-clonic",
      image: "xinobi-tonic-clonic.jpg",
    },
    {
      name: "Undertones",
      slug: "xinobi-undertones",
      image: "xinobi-undertones.jpg",
    },
    {
      name: "Wonderful People",
      slug: "xinobi-wonderful-people",
      image: "xinobi-wonderful-people.jpg",
    },
    {
      name: "Woods (Bufi Remix)",
      slug: "xinobi-woods-bufi-remix",
      image: "xinobi-woods-bufi-remix.jpg",
    },
    {
      name: "Woods (Mirror People Remix)",
      slug: "xinobi-woods-mirror-people-remix",
      image: "xinobi-woods-mirror-people-remix.jpg",
    },
  ],
  Rigopolar: [
    {
      name: "Black Mantis (Original Mix)",
      slug: "rigopolar-black-mantis-original-mix",
      image: "rigopolar-black-mantis-original-mix.jpg",
    },
    {
      name: "Crashes",
      slug: "rigopolar-crashes",
      image: "rigopolar-crashes.jpg",
    },
    {
      name: "Espiral",
      slug: "rigopolar-espiral",
      image: "rigopolar-espiral.jpg",
    },
    { name: "Time", slug: "rigopolar-time", image: "rigopolar-time.jpg" },
  ],
  "Vision Paname": [
    {
      name: "Black Miracle",
      slug: "vision-paname-black-miracle",
      image: "vision-paname-black-miracle.jpg",
    },
    {
      name: "Black Room",
      slug: "vision-paname-black-room",
      image: "vision-paname-black-room.jpg",
    },
    {
      name: "Music Television",
      slug: "vision-paname-music-television",
      image: "vision-paname-music-television.jpg",
    },
    {
      name: "Never Stop",
      slug: "vision-paname-never-stop",
      image: "vision-paname-never-stop.jpg",
    },
    {
      name: "New Romance",
      slug: "vision-paname-new-romance",
      image: "vision-paname-new-romance.jpg",
    },
    {
      name: "Sex Emotion",
      slug: "vision-paname-sex-emotion",
      image: "vision-paname-sex-emotion.jpg",
    },
    {
      name: "Smile",
      slug: "vision-paname-smile",
      image: "vision-paname-smile.jpg",
    },
  ],
  "Faith&Spirit": [
    {
      name: "Black Moon",
      slug: "faith-and-spirit-black-moon",
      image: "faith-and-spirit-black-moon.jpg",
    },
    {
      name: "Crossfire Hurricane",
      slug: "faith-and-spirit-crossfire-hurricane",
      image: "faith-and-spirit-crossfire-hurricane.jpg",
    },
    {
      name: "Down The Road",
      slug: "faith-and-spirit-down-the-road",
      image: "faith-and-spirit-down-the-road.jpg",
    },
    {
      name: "Fade",
      slug: "faith-and-spirit-fade",
      image: "faith-and-spirit-fade.jpg",
    },
    {
      name: "Glorious Days",
      slug: "faith-and-spirit-glorious-days",
      image: "faith-and-spirit-glorious-days.jpg",
    },
    {
      name: "I'll Be Your Man",
      slug: "faith-and-spirit-i-ll-be-your-man",
      image: "faith-and-spirit-i-ll-be-your-man.jpg",
    },
    {
      name: "It's Your Turn To Cry",
      slug: "faith-and-spirit-it-s-your-turn-to-cry",
      image: "faith-and-spirit-it-s-your-turn-to-cry.jpg",
    },
    {
      name: "Strike Back",
      slug: "faith-and-spirit-strike-back",
      image: "faith-and-spirit-strike-back.jpg",
    },
    {
      name: "Take It Loud",
      slug: "faith-and-spirit-take-it-loud",
      image: "faith-and-spirit-take-it-loud.jpg",
    },
    {
      name: "Time Goes On",
      slug: "faith-and-spirit-time-goes-on",
      image: "faith-and-spirit-time-goes-on.jpg",
    },
    {
      name: "When The Lights Is Gone",
      slug: "faith-and-spirit-when-the-lights-is-gone",
      image: "faith-and-spirit-when-the-lights-is-gone.jpg",
    },
  ],
  "Dead Capo": [
    {
      name: "Blade Runner (End Title)",
      slug: "dead-capo-blade-runner-end-title",
      image: "dead-capo-blade-runner-end-title.jpg",
    },
    {
      name: "Blues Monka",
      slug: "dead-capo-blues-monka",
      image: "dead-capo-blues-monka.jpg",
    },
    {
      name: "Carnaza",
      slug: "dead-capo-carnaza",
      image: "dead-capo-carnaza.jpg",
    },
    {
      name: "Cicatrizando El Aire",
      slug: "dead-capo-cicatrizando-el-aire",
      image: "dead-capo-cicatrizando-el-aire.jpg",
    },
    {
      name: "Fat Dog Mendoza",
      slug: "dead-capo-fat-dog-mendoza",
      image: "dead-capo-fat-dog-mendoza.jpg",
    },
    {
      name: "Monkatis Revisited",
      slug: "dead-capo-monkatis-revisited",
      image: "dead-capo-monkatis-revisited.jpg",
    },
    {
      name: "Polvoriento",
      slug: "dead-capo-polvoriento",
      image: "dead-capo-polvoriento.jpg",
    },
    { name: "Sirope", slug: "dead-capo-sirope", image: "dead-capo-sirope.jpg" },
    {
      name: "Sunny Garcia",
      slug: "dead-capo-sunny-garcia",
      image: "dead-capo-sunny-garcia.jpg",
    },
    {
      name: "Well You Needn't",
      slug: "dead-capo-well-you-needn-t",
      image: "dead-capo-well-you-needn-t.jpg",
    },
  ],
  "Golden Bug and In Fields": [
    {
      name: "Blades",
      slug: "golden-bug-and-in-fields-blades",
      image: "golden-bug-and-in-fields-blades.jpg",
    },
    {
      name: "Blind",
      slug: "golden-bug-and-in-fields-blind",
      image: "golden-bug-and-in-fields-blind.jpg",
    },
    {
      name: "Bones (Fantastic Twins Remix)",
      slug: "golden-bug-and-in-fields-bones-fantastic-twins-remix",
      image: "golden-bug-and-in-fields-bones-fantastic-twins-remix.jpg",
    },
    {
      name: "Bones feat. Diego Hdez",
      slug: "golden-bug-and-in-fields-bones-feat-diego-hdez",
      image: "golden-bug-and-in-fields-bones-feat-diego-hdez.jpg",
    },
    {
      name: "Breath",
      slug: "golden-bug-and-in-fields-breath",
      image: "golden-bug-and-in-fields-breath.jpg",
    },
    {
      name: "Cracks",
      slug: "golden-bug-and-in-fields-cracks",
      image: "golden-bug-and-in-fields-cracks.jpg",
    },
    {
      name: "Dust",
      slug: "golden-bug-and-in-fields-dust",
      image: "golden-bug-and-in-fields-dust.jpg",
    },
    {
      name: "Ground",
      slug: "golden-bug-and-in-fields-ground",
      image: "golden-bug-and-in-fields-ground.jpg",
    },
    {
      name: "La Main Jaune",
      slug: "golden-bug-and-in-fields-la-main-jaune",
      image: "golden-bug-and-in-fields-la-main-jaune.jpg",
    },
    {
      name: "Lungs",
      slug: "golden-bug-and-in-fields-lungs",
      image: "golden-bug-and-in-fields-lungs.jpg",
    },
    {
      name: "Smack",
      slug: "golden-bug-and-in-fields-smack",
      image: "golden-bug-and-in-fields-smack.jpg",
    },
    {
      name: "Vibrations Métalliques",
      slug: "golden-bug-and-in-fields-vibrations-metalliques",
      image: "golden-bug-and-in-fields-vibrations-metalliques.jpg",
    },
  ],
  "Pete Bombastic": [
    {
      name: "Blonde English Streets",
      slug: "pete-bombastic-blonde-english-streets",
      image: "pete-bombastic-blonde-english-streets.jpg",
    },
    {
      name: "Empty Chords",
      slug: "pete-bombastic-empty-chords",
      image: "pete-bombastic-empty-chords.jpg",
    },
    {
      name: "Homicidal Clown",
      slug: "pete-bombastic-homicidal-clown",
      image: "pete-bombastic-homicidal-clown.jpg",
    },
    {
      name: "Jackson Pollock",
      slug: "pete-bombastic-jackson-pollock",
      image: "pete-bombastic-jackson-pollock.jpg",
    },
    {
      name: "Mr Idle",
      slug: "pete-bombastic-mr-idle",
      image: "pete-bombastic-mr-idle.jpg",
    },
    {
      name: "The Amazing Supersonic",
      slug: "pete-bombastic-the-amazing-supersonic",
      image: "pete-bombastic-the-amazing-supersonic.jpg",
    },
  ],
  Zerowatt: [
    {
      name: "Bloody Brainless",
      slug: "zerowatt-bloody-brainless",
      image: "zerowatt-bloody-brainless.jpg",
    },
    {
      name: "Deep Blue Sea",
      slug: "zerowatt-deep-blue-sea",
      image: "zerowatt-deep-blue-sea.jpg",
    },
    {
      name: "Half Moon",
      slug: "zerowatt-half-moon",
      image: "zerowatt-half-moon.jpg",
    },
    { name: "Nu", slug: "zerowatt-nu", image: "zerowatt-nu.jpg" },
    { name: "Nu 8", slug: "zerowatt-nu-8", image: "zerowatt-nu-8.jpg" },
    {
      name: "Number 4",
      slug: "zerowatt-number-4",
      image: "zerowatt-number-4.jpg",
    },
    {
      name: "Pièce pour violoncelle et Piano n° 1",
      slug: "zerowatt-piece-pour-violoncelle-et-piano-n-1",
      image: "zerowatt-piece-pour-violoncelle-et-piano-n-1.jpg",
    },
    {
      name: "Pièce pour violoncelle et Piano n° 2",
      slug: "zerowatt-piece-pour-violoncelle-et-piano-n-2",
      image: "zerowatt-piece-pour-violoncelle-et-piano-n-2.jpg",
    },
    {
      name: "Quatuor à cordes n° 1",
      slug: "zerowatt-quatuor-a-cordes-n-1",
      image: "zerowatt-quatuor-a-cordes-n-1.jpg",
    },
    {
      name: "Quatuor à cordes n° 2",
      slug: "zerowatt-quatuor-a-cordes-n-2",
      image: "zerowatt-quatuor-a-cordes-n-2.jpg",
    },
    {
      name: "Quatuor à cordes n° 3",
      slug: "zerowatt-quatuor-a-cordes-n-3",
      image: "zerowatt-quatuor-a-cordes-n-3.jpg",
    },
    {
      name: "The Garden Gnome",
      slug: "zerowatt-the-garden-gnome",
      image: "zerowatt-the-garden-gnome.jpg",
    },
    {
      name: "The Wicked Witch Of The West",
      slug: "zerowatt-the-wicked-witch-of-the-west",
      image: "zerowatt-the-wicked-witch-of-the-west.jpg",
    },
    {
      name: "Tricks Of Light",
      slug: "zerowatt-tricks-of-light",
      image: "zerowatt-tricks-of-light.jpg",
    },
    {
      name: "Trio avec piano",
      slug: "zerowatt-trio-avec-piano",
      image: "zerowatt-trio-avec-piano.jpg",
    },
    {
      name: "Trio à cordes n° 1",
      slug: "zerowatt-trio-a-cordes-n-1",
      image: "zerowatt-trio-a-cordes-n-1.jpg",
    },
    {
      name: "Trio à cordes n° 2",
      slug: "zerowatt-trio-a-cordes-n-2",
      image: "zerowatt-trio-a-cordes-n-2.jpg",
    },
    {
      name: "Unicorn",
      slug: "zerowatt-unicorn",
      image: "zerowatt-unicorn.jpg",
    },
  ],
  "Robin Dylan": [
    {
      name: "Bloom",
      slug: "robin-dylan-bloom",
      image: "robin-dylan-bloom.jpg",
    },
  ],
  Uncut: [
    {
      name: "Blue Eyes Lover",
      slug: "uncut-blue-eyes-lover",
      image: "uncut-blue-eyes-lover.jpg",
    },
  ],
  Horizon: [
    {
      name: "Blue Moon",
      slug: "horizon-blue-moon",
      image: "horizon-blue-moon.jpg",
    },
    {
      name: "Feeling Alone",
      slug: "horizon-feeling-alone",
      image: "horizon-feeling-alone.jpg",
    },
    {
      name: "Long Time No See",
      slug: "horizon-long-time-no-see",
      image: "horizon-long-time-no-see.jpg",
    },
    {
      name: "Sorry Didn't Mean To",
      slug: "horizon-sorry-didn-t-mean-to",
      image: null,
    },
  ],
  "Bart Davenport": [
    {
      name: "Blue Motel",
      slug: "bart-davenport-blue-motel",
      image: "bart-davenport-blue-motel.jpg",
    },
    {
      name: "Dust In The Circuits",
      slug: "bart-davenport-dust-in-the-circuits",
      image: "bart-davenport-dust-in-the-circuits.jpg",
    },
    {
      name: "Every Litle Step",
      slug: "bart-davenport-every-litle-step",
      image: "bart-davenport-every-litle-step.jpg",
    },
    {
      name: "Fuck Fame",
      slug: "bart-davenport-fuck-fame",
      image: "bart-davenport-fuck-fame.jpg",
    },
    {
      name: "Girl Gotta Way",
      slug: "bart-davenport-girl-gotta-way",
      image: "bart-davenport-girl-gotta-way.jpg",
    },
    {
      name: "Girl Gotta Way (Peaking Lights Instrumental Remix)",
      slug: "bart-davenport-girl-gotta-way-peaking-lights-instrumental-remix",
      image:
        "bart-davenport-girl-gotta-way-peaking-lights-instrumental-remix.jpg",
    },
    {
      name: "Girl Gotta Way (Peaking Lights Remix Radio Edit)",
      slug: "bart-davenport-girl-gotta-way-peaking-lights-remix-radio-edit",
      image:
        "bart-davenport-girl-gotta-way-peaking-lights-remix-radio-edit.jpg",
    },
    {
      name: "Grownups",
      slug: "bart-davenport-grownups",
      image: "bart-davenport-grownups.jpg",
    },
    {
      name: "Halloween By The Sea",
      slug: "bart-davenport-halloween-by-the-sea",
      image: "bart-davenport-halloween-by-the-sea.jpg",
    },
    {
      name: "Life Under Water",
      slug: "bart-davenport-life-under-water",
      image: "bart-davenport-life-under-water.jpg",
    },
    {
      name: "Loop In My Head",
      slug: "bart-davenport-loop-in-my-head",
      image: "bart-davenport-loop-in-my-head.jpg",
    },
    {
      name: "On Your Own Planet",
      slug: "bart-davenport-on-your-own-planet",
      image: "bart-davenport-on-your-own-planet.jpg",
    },
    {
      name: "Pamela",
      slug: "bart-davenport-pamela",
      image: "bart-davenport-pamela.jpg",
    },
    {
      name: "Physical World",
      slug: "bart-davenport-physical-world",
      image: "bart-davenport-physical-world.jpg",
    },
    {
      name: "Single Life",
      slug: "bart-davenport-single-life",
      image: "bart-davenport-single-life.jpg",
    },
    {
      name: "The Amateurs",
      slug: "bart-davenport-the-amateurs",
      image: "bart-davenport-the-amateurs.jpg",
    },
    {
      name: "The House That Built Itself",
      slug: "bart-davenport-the-house-that-built-itself",
      image: "bart-davenport-the-house-that-built-itself.jpg",
    },
    {
      name: "Time Machine For Two",
      slug: "bart-davenport-time-machine-for-two",
      image: "bart-davenport-time-machine-for-two.jpg",
    },
    {
      name: "Vampire",
      slug: "bart-davenport-vampire",
      image: "bart-davenport-vampire.jpg",
    },
    {
      name: "Vow",
      slug: "bart-davenport-vow",
      image: "bart-davenport-vow.jpg",
    },
    {
      name: "Wearing The Changes",
      slug: "bart-davenport-wearing-the-changes",
      image: "bart-davenport-wearing-the-changes.jpg",
    },
    {
      name: "What's Your Secret",
      slug: "bart-davenport-what-s-your-secret",
      image: "bart-davenport-what-s-your-secret.jpg",
    },
    {
      name: "Your Sorrow",
      slug: "bart-davenport-your-sorrow",
      image: "bart-davenport-your-sorrow.jpg",
    },
  ],
  "Raoul Vignal": [
    {
      name: "Blue Raven",
      slug: "raoul-vignal-blue-raven",
      image: "raoul-vignal-blue-raven.jpg",
    },
    {
      name: "I Have Sinned",
      slug: "raoul-vignal-i-have-sinned",
      image: "raoul-vignal-i-have-sinned.jpg",
    },
    {
      name: "I Might",
      slug: "raoul-vignal-i-might",
      image: "raoul-vignal-i-might.jpg",
    },
    {
      name: "Mirror",
      slug: "raoul-vignal-mirror",
      image: "raoul-vignal-mirror.jpg",
    },
    {
      name: "No Faith",
      slug: "raoul-vignal-no-faith",
      image: "raoul-vignal-no-faith.jpg",
    },
    { name: "One", slug: "raoul-vignal-one", image: "raoul-vignal-one.jpg" },
    {
      name: "Pepa's Eyes",
      slug: "raoul-vignal-pepa-s-eyes",
      image: "raoul-vignal-pepa-s-eyes.jpg",
    },
    {
      name: "The Dream",
      slug: "raoul-vignal-the-dream",
      image: "raoul-vignal-the-dream.jpg",
    },
    {
      name: "The Valve",
      slug: "raoul-vignal-the-valve",
      image: "raoul-vignal-the-valve.jpg",
    },
    {
      name: "The Waves Part 1",
      slug: "raoul-vignal-the-waves-part-1",
      image: "raoul-vignal-the-waves-part-1.jpg",
    },
    {
      name: "The Waves Part 2",
      slug: "raoul-vignal-the-waves-part-2",
      image: "raoul-vignal-the-waves-part-2.jpg",
    },
    {
      name: "Under The Same Sky",
      slug: "raoul-vignal-under-the-same-sky",
      image: "raoul-vignal-under-the-same-sky.jpg",
    },
    {
      name: "Whispers",
      slug: "raoul-vignal-whispers",
      image: "raoul-vignal-whispers.jpg",
    },
  ],
  Diskay: [
    {
      name: "Blue Ride",
      slug: "diskay-blue-ride",
      image: "diskay-blue-ride.jpg",
    },
    {
      name: "Life On The Ground",
      slug: "diskay-life-on-the-ground",
      image: "diskay-life-on-the-ground.jpg",
    },
    { name: "Odessa", slug: "diskay-odessa", image: "diskay-odessa.jpg" },
  ],
  "Lou Berry": [
    {
      name: "Blue Sky feat Eylia (Neumodel Remix)",
      slug: "lou-berry-blue-sky-feat-eylia-neumodel-remix",
      image: "lou-berry-blue-sky-feat-eylia-neumodel-remix.jpg",
    },
  ],
  "Sordid Sound System": [
    {
      name: "Blues Pour Vivienne",
      slug: "sordid-sound-system-blues-pour-vivienne",
      image: "sordid-sound-system-blues-pour-vivienne.jpg",
    },
    {
      name: "Cochise",
      slug: "sordid-sound-system-cochise",
      image: "sordid-sound-system-cochise.jpg",
    },
    {
      name: "Dia De Muertos",
      slug: "sordid-sound-system-dia-de-muertos",
      image: "sordid-sound-system-dia-de-muertos.jpg",
    },
    {
      name: "Dub Cha Cha",
      slug: "sordid-sound-system-dub-cha-cha",
      image: "sordid-sound-system-dub-cha-cha.jpg",
    },
    {
      name: "Golden Pudel",
      slug: "sordid-sound-system-golden-pudel",
      image: "sordid-sound-system-golden-pudel.jpg",
    },
    {
      name: "I Walk on Splintered Gilders",
      slug: "sordid-sound-system-i-walk-on-splintered-gilders",
      image: "sordid-sound-system-i-walk-on-splintered-gilders.jpg",
    },
    {
      name: "Keep Your Head",
      slug: "sordid-sound-system-keep-your-head",
      image: "sordid-sound-system-keep-your-head.jpg",
    },
    {
      name: "Lux Exterior",
      slug: "sordid-sound-system-lux-exterior",
      image: "sordid-sound-system-lux-exterior.jpg",
    },
    {
      name: "Scratch",
      slug: "sordid-sound-system-scratch",
      image: "sordid-sound-system-scratch.jpg",
    },
  ],
  "Henrik Rylander": [
    {
      name: "Bländning",
      slug: "henrik-rylander-blaendning",
      image: "henrik-rylander-blaendning.jpg",
    },
    {
      name: "Dansant Lösning",
      slug: "henrik-rylander-dansant-loesning",
      image: "henrik-rylander-dansant-loesning.jpg",
    },
    {
      name: "Kontakt",
      slug: "henrik-rylander-kontakt",
      image: "henrik-rylander-kontakt.jpg",
    },
    {
      name: "Och Plötsigt",
      slug: "henrik-rylander-och-ploetsigt",
      image: "henrik-rylander-och-ploetsigt.jpg",
    },
    {
      name: "Organ1",
      slug: "henrik-rylander-organ1",
      image: "henrik-rylander-organ1.jpg",
    },
    {
      name: "Snask",
      slug: "henrik-rylander-snask",
      image: "henrik-rylander-snask.jpg",
    },
    {
      name: "Som Att Tala Till En Vägg",
      slug: "henrik-rylander-som-att-tala-till-en-vaegg",
      image: "henrik-rylander-som-att-tala-till-en-vaegg.jpg",
    },
    {
      name: "Sommarregn Är Inte Farligt",
      slug: "henrik-rylander-sommarregn-aer-inte-farligt",
      image: "henrik-rylander-sommarregn-aer-inte-farligt.jpg",
    },
    {
      name: "Somnambul Sorti",
      slug: "henrik-rylander-somnambul-sorti",
      image: "henrik-rylander-somnambul-sorti.jpg",
    },
    {
      name: "Ängrar, Finns Dom",
      slug: "henrik-rylander-aengrar-finns-dom",
      image: "henrik-rylander-aengrar-finns-dom.jpg",
    },
  ],
  "Henri Caraguel": [
    {
      name: "Boca De Uchire",
      slug: "henri-caraguel-boca-de-uchire",
      image: "henri-caraguel-boca-de-uchire.jpg",
    },
    {
      name: "Claujac",
      slug: "henri-caraguel-claujac",
      image: "henri-caraguel-claujac.jpg",
    },
    {
      name: "Conney Island",
      slug: "henri-caraguel-conney-island",
      image: "henri-caraguel-conney-island.jpg",
    },
    {
      name: "Dune",
      slug: "henri-caraguel-dune",
      image: "henri-caraguel-dune.jpg",
    },
    {
      name: "Jambes Brulées",
      slug: "henri-caraguel-jambes-brulees",
      image: "henri-caraguel-jambes-brulees.jpg",
    },
    {
      name: "L'Ile Du Levant",
      slug: "henri-caraguel-l-ile-du-levant",
      image: "henri-caraguel-l-ile-du-levant.jpg",
    },
    {
      name: "Matsukatze",
      slug: "henri-caraguel-matsukatze",
      image: "henri-caraguel-matsukatze.jpg",
    },
    {
      name: "Pals",
      slug: "henri-caraguel-pals",
      image: "henri-caraguel-pals.jpg",
    },
  ],
  Combray: [
    { name: "Boira", slug: "combray-boira", image: "combray-boira.jpg" },
    { name: "Erial", slug: "combray-erial", image: "combray-erial.jpg" },
    { name: "Eunice", slug: "combray-eunice", image: "combray-eunice.jpg" },
    { name: "Glacera", slug: "combray-glacera", image: "combray-glacera.jpg" },
    { name: "Pilea", slug: "combray-pilea", image: "combray-pilea.jpg" },
    {
      name: "Ullapool",
      slug: "combray-ullapool",
      image: "combray-ullapool.jpg",
    },
  ],
  "The Bite": [
    {
      name: "Bonecrusher",
      slug: "the-bite-bonecrusher",
      image: "the-bite-bonecrusher.jpg",
    },
    {
      name: "Doublethink",
      slug: "the-bite-doublethink",
      image: "the-bite-doublethink.jpg",
    },
    { name: "Drugs", slug: "the-bite-drugs", image: "the-bite-drugs.jpg" },
    {
      name: "I Realized",
      slug: "the-bite-i-realized",
      image: "the-bite-i-realized.jpg",
    },
    {
      name: "Nasty Love",
      slug: "the-bite-nasty-love",
      image: "the-bite-nasty-love.jpg",
    },
    {
      name: "Old White Money",
      slug: "the-bite-old-white-money",
      image: "the-bite-old-white-money.jpg",
    },
    {
      name: "Smart And Clean",
      slug: "the-bite-smart-and-clean",
      image: "the-bite-smart-and-clean.jpg",
    },
    {
      name: "Strange Kids",
      slug: "the-bite-strange-kids",
      image: "the-bite-strange-kids.jpg",
    },
    {
      name: "Tv Personality",
      slug: "the-bite-tv-personality",
      image: "the-bite-tv-personality.jpg",
    },
    {
      name: "Wake Up",
      slug: "the-bite-wake-up",
      image: "the-bite-wake-up.jpg",
    },
    {
      name: "Wasted Talent",
      slug: "the-bite-wasted-talent",
      image: "the-bite-wasted-talent.jpg",
    },
  ],
  Emrod: [
    { name: "Bonheur", slug: "emrod-bonheur", image: "emrod-bonheur.jpg" },
    { name: "Children", slug: "emrod-children", image: "emrod-children.jpg" },
    { name: "Espera", slug: "emrod-espera", image: "emrod-espera.jpg" },
    { name: "Forever", slug: "emrod-forever", image: "emrod-forever.jpg" },
    { name: "Gloves", slug: "emrod-gloves", image: "emrod-gloves.jpg" },
    { name: "Jennesys", slug: "emrod-jennesys", image: "emrod-jennesys.jpg" },
    { name: "Lumiere", slug: "emrod-lumiere", image: "emrod-lumiere.jpg" },
    { name: "Malabar", slug: "emrod-malabar", image: "emrod-malabar.jpg" },
    {
      name: "Revelation",
      slug: "emrod-revelation",
      image: "emrod-revelation.jpg",
    },
    { name: "Tango", slug: "emrod-tango", image: "emrod-tango.jpg" },
  ],
  "The Gigoletto Brass Band": [
    {
      name: "Boogalow",
      slug: "the-gigoletto-brass-band-boogalow",
      image: "the-gigoletto-brass-band-boogalow.jpg",
    },
    {
      name: "Koendu",
      slug: "the-gigoletto-brass-band-koendu",
      image: "the-gigoletto-brass-band-koendu.jpg",
    },
  ],
  "Mirror People": [
    {
      name: "Boogie Dance feat. Hard Ton",
      slug: "mirror-people-boogie-dance-feat-hard-ton",
      image: "mirror-people-boogie-dance-feat-hard-ton.jpg",
    },
    {
      name: "Boogie Dance feat. Hard Ton (Extended Mix)",
      slug: "mirror-people-boogie-dance-feat-hard-ton-extended-mix",
      image: "mirror-people-boogie-dance-feat-hard-ton-extended-mix.jpg",
    },
    {
      name: "Bring The Light",
      slug: "mirror-people-bring-the-light",
      image: "mirror-people-bring-the-light.jpg",
    },
    {
      name: "Come Over (Instrumental)",
      slug: "mirror-people-come-over-instrumental",
      image: "mirror-people-come-over-instrumental.jpg",
    },
    {
      name: "Come Over (Original)",
      slug: "mirror-people-come-over-original",
      image: "mirror-people-come-over-original.jpg",
    },
    {
      name: "Cool Kids",
      slug: "mirror-people-cool-kids",
      image: "mirror-people-cool-kids.jpg",
    },
    {
      name: "Crime Scene",
      slug: "mirror-people-crime-scene",
      image: "mirror-people-crime-scene.jpg",
    },
    {
      name: "Dance The Night Away",
      slug: "mirror-people-dance-the-night-away",
      image: "mirror-people-dance-the-night-away.jpg",
    },
    {
      name: "Drinks Promise Better (2 Jack 4U 2many 303 Remix)",
      slug: "mirror-people-drinks-promise-better-2-jack-4u-2many-303-remix",
      image:
        "mirror-people-drinks-promise-better-2-jack-4u-2many-303-remix.jpg",
    },
    {
      name: "Drinks Promise Better (Instrumental Mix)",
      slug: "mirror-people-drinks-promise-better-instrumental-mix",
      image: "mirror-people-drinks-promise-better-instrumental-mix.jpg",
    },
    {
      name: "Drinks Promise Better (Isac Ace Remix)",
      slug: "mirror-people-drinks-promise-better-isac-ace-remix",
      image: "mirror-people-drinks-promise-better-isac-ace-remix.jpg",
    },
    {
      name: "Drinks Promise Better (Miguel Torga's South Bronx Mix)",
      slug:
        "mirror-people-drinks-promise-better-miguel-torga-s-south-bronx-mix",
      image:
        "mirror-people-drinks-promise-better-miguel-torga-s-south-bronx-mix.jpg",
    },
    {
      name: "Drinks Promise Better (SaiR Remix)",
      slug: "mirror-people-drinks-promise-better-sair-remix",
      image: "mirror-people-drinks-promise-better-sair-remix.jpg",
    },
    {
      name: "Drinks Promise Better feat. Da Chick",
      slug: "mirror-people-drinks-promise-better-feat-da-chick",
      image: "mirror-people-drinks-promise-better-feat-da-chick.jpg",
    },
    {
      name: "Drinks Promise Better feat. Da Chick (Edit)",
      slug: "mirror-people-drinks-promise-better-feat-da-chick-edit",
      image: "mirror-people-drinks-promise-better-feat-da-chick-edit.jpg",
    },
    {
      name: "Feel The Need feat Rowetta ( Moullinex Remix)",
      slug: "mirror-people-feel-the-need-feat-rowetta-moullinex-remix",
      image: "mirror-people-feel-the-need-feat-rowetta-moullinex-remix.jpg",
    },
    {
      name: "Feel The Need feat Rowetta (Original)",
      slug: "mirror-people-feel-the-need-feat-rowetta-original",
      image: "mirror-people-feel-the-need-feat-rowetta-original.jpg",
    },
    {
      name: "Feel The Need feat Rowetta (Social Disco Club Dub Remix)",
      slug:
        "mirror-people-feel-the-need-feat-rowetta-social-disco-club-dub-remix",
      image:
        "mirror-people-feel-the-need-feat-rowetta-social-disco-club-dub-remix.jpg",
    },
    {
      name: "Foolish Man",
      slug: "mirror-people-foolish-man",
      image: "mirror-people-foolish-man.jpg",
    },
    {
      name: "Good Times",
      slug: "mirror-people-good-times",
      image: "mirror-people-good-times.jpg",
    },
    {
      name: "I Need Love",
      slug: "mirror-people-i-need-love",
      image: "mirror-people-i-need-love.jpg",
    },
    {
      name: "In Your Eyes",
      slug: "mirror-people-in-your-eyes",
      image: "mirror-people-in-your-eyes.jpg",
    },
    {
      name: "It's Not Over",
      slug: "mirror-people-it-s-not-over",
      image: "mirror-people-it-s-not-over.jpg",
    },
    {
      name: "Kaleidoscope",
      slug: "mirror-people-kaleidoscope",
      image: "mirror-people-kaleidoscope.jpg",
    },
    {
      name: "Kaleidoscope (Psychemagik Remix)",
      slug: "mirror-people-kaleidoscope-psychemagik-remix",
      image: "mirror-people-kaleidoscope-psychemagik-remix.jpg",
    },
    {
      name: "Kaleidoscope (Xinobi Remix)",
      slug: "mirror-people-kaleidoscope-xinobi-remix",
      image: "mirror-people-kaleidoscope-xinobi-remix.jpg",
    },
    {
      name: "Look Out",
      slug: "mirror-people-look-out",
      image: "mirror-people-look-out.jpg",
    },
    {
      name: "Look Out (Instrumental)",
      slug: "mirror-people-look-out-instrumental",
      image: "mirror-people-look-out-instrumental.jpg",
    },
    {
      name: "Machines",
      slug: "mirror-people-machines",
      image: "mirror-people-machines.jpg",
    },
    {
      name: "Moonflowers",
      slug: "mirror-people-moonflowers",
      image: "mirror-people-moonflowers.jpg",
    },
    {
      name: "Night Time",
      slug: "mirror-people-night-time",
      image: "mirror-people-night-time.jpg",
    },
    {
      name: "Open Hand",
      slug: "mirror-people-open-hand",
      image: "mirror-people-open-hand.jpg",
    },
    {
      name: "Ruby Went Out Dancing",
      slug: "mirror-people-ruby-went-out-dancing",
      image: "mirror-people-ruby-went-out-dancing.jpg",
    },
    {
      name: "So It Goes",
      slug: "mirror-people-so-it-goes",
      image: "mirror-people-so-it-goes.jpg",
    },
    {
      name: "Taste Of Murder",
      slug: "mirror-people-taste-of-murder",
      image: "mirror-people-taste-of-murder.jpg",
    },
    {
      name: "Telephone Call",
      slug: "mirror-people-telephone-call",
      image: "mirror-people-telephone-call.jpg",
    },
    {
      name: "Telephone Call (Cut Slack Remix)",
      slug: "mirror-people-telephone-call-cut-slack-remix",
      image: "mirror-people-telephone-call-cut-slack-remix.jpg",
    },
  ],
  Kingdom: [
    { name: "Boom", slug: "kingdom-boom", image: "kingdom-boom.jpg" },
    {
      name: "Diamante Salvaje",
      slug: "kingdom-diamante-salvaje",
      image: "kingdom-diamante-salvaje.jpg",
    },
    {
      name: "Leave It All",
      slug: "kingdom-leave-it-all",
      image: "kingdom-leave-it-all.jpg",
    },
    { name: "Marte", slug: "kingdom-marte", image: "kingdom-marte.jpg" },
    {
      name: "Superextraño",
      slug: "kingdom-superextrano",
      image: "kingdom-superextrano.jpg",
    },
    { name: "What If", slug: "kingdom-what-if", image: "kingdom-what-if.jpg" },
    {
      name: "What If (Instrumental Edit)",
      slug: "kingdom-what-if-instrumental-edit",
      image: "kingdom-what-if-instrumental-edit.jpg",
    },
    {
      name: "What If (Instrumental)",
      slug: "kingdom-what-if-instrumental",
      image: "kingdom-what-if-instrumental.jpg",
    },
  ],
  "X-Wife": [
    {
      name: "Boom Shaka Boom",
      slug: "x-wife-boom-shaka-boom",
      image: "x-wife-boom-shaka-boom.jpg",
    },
  ],
  STA: [
    { name: "Boqueig", slug: "sta-boqueig", image: "sta-boqueig.jpg" },
    { name: "Burdd", slug: "sta-burdd", image: "sta-burdd.jpg" },
    { name: "CIT", slug: "sta-cit", image: "sta-cit.jpg" },
    { name: "Dorham", slug: "sta-dorham", image: "sta-dorham.jpg" },
    {
      name: "Jean Phocas",
      slug: "sta-jean-phocas",
      image: "sta-jean-phocas.jpg",
    },
    {
      name: "King Hobby Meet Pope At Tundra Of Dub II",
      slug: "sta-king-hobby-meet-pope-at-tundra-of-dub-ii",
      image: "sta-king-hobby-meet-pope-at-tundra-of-dub-ii.jpg",
    },
    { name: "Mangel", slug: "sta-mangel", image: "sta-mangel.jpg" },
    { name: "Mobley", slug: "sta-mobley", image: "sta-mobley.jpg" },
    { name: "Pesado", slug: "sta-pesado", image: "sta-pesado.jpg" },
    { name: "Raa", slug: "sta-raa", image: "sta-raa.jpg" },
    { name: "Rhythm Pad", slug: "sta-rhythm-pad", image: "sta-rhythm-pad.jpg" },
    { name: "STA vs SSS", slug: "sta-sta-vs-sss", image: "sta-sta-vs-sss.jpg" },
    {
      name: "Sistema Nervioso",
      slug: "sta-sistema-nervioso",
      image: "sta-sistema-nervioso.jpg",
    },
    { name: "Sub", slug: "sta-sub", image: "sta-sub.jpg" },
    { name: "Succa", slug: "sta-succa", image: "sta-succa.jpg" },
    {
      name: "The Seaweed Collector",
      slug: "sta-the-seaweed-collector",
      image: "sta-the-seaweed-collector.jpg",
    },
    { name: "Total Dub", slug: "sta-total-dub", image: "sta-total-dub.jpg" },
    { name: "Tundra", slug: "sta-tundra", image: "sta-tundra.jpg" },
    { name: "Wann", slug: "sta-wann", image: "sta-wann.jpg" },
  ],
  Vantraxx: [
    {
      name: "Borealis Dreams (Radio Edit)",
      slug: "vantraxx-borealis-dreams-radio-edit",
      image: "vantraxx-borealis-dreams-radio-edit.jpg",
    },
  ],
  Kanot: [
    {
      name: "Bottenmannen",
      slug: "kanot-bottenmannen",
      image: "kanot-bottenmannen.jpg",
    },
    {
      name: "La Danse Des Corneilles",
      slug: "kanot-la-danse-des-corneilles",
      image: "kanot-la-danse-des-corneilles.jpg",
    },
  ],
  "K!MŦU & R-ASH": [
    {
      name: "Boukak",
      slug: "k-m-u-and-r-ash-boukak",
      image: "k-m-u-and-r-ash-boukak.jpg",
    },
  ],
  "Bonheur Permanent": [
    {
      name: "Bowling",
      slug: "bonheur-permanent-bowling",
      image: "bonheur-permanent-bowling.jpg",
    },
  ],
  "FM Laeti": [
    { name: "Boy", slug: "fm-laeti-boy", image: "fm-laeti-boy.jpg" },
    { name: "Coco", slug: "fm-laeti-coco", image: "fm-laeti-coco.jpg" },
    {
      name: "Doesn't Have to Be That Way",
      slug: "fm-laeti-doesn-t-have-to-be-that-way",
      image: "fm-laeti-doesn-t-have-to-be-that-way.jpg",
    },
    {
      name: "Doesn't Have to Be That Way (Instrumental)",
      slug: "fm-laeti-doesn-t-have-to-be-that-way-instrumental",
      image: "fm-laeti-doesn-t-have-to-be-that-way-instrumental.jpg",
    },
    {
      name: "For the Music",
      slug: "fm-laeti-for-the-music",
      image: "fm-laeti-for-the-music.jpg",
    },
    {
      name: "For the Music (Instrumental)",
      slug: "fm-laeti-for-the-music-instrumental",
      image: "fm-laeti-for-the-music-instrumental.jpg",
    },
    {
      name: "Gimme Love And Truth",
      slug: "fm-laeti-gimme-love-and-truth",
      image: "fm-laeti-gimme-love-and-truth.jpg",
    },
    {
      name: "I Got the Boogie",
      slug: "fm-laeti-i-got-the-boogie",
      image: "fm-laeti-i-got-the-boogie.jpg",
    },
    {
      name: "I Got the Boogie (Instrumental)",
      slug: "fm-laeti-i-got-the-boogie-instrumental",
      image: "fm-laeti-i-got-the-boogie-instrumental.jpg",
    },
    {
      name: "I Will All Come Around (Instrumental)",
      slug: "fm-laeti-i-will-all-come-around-instrumental",
      image: "fm-laeti-i-will-all-come-around-instrumental.jpg",
    },
    {
      name: "Is It Something",
      slug: "fm-laeti-is-it-something",
      image: "fm-laeti-is-it-something.jpg",
    },
    {
      name: "Is It Something (Instrumental)",
      slug: "fm-laeti-is-it-something-instrumental",
      image: "fm-laeti-is-it-something-instrumental.jpg",
    },
    {
      name: "It Will All Come Around",
      slug: "fm-laeti-it-will-all-come-around",
      image: "fm-laeti-it-will-all-come-around.jpg",
    },
    {
      name: "Iwaca (instrumental)",
      slug: "fm-laeti-iwaca-instrumental",
      image: "fm-laeti-iwaca-instrumental.jpg",
    },
    {
      name: "Out Of My Hands",
      slug: "fm-laeti-out-of-my-hands",
      image: "fm-laeti-out-of-my-hands.jpg",
    },
    {
      name: "Out Of My Hands (Instrumental)",
      slug: "fm-laeti-out-of-my-hands-instrumental",
      image: "fm-laeti-out-of-my-hands-instrumental.jpg",
    },
    {
      name: "Ping Pong",
      slug: "fm-laeti-ping-pong",
      image: "fm-laeti-ping-pong.jpg",
    },
    {
      name: "Ping Pong (Instrumental)",
      slug: "fm-laeti-ping-pong-instrumental",
      image: "fm-laeti-ping-pong-instrumental.jpg",
    },
    {
      name: "Rise In The Sun",
      slug: "fm-laeti-rise-in-the-sun",
      image: "fm-laeti-rise-in-the-sun.jpg",
    },
    {
      name: "Rise In The Sun (Instrumental)",
      slug: "fm-laeti-rise-in-the-sun-instrumental",
      image: "fm-laeti-rise-in-the-sun-instrumental.jpg",
    },
    {
      name: "Rock Matata",
      slug: "fm-laeti-rock-matata",
      image: "fm-laeti-rock-matata.jpg",
    },
    {
      name: "Rock Matata (Instrumental)",
      slug: "fm-laeti-rock-matata-instrumental",
      image: "fm-laeti-rock-matata-instrumental.jpg",
    },
    {
      name: "Sanctuary",
      slug: "fm-laeti-sanctuary",
      image: "fm-laeti-sanctuary.jpg",
    },
    {
      name: "Sanctuary (Instrumental)",
      slug: "fm-laeti-sanctuary-instrumental",
      image: "fm-laeti-sanctuary-instrumental.jpg",
    },
    {
      name: "Show Me The Way",
      slug: "fm-laeti-show-me-the-way",
      image: "fm-laeti-show-me-the-way.jpg",
    },
    {
      name: "Show Me The Way (Instrumental)",
      slug: "fm-laeti-show-me-the-way-instrumental",
      image: "fm-laeti-show-me-the-way-instrumental.jpg",
    },
    {
      name: "Sunken Dream",
      slug: "fm-laeti-sunken-dream",
      image: "fm-laeti-sunken-dream.jpg",
    },
    {
      name: "Sunken Dream (Instrumental)",
      slug: "fm-laeti-sunken-dream-instrumental",
      image: "fm-laeti-sunken-dream-instrumental.jpg",
    },
    {
      name: "Sunshine On My Face",
      slug: "fm-laeti-sunshine-on-my-face",
      image: "fm-laeti-sunshine-on-my-face.jpg",
    },
    {
      name: "Sunshine On My Face (Instrumental)",
      slug: "fm-laeti-sunshine-on-my-face-instrumental",
      image: "fm-laeti-sunshine-on-my-face-instrumental.jpg",
    },
    {
      name: "Tell Me A Story",
      slug: "fm-laeti-tell-me-a-story",
      image: "fm-laeti-tell-me-a-story.jpg",
    },
    {
      name: "Tell Me A Story (Instrumental)",
      slug: "fm-laeti-tell-me-a-story-instrumental",
      image: "fm-laeti-tell-me-a-story-instrumental.jpg",
    },
    {
      name: "The Cove",
      slug: "fm-laeti-the-cove",
      image: "fm-laeti-the-cove.jpg",
    },
    {
      name: "The Cove (Instrumental)",
      slug: "fm-laeti-the-cove-instrumental",
      image: "fm-laeti-the-cove-instrumental.jpg",
    },
    {
      name: "The Night Has Begun To Call",
      slug: "fm-laeti-the-night-has-begun-to-call",
      image: "fm-laeti-the-night-has-begun-to-call.jpg",
    },
    {
      name: "The Night Has Begun to Call (Instrumental)",
      slug: "fm-laeti-the-night-has-begun-to-call-instrumental",
      image: "fm-laeti-the-night-has-begun-to-call-instrumental.jpg",
    },
    {
      name: "Wanna Dance",
      slug: "fm-laeti-wanna-dance",
      image: "fm-laeti-wanna-dance.jpg",
    },
    {
      name: "Wanna Dance (Instrumental)",
      slug: "fm-laeti-wanna-dance-instrumental",
      image: "fm-laeti-wanna-dance-instrumental.jpg",
    },
    {
      name: "We Go Slow",
      slug: "fm-laeti-we-go-slow",
      image: "fm-laeti-we-go-slow.jpg",
    },
    {
      name: "We Go Slow (Instrumental)",
      slug: "fm-laeti-we-go-slow-instrumental",
      image: "fm-laeti-we-go-slow-instrumental.jpg",
    },
    {
      name: "Where Would You Be Now",
      slug: "fm-laeti-where-would-you-be-now",
      image: "fm-laeti-where-would-you-be-now.jpg",
    },
    {
      name: "Where Would You Be Now (Instrumental)",
      slug: "fm-laeti-where-would-you-be-now-instrumental",
      image: "fm-laeti-where-would-you-be-now-instrumental.jpg",
    },
    {
      name: "Wonderful Life",
      slug: "fm-laeti-wonderful-life",
      image: "fm-laeti-wonderful-life.jpg",
    },
    {
      name: "Wonderful Life (Instrumental)",
      slug: "fm-laeti-wonderful-life-instrumental",
      image: "fm-laeti-wonderful-life-instrumental.jpg",
    },
    {
      name: "You Inspire Me",
      slug: "fm-laeti-you-inspire-me",
      image: "fm-laeti-you-inspire-me.jpg",
    },
    {
      name: "You Inspire Me (Instrumental)",
      slug: "fm-laeti-you-inspire-me-instrumental",
      image: "fm-laeti-you-inspire-me-instrumental.jpg",
    },
  ],
  "You Said Strange": [
    {
      name: "Brain",
      slug: "you-said-strange-brain",
      image: "you-said-strange-brain.jpg",
    },
    {
      name: "Cold Crusader",
      slug: "you-said-strange-cold-crusader",
      image: "you-said-strange-cold-crusader.jpg",
    },
    {
      name: "Extend",
      slug: "you-said-strange-extend",
      image: "you-said-strange-extend.jpg",
    },
    {
      name: "Get Out",
      slug: "you-said-strange-get-out",
      image: "you-said-strange-get-out.jpg",
    },
    {
      name: "Halo",
      slug: "you-said-strange-halo",
      image: "you-said-strange-halo.jpg",
    },
    {
      name: "Just Wait",
      slug: "you-said-strange-just-wait",
      image: "you-said-strange-just-wait.jpg",
    },
    {
      name: "Leave the Lord",
      slug: "you-said-strange-leave-the-lord",
      image: "you-said-strange-leave-the-lord.jpg",
    },
    {
      name: "Power House",
      slug: "you-said-strange-power-house",
      image: "you-said-strange-power-house.jpg",
    },
    {
      name: "Salvation Rain",
      slug: "you-said-strange-salvation-rain",
      image: "you-said-strange-salvation-rain.jpg",
    },
    {
      name: "The Way to the Holy War",
      slug: "you-said-strange-the-way-to-the-holy-war",
      image: "you-said-strange-the-way-to-the-holy-war.jpg",
    },
  ],
  Cozmoe: [
    {
      name: "Brand New Day",
      slug: "cozmoe-brand-new-day",
      image: "cozmoe-brand-new-day.jpg",
    },
  ],
  "Lonely in the Rain": [
    {
      name: "Breathe",
      slug: "lonely-in-the-rain-breathe",
      image: "lonely-in-the-rain-breathe.jpg",
    },
    {
      name: "Can't Lose You",
      slug: "lonely-in-the-rain-can-t-lose-you",
      image: "lonely-in-the-rain-can-t-lose-you.jpg",
    },
    {
      name: "City Lights feat. Est",
      slug: "lonely-in-the-rain-city-lights-feat-est",
      image: "lonely-in-the-rain-city-lights-feat-est.jpg",
    },
    {
      name: "Cold Heart feat. Helsa",
      slug: "lonely-in-the-rain-cold-heart-feat-helsa",
      image: "lonely-in-the-rain-cold-heart-feat-helsa.jpg",
    },
    {
      name: "Collide feat. Ricky Kirby",
      slug: "lonely-in-the-rain-collide-feat-ricky-kirby",
      image: "lonely-in-the-rain-collide-feat-ricky-kirby.jpg",
    },
    {
      name: "Dive In",
      slug: "lonely-in-the-rain-dive-in",
      image: "lonely-in-the-rain-dive-in.jpg",
    },
    {
      name: "From The Moon feat. Est",
      slug: "lonely-in-the-rain-from-the-moon-feat-est",
      image: "lonely-in-the-rain-from-the-moon-feat-est.jpg",
    },
    {
      name: "Heaven",
      slug: "lonely-in-the-rain-heaven",
      image: "lonely-in-the-rain-heaven.jpg",
    },
    {
      name: "On On feat. Est",
      slug: "lonely-in-the-rain-on-on-feat-est",
      image: "lonely-in-the-rain-on-on-feat-est.jpg",
    },
    {
      name: "Shine feat. Nicolas Rostren and Est",
      slug: "lonely-in-the-rain-shine-feat-nicolas-rostren-and-est",
      image: "lonely-in-the-rain-shine-feat-nicolas-rostren-and-est.jpg",
    },
    {
      name: "Sky On Fire feat. NVRT",
      slug: "lonely-in-the-rain-sky-on-fire-feat-nvrt",
      image: "lonely-in-the-rain-sky-on-fire-feat-nvrt.jpg",
    },
    {
      name: "Stay Up feat. Jænne",
      slug: "lonely-in-the-rain-stay-up-feat-jaenne",
      image: "lonely-in-the-rain-stay-up-feat-jaenne.jpg",
    },
    {
      name: "Stronger feat. Feather Feather",
      slug: "lonely-in-the-rain-stronger-feat-feather-feather",
      image: "lonely-in-the-rain-stronger-feat-feather-feather.jpg",
    },
    {
      name: "Traveling Alone feat. Sauvane",
      slug: "lonely-in-the-rain-traveling-alone-feat-sauvane",
      image: "lonely-in-the-rain-traveling-alone-feat-sauvane.jpg",
    },
  ],
  "Lisa Mélissa & The Mess": [
    {
      name: "Bride Of A Zombie",
      slug: "lisa-melissa-and-the-mess-bride-of-a-zombie",
      image: "lisa-melissa-and-the-mess-bride-of-a-zombie.jpg",
    },
    {
      name: "Supposed To Be",
      slug: "lisa-melissa-and-the-mess-supposed-to-be",
      image: "lisa-melissa-and-the-mess-supposed-to-be.jpg",
    },
  ],
  "Purple Desert Rain God": [
    {
      name: "Bridge to Nowhere",
      slug: "purple-desert-rain-god-bridge-to-nowhere",
      image: "purple-desert-rain-god-bridge-to-nowhere.jpg",
    },
    {
      name: "Invisible Matter",
      slug: "purple-desert-rain-god-invisible-matter",
      image: "purple-desert-rain-god-invisible-matter.jpg",
    },
  ],
  "Yvonne La Nuit": [
    {
      name: "Bright Stars",
      slug: "yvonne-la-nuit-bright-stars",
      image: "yvonne-la-nuit-bright-stars.jpg",
    },
    {
      name: "Fool",
      slug: "yvonne-la-nuit-fool",
      image: "yvonne-la-nuit-fool.jpg",
    },
    {
      name: "Gage En Or",
      slug: "yvonne-la-nuit-gage-en-or",
      image: "yvonne-la-nuit-gage-en-or.jpg",
    },
    {
      name: "Les On Dit",
      slug: "yvonne-la-nuit-les-on-dit",
      image: "yvonne-la-nuit-les-on-dit.jpg",
    },
    {
      name: "Nos Silences",
      slug: "yvonne-la-nuit-nos-silences",
      image: "yvonne-la-nuit-nos-silences.jpg",
    },
  ],
  "Da Break": [
    {
      name: "Bring It Back",
      slug: "da-break-bring-it-back",
      image: "da-break-bring-it-back.jpg",
    },
    {
      name: "Burning",
      slug: "da-break-burning",
      image: "da-break-burning.jpg",
    },
    {
      name: "Don't Think So",
      slug: "da-break-don-t-think-so",
      image: "da-break-don-t-think-so.jpg",
    },
    {
      name: "Everytime We Say Goodbye",
      slug: "da-break-everytime-we-say-goodbye",
      image: "da-break-everytime-we-say-goodbye.jpg",
    },
    {
      name: "Gotta Break It Up",
      slug: "da-break-gotta-break-it-up",
      image: "da-break-gotta-break-it-up.jpg",
    },
    {
      name: "Miss Rosa",
      slug: "da-break-miss-rosa",
      image: "da-break-miss-rosa.jpg",
    },
    {
      name: "Mr Nightingale",
      slug: "da-break-mr-nightingale",
      image: "da-break-mr-nightingale.jpg",
    },
    {
      name: "Pig Daddy",
      slug: "da-break-pig-daddy",
      image: "da-break-pig-daddy.jpg",
    },
    { name: "Shine", slug: "da-break-shine", image: "da-break-shine.jpg" },
    {
      name: "Show Me The Steps",
      slug: "da-break-show-me-the-steps",
      image: "da-break-show-me-the-steps.jpg",
    },
  ],
  "Franck Larose": [
    {
      name: "Bring You Booty (Radio Edit)",
      slug: "franck-larose-bring-you-booty-radio-edit",
      image: "franck-larose-bring-you-booty-radio-edit.jpg",
    },
    {
      name: "Dança",
      slug: "franck-larose-danca",
      image: "franck-larose-danca.jpg",
    },
    {
      name: "Dança (Instrumental)",
      slug: "franck-larose-danca-instrumental",
      image: "franck-larose-danca-instrumental.jpg",
    },
    {
      name: "Drop The Bass (Radio Edit)",
      slug: "franck-larose-drop-the-bass-radio-edit",
      image: "franck-larose-drop-the-bass-radio-edit.jpg",
    },
    {
      name: "Fly (Radio Edit)",
      slug: "franck-larose-fly-radio-edit",
      image: "franck-larose-fly-radio-edit.jpg",
    },
    {
      name: "Move It Up Baby (Radio Edit)",
      slug: "franck-larose-move-it-up-baby-radio-edit",
      image: "franck-larose-move-it-up-baby-radio-edit.jpg",
    },
    {
      name: "Nasdrovia (Radio Edit)",
      slug: "franck-larose-nasdrovia-radio-edit",
      image: "franck-larose-nasdrovia-radio-edit.jpg",
    },
    {
      name: "Pump It Up (Extended Mix)",
      slug: "franck-larose-pump-it-up-extended-mix",
      image: "franck-larose-pump-it-up-extended-mix.jpg",
    },
    {
      name: "Yeah (Radio Edit)",
      slug: "franck-larose-yeah-radio-edit",
      image: "franck-larose-yeah-radio-edit.jpg",
    },
  ],
  Turnsteak: [
    {
      name: "Broken Control",
      slug: "turnsteak-broken-control",
      image: "turnsteak-broken-control.jpg",
    },
    {
      name: "Erotica",
      slug: "turnsteak-erotica",
      image: "turnsteak-erotica.jpg",
    },
    {
      name: "High Line",
      slug: "turnsteak-high-line",
      image: "turnsteak-high-line.jpg",
    },
    {
      name: "Purpurea",
      slug: "turnsteak-purpurea",
      image: "turnsteak-purpurea.jpg",
    },
    {
      name: "Réalité Augmentée",
      slug: "turnsteak-realite-augmentee",
      image: "turnsteak-realite-augmentee.jpg",
    },
    {
      name: "So Good For Me",
      slug: "turnsteak-so-good-for-me",
      image: "turnsteak-so-good-for-me.jpg",
    },
    {
      name: "The New Walk",
      slug: "turnsteak-the-new-walk",
      image: "turnsteak-the-new-walk.jpg",
    },
    {
      name: "Woody Wood",
      slug: "turnsteak-woody-wood",
      image: "turnsteak-woody-wood.jpg",
    },
  ],
  Greus: [
    {
      name: "Brou De Cultiu",
      slug: "greus-brou-de-cultiu",
      image: "greus-brou-de-cultiu.jpg",
    },
    { name: "Cervical", slug: "greus-cervical", image: "greus-cervical.jpg" },
    { name: "El No Yo", slug: "greus-el-no-yo", image: "greus-el-no-yo.jpg" },
    { name: "Engrudo", slug: "greus-engrudo", image: "greus-engrudo.jpg" },
    {
      name: "Mitocrondia",
      slug: "greus-mitocrondia",
      image: "greus-mitocrondia.jpg",
    },
  ],
  Bufi: [
    { name: "Brujerías", slug: "bufi-brujerias", image: "bufi-brujerias.jpg" },
    {
      name: "Cosmoattack",
      slug: "bufi-cosmoattack",
      image: "bufi-cosmoattack.jpg",
    },
    {
      name: "Cosmoattack (Mijo Remix)",
      slug: "bufi-cosmoattack-mijo-remix",
      image: "bufi-cosmoattack-mijo-remix.jpg",
    },
    {
      name: "Hillalum (Amazónica)",
      slug: "bufi-hillalum-amazonica",
      image: "bufi-hillalum-amazonica.jpg",
    },
    {
      name: "Horsepower",
      slug: "bufi-horsepower",
      image: "bufi-horsepower.jpg",
    },
    {
      name: "I Call You",
      slug: "bufi-i-call-you",
      image: "bufi-i-call-you.jpg",
    },
    {
      name: "Impresionistas",
      slug: "bufi-impresionistas",
      image: "bufi-impresionistas.jpg",
    },
    { name: "Intro", slug: "bufi-intro", image: "bufi-intro.jpg" },
    {
      name: "La Cumbia De Las Frecuencias",
      slug: "bufi-la-cumbia-de-las-frecuencias",
      image: "bufi-la-cumbia-de-las-frecuencias.jpg",
    },
    { name: "La Fuerza", slug: "bufi-la-fuerza", image: "bufi-la-fuerza.jpg" },
    {
      name: "Maquina del Ritmo (Dub Mix)",
      slug: "bufi-maquina-del-ritmo-dub-mix",
      image: "bufi-maquina-del-ritmo-dub-mix.jpg",
    },
    { name: "Mexico 70", slug: "bufi-mexico-70", image: "bufi-mexico-70.jpg" },
    {
      name: "Máquina Del Ritmo",
      slug: "bufi-maquina-del-ritmo",
      image: "bufi-maquina-del-ritmo.jpg",
    },
    {
      name: "Panamerica",
      slug: "bufi-panamerica",
      image: "bufi-panamerica.jpg",
    },
    { name: "Papers", slug: "bufi-papers", image: "bufi-papers.jpg" },
    { name: "Pixels", slug: "bufi-pixels", image: "bufi-pixels.jpg" },
    { name: "Salvaje", slug: "bufi-salvaje", image: "bufi-salvaje.jpg" },
    {
      name: "Semanauak Tsotsona",
      slug: "bufi-semanauak-tsotsona",
      image: "bufi-semanauak-tsotsona.jpg",
    },
    {
      name: "Sombrero Man",
      slug: "bufi-sombrero-man",
      image: "bufi-sombrero-man.jpg",
    },
    {
      name: "África Latina",
      slug: "bufi-africa-latina",
      image: "bufi-africa-latina.jpg",
    },
    {
      name: "África Latina (Maya Danon Mix)",
      slug: "bufi-africa-latina-maya-danon-mix",
      image: "bufi-africa-latina-maya-danon-mix.jpg",
    },
    {
      name: "África Latina (Richard Rossa Mix)",
      slug: "bufi-africa-latina-richard-rossa-mix",
      image: "bufi-africa-latina-richard-rossa-mix.jpg",
    },
  ],
  Ari: [
    { name: "Bug", slug: "ari-bug", image: "ari-bug.jpg" },
    { name: "Don't", slug: "ari-don-t", image: "ari-don-t.jpg" },
    {
      name: "Don't (Life Like Nervous Remix)",
      slug: "ari-don-t-life-like-nervous-remix",
      image: "ari-don-t-life-like-nervous-remix.jpg",
    },
    { name: "Supernova", slug: "ari-supernova", image: "ari-supernova.jpg" },
  ],
  Moullinex: [
    {
      name: "Build A Wall",
      slug: "moullinex-build-a-wall",
      image: "moullinex-build-a-wall.jpg",
    },
    {
      name: "Carnival feat. Shemar (Romance Orchestra Remix)",
      slug: "moullinex-carnival-feat-shemar-romance-orchestra-remix",
      image: "moullinex-carnival-feat-shemar-romance-orchestra-remix.jpg",
    },
    {
      name: "Carnival feat. Sherman",
      slug: "moullinex-carnival-feat-sherman",
      image: "moullinex-carnival-feat-sherman.jpg",
    },
    {
      name: "Club Cotton",
      slug: "moullinex-club-cotton",
      image: "moullinex-club-cotton.jpg",
    },
    {
      name: "Club Cotton (Instrumental)",
      slug: "moullinex-club-cotton-instrumental",
      image: "moullinex-club-cotton-instrumental.jpg",
    },
    {
      name: "Daydream (Yanagui Remix)",
      slug: "moullinex-daydream-yanagui-remix",
      image: "moullinex-daydream-yanagui-remix.jpg",
    },
    {
      name: "Daydream (Yuksek Remix)",
      slug: "moullinex-daydream-yuksek-remix",
      image: "moullinex-daydream-yuksek-remix.jpg",
    },
    {
      name: "Daydream feat. Da Chick",
      slug: "moullinex-daydream-feat-da-chick",
      image: "moullinex-daydream-feat-da-chick.jpg",
    },
    {
      name: "Dream On (Radio Edit)",
      slug: "moullinex-dream-on-radio-edit",
      image: "moullinex-dream-on-radio-edit.jpg",
    },
    {
      name: "Hidden Affection (Meera Remix)",
      slug: "moullinex-hidden-affection-meera-remix",
      image: "moullinex-hidden-affection-meera-remix.jpg",
    },
    {
      name: "Hidden Affection feat.Best Youth",
      slug: "moullinex-hidden-affection-feat-best-youth",
      image: "moullinex-hidden-affection-feat-best-youth.jpg",
    },
    {
      name: "Like A Man feat. Marta Ren",
      slug: "moullinex-like-a-man-feat-marta-ren",
      image: "moullinex-like-a-man-feat-marta-ren.jpg",
    },
    {
      name: "Love Love Love",
      slug: "moullinex-love-love-love",
      image: "moullinex-love-love-love.jpg",
    },
    {
      name: "Love Love Love (Larse Remix)",
      slug: "moullinex-love-love-love-larse-remix",
      image: "moullinex-love-love-love-larse-remix.jpg",
    },
    {
      name: "Love Love Love (Les Loups Remix)",
      slug: "moullinex-love-love-love-les-loups-remix",
      image: "moullinex-love-love-love-les-loups-remix.jpg",
    },
    {
      name: "Love Love Love (Mr Mitsuhirato Remix)",
      slug: "moullinex-love-love-love-mr-mitsuhirato-remix",
      image: "moullinex-love-love-love-mr-mitsuhirato-remix.jpg",
    },
    {
      name: "Love Love Love (Switchdance Remix)",
      slug: "moullinex-love-love-love-switchdance-remix",
      image: "moullinex-love-love-love-switchdance-remix.jpg",
    },
    { name: "Luz", slug: "moullinex-luz", image: "moullinex-luz.jpg" },
    {
      name: "Morse Code",
      slug: "moullinex-morse-code",
      image: "moullinex-morse-code.jpg",
    },
    {
      name: "My Ladybug",
      slug: "moullinex-my-ladybug",
      image: "moullinex-my-ladybug.jpg",
    },
    {
      name: "My Ladybug (Severino Remix)",
      slug: "moullinex-my-ladybug-severino-remix",
      image: "moullinex-my-ladybug-severino-remix.jpg",
    },
    {
      name: "Open House feat.Tee Flowers",
      slug: "moullinex-open-house-feat-tee-flowers",
      image: "moullinex-open-house-feat-tee-flowers.jpg",
    },
    {
      name: "Painting By Numbers feat.UhAhUh",
      slug: "moullinex-painting-by-numbers-feat-uhahuh",
      image: "moullinex-painting-by-numbers-feat-uhahuh.jpg",
    },
    {
      name: "Porcelain feat.Iwona Skwarek",
      slug: "moullinex-porcelain-feat-iwona-skwarek",
      image: "moullinex-porcelain-feat-iwona-skwarek.jpg",
    },
    {
      name: "Running In The Dark (Seb Wildblood Remix)",
      slug: "moullinex-running-in-the-dark-seb-wildblood-remix",
      image: "moullinex-running-in-the-dark-seb-wildblood-remix.jpg",
    },
    {
      name: "Running In The Dark feat. GPU Panic",
      slug: "moullinex-running-in-the-dark-feat-gpu-panic",
      image: "moullinex-running-in-the-dark-feat-gpu-panic.jpg",
    },
    {
      name: "Say It Slow (Wayward Remix)",
      slug: "moullinex-say-it-slow-wayward-remix",
      image: "moullinex-say-it-slow-wayward-remix.jpg",
    },
    {
      name: "Say It Slow (Wild and Free Remix)",
      slug: "moullinex-say-it-slow-wild-and-free-remix",
      image: "moullinex-say-it-slow-wild-and-free-remix.jpg",
    },
    {
      name: "Say It Slow feat. Georgia Anne Muldrow",
      slug: "moullinex-say-it-slow-feat-georgia-anne-muldrow",
      image: "moullinex-say-it-slow-feat-georgia-anne-muldrow.jpg",
    },
    {
      name: "Swim featuring GPU Panic",
      slug: "moullinex-swim-featuring-gpu-panic",
      image: "moullinex-swim-featuring-gpu-panic.jpg",
    },
    {
      name: "The Huggers",
      slug: "moullinex-the-huggers",
      image: "moullinex-the-huggers.jpg",
    },
    {
      name: "The Huggers (Club Edit)",
      slug: "moullinex-the-huggers-club-edit",
      image: "moullinex-the-huggers-club-edit.jpg",
    },
    {
      name: "To Be Clear (RAC Remix)",
      slug: "moullinex-to-be-clear-rac-remix",
      image: "moullinex-to-be-clear-rac-remix.jpg",
    },
    {
      name: "What To Do (Radio Edit)",
      slug: "moullinex-what-to-do-radio-edit",
      image: "moullinex-what-to-do-radio-edit.jpg",
    },
    {
      name: "Work It Out feat.Fritz Helder",
      slug: "moullinex-work-it-out-feat-fritz-helder",
      image: "moullinex-work-it-out-feat-fritz-helder.jpg",
    },
    {
      name: "Work It feat.Fritz Helder (Instrumental)",
      slug: "moullinex-work-it-feat-fritz-helder-instrumental",
      image: "moullinex-work-it-feat-fritz-helder-instrumental.jpg",
    },
    {
      name: "X Marks The Spot",
      slug: "moullinex-x-marks-the-spot",
      image: "moullinex-x-marks-the-spot.jpg",
    },
    {
      name: "X Marks The Spot (Drop Out Orchestra Remix)",
      slug: "moullinex-x-marks-the-spot-drop-out-orchestra-remix",
      image: "moullinex-x-marks-the-spot-drop-out-orchestra-remix.jpg",
    },
  ],
  Paredes: [
    {
      name: "Bulletproof",
      slug: "paredes-bulletproof",
      image: "paredes-bulletproof.jpg",
    },
    {
      name: "Gold Rush",
      slug: "paredes-gold-rush",
      image: "paredes-gold-rush.jpg",
    },
    {
      name: "Without Intermission",
      slug: "paredes-without-intermission",
      image: "paredes-without-intermission.jpg",
    },
  ],
  Sandré: [
    { name: "Bullying", slug: "sandre-bullying", image: "sandre-bullying.jpg" },
    {
      name: "Diòxid De Carboni",
      slug: "sandre-dioxid-de-carboni",
      image: "sandre-dioxid-de-carboni.jpg",
    },
    { name: "Fracaso", slug: "sandre-fracaso", image: "sandre-fracaso.jpg" },
    {
      name: "Gina Thorstensen",
      slug: "sandre-gina-thorstensen",
      image: "sandre-gina-thorstensen.jpg",
    },
    {
      name: "Més Ràpid Et Mors",
      slug: "sandre-mes-rapid-et-mors",
      image: "sandre-mes-rapid-et-mors.jpg",
    },
    { name: "No", slug: "sandre-no", image: "sandre-no.jpg" },
    { name: "Potu", slug: "sandre-potu", image: "sandre-potu.jpg" },
    { name: "Rància", slug: "sandre-rancia", image: "sandre-rancia.jpg" },
    {
      name: "Te Debo Pasta",
      slug: "sandre-te-debo-pasta",
      image: "sandre-te-debo-pasta.jpg",
    },
  ],
  "Howlin' Jaws": [
    {
      name: "Bumblebee Bop",
      slug: "howlin-jaws-bumblebee-bop",
      image: "howlin-jaws-bumblebee-bop.jpg",
    },
    {
      name: "Bye Bye Baby",
      slug: "howlin-jaws-bye-bye-baby",
      image: "howlin-jaws-bye-bye-baby.jpg",
    },
    {
      name: "Comin' Home",
      slug: "howlin-jaws-comin-home",
      image: "howlin-jaws-comin-home.jpg",
    },
    {
      name: "Howlin",
      slug: "howlin-jaws-howlin",
      image: "howlin-jaws-howlin.jpg",
    },
    {
      name: "Sleepwalkin'",
      slug: "howlin-jaws-sleepwalkin",
      image: "howlin-jaws-sleepwalkin.jpg",
    },
    {
      name: "Tough Love",
      slug: "howlin-jaws-tough-love",
      image: "howlin-jaws-tough-love.jpg",
    },
  ],
  Brioski: [
    { name: "Bump", slug: "brioski-bump", image: "brioski-bump.jpg" },
    {
      name: "Good Days",
      slug: "brioski-good-days",
      image: "brioski-good-days.jpg",
    },
  ],
  Holögrama: [
    {
      name: "Burgundy Coloured Mazes",
      slug: "holoegrama-burgundy-coloured-mazes",
      image: "holoegrama-burgundy-coloured-mazes.jpg",
    },
    {
      name: "Endless Circle",
      slug: "holoegrama-endless-circle",
      image: "holoegrama-endless-circle.jpg",
    },
    {
      name: "Interlude",
      slug: "holoegrama-interlude",
      image: "holoegrama-interlude.jpg",
    },
    {
      name: "Last Train",
      slug: "holoegrama-last-train",
      image: "holoegrama-last-train.jpg",
    },
    {
      name: "Teenagers",
      slug: "holoegrama-teenagers",
      image: "holoegrama-teenagers.jpg",
    },
  ],
  "Lena Deluxe": [
    {
      name: "Burning City",
      slug: "lena-deluxe-burning-city",
      image: "lena-deluxe-burning-city.jpg",
    },
    {
      name: "D-Day",
      slug: "lena-deluxe-d-day",
      image: "lena-deluxe-d-day.jpg",
    },
    { name: "Ink", slug: "lena-deluxe-ink", image: "lena-deluxe-ink.jpg" },
    {
      name: "Kill The King",
      slug: "lena-deluxe-kill-the-king",
      image: "lena-deluxe-kill-the-king.jpg",
    },
    {
      name: "Ladybird",
      slug: "lena-deluxe-ladybird",
      image: "lena-deluxe-ladybird.jpg",
    },
    {
      name: "Love Is All Around",
      slug: "lena-deluxe-love-is-all-around",
      image: "lena-deluxe-love-is-all-around.jpg",
    },
    {
      name: "Nowhere To Go",
      slug: "lena-deluxe-nowhere-to-go",
      image: "lena-deluxe-nowhere-to-go.jpg",
    },
    {
      name: "Rainbow",
      slug: "lena-deluxe-rainbow",
      image: "lena-deluxe-rainbow.jpg",
    },
    {
      name: "Reeperbahn",
      slug: "lena-deluxe-reeperbahn",
      image: "lena-deluxe-reeperbahn.jpg",
    },
    {
      name: "Tears Of Rain",
      slug: "lena-deluxe-tears-of-rain",
      image: "lena-deluxe-tears-of-rain.jpg",
    },
  ],
  "Penny Cocks": [
    {
      name: "Burning Down My Youth",
      slug: "penny-cocks-burning-down-my-youth",
      image: "penny-cocks-burning-down-my-youth.jpg",
    },
    {
      name: "Down The Underground",
      slug: "penny-cocks-down-the-underground",
      image: "penny-cocks-down-the-underground.jpg",
    },
    {
      name: "Louise",
      slug: "penny-cocks-louise",
      image: "penny-cocks-louise.jpg",
    },
    {
      name: "Midnight Train",
      slug: "penny-cocks-midnight-train",
      image: "penny-cocks-midnight-train.jpg",
    },
    {
      name: "Obsession Girl",
      slug: "penny-cocks-obsession-girl",
      image: "penny-cocks-obsession-girl.jpg",
    },
  ],
  "2CV": [
    {
      name: "Burpee Nation",
      slug: "2cv-burpee-nation",
      image: "2cv-burpee-nation.jpg",
    },
    {
      name: "Filthy Fifty",
      slug: "2cv-filthy-fifty",
      image: "2cv-filthy-fifty.jpg",
    },
    {
      name: "Sally Up Sally Down",
      slug: "2cv-sally-up-sally-down",
      image: "2cv-sally-up-sally-down.jpg",
    },
    {
      name: "Sally Up Sally Down (Mugwump Remix)",
      slug: "2cv-sally-up-sally-down-mugwump-remix",
      image: "2cv-sally-up-sally-down-mugwump-remix.jpg",
    },
  ],
  "The Lions Constellation": [
    {
      name: "Butterflies And Flowers",
      slug: "the-lions-constellation-butterflies-and-flowers",
      image: "the-lions-constellation-butterflies-and-flowers.jpg",
    },
    {
      name: "It's You",
      slug: "the-lions-constellation-it-s-you",
      image: "the-lions-constellation-it-s-you.jpg",
    },
    {
      name: "Kiss Me",
      slug: "the-lions-constellation-kiss-me",
      image: "the-lions-constellation-kiss-me.jpg",
    },
    {
      name: "Lies About Love",
      slug: "the-lions-constellation-lies-about-love",
      image: "the-lions-constellation-lies-about-love.jpg",
    },
    {
      name: "My Girl",
      slug: "the-lions-constellation-my-girl",
      image: "the-lions-constellation-my-girl.jpg",
    },
    {
      name: "Nothing To Be Done",
      slug: "the-lions-constellation-nothing-to-be-done",
      image: "the-lions-constellation-nothing-to-be-done.jpg",
    },
    {
      name: "She's My Heroin",
      slug: "the-lions-constellation-she-s-my-heroin",
      image: "the-lions-constellation-she-s-my-heroin.jpg",
    },
    {
      name: "The End Of Our Days",
      slug: "the-lions-constellation-the-end-of-our-days",
      image: "the-lions-constellation-the-end-of-our-days.jpg",
    },
    {
      name: "Walking On The Sun",
      slug: "the-lions-constellation-walking-on-the-sun",
      image: "the-lions-constellation-walking-on-the-sun.jpg",
    },
    {
      name: "Where Did you Go",
      slug: "the-lions-constellation-where-did-you-go",
      image: "the-lions-constellation-where-did-you-go.jpg",
    },
    {
      name: "You're Everything",
      slug: "the-lions-constellation-you-re-everything",
      image: "the-lions-constellation-you-re-everything.jpg",
    },
  ],
  "Blood Queen": [
    {
      name: "Butterfly feat. Mélodieuse",
      slug: "blood-queen-butterfly-feat-melodieuse",
      image: "blood-queen-butterfly-feat-melodieuse.jpg",
    },
  ],
  "Sat L'Artificier": [
    {
      name: "C'est Chaud",
      slug: "sat-l-artificier-c-est-chaud",
      image: "sat-l-artificier-c-est-chaud.jpg",
    },
    {
      name: "Le Hood",
      slug: "sat-l-artificier-le-hood",
      image: "sat-l-artificier-le-hood.jpg",
    },
  ],
  Entschuldigung: [
    {
      name: "C.O.N",
      slug: "entschuldigung-c-o-n",
      image: "entschuldigung-c-o-n.jpg",
    },
    {
      name: "Gina Cecello",
      slug: "entschuldigung-gina-cecello",
      image: "entschuldigung-gina-cecello.jpg",
    },
    {
      name: "Killin' Off The Day",
      slug: "entschuldigung-killin-off-the-day",
      image: "entschuldigung-killin-off-the-day.jpg",
    },
    {
      name: "Mysterious Downtown",
      slug: "entschuldigung-mysterious-downtown",
      image: "entschuldigung-mysterious-downtown.jpg",
    },
    {
      name: "S.W.A.T",
      slug: "entschuldigung-s-w-a-t",
      image: "entschuldigung-s-w-a-t.jpg",
    },
    {
      name: "Say It Loud",
      slug: "entschuldigung-say-it-loud",
      image: "entschuldigung-say-it-loud.jpg",
    },
    {
      name: "Ting Ting",
      slug: "entschuldigung-ting-ting",
      image: "entschuldigung-ting-ting.jpg",
    },
  ],
  "Throes and The Shine": [
    {
      name: "Cabetula",
      slug: "throes-and-the-shine-cabetula",
      image: "throes-and-the-shine-cabetula.jpg",
    },
    {
      name: "Capuca (feat. Pierre Kwenders)",
      slug: "throes-and-the-shine-capuca-feat-pierre-kwenders",
      image: "throes-and-the-shine-capuca-feat-pierre-kwenders.jpg",
    },
    {
      name: "Coisa Louca",
      slug: "throes-and-the-shine-coisa-louca",
      image: "throes-and-the-shine-coisa-louca.jpg",
    },
    {
      name: "Guerreros (feat. La Yegros)",
      slug: "throes-and-the-shine-guerreros-feat-la-yegros",
      image: "throes-and-the-shine-guerreros-feat-la-yegros.jpg",
    },
    {
      name: "Keep It In (feat. Da Chick)",
      slug: "throes-and-the-shine-keep-it-in-feat-da-chick",
      image: "throes-and-the-shine-keep-it-in-feat-da-chick.jpg",
    },
    {
      name: "Ndele",
      slug: "throes-and-the-shine-ndele",
      image: "throes-and-the-shine-ndele.jpg",
    },
    {
      name: "Praca",
      slug: "throes-and-the-shine-praca",
      image: "throes-and-the-shine-praca.jpg",
    },
    {
      name: "Quentura (feat.Meridian Brothers)",
      slug: "throes-and-the-shine-quentura-feat-meridian-brothers",
      image: "throes-and-the-shine-quentura-feat-meridian-brothers.jpg",
    },
    {
      name: "Shake The Floor",
      slug: "throes-and-the-shine-shake-the-floor",
      image: "throes-and-the-shine-shake-the-floor.jpg",
    },
    {
      name: "Ta A Bater",
      slug: "throes-and-the-shine-ta-a-bater",
      image: "throes-and-the-shine-ta-a-bater.jpg",
    },
  ],
  "Chlöe's Clue": [
    {
      name: "Café Bar 2000",
      slug: "chloee-s-clue-cafe-bar-2000",
      image: "chloee-s-clue-cafe-bar-2000.jpg",
    },
    {
      name: "Decadence is Dead",
      slug: "chloee-s-clue-decadence-is-dead",
      image: "chloee-s-clue-decadence-is-dead.jpg",
    },
    {
      name: "Dibidaa",
      slug: "chloee-s-clue-dibidaa",
      image: "chloee-s-clue-dibidaa.jpg",
    },
    {
      name: "Lira Versilia",
      slug: "chloee-s-clue-lira-versilia",
      image: "chloee-s-clue-lira-versilia.jpg",
    },
    {
      name: "Pain Boutique",
      slug: "chloee-s-clue-pain-boutique",
      image: "chloee-s-clue-pain-boutique.jpg",
    },
    {
      name: "Panorama",
      slug: "chloee-s-clue-panorama",
      image: "chloee-s-clue-panorama.jpg",
    },
    {
      name: "Rumors From A Room",
      slug: "chloee-s-clue-rumors-from-a-room",
      image: "chloee-s-clue-rumors-from-a-room.jpg",
    },
    {
      name: "The Desk Of Despair",
      slug: "chloee-s-clue-the-desk-of-despair",
      image: "chloee-s-clue-the-desk-of-despair.jpg",
    },
    {
      name: "Velvet Sofa",
      slug: "chloee-s-clue-velvet-sofa",
      image: "chloee-s-clue-velvet-sofa.jpg",
    },
    {
      name: "Villa Rosita",
      slug: "chloee-s-clue-villa-rosita",
      image: "chloee-s-clue-villa-rosita.jpg",
    },
    {
      name: "Visions and Versions",
      slug: "chloee-s-clue-visions-and-versions",
      image: "chloee-s-clue-visions-and-versions.jpg",
    },
  ],
  Cuzo: [
    {
      name: "Caida y Auge Del Heavy Metal",
      slug: "cuzo-caida-y-auge-del-heavy-metal",
      image: "cuzo-caida-y-auge-del-heavy-metal.jpg",
    },
    {
      name: "Cosas Mavarillosas",
      slug: "cuzo-cosas-mavarillosas",
      image: "cuzo-cosas-mavarillosas.jpg",
    },
    {
      name: "El Exorcista Turco",
      slug: "cuzo-el-exorcista-turco",
      image: "cuzo-el-exorcista-turco.jpg",
    },
    {
      name: "La Mussara",
      slug: "cuzo-la-mussara",
      image: "cuzo-la-mussara.jpg",
    },
    { name: "Tunel", slug: "cuzo-tunel", image: "cuzo-tunel.jpg" },
  ],
  "Tokyo Sex Destruction": [
    {
      name: "Call The Doctor",
      slug: "tokyo-sex-destruction-call-the-doctor",
      image: "tokyo-sex-destruction-call-the-doctor.jpg",
    },
    {
      name: "Cold Sweat",
      slug: "tokyo-sex-destruction-cold-sweat",
      image: "tokyo-sex-destruction-cold-sweat.jpg",
    },
    {
      name: "Dead Cops",
      slug: "tokyo-sex-destruction-dead-cops",
      image: "tokyo-sex-destruction-dead-cops.jpg",
    },
    {
      name: "Don't Let My Hands Fall",
      slug: "tokyo-sex-destruction-don-t-let-my-hands-fall",
      image: "tokyo-sex-destruction-don-t-let-my-hands-fall.jpg",
    },
    {
      name: "Dope & Love",
      slug: "tokyo-sex-destruction-dope-and-love",
      image: "tokyo-sex-destruction-dope-and-love.jpg",
    },
    {
      name: "Every Litle Thing",
      slug: "tokyo-sex-destruction-every-litle-thing",
      image: "tokyo-sex-destruction-every-litle-thing.jpg",
    },
    {
      name: "Give Me Something To Believe In",
      slug: "tokyo-sex-destruction-give-me-something-to-believe-in",
      image: "tokyo-sex-destruction-give-me-something-to-believe-in.jpg",
    },
    {
      name: "I Think You Lie",
      slug: "tokyo-sex-destruction-i-think-you-lie",
      image: "tokyo-sex-destruction-i-think-you-lie.jpg",
    },
    {
      name: "In The Right Place",
      slug: "tokyo-sex-destruction-in-the-right-place",
      image: "tokyo-sex-destruction-in-the-right-place.jpg",
    },
    {
      name: "It's Gonna Be Alright",
      slug: "tokyo-sex-destruction-it-s-gonna-be-alright",
      image: "tokyo-sex-destruction-it-s-gonna-be-alright.jpg",
    },
    {
      name: "Move It",
      slug: "tokyo-sex-destruction-move-it",
      image: "tokyo-sex-destruction-move-it.jpg",
    },
    {
      name: "Put Your Hands Up!",
      slug: "tokyo-sex-destruction-put-your-hands-up",
      image: "tokyo-sex-destruction-put-your-hands-up.jpg",
    },
    {
      name: "Sagittarius",
      slug: "tokyo-sex-destruction-sagittarius",
      image: "tokyo-sex-destruction-sagittarius.jpg",
    },
    {
      name: "Seven Sisters",
      slug: "tokyo-sex-destruction-seven-sisters",
      image: "tokyo-sex-destruction-seven-sisters.jpg",
    },
    {
      name: "Stories From The Neighbourhood",
      slug: "tokyo-sex-destruction-stories-from-the-neighbourhood",
      image: "tokyo-sex-destruction-stories-from-the-neighbourhood.jpg",
    },
    {
      name: "Sweet Riot",
      slug: "tokyo-sex-destruction-sweet-riot",
      image: "tokyo-sex-destruction-sweet-riot.jpg",
    },
    {
      name: "The Sounds Of Your Soul",
      slug: "tokyo-sex-destruction-the-sounds-of-your-soul",
      image: "tokyo-sex-destruction-the-sounds-of-your-soul.jpg",
    },
    {
      name: "They've Lost Control",
      slug: "tokyo-sex-destruction-they-ve-lost-control",
      image: "tokyo-sex-destruction-they-ve-lost-control.jpg",
    },
    {
      name: "When Those Times Are Coming Back",
      slug: "tokyo-sex-destruction-when-those-times-are-coming-back",
      image: "tokyo-sex-destruction-when-those-times-are-coming-back.jpg",
    },
  ],
  Betunizer: [
    {
      name: "Camilo José Shellac",
      slug: "betunizer-camilo-jose-shellac",
      image: "betunizer-camilo-jose-shellac.jpg",
    },
    {
      name: "Con La Pajara en los Talones",
      slug: "betunizer-con-la-pajara-en-los-talones",
      image: "betunizer-con-la-pajara-en-los-talones.jpg",
    },
    {
      name: "Di No y Todo Sera Tuyo",
      slug: "betunizer-di-no-y-todo-sera-tuyo",
      image: "betunizer-di-no-y-todo-sera-tuyo.jpg",
    },
    {
      name: "Disfrutar Es Ir Con Todo",
      slug: "betunizer-disfrutar-es-ir-con-todo",
      image: "betunizer-disfrutar-es-ir-con-todo.jpg",
    },
    {
      name: "La Caza del Vacilante",
      slug: "betunizer-la-caza-del-vacilante",
      image: "betunizer-la-caza-del-vacilante.jpg",
    },
    {
      name: "La Mili del Placer",
      slug: "betunizer-la-mili-del-placer",
      image: "betunizer-la-mili-del-placer.jpg",
    },
    {
      name: "Nicho Vegas",
      slug: "betunizer-nicho-vegas",
      image: "betunizer-nicho-vegas.jpg",
    },
    { name: "Oleada", slug: "betunizer-oleada", image: "betunizer-oleada.jpg" },
  ],
  "Salvaje Montoya": [
    {
      name: "Campesina de Mi Amor (Instrumental)",
      slug: "salvaje-montoya-campesina-de-mi-amor-instrumental",
      image: "salvaje-montoya-campesina-de-mi-amor-instrumental.jpg",
    },
    {
      name: "El Vuelo del Condor (Instrumental)",
      slug: "salvaje-montoya-el-vuelo-del-condor-instrumental",
      image: "salvaje-montoya-el-vuelo-del-condor-instrumental.jpg",
    },
    {
      name: "Hechizo (Instrumental)",
      slug: "salvaje-montoya-hechizo-instrumental",
      image: "salvaje-montoya-hechizo-instrumental.jpg",
    },
    {
      name: "Leyenda Local (Instrumental)",
      slug: "salvaje-montoya-leyenda-local-instrumental",
      image: "salvaje-montoya-leyenda-local-instrumental.jpg",
    },
    {
      name: "Mala Hierba (Instrumental)",
      slug: "salvaje-montoya-mala-hierba-instrumental",
      image: "salvaje-montoya-mala-hierba-instrumental.jpg",
    },
    {
      name: "Mujer Madura (Instrumental)",
      slug: "salvaje-montoya-mujer-madura-instrumental",
      image: "salvaje-montoya-mujer-madura-instrumental.jpg",
    },
    {
      name: "Prohibido Romper La Yuca (Instrumental)",
      slug: "salvaje-montoya-prohibido-romper-la-yuca-instrumental",
      image: "salvaje-montoya-prohibido-romper-la-yuca-instrumental.jpg",
    },
    {
      name: "Rituales de Cuchillas (Instrumental)",
      slug: "salvaje-montoya-rituales-de-cuchillas-instrumental",
      image: "salvaje-montoya-rituales-de-cuchillas-instrumental.jpg",
    },
    {
      name: "Santa Mamita del Raval (Instrumental)",
      slug: "salvaje-montoya-santa-mamita-del-raval-instrumental",
      image: "salvaje-montoya-santa-mamita-del-raval-instrumental.jpg",
    },
    {
      name: "Serpiente En Celo (Instrumental)",
      slug: "salvaje-montoya-serpiente-en-celo-instrumental",
      image: "salvaje-montoya-serpiente-en-celo-instrumental.jpg",
    },
  ],
  "De Pompidou": [
    {
      name: "Can't Be With You",
      slug: "de-pompidou-can-t-be-with-you",
      image: "de-pompidou-can-t-be-with-you.jpg",
    },
  ],
  "Angel Lamar": [
    {
      name: "Can't Follow Me (Radio Edit)",
      slug: "angel-lamar-can-t-follow-me-radio-edit",
      image: "angel-lamar-can-t-follow-me-radio-edit.jpg",
    },
    {
      name: "Check It Now (Radio Edit)",
      slug: "angel-lamar-check-it-now-radio-edit",
      image: "angel-lamar-check-it-now-radio-edit.jpg",
    },
    {
      name: "Cure Your Disease (Radio Edit)",
      slug: "angel-lamar-cure-your-disease-radio-edit",
      image: "angel-lamar-cure-your-disease-radio-edit.jpg",
    },
    {
      name: "Disco Rocker",
      slug: "angel-lamar-disco-rocker",
      image: "angel-lamar-disco-rocker.jpg",
    },
    {
      name: "Fiesta Fatale (Radio Edit)",
      slug: "angel-lamar-fiesta-fatale-radio-edit",
      image: "angel-lamar-fiesta-fatale-radio-edit.jpg",
    },
    {
      name: "Get Party (Radio Edit)",
      slug: "angel-lamar-get-party-radio-edit",
      image: "angel-lamar-get-party-radio-edit.jpg",
    },
    {
      name: "Non Stop The Beat",
      slug: "angel-lamar-non-stop-the-beat",
      image: "angel-lamar-non-stop-the-beat.jpg",
    },
    {
      name: "Non Stop The Beat (Stan Bawer Remix)",
      slug: "angel-lamar-non-stop-the-beat-stan-bawer-remix",
      image: "angel-lamar-non-stop-the-beat-stan-bawer-remix.jpg",
    },
  ],
  Magoo: [
    {
      name: "Can't Get Enough",
      slug: "magoo-can-t-get-enough",
      image: "magoo-can-t-get-enough.jpg",
    },
    {
      name: "Let's Have A Boogie",
      slug: "magoo-let-s-have-a-boogie",
      image: "magoo-let-s-have-a-boogie.jpg",
    },
    {
      name: "Party Down",
      slug: "magoo-party-down",
      image: "magoo-party-down.jpg",
    },
    {
      name: "Still Really Love",
      slug: "magoo-still-really-love",
      image: "magoo-still-really-love.jpg",
    },
    {
      name: "We Are One",
      slug: "magoo-we-are-one",
      image: "magoo-we-are-one.jpg",
    },
    {
      name: "We Can Make It Better",
      slug: "magoo-we-can-make-it-better",
      image: "magoo-we-can-make-it-better.jpg",
    },
  ],
  "Minami Deutsch": [
    {
      name: "Can't Get There",
      slug: "minami-deutsch-can-t-get-there",
      image: "minami-deutsch-can-t-get-there.jpg",
    },
    {
      name: "Can't Get There (Jamie Paton Remix)",
      slug: "minami-deutsch-can-t-get-there-jamie-paton-remix",
      image: "minami-deutsch-can-t-get-there-jamie-paton-remix.jpg",
    },
    {
      name: "Can't Get There (Mythologen Remix)",
      slug: "minami-deutsch-can-t-get-there-mythologen-remix",
      image: "minami-deutsch-can-t-get-there-mythologen-remix.jpg",
    },
    {
      name: "Israeli Blues",
      slug: "minami-deutsch-israeli-blues",
      image: "minami-deutsch-israeli-blues.jpg",
    },
    {
      name: "New Pastoral Life",
      slug: "minami-deutsch-new-pastoral-life",
      image: "minami-deutsch-new-pastoral-life.jpg",
    },
    {
      name: "Nishi No Jiku",
      slug: "minami-deutsch-nishi-no-jiku",
      image: "minami-deutsch-nishi-no-jiku.jpg",
    },
    {
      name: "Tunnel",
      slug: "minami-deutsch-tunnel",
      image: "minami-deutsch-tunnel.jpg",
    },
  ],
  "Them and Us": [
    {
      name: "Can't Keep Coming Around",
      slug: "them-and-us-can-t-keep-coming-around",
      image: "them-and-us-can-t-keep-coming-around.jpg",
    },
    {
      name: "Can't Keep Coming Around (Beatbox Version)",
      slug: "them-and-us-can-t-keep-coming-around-beatbox-version",
      image: "them-and-us-can-t-keep-coming-around-beatbox-version.jpg",
    },
    {
      name: "Can't Keep Coming Around (Instrumental)",
      slug: "them-and-us-can-t-keep-coming-around-instrumental",
      image: "them-and-us-can-t-keep-coming-around-instrumental.jpg",
    },
    {
      name: "Happy Never After (Instrumental)",
      slug: "them-and-us-happy-never-after-instrumental",
      image: "them-and-us-happy-never-after-instrumental.jpg",
    },
    {
      name: "Heart Attack (Instrumental)",
      slug: "them-and-us-heart-attack-instrumental",
      image: "them-and-us-heart-attack-instrumental.jpg",
    },
    {
      name: "Like Poison",
      slug: "them-and-us-like-poison",
      image: "them-and-us-like-poison.jpg",
    },
    {
      name: "Like Poison (Beatbox Version)",
      slug: "them-and-us-like-poison-beatbox-version",
      image: "them-and-us-like-poison-beatbox-version.jpg",
    },
    {
      name: "Like Poison (Instrumental Beatbox Version)",
      slug: "them-and-us-like-poison-instrumental-beatbox-version",
      image: "them-and-us-like-poison-instrumental-beatbox-version.jpg",
    },
    {
      name: "Oh My God",
      slug: "them-and-us-oh-my-god",
      image: "them-and-us-oh-my-god.jpg",
    },
    {
      name: "One Day (Beatbox Instrumental Version)",
      slug: "them-and-us-one-day-beatbox-instrumental-version",
      image: "them-and-us-one-day-beatbox-instrumental-version.jpg",
    },
    {
      name: "One Day (Beatbox Version)",
      slug: "them-and-us-one-day-beatbox-version",
      image: "them-and-us-one-day-beatbox-version.jpg",
    },
    {
      name: "Safe Place",
      slug: "them-and-us-safe-place",
      image: "them-and-us-safe-place.jpg",
    },
    {
      name: "Valentinian (Beatbox Version)",
      slug: "them-and-us-valentinian-beatbox-version",
      image: "them-and-us-valentinian-beatbox-version.jpg",
    },
  ],
  "Bogus & Paguro": [
    {
      name: "Canicola",
      slug: "bogus-and-paguro-canicola",
      image: "bogus-and-paguro-canicola.jpg",
    },
  ],
  "Grant Phabao": [
    {
      name: "Cannonbutt",
      slug: "grant-phabao-cannonbutt",
      image: "grant-phabao-cannonbutt.jpg",
    },
    { name: "Tub", slug: "grant-phabao-tub", image: "grant-phabao-tub.jpg" },
  ],
  "Limite 45": [
    {
      name: "Capitulo 1",
      slug: "limite-45-capitulo-1",
      image: "limite-45-capitulo-1.jpg",
    },
    {
      name: "Sacramento Av",
      slug: "limite-45-sacramento-av",
      image: "limite-45-sacramento-av.jpg",
    },
  ],
  "Filippo Diana": [
    {
      name: "Capofitto",
      slug: "filippo-diana-capofitto",
      image: "filippo-diana-capofitto.jpg",
    },
    {
      name: "Centro Sviluppo Spazio",
      slug: "filippo-diana-centro-sviluppo-spazio",
      image: "filippo-diana-centro-sviluppo-spazio.jpg",
    },
    {
      name: "Foresta",
      slug: "filippo-diana-foresta",
      image: "filippo-diana-foresta.jpg",
    },
    {
      name: "Forze Bilanciate",
      slug: "filippo-diana-forze-bilanciate",
      image: "filippo-diana-forze-bilanciate.jpg",
    },
    {
      name: "Ipnagogia",
      slug: "filippo-diana-ipnagogia",
      image: "filippo-diana-ipnagogia.jpg",
    },
    {
      name: "Macchine Molecolari",
      slug: "filippo-diana-macchine-molecolari",
      image: "filippo-diana-macchine-molecolari.jpg",
    },
    {
      name: "Masai",
      slug: "filippo-diana-masai",
      image: "filippo-diana-masai.jpg",
    },
    {
      name: "Notte Pagana",
      slug: "filippo-diana-notte-pagana",
      image: "filippo-diana-notte-pagana.jpg",
    },
  ],
  LOSSA: [
    { name: "Caprisun", slug: "lossa-caprisun", image: "lossa-caprisun.jpg" },
  ],
  "Sorry Kate": [
    {
      name: "Caramel's Fruit",
      slug: "sorry-kate-caramel-s-fruit",
      image: "sorry-kate-caramel-s-fruit.jpg",
    },
    {
      name: "Ceased Haze",
      slug: "sorry-kate-ceased-haze",
      image: "sorry-kate-ceased-haze.jpg",
    },
    {
      name: "Is It Ok For Me To Be Me?",
      slug: "sorry-kate-is-it-ok-for-me-to-be-me",
      image: "sorry-kate-is-it-ok-for-me-to-be-me.jpg",
    },
    {
      name: "Lo Bueno Se Termina",
      slug: "sorry-kate-lo-bueno-se-termina",
      image: "sorry-kate-lo-bueno-se-termina.jpg",
    },
    {
      name: "Lo Bueno Se Termina (Radio Edit)",
      slug: "sorry-kate-lo-bueno-se-termina-radio-edit",
      image: "sorry-kate-lo-bueno-se-termina-radio-edit.jpg",
    },
    {
      name: "Playground",
      slug: "sorry-kate-playground",
      image: "sorry-kate-playground.jpg",
    },
    {
      name: "Playing Dead VHS",
      slug: "sorry-kate-playing-dead-vhs",
      image: "sorry-kate-playing-dead-vhs.jpg",
    },
    { name: "Shin", slug: "sorry-kate-shin", image: "sorry-kate-shin.jpg" },
    {
      name: "Treehouse",
      slug: "sorry-kate-treehouse",
      image: "sorry-kate-treehouse.jpg",
    },
    {
      name: "Trust Visits",
      slug: "sorry-kate-trust-visits",
      image: "sorry-kate-trust-visits.jpg",
    },
    { name: "WeiB", slug: "sorry-kate-weib", image: "sorry-kate-weib.jpg" },
  ],
  "Giulia y Los Tellarini": [
    {
      name: "Caricias",
      slug: "giulia-y-los-tellarini-caricias",
      image: "giulia-y-los-tellarini-caricias.jpg",
    },
    {
      name: "El Gato De Me Vecina",
      slug: "giulia-y-los-tellarini-el-gato-de-me-vecina",
      image: "giulia-y-los-tellarini-el-gato-de-me-vecina.jpg",
    },
    {
      name: "Gabriella",
      slug: "giulia-y-los-tellarini-gabriella",
      image: "giulia-y-los-tellarini-gabriella.jpg",
    },
    {
      name: "Il Cuore",
      slug: "giulia-y-los-tellarini-il-cuore",
      image: "giulia-y-los-tellarini-il-cuore.jpg",
    },
    {
      name: "Il Ne M'Aime Pas",
      slug: "giulia-y-los-tellarini-il-ne-m-aime-pas",
      image: "giulia-y-los-tellarini-il-ne-m-aime-pas.jpg",
    },
    {
      name: "Jail",
      slug: "giulia-y-los-tellarini-jail",
      image: "giulia-y-los-tellarini-jail.jpg",
    },
    {
      name: "Le Dolce Parfum",
      slug: "giulia-y-los-tellarini-le-dolce-parfum",
      image: "giulia-y-los-tellarini-le-dolce-parfum.jpg",
    },
    {
      name: "Le Dolce Parfum (Instrumental)",
      slug: "giulia-y-los-tellarini-le-dolce-parfum-instrumental",
      image: "giulia-y-los-tellarini-le-dolce-parfum-instrumental.jpg",
    },
    {
      name: "Le Parfum",
      slug: "giulia-y-los-tellarini-le-parfum",
      image: "giulia-y-los-tellarini-le-parfum.jpg",
    },
    {
      name: "Loko Amor",
      slug: "giulia-y-los-tellarini-loko-amor",
      image: "giulia-y-los-tellarini-loko-amor.jpg",
    },
    {
      name: "Madita Fe",
      slug: "giulia-y-los-tellarini-madita-fe",
      image: "giulia-y-los-tellarini-madita-fe.jpg",
    },
    {
      name: "Turtle",
      slug: "giulia-y-los-tellarini-turtle",
      image: "giulia-y-los-tellarini-turtle.jpg",
    },
    {
      name: "Warszawa",
      slug: "giulia-y-los-tellarini-warszawa",
      image: "giulia-y-los-tellarini-warszawa.jpg",
    },
  ],
  "Edward Pli": [
    { name: "Carla", slug: "edward-pli-carla", image: null },
    { name: "Creep", slug: "edward-pli-creep", image: null },
    { name: "Elsa", slug: "edward-pli-elsa", image: null },
    { name: "I Will Fly", slug: "edward-pli-i-will-fly", image: null },
    {
      name: "La Ballade De L'Homme Préhistorique",
      slug: "edward-pli-la-ballade-de-l-homme-prehistorique",
      image: null,
    },
    {
      name: "Le Playboy De Paris",
      slug: "edward-pli-le-playboy-de-paris",
      image: null,
    },
    { name: "Ma Femme A Moi", slug: "edward-pli-ma-femme-a-moi", image: null },
    { name: "Mao", slug: "edward-pli-mao", image: null },
    { name: "Me & You", slug: "edward-pli-me-and-you", image: null },
    { name: "Mieux A Deux", slug: "edward-pli-mieux-a-deux", image: null },
    { name: "Psychopathe", slug: "edward-pli-psychopathe", image: null },
  ],
  "Half an Orange": [
    {
      name: "Catching Fireflies",
      slug: "half-an-orange-catching-fireflies",
      image: "half-an-orange-catching-fireflies.jpg",
    },
    {
      name: "Downtown",
      slug: "half-an-orange-downtown",
      image: "half-an-orange-downtown.jpg",
    },
    {
      name: "Downtown (Holmsey Remix)",
      slug: "half-an-orange-downtown-holmsey-remix",
      image: "half-an-orange-downtown-holmsey-remix.jpg",
    },
    {
      name: "Downtown (Instrumental)",
      slug: "half-an-orange-downtown-instrumental",
      image: "half-an-orange-downtown-instrumental.jpg",
    },
    {
      name: "Far From Young",
      slug: "half-an-orange-far-from-young",
      image: "half-an-orange-far-from-young.jpg",
    },
    {
      name: "Far From Young (Instrumental)",
      slug: "half-an-orange-far-from-young-instrumental",
      image: "half-an-orange-far-from-young-instrumental.jpg",
    },
    {
      name: "Given Up",
      slug: "half-an-orange-given-up",
      image: "half-an-orange-given-up.jpg",
    },
    {
      name: "I Need U To Stay",
      slug: "half-an-orange-i-need-u-to-stay",
      image: "half-an-orange-i-need-u-to-stay.jpg",
    },
    {
      name: "I Need U To Stay (Instrumental Version)",
      slug: "half-an-orange-i-need-u-to-stay-instrumental-version",
      image: "half-an-orange-i-need-u-to-stay-instrumental-version.jpg",
    },
    {
      name: "Stems",
      slug: "half-an-orange-stems",
      image: "half-an-orange-stems.jpg",
    },
    {
      name: "Stems (Acoustic Instrumental Version)",
      slug: "half-an-orange-stems-acoustic-instrumental-version",
      image: "half-an-orange-stems-acoustic-instrumental-version.jpg",
    },
    {
      name: "Stems (Acoustic Version)",
      slug: "half-an-orange-stems-acoustic-version",
      image: "half-an-orange-stems-acoustic-version.jpg",
    },
  ],
  "The Conqueror Project": [
    {
      name: "Caught My Eyes",
      slug: "the-conqueror-project-caught-my-eyes",
      image: "the-conqueror-project-caught-my-eyes.jpg",
    },
    {
      name: "Edge Of Present Day",
      slug: "the-conqueror-project-edge-of-present-day",
      image: "the-conqueror-project-edge-of-present-day.jpg",
    },
    {
      name: "Game Over",
      slug: "the-conqueror-project-game-over",
      image: "the-conqueror-project-game-over.jpg",
    },
    {
      name: "Greetings",
      slug: "the-conqueror-project-greetings",
      image: "the-conqueror-project-greetings.jpg",
    },
    {
      name: "Market Falling",
      slug: "the-conqueror-project-market-falling",
      image: "the-conqueror-project-market-falling.jpg",
    },
    {
      name: "Musical Frown",
      slug: "the-conqueror-project-musical-frown",
      image: "the-conqueror-project-musical-frown.jpg",
    },
    {
      name: "Prison Is So Safe",
      slug: "the-conqueror-project-prison-is-so-safe",
      image: "the-conqueror-project-prison-is-so-safe.jpg",
    },
    {
      name: "Saraswati Dub",
      slug: "the-conqueror-project-saraswati-dub",
      image: "the-conqueror-project-saraswati-dub.jpg",
    },
  ],
  Moksha: [
    {
      name: "Cavalgant La Corda Fluixa",
      slug: "moksha-cavalgant-la-corda-fluixa",
      image: "moksha-cavalgant-la-corda-fluixa.jpg",
    },
    {
      name: "Corre I Caure",
      slug: "moksha-corre-i-caure",
      image: "moksha-corre-i-caure.jpg",
    },
    {
      name: "Corrupcio I Mafia",
      slug: "moksha-corrupcio-i-mafia",
      image: "moksha-corrupcio-i-mafia.jpg",
    },
    { name: "El Basto", slug: "moksha-el-basto", image: "moksha-el-basto.jpg" },
    { name: "El Sot", slug: "moksha-el-sot", image: "moksha-el-sot.jpg" },
    {
      name: "Esgarriat",
      slug: "moksha-esgarriat",
      image: "moksha-esgarriat.jpg",
    },
    {
      name: "Humanitat Podrida",
      slug: "moksha-humanitat-podrida",
      image: "moksha-humanitat-podrida.jpg",
    },
    {
      name: "L'Antidot",
      slug: "moksha-l-antidot",
      image: "moksha-l-antidot.jpg",
    },
    {
      name: "La Puta Ruina",
      slug: "moksha-la-puta-ruina",
      image: "moksha-la-puta-ruina.jpg",
    },
    {
      name: "Sang De Roure",
      slug: "moksha-sang-de-roure",
      image: "moksha-sang-de-roure.jpg",
    },
  ],
  "El Gos Binari": [
    {
      name: "Celebro Que Chamuscado",
      slug: "el-gos-binari-celebro-que-chamuscado",
      image: "el-gos-binari-celebro-que-chamuscado.jpg",
    },
    {
      name: "Hoy Me Siento Jeff",
      slug: "el-gos-binari-hoy-me-siento-jeff",
      image: "el-gos-binari-hoy-me-siento-jeff.jpg",
    },
    {
      name: "Inverosimil",
      slug: "el-gos-binari-inverosimil",
      image: "el-gos-binari-inverosimil.jpg",
    },
    {
      name: "Me Pica",
      slug: "el-gos-binari-me-pica",
      image: "el-gos-binari-me-pica.jpg",
    },
    {
      name: "No Se Si Tu",
      slug: "el-gos-binari-no-se-si-tu",
      image: "el-gos-binari-no-se-si-tu.jpg",
    },
    {
      name: "Perro Ladrador",
      slug: "el-gos-binari-perro-ladrador",
      image: "el-gos-binari-perro-ladrador.jpg",
    },
  ],
  "Little Clara & Les Chacals": [
    {
      name: "Chacal Twist",
      slug: "little-clara-and-les-chacals-chacal-twist",
      image: "little-clara-and-les-chacals-chacal-twist.jpg",
    },
  ],
  "Alex Rossi": [
    {
      name: "Chair et Canon",
      slug: "alex-rossi-chair-et-canon",
      image: "alex-rossi-chair-et-canon.jpg",
    },
    {
      name: "Domani è un altra notte",
      slug: "alex-rossi-domani-e-un-altra-notte",
      image: "alex-rossi-domani-e-un-altra-notte.jpg",
    },
    {
      name: "Je Te Prends (Instrumental)",
      slug: "alex-rossi-je-te-prends-instrumental",
      image: "alex-rossi-je-te-prends-instrumental.jpg",
    },
    {
      name: "Je Te Prends feat. Inès Olympe Mercadal",
      slug: "alex-rossi-je-te-prends-feat-ines-olympe-mercadal",
      image: "alex-rossi-je-te-prends-feat-ines-olympe-mercadal.jpg",
    },
    {
      name: "L'Ultima Canzone",
      slug: "alex-rossi-l-ultima-canzone",
      image: "alex-rossi-l-ultima-canzone.jpg",
    },
  ],
  Gameboyz: [
    { name: "Chaman", slug: "gameboyz-chaman", image: "gameboyz-chaman.jpg" },
    {
      name: "Ellas Son Satan",
      slug: "gameboyz-ellas-son-satan",
      image: "gameboyz-ellas-son-satan.jpg",
    },
    {
      name: "Gipsy Drug",
      slug: "gameboyz-gipsy-drug",
      image: "gameboyz-gipsy-drug.jpg",
    },
    {
      name: "Interludio",
      slug: "gameboyz-interludio",
      image: "gameboyz-interludio.jpg",
    },
    { name: "Mason", slug: "gameboyz-mason", image: "gameboyz-mason.jpg" },
    {
      name: "Mucho Danger",
      slug: "gameboyz-mucho-danger",
      image: "gameboyz-mucho-danger.jpg",
    },
  ],
  "Rodion And La Royale": [
    {
      name: "Chamorro Tomorrow",
      slug: "rodion-and-la-royale-chamorro-tomorrow",
      image: "rodion-and-la-royale-chamorro-tomorrow.jpg",
    },
  ],
  "The Elriks": [
    {
      name: "Channel 1984",
      slug: "the-elriks-channel-1984",
      image: "the-elriks-channel-1984.jpg",
    },
    {
      name: "Frequency Modulation",
      slug: "the-elriks-frequency-modulation",
      image: "the-elriks-frequency-modulation.jpg",
    },
    {
      name: "I Am Who I Am",
      slug: "the-elriks-i-am-who-i-am",
      image: "the-elriks-i-am-who-i-am.jpg",
    },
    {
      name: "I Am Who I Am (Edit)",
      slug: "the-elriks-i-am-who-i-am-edit",
      image: "the-elriks-i-am-who-i-am-edit.jpg",
    },
    {
      name: "I Am Who I Am (Fabrizio Marmarella Remix)",
      slug: "the-elriks-i-am-who-i-am-fabrizio-marmarella-remix",
      image: "the-elriks-i-am-who-i-am-fabrizio-marmarella-remix.jpg",
    },
    {
      name: "Like A Robot",
      slug: "the-elriks-like-a-robot",
      image: "the-elriks-like-a-robot.jpg",
    },
  ],
  "K Conjog": [
    {
      name: "Chapter II",
      slug: "k-conjog-chapter-ii",
      image: "k-conjog-chapter-ii.jpg",
    },
    {
      name: "Enamanera",
      slug: "k-conjog-enamanera",
      image: "k-conjog-enamanera.jpg",
    },
    {
      name: "Good Intention",
      slug: "k-conjog-good-intention",
      image: "k-conjog-good-intention.jpg",
    },
    {
      name: "How to Cure Hangover in April (Herr Styler Remix)",
      slug: "k-conjog-how-to-cure-hangover-in-april-herr-styler-remix",
      image: "k-conjog-how-to-cure-hangover-in-april-herr-styler-remix.jpg",
    },
    {
      name: "I Come From Mentedey",
      slug: "k-conjog-i-come-from-mentedey",
      image: "k-conjog-i-come-from-mentedey.jpg",
    },
    {
      name: "I Only Dream To Run With You",
      slug: "k-conjog-i-only-dream-to-run-with-you",
      image: "k-conjog-i-only-dream-to-run-with-you.jpg",
    },
    {
      name: "It is Possible to Set Our Spirit Freak?",
      slug: "k-conjog-it-is-possible-to-set-our-spirit-freak",
      image: "k-conjog-it-is-possible-to-set-our-spirit-freak.jpg",
    },
    {
      name: "It's All Around Asia",
      slug: "k-conjog-it-s-all-around-asia",
      image: "k-conjog-it-s-all-around-asia.jpg",
    },
    {
      name: "It's Impossible For Me To Be Against You (Offthesky Remix)",
      slug: "k-conjog-it-s-impossible-for-me-to-be-against-you-offthesky-remix",
      image:
        "k-conjog-it-s-impossible-for-me-to-be-against-you-offthesky-remix.jpg",
    },
    {
      name: "Jabberwock",
      slug: "k-conjog-jabberwock",
      image: "k-conjog-jabberwock.jpg",
    },
    {
      name: "Lake Minor",
      slug: "k-conjog-lake-minor",
      image: "k-conjog-lake-minor.jpg",
    },
    {
      name: "Meanings",
      slug: "k-conjog-meanings",
      image: "k-conjog-meanings.jpg",
    },
    {
      name: "Mono No Aware",
      slug: "k-conjog-mono-no-aware",
      image: "k-conjog-mono-no-aware.jpg",
    },
    {
      name: "Polite Impolite",
      slug: "k-conjog-polite-impolite",
      image: "k-conjog-polite-impolite.jpg",
    },
    { name: "Qwerty", slug: "k-conjog-qwerty", image: "k-conjog-qwerty.jpg" },
    {
      name: "Re Thinking About Robin (Pawn Remix)",
      slug: "k-conjog-re-thinking-about-robin-pawn-remix",
      image: "k-conjog-re-thinking-about-robin-pawn-remix.jpg",
    },
    { name: "Sein", slug: "k-conjog-sein", image: "k-conjog-sein.jpg" },
    {
      name: "Thinking About Robin",
      slug: "k-conjog-thinking-about-robin",
      image: "k-conjog-thinking-about-robin.jpg",
    },
    {
      name: "Uno is Walking",
      slug: "k-conjog-uno-is-walking",
      image: "k-conjog-uno-is-walking.jpg",
    },
    {
      name: "Untitled 155",
      slug: "k-conjog-untitled-155",
      image: "k-conjog-untitled-155.jpg",
    },
  ],
  Seno: [
    {
      name: "Chargé feat. Testos",
      slug: "seno-charge-feat-testos",
      image: "seno-charge-feat-testos.jpg",
    },
    {
      name: "Dans Mes Mains",
      slug: "seno-dans-mes-mains",
      image: "seno-dans-mes-mains.jpg",
    },
    {
      name: "Kosher Nostra",
      slug: "seno-kosher-nostra",
      image: "seno-kosher-nostra.jpg",
    },
  ],
  "I Love My Neighbours": [
    {
      name: "Chasing Rainbows",
      slug: "i-love-my-neighbours-chasing-rainbows",
      image: "i-love-my-neighbours-chasing-rainbows.jpg",
    },
    {
      name: "Dahlia",
      slug: "i-love-my-neighbours-dahlia",
      image: "i-love-my-neighbours-dahlia.jpg",
    },
    {
      name: "Hello",
      slug: "i-love-my-neighbours-hello",
      image: "i-love-my-neighbours-hello.jpg",
    },
    {
      name: "Horizon",
      slug: "i-love-my-neighbours-horizon",
      image: "i-love-my-neighbours-horizon.jpg",
    },
    {
      name: "James",
      slug: "i-love-my-neighbours-james",
      image: "i-love-my-neighbours-james.jpg",
    },
    {
      name: "Love Is Coming Back",
      slug: "i-love-my-neighbours-love-is-coming-back",
      image: "i-love-my-neighbours-love-is-coming-back.jpg",
    },
    {
      name: "Now Sing",
      slug: "i-love-my-neighbours-now-sing",
      image: "i-love-my-neighbours-now-sing.jpg",
    },
    {
      name: "Tiaa",
      slug: "i-love-my-neighbours-tiaa",
      image: "i-love-my-neighbours-tiaa.jpg",
    },
    {
      name: "Uptight",
      slug: "i-love-my-neighbours-uptight",
      image: "i-love-my-neighbours-uptight.jpg",
    },
    {
      name: "Widows",
      slug: "i-love-my-neighbours-widows",
      image: "i-love-my-neighbours-widows.jpg",
    },
  ],
  Victorine: [
    {
      name: "Chausson Pop",
      slug: "victorine-chausson-pop",
      image: "victorine-chausson-pop.jpg",
    },
    { name: "Daddy", slug: "victorine-daddy", image: "victorine-daddy.jpg" },
    {
      name: "Desunis de L'Univers",
      slug: "victorine-desunis-de-l-univers",
      image: "victorine-desunis-de-l-univers.jpg",
    },
    {
      name: "Desunis de L'Univers (Plaisir de France Remix)",
      slug: "victorine-desunis-de-l-univers-plaisir-de-france-remix",
      image: "victorine-desunis-de-l-univers-plaisir-de-france-remix.jpg",
    },
    {
      name: "Escalier C",
      slug: "victorine-escalier-c",
      image: "victorine-escalier-c.jpg",
    },
    {
      name: "Fukushima",
      slug: "victorine-fukushima",
      image: "victorine-fukushima.jpg",
    },
    {
      name: "Fukushima Femme Fontaine",
      slug: "victorine-fukushima-femme-fontaine",
      image: "victorine-fukushima-femme-fontaine.jpg",
    },
    {
      name: "La Rentrée",
      slug: "victorine-la-rentree",
      image: "victorine-la-rentree.jpg",
    },
    {
      name: "La Rentrée (Arnaud Pilard Club Remix)",
      slug: "victorine-la-rentree-arnaud-pilard-club-remix",
      image: "victorine-la-rentree-arnaud-pilard-club-remix.jpg",
    },
    {
      name: "La Rentrée (Arnaud Pillard Pop Remix)",
      slug: "victorine-la-rentree-arnaud-pillard-pop-remix",
      image: "victorine-la-rentree-arnaud-pillard-pop-remix.jpg",
    },
    {
      name: "La Rentrée (Gael Etienne Funk Remix)",
      slug: "victorine-la-rentree-gael-etienne-funk-remix",
      image: "victorine-la-rentree-gael-etienne-funk-remix.jpg",
    },
    {
      name: "La Rentrée (Instrumental)",
      slug: "victorine-la-rentree-instrumental",
      image: "victorine-la-rentree-instrumental.jpg",
    },
    {
      name: "Potandre",
      slug: "victorine-potandre",
      image: "victorine-potandre.jpg",
    },
    {
      name: "Saint Mathieu",
      slug: "victorine-saint-mathieu",
      image: "victorine-saint-mathieu.jpg",
    },
    {
      name: "T'es Loin",
      slug: "victorine-t-es-loin",
      image: "victorine-t-es-loin.jpg",
    },
    {
      name: "T'es Loin (Instrumental)",
      slug: "victorine-t-es-loin-instrumental",
      image: "victorine-t-es-loin-instrumental.jpg",
    },
  ],
  Robotalco: [
    {
      name: "Cheers in Space",
      slug: "robotalco-cheers-in-space",
      image: "robotalco-cheers-in-space.jpg",
    },
  ],
  "Hot Spell": [
    {
      name: "Chocolat (Begun Remix)",
      slug: "hot-spell-chocolat-begun-remix",
      image: "hot-spell-chocolat-begun-remix.jpg",
    },
    {
      name: "Chocolat (Instrumental)",
      slug: "hot-spell-chocolat-instrumental",
      image: "hot-spell-chocolat-instrumental.jpg",
    },
    {
      name: "Chocolat feat. Gustaph",
      slug: "hot-spell-chocolat-feat-gustaph",
      image: "hot-spell-chocolat-feat-gustaph.jpg",
    },
    {
      name: "Cloaking",
      slug: "hot-spell-cloaking",
      image: "hot-spell-cloaking.jpg",
    },
    { name: "Sugar", slug: "hot-spell-sugar", image: "hot-spell-sugar.jpg" },
  ],
  "Da Octopusss": [
    {
      name: "Chrystal",
      slug: "da-octopusss-chrystal",
      image: "da-octopusss-chrystal.jpg",
    },
    {
      name: "Evilminded",
      slug: "da-octopusss-evilminded",
      image: "da-octopusss-evilminded.jpg",
    },
    {
      name: "Goats",
      slug: "da-octopusss-goats",
      image: "da-octopusss-goats.jpg",
    },
    { name: "Heat", slug: "da-octopusss-heat", image: "da-octopusss-heat.jpg" },
    {
      name: "Indians",
      slug: "da-octopusss-indians",
      image: "da-octopusss-indians.jpg",
    },
    {
      name: "King Of Sweden",
      slug: "da-octopusss-king-of-sweden",
      image: "da-octopusss-king-of-sweden.jpg",
    },
    {
      name: "Moon Drop",
      slug: "da-octopusss-moon-drop",
      image: "da-octopusss-moon-drop.jpg",
    },
    {
      name: "Rock The Hulk",
      slug: "da-octopusss-rock-the-hulk",
      image: "da-octopusss-rock-the-hulk.jpg",
    },
    {
      name: "The Hunt",
      slug: "da-octopusss-the-hunt",
      image: "da-octopusss-the-hunt.jpg",
    },
    {
      name: "Vapor",
      slug: "da-octopusss-vapor",
      image: "da-octopusss-vapor.jpg",
    },
  ],
  Lebollet: [
    {
      name: "Chukraut Western",
      slug: "lebollet-chukraut-western",
      image: "lebollet-chukraut-western.jpg",
    },
    {
      name: "Chukraut Western (Leonor Remix)",
      slug: "lebollet-chukraut-western-leonor-remix",
      image: "lebollet-chukraut-western-leonor-remix.jpg",
    },
    {
      name: "Ennio and Leone",
      slug: "lebollet-ennio-and-leone",
      image: "lebollet-ennio-and-leone.jpg",
    },
    {
      name: "Ennio and Leone (Azaria Remix)",
      slug: "lebollet-ennio-and-leone-azaria-remix",
      image: "lebollet-ennio-and-leone-azaria-remix.jpg",
    },
  ],
  Italoscillazioni: [
    {
      name: "Circo Muliebre",
      slug: "italoscillazioni-circo-muliebre",
      image: "italoscillazioni-circo-muliebre.jpg",
    },
  ],
  Filastine: [
    {
      name: "Circulate False Notes",
      slug: "filastine-circulate-false-notes",
      image: "filastine-circulate-false-notes.jpg",
    },
    {
      name: "Circulate False Notes (Nucleya Remix)",
      slug: "filastine-circulate-false-notes-nucleya-remix",
      image: "filastine-circulate-false-notes-nucleya-remix.jpg",
    },
    {
      name: "Circulate False Notes (Suckafish P Jones Remix)",
      slug: "filastine-circulate-false-notes-suckafish-p-jones-remix",
      image: "filastine-circulate-false-notes-suckafish-p-jones-remix.jpg",
    },
    {
      name: "Circulate False Notes (The Clerk Remix)",
      slug: "filastine-circulate-false-notes-the-clerk-remix",
      image: "filastine-circulate-false-notes-the-clerk-remix.jpg",
    },
    {
      name: "Colony Collapse (Aucan Remix)",
      slug: "filastine-colony-collapse-aucan-remix",
      image: "filastine-colony-collapse-aucan-remix.jpg",
    },
    {
      name: "Colony Collapse (Beat Antique Remix)",
      slug: "filastine-colony-collapse-beat-antique-remix",
      image: "filastine-colony-collapse-beat-antique-remix.jpg",
    },
    {
      name: "Colony Collapse (Fletcher In Dub Remix)",
      slug: "filastine-colony-collapse-fletcher-in-dub-remix",
      image: "filastine-colony-collapse-fletcher-in-dub-remix.jpg",
    },
    {
      name: "Colony Collapse (L'Oeuf Raide Remix)",
      slug: "filastine-colony-collapse-l-oeuf-raide-remix",
      image: "filastine-colony-collapse-l-oeuf-raide-remix.jpg",
    },
    {
      name: "Colony Collapse (Speaky Lobster Remix)",
      slug: "filastine-colony-collapse-speaky-lobster-remix",
      image: "filastine-colony-collapse-speaky-lobster-remix.jpg",
    },
    {
      name: "Colony Collapse feat. Nova",
      slug: "filastine-colony-collapse-feat-nova",
      image: "filastine-colony-collapse-feat-nova.jpg",
    },
    {
      name: "Gendjer2 (Copyflex Remix)",
      slug: "filastine-gendjer2-copyflex-remix",
      image: "filastine-gendjer2-copyflex-remix.jpg",
    },
    {
      name: "Gendjer2 (Dj Delay Remix)",
      slug: "filastine-gendjer2-dj-delay-remix",
      image: "filastine-gendjer2-dj-delay-remix.jpg",
    },
    {
      name: "Gendjer2 feat. Nova",
      slug: "filastine-gendjer2-feat-nova",
      image: "filastine-gendjer2-feat-nova.jpg",
    },
    {
      name: "Hypnotico",
      slug: "filastine-hypnotico",
      image: "filastine-hypnotico.jpg",
    },
    {
      name: "Informal Sector Parade",
      slug: "filastine-informal-sector-parade",
      image: "filastine-informal-sector-parade.jpg",
    },
    {
      name: "Informal Sector Parade (Thornato Remix)",
      slug: "filastine-informal-sector-parade-thornato-remix",
      image: "filastine-informal-sector-parade-thornato-remix.jpg",
    },
    {
      name: "Lost Records",
      slug: "filastine-lost-records",
      image: "filastine-lost-records.jpg",
    },
    {
      name: "No Step",
      slug: "filastine-no-step",
      image: "filastine-no-step.jpg",
    },
    {
      name: "Shanty Tones",
      slug: "filastine-shanty-tones",
      image: "filastine-shanty-tones.jpg",
    },
    {
      name: "Sidi Bouzid",
      slug: "filastine-sidi-bouzid",
      image: "filastine-sidi-bouzid.jpg",
    },
    {
      name: "Sidi Bouzid (Alter Echo & E3 Remix)",
      slug: "filastine-sidi-bouzid-alter-echo-and-e3-remix",
      image: "filastine-sidi-bouzid-alter-echo-and-e3-remix.jpg",
    },
    {
      name: "Skirmish",
      slug: "filastine-skirmish",
      image: "filastine-skirmish.jpg",
    },
    {
      name: "Skirmish (Niveau Zero Remix)",
      slug: "filastine-skirmish-niveau-zero-remix",
      image: "filastine-skirmish-niveau-zero-remix.jpg",
    },
    {
      name: "Spectralization",
      slug: "filastine-spectralization",
      image: "filastine-spectralization.jpg",
    },
  ],
  Fatma: [
    { name: "Cirklar", slug: "fatma-cirklar", image: "fatma-cirklar.jpg" },
    {
      name: "The Dirty Beat",
      slug: "fatma-the-dirty-beat",
      image: "fatma-the-dirty-beat.jpg",
    },
  ],
  Calme: [
    {
      name: "Cité Lumineuse 1982",
      slug: "calme-cite-lumineuse-1982",
      image: "calme-cite-lumineuse-1982.jpg",
    },
    {
      name: "Hyper Calme",
      slug: "calme-hyper-calme",
      image: "calme-hyper-calme.jpg",
    },
  ],
  "Julio Monterrey": [
    {
      name: "Ciudad Jardin",
      slug: "julio-monterrey-ciudad-jardin",
      image: null,
    },
  ],
  "Marc Piñol": [
    {
      name: "Clef III",
      slug: "marc-pinol-clef-iii",
      image: "marc-pinol-clef-iii.jpg",
    },
    {
      name: "Clef III (Alejandro Paz Remix)",
      slug: "marc-pinol-clef-iii-alejandro-paz-remix",
      image: "marc-pinol-clef-iii-alejandro-paz-remix.jpg",
    },
  ],
  Hesanobody: [
    {
      name: "Cliché",
      slug: "hesanobody-cliche",
      image: "hesanobody-cliche.jpg",
    },
    {
      name: "Mourning The Ghost",
      slug: "hesanobody-mourning-the-ghost",
      image: "hesanobody-mourning-the-ghost.jpg",
    },
    {
      name: "Night 23",
      slug: "hesanobody-night-23",
      image: "hesanobody-night-23.jpg",
    },
    {
      name: "Roadblock",
      slug: "hesanobody-roadblock",
      image: "hesanobody-roadblock.jpg",
    },
    {
      name: "The Need To Belong",
      slug: "hesanobody-the-need-to-belong",
      image: "hesanobody-the-need-to-belong.jpg",
    },
    {
      name: "Wishes",
      slug: "hesanobody-wishes",
      image: "hesanobody-wishes.jpg",
    },
    {
      name: "Zeroseventwonine",
      slug: "hesanobody-zeroseventwonine",
      image: "hesanobody-zeroseventwonine.jpg",
    },
  ],
  "Simon Says": [
    {
      name: "Closer To The Red",
      slug: "simon-says-closer-to-the-red",
      image: "simon-says-closer-to-the-red.jpg",
    },
    {
      name: "Coloritmo",
      slug: "simon-says-coloritmo",
      image: "simon-says-coloritmo.jpg",
    },
    {
      name: "Paradis Fantastique",
      slug: "simon-says-paradis-fantastique",
      image: "simon-says-paradis-fantastique.jpg",
    },
  ],
  "Best Youth": [
    {
      name: "Coincidence",
      slug: "best-youth-coincidence",
      image: "best-youth-coincidence.jpg",
    },
    {
      name: "Disintegrate",
      slug: "best-youth-disintegrate",
      image: "best-youth-disintegrate.jpg",
    },
    {
      name: "Feelings",
      slug: "best-youth-feelings",
      image: "best-youth-feelings.jpg",
    },
    {
      name: "Feelings (Acoustic Version)",
      slug: "best-youth-feelings-acoustic-version",
      image: "best-youth-feelings-acoustic-version.jpg",
    },
    {
      name: "Hang Out",
      slug: "best-youth-hang-out",
      image: "best-youth-hang-out.jpg",
    },
    {
      name: "Highlights",
      slug: "best-youth-highlights",
      image: "best-youth-highlights.jpg",
    },
    {
      name: "Honey Trap",
      slug: "best-youth-honey-trap",
      image: "best-youth-honey-trap.jpg",
    },
    {
      name: "Midnight Rain (Acoustic Version)",
      slug: "best-youth-midnight-rain-acoustic-version",
      image: "best-youth-midnight-rain-acoustic-version.jpg",
    },
    {
      name: "Midnight Train",
      slug: "best-youth-midnight-train",
      image: "best-youth-midnight-train.jpg",
    },
    {
      name: "New Girl New Boy",
      slug: "best-youth-new-girl-new-boy",
      image: "best-youth-new-girl-new-boy.jpg",
    },
    {
      name: "Nightfalls",
      slug: "best-youth-nightfalls",
      image: "best-youth-nightfalls.jpg",
    },
    {
      name: "Nightfalls (Acoustic Version)",
      slug: "best-youth-nightfalls-acoustic-version",
      image: "best-youth-nightfalls-acoustic-version.jpg",
    },
    {
      name: "Part Of The Noise",
      slug: "best-youth-part-of-the-noise",
      image: "best-youth-part-of-the-noise.jpg",
    },
    {
      name: "Part Of The Noise (Acoustic Version)",
      slug: "best-youth-part-of-the-noise-acoustic-version",
      image: "best-youth-part-of-the-noise-acoustic-version.jpg",
    },
    {
      name: "Part Of The Noise (Best Youth Instrumental Remix)",
      slug: "best-youth-part-of-the-noise-best-youth-instrumental-remix",
      image: "best-youth-part-of-the-noise-best-youth-instrumental-remix.jpg",
    },
    {
      name: "Part Of The Noise (Best Youth Remix)",
      slug: "best-youth-part-of-the-noise-best-youth-remix",
      image: "best-youth-part-of-the-noise-best-youth-remix.jpg",
    },
    {
      name: "Part Of The Noise (Black Loops Dub Version)",
      slug: "best-youth-part-of-the-noise-black-loops-dub-version",
      image: "best-youth-part-of-the-noise-black-loops-dub-version.jpg",
    },
    {
      name: "Part Of The Noise (Oma Nata Instrumental Remix)",
      slug: "best-youth-part-of-the-noise-oma-nata-instrumental-remix",
      image: "best-youth-part-of-the-noise-oma-nata-instrumental-remix.jpg",
    },
    {
      name: "Part Of The Noise (Oma Nata Remix)",
      slug: "best-youth-part-of-the-noise-oma-nata-remix",
      image: "best-youth-part-of-the-noise-oma-nata-remix.jpg",
    },
    {
      name: "Part Of The Noise (Xinobi Instrumental Remix)",
      slug: "best-youth-part-of-the-noise-xinobi-instrumental-remix",
      image: "best-youth-part-of-the-noise-xinobi-instrumental-remix.jpg",
    },
    {
      name: "Part Of The Noise (Xinobi Remix)",
      slug: "best-youth-part-of-the-noise-xinobi-remix",
      image: "best-youth-part-of-the-noise-xinobi-remix.jpg",
    },
    {
      name: "Please Hold",
      slug: "best-youth-please-hold",
      image: "best-youth-please-hold.jpg",
    },
    {
      name: "Shouts",
      slug: "best-youth-shouts",
      image: "best-youth-shouts.jpg",
    },
    {
      name: "Still Your Girl",
      slug: "best-youth-still-your-girl",
      image: "best-youth-still-your-girl.jpg",
    },
    {
      name: "Tigers On The Catwalk",
      slug: "best-youth-tigers-on-the-catwalk",
      image: "best-youth-tigers-on-the-catwalk.jpg",
    },
    {
      name: "Wait For Me",
      slug: "best-youth-wait-for-me",
      image: "best-youth-wait-for-me.jpg",
    },
  ],
  "Higamos Hogamos": [
    {
      name: "Cold 100",
      slug: "higamos-hogamos-cold-100",
      image: "higamos-hogamos-cold-100.jpg",
    },
    {
      name: "Dendron",
      slug: "higamos-hogamos-dendron",
      image: "higamos-hogamos-dendron.jpg",
    },
    {
      name: "Fuzzy Majesty",
      slug: "higamos-hogamos-fuzzy-majesty",
      image: "higamos-hogamos-fuzzy-majesty.jpg",
    },
    {
      name: "Inwards Empire",
      slug: "higamos-hogamos-inwards-empire",
      image: "higamos-hogamos-inwards-empire.jpg",
    },
    {
      name: "Johari Window",
      slug: "higamos-hogamos-johari-window",
      image: "higamos-hogamos-johari-window.jpg",
    },
    {
      name: "Lionhead",
      slug: "higamos-hogamos-lionhead",
      image: "higamos-hogamos-lionhead.jpg",
    },
    {
      name: "My Travel",
      slug: "higamos-hogamos-my-travel",
      image: "higamos-hogamos-my-travel.jpg",
    },
    {
      name: "NY List",
      slug: "higamos-hogamos-ny-list",
      image: "higamos-hogamos-ny-list.jpg",
    },
    {
      name: "Purest Space",
      slug: "higamos-hogamos-purest-space",
      image: "higamos-hogamos-purest-space.jpg",
    },
    {
      name: "Sorcery",
      slug: "higamos-hogamos-sorcery",
      image: "higamos-hogamos-sorcery.jpg",
    },
  ],
  BGB: [
    {
      name: "Colourful Life",
      slug: "bgb-colourful-life",
      image: "bgb-colourful-life.jpg",
    },
    { name: "Ice Queen", slug: "bgb-ice-queen", image: "bgb-ice-queen.jpg" },
    { name: "Isotope", slug: "bgb-isotope", image: "bgb-isotope.jpg" },
    {
      name: "Red Hair Red Dress",
      slug: "bgb-red-hair-red-dress",
      image: "bgb-red-hair-red-dress.jpg",
    },
    { name: "This Junk", slug: "bgb-this-junk", image: "bgb-this-junk.jpg" },
    {
      name: "Tone Defiance",
      slug: "bgb-tone-defiance",
      image: "bgb-tone-defiance.jpg",
    },
    { name: "When", slug: "bgb-when", image: "bgb-when.jpg" },
  ],
  Psyback: [
    {
      name: "Combneishon",
      slug: "psyback-combneishon",
      image: "psyback-combneishon.jpg",
    },
    {
      name: "Surprise Cake",
      slug: "psyback-surprise-cake",
      image: "psyback-surprise-cake.jpg",
    },
  ],
  "The Adelians": [
    {
      name: "Come Back",
      slug: "the-adelians-come-back",
      image: "the-adelians-come-back.jpg",
    },
    {
      name: "Dis Moi Oui ou Non",
      slug: "the-adelians-dis-moi-oui-ou-non",
      image: "the-adelians-dis-moi-oui-ou-non.jpg",
    },
    { name: "Hey!", slug: "the-adelians-hey", image: "the-adelians-hey.jpg" },
    {
      name: "It's Too Late",
      slug: "the-adelians-it-s-too-late",
      image: "the-adelians-it-s-too-late.jpg",
    },
    {
      name: "Let Us Live",
      slug: "the-adelians-let-us-live",
      image: "the-adelians-let-us-live.jpg",
    },
    {
      name: "Naive",
      slug: "the-adelians-naive",
      image: "the-adelians-naive.jpg",
    },
    {
      name: "Nothing Without You",
      slug: "the-adelians-nothing-without-you",
      image: "the-adelians-nothing-without-you.jpg",
    },
    {
      name: "Seulle",
      slug: "the-adelians-seulle",
      image: "the-adelians-seulle.jpg",
    },
    {
      name: "Tu M'ennuie",
      slug: "the-adelians-tu-m-ennuie",
      image: "the-adelians-tu-m-ennuie.jpg",
    },
  ],
  doVicente: [
    {
      name: "Come Here With featuring NVRT",
      slug: "dovicente-come-here-with-featuring-nvrt",
      image: "dovicente-come-here-with-featuring-nvrt.jpg",
    },
  ],
  "The Callstore": [
    {
      name: "Come On Then",
      slug: "the-callstore-come-on-then",
      image: "the-callstore-come-on-then.jpg",
    },
    {
      name: "In Between Tricks The Magician Bows",
      slug: "the-callstore-in-between-tricks-the-magician-bows",
      image: "the-callstore-in-between-tricks-the-magician-bows.jpg",
    },
    {
      name: "The Letting Go",
      slug: "the-callstore-the-letting-go",
      image: "the-callstore-the-letting-go.jpg",
    },
  ],
  "Franz Scala": [
    {
      name: "Cometa",
      slug: "franz-scala-cometa",
      image: "franz-scala-cometa.jpg",
    },
    {
      name: "Mondo Della Notte",
      slug: "franz-scala-mondo-della-notte",
      image: "franz-scala-mondo-della-notte.jpg",
    },
    {
      name: "Museum Of Illusions",
      slug: "franz-scala-museum-of-illusions",
      image: "franz-scala-museum-of-illusions.jpg",
    },
    {
      name: "One Way Love (Rework)",
      slug: "franz-scala-one-way-love-rework",
      image: "franz-scala-one-way-love-rework.jpg",
    },
  ],
  Copacabana: [
    {
      name: "Como La Dizindo",
      slug: "copacabana-como-la-dizindo",
      image: "copacabana-como-la-dizindo.jpg",
    },
    {
      name: "Deixa Pra La",
      slug: "copacabana-deixa-pra-la",
      image: "copacabana-deixa-pra-la.jpg",
    },
    {
      name: "Noite Em Copacabana",
      slug: "copacabana-noite-em-copacabana",
      image: "copacabana-noite-em-copacabana.jpg",
    },
    {
      name: "Ronaldinho",
      slug: "copacabana-ronaldinho",
      image: "copacabana-ronaldinho.jpg",
    },
  ],
  "Müller & Makaroff": [
    {
      name: "Comodoro Rivadavia",
      slug: "mueller-and-makaroff-comodoro-rivadavia",
      image: "mueller-and-makaroff-comodoro-rivadavia.jpg",
    },
    {
      name: "Comodoro Rivadavia III",
      slug: "mueller-and-makaroff-comodoro-rivadavia-iii",
      image: "mueller-and-makaroff-comodoro-rivadavia-iii.jpg",
    },
    {
      name: "El Piche",
      slug: "mueller-and-makaroff-el-piche",
      image: "mueller-and-makaroff-el-piche.jpg",
    },
    {
      name: "Jesus Maria",
      slug: "mueller-and-makaroff-jesus-maria",
      image: "mueller-and-makaroff-jesus-maria.jpg",
    },
    {
      name: "Jesus Maria II",
      slug: "mueller-and-makaroff-jesus-maria-ii",
      image: "mueller-and-makaroff-jesus-maria-ii.jpg",
    },
    {
      name: "Rio Negro",
      slug: "mueller-and-makaroff-rio-negro",
      image: "mueller-and-makaroff-rio-negro.jpg",
    },
  ],
  Etcha: [
    {
      name: "Confucius (Bird of Paradise Remix)",
      slug: "etcha-confucius-bird-of-paradise-remix",
      image: "etcha-confucius-bird-of-paradise-remix.jpg",
    },
    {
      name: "Confucius Says",
      slug: "etcha-confucius-says",
      image: "etcha-confucius-says.jpg",
    },
    {
      name: "Operation Oskar Panizza",
      slug: "etcha-operation-oskar-panizza",
      image: "etcha-operation-oskar-panizza.jpg",
    },
    {
      name: "Operation Oskar Panizza (Marvin & Guy Remix)",
      slug: "etcha-operation-oskar-panizza-marvin-and-guy-remix",
      image: "etcha-operation-oskar-panizza-marvin-and-guy-remix.jpg",
    },
  ],
  "Alessandro Parisi": [
    {
      name: "Contact",
      slug: "alessandro-parisi-contact",
      image: "alessandro-parisi-contact.jpg",
    },
    {
      name: "Dimensional",
      slug: "alessandro-parisi-dimensional",
      image: "alessandro-parisi-dimensional.jpg",
    },
    {
      name: "Dimensional Wave Impulse",
      slug: "alessandro-parisi-dimensional-wave-impulse",
      image: "alessandro-parisi-dimensional-wave-impulse.jpg",
    },
    {
      name: "Space Machine",
      slug: "alessandro-parisi-space-machine",
      image: "alessandro-parisi-space-machine.jpg",
    },
    {
      name: "The Cosmic Task",
      slug: "alessandro-parisi-the-cosmic-task",
      image: "alessandro-parisi-the-cosmic-task.jpg",
    },
  ],
  Betical: [
    {
      name: "Control feat. Tequisha",
      slug: "betical-control-feat-tequisha",
      image: "betical-control-feat-tequisha.jpg",
    },
    { name: "Runnin", slug: "betical-runnin", image: "betical-runnin.jpg" },
    { name: "Solar", slug: "betical-solar", image: "betical-solar.jpg" },
    {
      name: "Strangers",
      slug: "betical-strangers",
      image: "betical-strangers.jpg",
    },
    {
      name: "Surrender",
      slug: "betical-surrender",
      image: "betical-surrender.jpg",
    },
    { name: "Voices", slug: "betical-voices", image: "betical-voices.jpg" },
  ],
  "General Pecos": [
    {
      name: "Controversy",
      slug: "general-pecos-controversy",
      image: "general-pecos-controversy.jpg",
    },
    {
      name: "Ghetto Life",
      slug: "general-pecos-ghetto-life",
      image: "general-pecos-ghetto-life.jpg",
    },
    {
      name: "Gummy Glue Don",
      slug: "general-pecos-gummy-glue-don",
      image: "general-pecos-gummy-glue-don.jpg",
    },
    {
      name: "Hardcore Lover",
      slug: "general-pecos-hardcore-lover",
      image: "general-pecos-hardcore-lover.jpg",
    },
    {
      name: "Love Me So Bad",
      slug: "general-pecos-love-me-so-bad",
      image: "general-pecos-love-me-so-bad.jpg",
    },
    {
      name: "Mad House",
      slug: "general-pecos-mad-house",
      image: "general-pecos-mad-house.jpg",
    },
    {
      name: "Right Stuff",
      slug: "general-pecos-right-stuff",
      image: "general-pecos-right-stuff.jpg",
    },
    {
      name: "Run Come",
      slug: "general-pecos-run-come",
      image: "general-pecos-run-come.jpg",
    },
    {
      name: "Under Bondage",
      slug: "general-pecos-under-bondage",
      image: "general-pecos-under-bondage.jpg",
    },
  ],
  Quizz: [
    {
      name: "Controversy",
      slug: "quizz-controversy",
      image: "quizz-controversy.jpg",
    },
  ],
  "Jesse Oliver": [
    {
      name: "Could You Be Mine",
      slug: "jesse-oliver-could-you-be-mine",
      image: "jesse-oliver-could-you-be-mine.jpg",
    },
    {
      name: "Nicodemus",
      slug: "jesse-oliver-nicodemus",
      image: "jesse-oliver-nicodemus.jpg",
    },
    {
      name: "Oceans",
      slug: "jesse-oliver-oceans",
      image: "jesse-oliver-oceans.jpg",
    },
    {
      name: "Oceans (Mirror People Remix)",
      slug: "jesse-oliver-oceans-mirror-people-remix",
      image: "jesse-oliver-oceans-mirror-people-remix.jpg",
    },
    {
      name: "Piece By Piece",
      slug: "jesse-oliver-piece-by-piece",
      image: "jesse-oliver-piece-by-piece.jpg",
    },
  ],
  Poomse: [
    {
      name: "Countless Angry Men",
      slug: "poomse-countless-angry-men",
      image: "poomse-countless-angry-men.jpg",
    },
    {
      name: "Daily Bread",
      slug: "poomse-daily-bread",
      image: "poomse-daily-bread.jpg",
    },
    {
      name: "Empty Sea",
      slug: "poomse-empty-sea",
      image: "poomse-empty-sea.jpg",
    },
    {
      name: "Invisible Wars",
      slug: "poomse-invisible-wars",
      image: "poomse-invisible-wars.jpg",
    },
    { name: "Liorna", slug: "poomse-liorna", image: "poomse-liorna.jpg" },
    {
      name: "Mathematic Light",
      slug: "poomse-mathematic-light",
      image: "poomse-mathematic-light.jpg",
    },
    { name: "Ronette", slug: "poomse-ronette", image: "poomse-ronette.jpg" },
    {
      name: "Song For Roberta Sparrow",
      slug: "poomse-song-for-roberta-sparrow",
      image: "poomse-song-for-roberta-sparrow.jpg",
    },
    {
      name: "The Kingdom of Death",
      slug: "poomse-the-kingdom-of-death",
      image: "poomse-the-kingdom-of-death.jpg",
    },
    {
      name: "The Third Cheek",
      slug: "poomse-the-third-cheek",
      image: "poomse-the-third-cheek.jpg",
    },
    {
      name: "Tomorrow Will Come",
      slug: "poomse-tomorrow-will-come",
      image: "poomse-tomorrow-will-come.jpg",
    },
  ],
  "Fell Reis": [
    { name: "Cova", slug: "fell-reis-cova", image: "fell-reis-cova.jpg" },
    {
      name: "Cova (Roommates Remix)",
      slug: "fell-reis-cova-roommates-remix",
      image: "fell-reis-cova-roommates-remix.jpg",
    },
    {
      name: "Divergent",
      slug: "fell-reis-divergent",
      image: "fell-reis-divergent.jpg",
    },
    {
      name: "Monk Dance",
      slug: "fell-reis-monk-dance",
      image: "fell-reis-monk-dance.jpg",
    },
  ],
  Shulte: [
    {
      name: "Crack In The Earth",
      slug: "shulte-crack-in-the-earth",
      image: "shulte-crack-in-the-earth.jpg",
    },
    { name: "Get Down", slug: "shulte-get-down", image: "shulte-get-down.jpg" },
  ],
  "Calido Home": [
    {
      name: "Crash Over Me",
      slug: "calido-home-crash-over-me",
      image: "calido-home-crash-over-me.jpg",
    },
    {
      name: "Dear Kiddo",
      slug: "calido-home-dear-kiddo",
      image: "calido-home-dear-kiddo.jpg",
    },
    {
      name: "Drop A Pebble",
      slug: "calido-home-drop-a-pebble",
      image: "calido-home-drop-a-pebble.jpg",
    },
    {
      name: "Full Moon",
      slug: "calido-home-full-moon",
      image: "calido-home-full-moon.jpg",
    },
    {
      name: "In A Vision Or In None",
      slug: "calido-home-in-a-vision-or-in-none",
      image: "calido-home-in-a-vision-or-in-none.jpg",
    },
    {
      name: "Sweet Britle",
      slug: "calido-home-sweet-britle",
      image: "calido-home-sweet-britle.jpg",
    },
    {
      name: "The Flood",
      slug: "calido-home-the-flood",
      image: "calido-home-the-flood.jpg",
    },
    {
      name: "The Moss On You",
      slug: "calido-home-the-moss-on-you",
      image: "calido-home-the-moss-on-you.jpg",
    },
    {
      name: "Tones and Shapes",
      slug: "calido-home-tones-and-shapes",
      image: "calido-home-tones-and-shapes.jpg",
    },
    {
      name: "We Spend The Days",
      slug: "calido-home-we-spend-the-days",
      image: "calido-home-we-spend-the-days.jpg",
    },
  ],
  "Xinobi and Mystery Affair": [
    {
      name: "Criaturas",
      slug: "xinobi-and-mystery-affair-criaturas",
      image: "xinobi-and-mystery-affair-criaturas.jpg",
    },
  ],
  Cristine: [
    {
      name: "Cross The Line",
      slug: "cristine-cross-the-line",
      image: "cristine-cross-the-line.jpg",
    },
    {
      name: "I Freak",
      slug: "cristine-i-freak",
      image: "cristine-i-freak.jpg",
    },
    {
      name: "I'm Sorry",
      slug: "cristine-i-m-sorry",
      image: "cristine-i-m-sorry.jpg",
    },
    {
      name: "J'suis Belle",
      slug: "cristine-j-suis-belle",
      image: "cristine-j-suis-belle.jpg",
    },
    {
      name: "Name On The Wall",
      slug: "cristine-name-on-the-wall",
      image: "cristine-name-on-the-wall.jpg",
    },
    {
      name: "Nevermind",
      slug: "cristine-nevermind",
      image: "cristine-nevermind.jpg",
    },
    {
      name: "She's In My",
      slug: "cristine-she-s-in-my",
      image: "cristine-she-s-in-my.jpg",
    },
    {
      name: "Show Me The Girl",
      slug: "cristine-show-me-the-girl",
      image: "cristine-show-me-the-girl.jpg",
    },
    { name: "Use", slug: "cristine-use", image: "cristine-use.jpg" },
    {
      name: "We Got Sun",
      slug: "cristine-we-got-sun",
      image: "cristine-we-got-sun.jpg",
    },
    {
      name: "You Won't Go",
      slug: "cristine-you-won-t-go",
      image: "cristine-you-won-t-go.jpg",
    },
  ],
  "David Cordero": [
    {
      name: "Cruce De Historias",
      slug: "david-cordero-cruce-de-historias",
      image: "david-cordero-cruce-de-historias.jpg",
    },
    {
      name: "Inicio",
      slug: "david-cordero-inicio",
      image: "david-cordero-inicio.jpg",
    },
    {
      name: "La Llamada",
      slug: "david-cordero-la-llamada",
      image: "david-cordero-la-llamada.jpg",
    },
    {
      name: "No Poder Mirar Atras",
      slug: "david-cordero-no-poder-mirar-atras",
      image: "david-cordero-no-poder-mirar-atras.jpg",
    },
    {
      name: "Presentacion",
      slug: "david-cordero-presentacion",
      image: "david-cordero-presentacion.jpg",
    },
    {
      name: "Primera Vez",
      slug: "david-cordero-primera-vez",
      image: "david-cordero-primera-vez.jpg",
    },
    {
      name: "Punto y Aparte",
      slug: "david-cordero-punto-y-aparte",
      image: "david-cordero-punto-y-aparte.jpg",
    },
    {
      name: "Sobre Arena",
      slug: "david-cordero-sobre-arena",
      image: "david-cordero-sobre-arena.jpg",
    },
    {
      name: "Varios Personajes",
      slug: "david-cordero-varios-personajes",
      image: "david-cordero-varios-personajes.jpg",
    },
  ],
  "Dulce Pajara": [
    {
      name: "Crucifiction",
      slug: "dulce-pajara-crucifiction",
      image: "dulce-pajara-crucifiction.jpg",
    },
    { name: "Dark", slug: "dulce-pajara-dark", image: "dulce-pajara-dark.jpg" },
    {
      name: "Freak In Tales",
      slug: "dulce-pajara-freak-in-tales",
      image: "dulce-pajara-freak-in-tales.jpg",
    },
    { name: "Home", slug: "dulce-pajara-home", image: "dulce-pajara-home.jpg" },
    {
      name: "Lapidation",
      slug: "dulce-pajara-lapidation",
      image: "dulce-pajara-lapidation.jpg",
    },
    {
      name: "Manantial",
      slug: "dulce-pajara-manantial",
      image: "dulce-pajara-manantial.jpg",
    },
    {
      name: "Saying All Goodbyes On Fire",
      slug: "dulce-pajara-saying-all-goodbyes-on-fire",
      image: "dulce-pajara-saying-all-goodbyes-on-fire.jpg",
    },
    {
      name: "Sonic",
      slug: "dulce-pajara-sonic",
      image: "dulce-pajara-sonic.jpg",
    },
    {
      name: "Triumph",
      slug: "dulce-pajara-triumph",
      image: "dulce-pajara-triumph.jpg",
    },
  ],
  Capofortuna: [
    {
      name: "Crush On You",
      slug: "capofortuna-crush-on-you",
      image: "capofortuna-crush-on-you.jpg",
    },
    {
      name: "Onda D'Urto",
      slug: "capofortuna-onda-d-urto",
      image: "capofortuna-onda-d-urto.jpg",
    },
    {
      name: "Playzone",
      slug: "capofortuna-playzone",
      image: "capofortuna-playzone.jpg",
    },
    {
      name: "Watching Her",
      slug: "capofortuna-watching-her",
      image: "capofortuna-watching-her.jpg",
    },
    {
      name: "Working For Who",
      slug: "capofortuna-working-for-who",
      image: "capofortuna-working-for-who.jpg",
    },
  ],
  AWN: [
    {
      name: "Cry me A River",
      slug: "awn-cry-me-a-river",
      image: "awn-cry-me-a-river.jpg",
    },
  ],
  "Harrison Ford Fiesta": [
    {
      name: "Crédit Agricole",
      slug: "harrison-ford-fiesta-credit-agricole",
      image: "harrison-ford-fiesta-credit-agricole.jpg",
    },
    {
      name: "La Soucoupe et le Perroquet",
      slug: "harrison-ford-fiesta-la-soucoupe-et-le-perroquet",
      image: "harrison-ford-fiesta-la-soucoupe-et-le-perroquet.jpg",
    },
    {
      name: "Lonely Ben",
      slug: "harrison-ford-fiesta-lonely-ben",
      image: "harrison-ford-fiesta-lonely-ben.jpg",
    },
    {
      name: "Role Play",
      slug: "harrison-ford-fiesta-role-play",
      image: "harrison-ford-fiesta-role-play.jpg",
    },
    {
      name: "Samy Fist",
      slug: "harrison-ford-fiesta-samy-fist",
      image: "harrison-ford-fiesta-samy-fist.jpg",
    },
    {
      name: "The Armchari and the Tentacle",
      slug: "harrison-ford-fiesta-the-armchari-and-the-tentacle",
      image: "harrison-ford-fiesta-the-armchari-and-the-tentacle.jpg",
    },
  ],
  "Jay Lamar / Jesse Oliver": [
    {
      name: "Cul De Sac",
      slug: "jay-lamar-jesse-oliver-cul-de-sac",
      image: "jay-lamar-jesse-oliver-cul-de-sac.jpg",
    },
  ],
  "Mr Gonzo": [
    {
      name: "Dance On You",
      slug: "mr-gonzo-dance-on-you",
      image: "mr-gonzo-dance-on-you.jpg",
    },
  ],
  Brazzabelle: [
    {
      name: "Dancefloor feat Dominique Young Unique and JSTRJR",
      slug: "brazzabelle-dancefloor-feat-dominique-young-unique-and-jstrjr",
      image:
        "brazzabelle-dancefloor-feat-dominique-young-unique-and-jstrjr.jpg",
    },
  ],
  Structures: [
    {
      name: "Dancers",
      slug: "structures-dancers",
      image: "structures-dancers.jpg",
    },
    {
      name: "Long Life",
      slug: "structures-long-life",
      image: "structures-long-life.jpg",
    },
    {
      name: "Satellite",
      slug: "structures-satellite",
      image: "structures-satellite.jpg",
    },
  ],
  "Lord Funk": [
    { name: "Danser", slug: "lord-funk-danser", image: "lord-funk-danser.jpg" },
    {
      name: "Holly Rappin Man",
      slug: "lord-funk-holly-rappin-man",
      image: "lord-funk-holly-rappin-man.jpg",
    },
    {
      name: "Inspiration",
      slug: "lord-funk-inspiration",
      image: "lord-funk-inspiration.jpg",
    },
    {
      name: "New York , New York",
      slug: "lord-funk-new-york-new-york",
      image: "lord-funk-new-york-new-york.jpg",
    },
    {
      name: "Piano Comic",
      slug: "lord-funk-piano-comic",
      image: "lord-funk-piano-comic.jpg",
    },
    {
      name: "Rumble (Bongo Jam)",
      slug: "lord-funk-rumble-bongo-jam",
      image: "lord-funk-rumble-bongo-jam.jpg",
    },
    {
      name: "Shake What U Gat (2Good2stop)",
      slug: "lord-funk-shake-what-u-gat-2good2stop",
      image: "lord-funk-shake-what-u-gat-2good2stop.jpg",
    },
    {
      name: "Spaghetti Head",
      slug: "lord-funk-spaghetti-head",
      image: "lord-funk-spaghetti-head.jpg",
    },
    {
      name: "Tropical Theme",
      slug: "lord-funk-tropical-theme",
      image: "lord-funk-tropical-theme.jpg",
    },
  ],
  "Dame Bonnet": [
    {
      name: "Dark , Slow",
      slug: "dame-bonnet-dark-slow",
      image: "dame-bonnet-dark-slow.jpg",
    },
    {
      name: "Portamento",
      slug: "dame-bonnet-portamento",
      image: "dame-bonnet-portamento.jpg",
    },
  ],
  "Nothing Places": [
    {
      name: "Dark Side",
      slug: "nothing-places-dark-side",
      image: "nothing-places-dark-side.jpg",
    },
    {
      name: "Draw Blood",
      slug: "nothing-places-draw-blood",
      image: "nothing-places-draw-blood.jpg",
    },
    {
      name: "In Twilight Comala",
      slug: "nothing-places-in-twilight-comala",
      image: "nothing-places-in-twilight-comala.jpg",
    },
    {
      name: "Lift Up",
      slug: "nothing-places-lift-up",
      image: "nothing-places-lift-up.jpg",
    },
    {
      name: "Lizard Brain",
      slug: "nothing-places-lizard-brain",
      image: "nothing-places-lizard-brain.jpg",
    },
    {
      name: "Powder In The Gun",
      slug: "nothing-places-powder-in-the-gun",
      image: "nothing-places-powder-in-the-gun.jpg",
    },
    {
      name: "Propeller Moon",
      slug: "nothing-places-propeller-moon",
      image: "nothing-places-propeller-moon.jpg",
    },
    {
      name: "Random Pull",
      slug: "nothing-places-random-pull",
      image: "nothing-places-random-pull.jpg",
    },
    {
      name: "Tidal Love",
      slug: "nothing-places-tidal-love",
      image: "nothing-places-tidal-love.jpg",
    },
  ],
  Remate: [
    {
      name: "Dawn Wiener",
      slug: "remate-dawn-wiener",
      image: "remate-dawn-wiener.jpg",
    },
    {
      name: "Elizabeth Travis",
      slug: "remate-elizabeth-travis",
      image: "remate-elizabeth-travis.jpg",
    },
    {
      name: "Emma Recchi",
      slug: "remate-emma-recchi",
      image: "remate-emma-recchi.jpg",
    },
    {
      name: "Fred Belair",
      slug: "remate-fred-belair",
      image: "remate-fred-belair.jpg",
    },
    { name: "Jackie", slug: "remate-jackie", image: "remate-jackie.jpg" },
    { name: "Kris", slug: "remate-kris", image: "remate-kris.jpg" },
    { name: "Martha", slug: "remate-martha", image: "remate-martha.jpg" },
    { name: "Nathalia", slug: "remate-nathalia", image: "remate-nathalia.jpg" },
    { name: "Ray Eddy", slug: "remate-ray-eddy", image: "remate-ray-eddy.jpg" },
    { name: "Star", slug: "remate-star", image: "remate-star.jpg" },
  ],
  "Night Night": [
    {
      name: "Day (Part 1)",
      slug: "night-night-day-part-1",
      image: "night-night-day-part-1.jpg",
    },
    {
      name: "Day (Part 2)",
      slug: "night-night-day-part-2",
      image: "night-night-day-part-2.jpg",
    },
    {
      name: "Where Do You Go",
      slug: "night-night-where-do-you-go",
      image: "night-night-where-do-you-go.jpg",
    },
  ],
  "Alan Braxe": [
    {
      name: "Day Dreaming",
      slug: "alan-braxe-day-dreaming",
      image: "alan-braxe-day-dreaming.jpg",
    },
    {
      name: "One More Chance",
      slug: "alan-braxe-one-more-chance",
      image: "alan-braxe-one-more-chance.jpg",
    },
    {
      name: "Repeater",
      slug: "alan-braxe-repeater",
      image: "alan-braxe-repeater.jpg",
    },
    {
      name: "Spacer",
      slug: "alan-braxe-spacer",
      image: "alan-braxe-spacer.jpg",
    },
    {
      name: "The Ascent",
      slug: "alan-braxe-the-ascent",
      image: "alan-braxe-the-ascent.jpg",
    },
    {
      name: "Time Machine",
      slug: "alan-braxe-time-machine",
      image: "alan-braxe-time-machine.jpg",
    },
    {
      name: "Voices",
      slug: "alan-braxe-voices",
      image: "alan-braxe-voices.jpg",
    },
    { name: "Words", slug: "alan-braxe-words", image: "alan-braxe-words.jpg" },
  ],
  "Su Real": [
    {
      name: "De Soundboy",
      slug: "su-real-de-soundboy",
      image: "su-real-de-soundboy.jpg",
    },
  ],
  TWLVE: [
    { name: "Deadrats", slug: "twlve-deadrats", image: "twlve-deadrats.jpg" },
    {
      name: "Me & Arrow",
      slug: "twlve-me-and-arrow",
      image: "twlve-me-and-arrow.jpg",
    },
    {
      name: "Murder In The Pool",
      slug: "twlve-murder-in-the-pool",
      image: "twlve-murder-in-the-pool.jpg",
    },
    { name: "Red Door", slug: "twlve-red-door", image: "twlve-red-door.jpg" },
    { name: "Sunbats", slug: "twlve-sunbats", image: "twlve-sunbats.jpg" },
    {
      name: "Versus Reverse",
      slug: "twlve-versus-reverse",
      image: "twlve-versus-reverse.jpg",
    },
  ],
  "Leo Justi": [
    {
      name: "Deela Ding",
      slug: "leo-justi-deela-ding",
      image: "leo-justi-deela-ding.jpg",
    },
  ],
  Bloum: [
    {
      name: "Deep Appeal",
      slug: "bloum-deep-appeal",
      image: "bloum-deep-appeal.jpg",
    },
    { name: "La Folie", slug: "bloum-la-folie", image: "bloum-la-folie.jpg" },
    {
      name: "Lady Mountain",
      slug: "bloum-lady-mountain",
      image: "bloum-lady-mountain.jpg",
    },
    {
      name: "Las Vegas",
      slug: "bloum-las-vegas",
      image: "bloum-las-vegas.jpg",
    },
    {
      name: "Something In My Mind",
      slug: "bloum-something-in-my-mind",
      image: "bloum-something-in-my-mind.jpg",
    },
  ],
  "Deux Control": [
    {
      name: "Des Visages featuring Jordi Sorder",
      slug: "deux-control-des-visages-featuring-jordi-sorder",
      image: null,
    },
    { name: "Freaks", slug: "deux-control-freaks", image: null },
    { name: "L'Enfant Do", slug: "deux-control-l-enfant-do", image: null },
    { name: "La Tia Miguel", slug: "deux-control-la-tia-miguel", image: null },
    { name: "Le Masque", slug: "deux-control-le-masque", image: null },
    { name: "Pantera", slug: "deux-control-pantera", image: null },
    { name: "Sex Miami", slug: "deux-control-sex-miami", image: null },
    {
      name: "The Flower Of Chapultepec",
      slug: "deux-control-the-flower-of-chapultepec",
      image: null,
    },
    { name: "Tomorrow", slug: "deux-control-tomorrow", image: null },
  ],
  Youkounkoun: [
    {
      name: "Desert Nights",
      slug: "youkounkoun-desert-nights",
      image: "youkounkoun-desert-nights.jpg",
    },
  ],
  "Marching Machines": [
    {
      name: "Desolat",
      slug: "marching-machines-desolat",
      image: "marching-machines-desolat.jpg",
    },
    {
      name: "Driven",
      slug: "marching-machines-driven",
      image: "marching-machines-driven.jpg",
    },
    {
      name: "Lonesome",
      slug: "marching-machines-lonesome",
      image: "marching-machines-lonesome.jpg",
    },
  ],
  "Alpha Stone": [
    {
      name: "Destiny Angel",
      slug: "alpha-stone-destiny-angel",
      image: "alpha-stone-destiny-angel.jpg",
    },
    {
      name: "Fall On Me",
      slug: "alpha-stone-fall-on-me",
      image: "alpha-stone-fall-on-me.jpg",
    },
    {
      name: "Martian Interlude",
      slug: "alpha-stone-martian-interlude",
      image: "alpha-stone-martian-interlude.jpg",
    },
    {
      name: "Narcosis Stereo",
      slug: "alpha-stone-narcosis-stereo",
      image: "alpha-stone-narcosis-stereo.jpg",
    },
    {
      name: "Retroglide",
      slug: "alpha-stone-retroglide",
      image: "alpha-stone-retroglide.jpg",
    },
    {
      name: "Some Dreams Fade",
      slug: "alpha-stone-some-dreams-fade",
      image: "alpha-stone-some-dreams-fade.jpg",
    },
    {
      name: "Special One",
      slug: "alpha-stone-special-one",
      image: "alpha-stone-special-one.jpg",
    },
    {
      name: "Tony Hart",
      slug: "alpha-stone-tony-hart",
      image: "alpha-stone-tony-hart.jpg",
    },
    {
      name: "Transfixed",
      slug: "alpha-stone-transfixed",
      image: "alpha-stone-transfixed.jpg",
    },
  ],
  AMG: [
    {
      name: "Deux Trois Barres",
      slug: "amg-deux-trois-barres",
      image: "amg-deux-trois-barres.jpg",
    },
  ],
  "Twin Theory x Fabich": [
    {
      name: "Dial Me feat. Bambie Thug",
      slug: "twin-theory-x-fabich-dial-me-feat-bambie-thug",
      image: null,
    },
  ],
  "Fuckin' Bollocks": [
    {
      name: "Diamond Rising",
      slug: "fuckin-bollocks-diamond-rising",
      image: "fuckin-bollocks-diamond-rising.jpg",
    },
    {
      name: "Drug Will Tear Us Apart",
      slug: "fuckin-bollocks-drug-will-tear-us-apart",
      image: "fuckin-bollocks-drug-will-tear-us-apart.jpg",
    },
    {
      name: "I Saw The Devil",
      slug: "fuckin-bollocks-i-saw-the-devil",
      image: "fuckin-bollocks-i-saw-the-devil.jpg",
    },
    {
      name: "I Told You",
      slug: "fuckin-bollocks-i-told-you",
      image: "fuckin-bollocks-i-told-you.jpg",
    },
    {
      name: "I've Been Waiting For So Long",
      slug: "fuckin-bollocks-i-ve-been-waiting-for-so-long",
      image: "fuckin-bollocks-i-ve-been-waiting-for-so-long.jpg",
    },
    {
      name: "I've Given Up",
      slug: "fuckin-bollocks-i-ve-given-up",
      image: "fuckin-bollocks-i-ve-given-up.jpg",
    },
    {
      name: "Love Can Fuck It All",
      slug: "fuckin-bollocks-love-can-fuck-it-all",
      image: "fuckin-bollocks-love-can-fuck-it-all.jpg",
    },
    {
      name: "So Many Times",
      slug: "fuckin-bollocks-so-many-times",
      image: "fuckin-bollocks-so-many-times.jpg",
    },
    {
      name: "Sweet Virginia",
      slug: "fuckin-bollocks-sweet-virginia",
      image: "fuckin-bollocks-sweet-virginia.jpg",
    },
    {
      name: "The House Of The Hill",
      slug: "fuckin-bollocks-the-house-of-the-hill",
      image: "fuckin-bollocks-the-house-of-the-hill.jpg",
    },
    {
      name: "Why To Change",
      slug: "fuckin-bollocks-why-to-change",
      image: "fuckin-bollocks-why-to-change.jpg",
    },
  ],
  XyWhy: [
    {
      name: "Diamonds In The Rough",
      slug: "xywhy-diamonds-in-the-rough",
      image: "xywhy-diamonds-in-the-rough.jpg",
    },
    {
      name: "Diamonds In The Rough (Deams Remix)",
      slug: "xywhy-diamonds-in-the-rough-deams-remix",
      image: "xywhy-diamonds-in-the-rough-deams-remix.jpg",
    },
    {
      name: "EOA (Villanova Remix)",
      slug: "xywhy-eoa-villanova-remix",
      image: "xywhy-eoa-villanova-remix.jpg",
    },
    {
      name: "EOA The Kite (XyWhy Remix)",
      slug: "xywhy-eoa-the-kite-xywhy-remix",
      image: "xywhy-eoa-the-kite-xywhy-remix.jpg",
    },
    { name: "Lounger", slug: "xywhy-lounger", image: "xywhy-lounger.jpg" },
    {
      name: "Lounger (Shungu Remix)",
      slug: "xywhy-lounger-shungu-remix",
      image: "xywhy-lounger-shungu-remix.jpg",
    },
    { name: "Scifly", slug: "xywhy-scifly", image: "xywhy-scifly.jpg" },
    {
      name: "Scifly (Mr Bop Remix)",
      slug: "xywhy-scifly-mr-bop-remix",
      image: "xywhy-scifly-mr-bop-remix.jpg",
    },
  ],
  Suma: [
    { name: "Die Zeit", slug: "suma-die-zeit", image: "suma-die-zeit.jpg" },
    {
      name: "Don't Kid Anyone",
      slug: "suma-don-t-kid-anyone",
      image: "suma-don-t-kid-anyone.jpg",
    },
    {
      name: "In The Middle Of Somewhere",
      slug: "suma-in-the-middle-of-somewhere",
      image: "suma-in-the-middle-of-somewhere.jpg",
    },
    { name: "Lepant 1", slug: "suma-lepant-1", image: "suma-lepant-1.jpg" },
    { name: "Lepant 2", slug: "suma-lepant-2", image: "suma-lepant-2.jpg" },
    { name: "Lightness", slug: "suma-lightness", image: "suma-lightness.jpg" },
    {
      name: "Low Summer Skies",
      slug: "suma-low-summer-skies",
      image: "suma-low-summer-skies.jpg",
    },
    {
      name: "Perhaps That's Good",
      slug: "suma-perhaps-that-s-good",
      image: "suma-perhaps-that-s-good.jpg",
    },
    {
      name: "Sometimes She Sings On Her Own",
      slug: "suma-sometimes-she-sings-on-her-own",
      image: "suma-sometimes-she-sings-on-her-own.jpg",
    },
    { name: "Truth", slug: "suma-truth", image: "suma-truth.jpg" },
    {
      name: "Watching You Drift",
      slug: "suma-watching-you-drift",
      image: "suma-watching-you-drift.jpg",
    },
  ],
  Inflagranti: [
    {
      name: "Different From The Rest (Moscoman Remix)",
      slug: "inflagranti-different-from-the-rest-moscoman-remix",
      image: "inflagranti-different-from-the-rest-moscoman-remix.jpg",
    },
    {
      name: "Different From The Rest (Sebastien Tex Remix)",
      slug: "inflagranti-different-from-the-rest-sebastien-tex-remix",
      image: "inflagranti-different-from-the-rest-sebastien-tex-remix.jpg",
    },
    {
      name: "Set It Out",
      slug: "inflagranti-set-it-out",
      image: "inflagranti-set-it-out.jpg",
    },
  ],
  "The Revolving Eyes": [
    {
      name: "Digitropic",
      slug: "the-revolving-eyes-digitropic",
      image: "the-revolving-eyes-digitropic.jpg",
    },
    {
      name: "North As North",
      slug: "the-revolving-eyes-north-as-north",
      image: "the-revolving-eyes-north-as-north.jpg",
    },
    {
      name: "Opposite",
      slug: "the-revolving-eyes-opposite",
      image: "the-revolving-eyes-opposite.jpg",
    },
  ],
  Aries: [
    {
      name: "Dilo Mañana",
      slug: "aries-dilo-manana",
      image: "aries-dilo-manana.jpg",
    },
  ],
  "Claap!": [
    {
      name: "Dimanche (Mike Simonetti Remix)",
      slug: "claap-dimanche-mike-simonetti-remix",
      image: "claap-dimanche-mike-simonetti-remix.jpg",
    },
    {
      name: "Dimanche (Original Instrumental)",
      slug: "claap-dimanche-original-instrumental",
      image: "claap-dimanche-original-instrumental.jpg",
    },
    {
      name: "Dimanche (Original)",
      slug: "claap-dimanche-original",
      image: "claap-dimanche-original.jpg",
    },
    {
      name: "Dimanche (Radio Edit)",
      slug: "claap-dimanche-radio-edit",
      image: "claap-dimanche-radio-edit.jpg",
    },
    { name: "Flash", slug: "claap-flash", image: "claap-flash.jpg" },
    {
      name: "Flash (Club Dub Version)",
      slug: "claap-flash-club-dub-version",
      image: "claap-flash-club-dub-version.jpg",
    },
    {
      name: "Flash (Club Vibradub Version)",
      slug: "claap-flash-club-vibradub-version",
      image: "claap-flash-club-vibradub-version.jpg",
    },
    {
      name: "Flash (Club Vocal Version)",
      slug: "claap-flash-club-vocal-version",
      image: "claap-flash-club-vocal-version.jpg",
    },
    {
      name: "Flash (Herr Styler Remix)",
      slug: "claap-flash-herr-styler-remix",
      image: "claap-flash-herr-styler-remix.jpg",
    },
    {
      name: "Flash (Instrumental)",
      slug: "claap-flash-instrumental",
      image: "claap-flash-instrumental.jpg",
    },
    {
      name: "Muddy Boots feat Santana",
      slug: "claap-muddy-boots-feat-santana",
      image: "claap-muddy-boots-feat-santana.jpg",
    },
    { name: "Oh", slug: "claap-oh", image: "claap-oh.jpg" },
    {
      name: "Oh (Instrumental)",
      slug: "claap-oh-instrumental",
      image: "claap-oh-instrumental.jpg",
    },
  ],
  Kriget: [
    { name: "Din Con", slug: "kriget-din-con", image: "kriget-din-con.jpg" },
    { name: "Sama", slug: "kriget-sama", image: "kriget-sama.jpg" },
  ],
  "Leonard and Ness": [
    {
      name: "Dis moi au revoir",
      slug: "leonard-and-ness-dis-moi-au-revoir",
      image: "leonard-and-ness-dis-moi-au-revoir.jpg",
    },
  ],
  Sparkle: [
    {
      name: "Disco Madness",
      slug: "sparkle-disco-madness",
      image: "sparkle-disco-madness.jpg",
    },
  ],
  Fictions: [
    {
      name: "Disco Revolver",
      slug: "fictions-disco-revolver",
      image: "fictions-disco-revolver.jpg",
    },
    {
      name: "Disco Revolver (Instrumental)",
      slug: "fictions-disco-revolver-instrumental",
      image: "fictions-disco-revolver-instrumental.jpg",
    },
    {
      name: "Flashback (Instrumental)",
      slug: "fictions-flashback-instrumental",
      image: "fictions-flashback-instrumental.jpg",
    },
    { name: "Lady B", slug: "fictions-lady-b", image: "fictions-lady-b.jpg" },
    {
      name: "Les Oiseaux de Moscou",
      slug: "fictions-les-oiseaux-de-moscou",
      image: "fictions-les-oiseaux-de-moscou.jpg",
    },
    {
      name: "More Than A Life",
      slug: "fictions-more-than-a-life",
      image: "fictions-more-than-a-life.jpg",
    },
    {
      name: "Sang Bleu",
      slug: "fictions-sang-bleu",
      image: "fictions-sang-bleu.jpg",
    },
    {
      name: "Sang Bleu (Instrumental)",
      slug: "fictions-sang-bleu-instrumental",
      image: "fictions-sang-bleu-instrumental.jpg",
    },
    { name: "UFO", slug: "fictions-ufo", image: "fictions-ufo.jpg" },
    {
      name: "UFO (Instrumental)",
      slug: "fictions-ufo-instrumental",
      image: "fictions-ufo-instrumental.jpg",
    },
  ],
  "Marcello Giordani": [
    {
      name: "Disco Sprint",
      slug: "marcello-giordani-disco-sprint",
      image: "marcello-giordani-disco-sprint.jpg",
    },
    {
      name: "Viserbella Sunset",
      slug: "marcello-giordani-viserbella-sunset",
      image: "marcello-giordani-viserbella-sunset.jpg",
    },
  ],
  "Jamie Paton": [
    {
      name: "Disk Memories",
      slug: "jamie-paton-disk-memories",
      image: "jamie-paton-disk-memories.jpg",
    },
    {
      name: "Enhance 224",
      slug: "jamie-paton-enhance-224",
      image: "jamie-paton-enhance-224.jpg",
    },
    {
      name: "Leviathan Aftermath",
      slug: "jamie-paton-leviathan-aftermath",
      image: "jamie-paton-leviathan-aftermath.jpg",
    },
    {
      name: "State Line",
      slug: "jamie-paton-state-line",
      image: "jamie-paton-state-line.jpg",
    },
    {
      name: "Telefuture",
      slug: "jamie-paton-telefuture",
      image: "jamie-paton-telefuture.jpg",
    },
  ],
  "Pete Bassman": [
    {
      name: "Distant Funk",
      slug: "pete-bassman-distant-funk",
      image: "pete-bassman-distant-funk.jpg",
    },
    {
      name: "Echo Lane",
      slug: "pete-bassman-echo-lane",
      image: "pete-bassman-echo-lane.jpg",
    },
    {
      name: "Fabrik",
      slug: "pete-bassman-fabrik",
      image: "pete-bassman-fabrik.jpg",
    },
    {
      name: "Fast Flowing Fluid",
      slug: "pete-bassman-fast-flowing-fluid",
      image: "pete-bassman-fast-flowing-fluid.jpg",
    },
    {
      name: "Let's Do It",
      slug: "pete-bassman-let-s-do-it",
      image: "pete-bassman-let-s-do-it.jpg",
    },
    {
      name: "Mettalic Decade",
      slug: "pete-bassman-mettalic-decade",
      image: "pete-bassman-mettalic-decade.jpg",
    },
    {
      name: "Music For Modern Living",
      slug: "pete-bassman-music-for-modern-living",
      image: "pete-bassman-music-for-modern-living.jpg",
    },
    {
      name: "Poison Butterfly",
      slug: "pete-bassman-poison-butterfly",
      image: "pete-bassman-poison-butterfly.jpg",
    },
    {
      name: "Scars",
      slug: "pete-bassman-scars",
      image: "pete-bassman-scars.jpg",
    },
    {
      name: "Small Town Illusion",
      slug: "pete-bassman-small-town-illusion",
      image: "pete-bassman-small-town-illusion.jpg",
    },
    {
      name: "Sweet 16",
      slug: "pete-bassman-sweet-16",
      image: "pete-bassman-sweet-16.jpg",
    },
    {
      name: "Wolf Eater",
      slug: "pete-bassman-wolf-eater",
      image: "pete-bassman-wolf-eater.jpg",
    },
  ],
  "Lou Teti": [
    { name: "Ditar", slug: "lou-teti-ditar", image: "lou-teti-ditar.jpg" },
    {
      name: "Ditar (Fiori Remix)",
      slug: "lou-teti-ditar-fiori-remix",
      image: "lou-teti-ditar-fiori-remix.jpg",
    },
    {
      name: "Dream Out Loud",
      slug: "lou-teti-dream-out-loud",
      image: "lou-teti-dream-out-loud.jpg",
    },
    {
      name: "Get Away (Drop Out Orchestra Rework)",
      slug: "lou-teti-get-away-drop-out-orchestra-rework",
      image: "lou-teti-get-away-drop-out-orchestra-rework.jpg",
    },
    {
      name: "Get Away (Radio Edit)",
      slug: "lou-teti-get-away-radio-edit",
      image: "lou-teti-get-away-radio-edit.jpg",
    },
    {
      name: "I Know The Way (Cassian Dub Remix)",
      slug: "lou-teti-i-know-the-way-cassian-dub-remix",
      image: "lou-teti-i-know-the-way-cassian-dub-remix.jpg",
    },
    {
      name: "I Know The Way (Cassian Remix)",
      slug: "lou-teti-i-know-the-way-cassian-remix",
      image: "lou-teti-i-know-the-way-cassian-remix.jpg",
    },
    {
      name: "I Know The Way (Original)",
      slug: "lou-teti-i-know-the-way-original",
      image: "lou-teti-i-know-the-way-original.jpg",
    },
    {
      name: "In Six Months",
      slug: "lou-teti-in-six-months",
      image: "lou-teti-in-six-months.jpg",
    },
    {
      name: "Juno Lullaby",
      slug: "lou-teti-juno-lullaby",
      image: "lou-teti-juno-lullaby.jpg",
    },
    {
      name: "Runaway",
      slug: "lou-teti-runaway",
      image: "lou-teti-runaway.jpg",
    },
    {
      name: "Slow Jam",
      slug: "lou-teti-slow-jam",
      image: "lou-teti-slow-jam.jpg",
    },
    {
      name: "Talk About It (Pete Herbert Dub Remix)",
      slug: "lou-teti-talk-about-it-pete-herbert-dub-remix",
      image: "lou-teti-talk-about-it-pete-herbert-dub-remix.jpg",
    },
    {
      name: "Talk About It (Pete Herbert Remix)",
      slug: "lou-teti-talk-about-it-pete-herbert-remix",
      image: "lou-teti-talk-about-it-pete-herbert-remix.jpg",
    },
    {
      name: "Talk About It (Radio Version)",
      slug: "lou-teti-talk-about-it-radio-version",
      image: "lou-teti-talk-about-it-radio-version.jpg",
    },
    { name: "Wasted", slug: "lou-teti-wasted", image: "lou-teti-wasted.jpg" },
    {
      name: "What I Am",
      slug: "lou-teti-what-i-am",
      image: "lou-teti-what-i-am.jpg",
    },
  ],
  Silvervince: [
    {
      name: "Do The Chicken",
      slug: "silvervince-do-the-chicken",
      image: "silvervince-do-the-chicken.jpg",
    },
    {
      name: "Silverwaltz",
      slug: "silvervince-silverwaltz",
      image: "silvervince-silverwaltz.jpg",
    },
  ],
  "Julia Cinna": [
    {
      name: "Do What You Want",
      slug: "julia-cinna-do-what-you-want",
      image: "julia-cinna-do-what-you-want.jpg",
    },
  ],
  "Loolie and The Surfing Rogers": [
    {
      name: "Do You Understand",
      slug: "loolie-and-the-surfing-rogers-do-you-understand",
      image: "loolie-and-the-surfing-rogers-do-you-understand.jpg",
    },
    {
      name: "Take A Good Look",
      slug: "loolie-and-the-surfing-rogers-take-a-good-look",
      image: "loolie-and-the-surfing-rogers-take-a-good-look.jpg",
    },
    {
      name: "Tell Me Why",
      slug: "loolie-and-the-surfing-rogers-tell-me-why",
      image: "loolie-and-the-surfing-rogers-tell-me-why.jpg",
    },
  ],
  "Kool Bandits": [
    {
      name: "Do Yourself A Favour (Plaisir de France Remix)",
      slug: "kool-bandits-do-yourself-a-favour-plaisir-de-france-remix",
      image: "kool-bandits-do-yourself-a-favour-plaisir-de-france-remix.jpg",
    },
  ],
  "King Pug": [
    {
      name: "Dog Hair Blues Tape",
      slug: "king-pug-dog-hair-blues-tape",
      image: "king-pug-dog-hair-blues-tape.jpg",
    },
  ],
  "Casbah 73": [
    {
      name: "Doing Our Own Thing",
      slug: "casbah-73-doing-our-own-thing",
      image: "casbah-73-doing-our-own-thing.jpg",
    },
    {
      name: "Loves Saves The Day",
      slug: "casbah-73-loves-saves-the-day",
      image: "casbah-73-loves-saves-the-day.jpg",
    },
    {
      name: "Loves Saves The Day (Percussion Jam)",
      slug: "casbah-73-loves-saves-the-day-percussion-jam",
      image: "casbah-73-loves-saves-the-day-percussion-jam.jpg",
    },
    {
      name: "Loves Saves The Day (Rahaan Remix)",
      slug: "casbah-73-loves-saves-the-day-rahaan-remix",
      image: "casbah-73-loves-saves-the-day-rahaan-remix.jpg",
    },
    {
      name: "Sweet Maybe (Synthstrumental Mix)",
      slug: "casbah-73-sweet-maybe-synthstrumental-mix",
      image: "casbah-73-sweet-maybe-synthstrumental-mix.jpg",
    },
    {
      name: "Sweet Maybe feat. Bart Davenport",
      slug: "casbah-73-sweet-maybe-feat-bart-davenport",
      image: "casbah-73-sweet-maybe-feat-bart-davenport.jpg",
    },
    {
      name: "To Be Free",
      slug: "casbah-73-to-be-free",
      image: "casbah-73-to-be-free.jpg",
    },
  ],
  Ueberschalle: [
    {
      name: "Dolore",
      slug: "ueberschalle-dolore",
      image: "ueberschalle-dolore.jpg",
    },
    { name: "Ego", slug: "ueberschalle-ego", image: "ueberschalle-ego.jpg" },
  ],
  "Al Von Stramm": [
    {
      name: "Don't Really Care",
      slug: "al-von-stramm-don-t-really-care",
      image: "al-von-stramm-don-t-really-care.jpg",
    },
    {
      name: "Hey Come On!",
      slug: "al-von-stramm-hey-come-on",
      image: "al-von-stramm-hey-come-on.jpg",
    },
    {
      name: "I Heard A Story",
      slug: "al-von-stramm-i-heard-a-story",
      image: "al-von-stramm-i-heard-a-story.jpg",
    },
    {
      name: "Icecream , Aliens and Empty Bottles",
      slug: "al-von-stramm-icecream-aliens-and-empty-bottles",
      image: "al-von-stramm-icecream-aliens-and-empty-bottles.jpg",
    },
    {
      name: "See Daisy",
      slug: "al-von-stramm-see-daisy",
      image: "al-von-stramm-see-daisy.jpg",
    },
    {
      name: "You Know What",
      slug: "al-von-stramm-you-know-what",
      image: "al-von-stramm-you-know-what.jpg",
    },
  ],
  "Cheaper Shepherd": [
    {
      name: "Don't Stop",
      slug: "cheaper-shepherd-don-t-stop",
      image: "cheaper-shepherd-don-t-stop.jpg",
    },
    {
      name: "Fast Lane",
      slug: "cheaper-shepherd-fast-lane",
      image: "cheaper-shepherd-fast-lane.jpg",
    },
    {
      name: "Inner City feat. D.Johns and Brett Laffin",
      slug: "cheaper-shepherd-inner-city-feat-d-johns-and-brett-laffin",
      image: "cheaper-shepherd-inner-city-feat-d-johns-and-brett-laffin.jpg",
    },
    {
      name: "International Thug (Instrumental)",
      slug: "cheaper-shepherd-international-thug-instrumental",
      image: "cheaper-shepherd-international-thug-instrumental.jpg",
    },
    {
      name: "International Thug feat. York",
      slug: "cheaper-shepherd-international-thug-feat-york",
      image: "cheaper-shepherd-international-thug-feat-york.jpg",
    },
    {
      name: "Keep Up feat. D.Johns",
      slug: "cheaper-shepherd-keep-up-feat-d-johns",
      image: "cheaper-shepherd-keep-up-feat-d-johns.jpg",
    },
    {
      name: "Keep up (Instrumental)",
      slug: "cheaper-shepherd-keep-up-instrumental",
      image: "cheaper-shepherd-keep-up-instrumental.jpg",
    },
    {
      name: "Money Power Respect feat. D.Johns",
      slug: "cheaper-shepherd-money-power-respect-feat-d-johns",
      image: "cheaper-shepherd-money-power-respect-feat-d-johns.jpg",
    },
    {
      name: "No Time Off",
      slug: "cheaper-shepherd-no-time-off",
      image: "cheaper-shepherd-no-time-off.jpg",
    },
    {
      name: "Offline (Instrumental)",
      slug: "cheaper-shepherd-offline-instrumental",
      image: "cheaper-shepherd-offline-instrumental.jpg",
    },
    {
      name: "One Night Stand",
      slug: "cheaper-shepherd-one-night-stand",
      image: "cheaper-shepherd-one-night-stand.jpg",
    },
    {
      name: "Position feat. D.Johns",
      slug: "cheaper-shepherd-position-feat-d-johns",
      image: "cheaper-shepherd-position-feat-d-johns.jpg",
    },
    {
      name: "Ridin feat. York",
      slug: "cheaper-shepherd-ridin-feat-york",
      image: "cheaper-shepherd-ridin-feat-york.jpg",
    },
    {
      name: "T.C.P",
      slug: "cheaper-shepherd-t-c-p",
      image: "cheaper-shepherd-t-c-p.jpg",
    },
    {
      name: "TCP (Instrumental)",
      slug: "cheaper-shepherd-tcp-instrumental",
      image: "cheaper-shepherd-tcp-instrumental.jpg",
    },
    {
      name: "What's Next (Instrumental)",
      slug: "cheaper-shepherd-what-s-next-instrumental",
      image: "cheaper-shepherd-what-s-next-instrumental.jpg",
    },
    {
      name: "What's Next feat. Djohns",
      slug: "cheaper-shepherd-what-s-next-feat-djohns",
      image: "cheaper-shepherd-what-s-next-feat-djohns.jpg",
    },
  ],
  Dressel: [
    {
      name: "Dorian Landscape",
      slug: "dressel-dorian-landscape",
      image: "dressel-dorian-landscape.jpg",
    },
    {
      name: "Inside Outsight",
      slug: "dressel-inside-outsight",
      image: "dressel-inside-outsight.jpg",
    },
    {
      name: "Space Wave Shaft",
      slug: "dressel-space-wave-shaft",
      image: "dressel-space-wave-shaft.jpg",
    },
    {
      name: "Space Wave Shaft (Ma Spaventi Chill Mix)",
      slug: "dressel-space-wave-shaft-ma-spaventi-chill-mix",
      image: "dressel-space-wave-shaft-ma-spaventi-chill-mix.jpg",
    },
  ],
  Mazoulew: [
    {
      name: "Dot featuring Handbook",
      slug: "mazoulew-dot-featuring-handbook",
      image: "mazoulew-dot-featuring-handbook.jpg",
    },
  ],
  Weak: [
    {
      name: "Double Standard",
      slug: "weak-double-standard",
      image: "weak-double-standard.jpg",
    },
    { name: "I'm Lost", slug: "weak-i-m-lost", image: "weak-i-m-lost.jpg" },
    {
      name: "Intoxicated Society",
      slug: "weak-intoxicated-society",
      image: "weak-intoxicated-society.jpg",
    },
    {
      name: "Nothing But Numbers",
      slug: "weak-nothing-but-numbers",
      image: "weak-nothing-but-numbers.jpg",
    },
    {
      name: "Parachutes",
      slug: "weak-parachutes",
      image: "weak-parachutes.jpg",
    },
    { name: "Solitaire", slug: "weak-solitaire", image: "weak-solitaire.jpg" },
    {
      name: "Still Makes No Sense",
      slug: "weak-still-makes-no-sense",
      image: "weak-still-makes-no-sense.jpg",
    },
    { name: "The Wheel", slug: "weak-the-wheel", image: "weak-the-wheel.jpg" },
  ],
  "High Boys": [
    {
      name: "Down With Chaos",
      slug: "high-boys-down-with-chaos",
      image: "high-boys-down-with-chaos.jpg",
    },
  ],
  "Mel Alston Jr": [
    {
      name: "Dreamer",
      slug: "mel-alston-jr-dreamer",
      image: "mel-alston-jr-dreamer.jpg",
    },
  ],
  "Gregory Isaacs": [
    {
      name: "Dreaming",
      slug: "gregory-isaacs-dreaming",
      image: "gregory-isaacs-dreaming.jpg",
    },
    {
      name: "Lady Of Your Calibre",
      slug: "gregory-isaacs-lady-of-your-calibre",
      image: "gregory-isaacs-lady-of-your-calibre.jpg",
    },
  ],
  Guxi: [
    {
      name: "Dribbling Disco (Brioski Bonus Beat)",
      slug: "guxi-dribbling-disco-brioski-bonus-beat",
      image: "guxi-dribbling-disco-brioski-bonus-beat.jpg",
    },
    {
      name: "Dribbling Disco (Brioski Remix)",
      slug: "guxi-dribbling-disco-brioski-remix",
      image: "guxi-dribbling-disco-brioski-remix.jpg",
    },
  ],
  "Carmen Randria": [
    {
      name: "Drive In",
      slug: "carmen-randria-drive-in",
      image: "carmen-randria-drive-in.jpg",
    },
    {
      name: "Fool For You",
      slug: "carmen-randria-fool-for-you",
      image: "carmen-randria-fool-for-you.jpg",
    },
    {
      name: "Get Out",
      slug: "carmen-randria-get-out",
      image: "carmen-randria-get-out.jpg",
    },
    {
      name: "I Love You",
      slug: "carmen-randria-i-love-you",
      image: "carmen-randria-i-love-you.jpg",
    },
    {
      name: "Let Us Live",
      slug: "carmen-randria-let-us-live",
      image: "carmen-randria-let-us-live.jpg",
    },
    {
      name: "Love At The First Sight",
      slug: "carmen-randria-love-at-the-first-sight",
      image: "carmen-randria-love-at-the-first-sight.jpg",
    },
    {
      name: "Mama Told Me",
      slug: "carmen-randria-mama-told-me",
      image: "carmen-randria-mama-told-me.jpg",
    },
    {
      name: "Not Afraid To Love You",
      slug: "carmen-randria-not-afraid-to-love-you",
      image: "carmen-randria-not-afraid-to-love-you.jpg",
    },
    {
      name: "On My Own",
      slug: "carmen-randria-on-my-own",
      image: "carmen-randria-on-my-own.jpg",
    },
    {
      name: "Rough Out There",
      slug: "carmen-randria-rough-out-there",
      image: "carmen-randria-rough-out-there.jpg",
    },
    {
      name: "Sunny Rain",
      slug: "carmen-randria-sunny-rain",
      image: "carmen-randria-sunny-rain.jpg",
    },
    {
      name: "Take My Hand",
      slug: "carmen-randria-take-my-hand",
      image: "carmen-randria-take-my-hand.jpg",
    },
  ],
  Coupons: [
    {
      name: "Driving To Your Party (Jad And The Ladyboy Remix)",
      slug: "coupons-driving-to-your-party-jad-and-the-ladyboy-remix",
      image: "coupons-driving-to-your-party-jad-and-the-ladyboy-remix.jpg",
    },
    {
      name: "Driving To Your Party (Original)",
      slug: "coupons-driving-to-your-party-original",
      image: "coupons-driving-to-your-party-original.jpg",
    },
    {
      name: "Driving To Your Party (Xinobi Remix)",
      slug: "coupons-driving-to-your-party-xinobi-remix",
      image: "coupons-driving-to-your-party-xinobi-remix.jpg",
    },
  ],
  Demon: [
    { name: "Drocks", slug: "demon-drocks", image: "demon-drocks.jpg" },
    {
      name: "For Club's Sake (Demon Remix)",
      slug: "demon-for-club-s-sake-demon-remix",
      image: "demon-for-club-s-sake-demon-remix.jpg",
    },
    {
      name: "For Fuck's Sake",
      slug: "demon-for-fuck-s-sake",
      image: "demon-for-fuck-s-sake.jpg",
    },
    {
      name: "For Fuck's Sake (Mondkropf Remix)",
      slug: "demon-for-fuck-s-sake-mondkropf-remix",
      image: "demon-for-fuck-s-sake-mondkropf-remix.jpg",
    },
    {
      name: "Happy Therapy (Ari Remix)",
      slug: "demon-happy-therapy-ari-remix",
      image: "demon-happy-therapy-ari-remix.jpg",
    },
    { name: "I Think", slug: "demon-i-think", image: "demon-i-think.jpg" },
    {
      name: "I Think ( D.I.M Remix)",
      slug: "demon-i-think-d-i-m-remix",
      image: "demon-i-think-d-i-m-remix.jpg",
    },
    {
      name: "I Think ( Donovan Remix)",
      slug: "demon-i-think-donovan-remix",
      image: "demon-i-think-donovan-remix.jpg",
    },
    {
      name: "I Think (Crusz Remix)",
      slug: "demon-i-think-crusz-remix",
      image: "demon-i-think-crusz-remix.jpg",
    },
    {
      name: "I Think (Dex Pistols Remix)",
      slug: "demon-i-think-dex-pistols-remix",
      image: "demon-i-think-dex-pistols-remix.jpg",
    },
    {
      name: "I Think (Magnus Arw Remix)",
      slug: "demon-i-think-magnus-arw-remix",
      image: "demon-i-think-magnus-arw-remix.jpg",
    },
    {
      name: "I Think (Memory Tapes Remix)",
      slug: "demon-i-think-memory-tapes-remix",
      image: "demon-i-think-memory-tapes-remix.jpg",
    },
    {
      name: "Luanda City Beats ( PAT 404 Remix)",
      slug: "demon-luanda-city-beats-pat-404-remix",
      image: "demon-luanda-city-beats-pat-404-remix.jpg",
    },
    {
      name: "Luanda City Beats (Original)",
      slug: "demon-luanda-city-beats-original",
      image: "demon-luanda-city-beats-original.jpg",
    },
    {
      name: "Luanda City Beats (Tagteam Terror Remix)",
      slug: "demon-luanda-city-beats-tagteam-terror-remix",
      image: "demon-luanda-city-beats-tagteam-terror-remix.jpg",
    },
    {
      name: "Luanda City Beats (The Toxic Avenger Remix)",
      slug: "demon-luanda-city-beats-the-toxic-avenger-remix",
      image: "demon-luanda-city-beats-the-toxic-avenger-remix.jpg",
    },
    {
      name: "Music That You Wanna Hear",
      slug: "demon-music-that-you-wanna-hear",
      image: "demon-music-that-you-wanna-hear.jpg",
    },
    { name: "Shook", slug: "demon-shook", image: "demon-shook.jpg" },
    { name: "Thriller", slug: "demon-thriller", image: "demon-thriller.jpg" },
  ],
  "Robert Leiner": [
    {
      name: "Dromomania",
      slug: "robert-leiner-dromomania",
      image: "robert-leiner-dromomania.jpg",
    },
    {
      name: "Injected",
      slug: "robert-leiner-injected",
      image: "robert-leiner-injected.jpg",
    },
    {
      name: "Laniakea Part 1",
      slug: "robert-leiner-laniakea-part-1",
      image: "robert-leiner-laniakea-part-1.jpg",
    },
    {
      name: "Laniakea Part 2",
      slug: "robert-leiner-laniakea-part-2",
      image: "robert-leiner-laniakea-part-2.jpg",
    },
    {
      name: "Norma",
      slug: "robert-leiner-norma",
      image: "robert-leiner-norma.jpg",
    },
  ],
  Charonne: [
    {
      name: "Drop The Pain",
      slug: "charonne-drop-the-pain",
      image: "charonne-drop-the-pain.jpg",
    },
  ],
  "Sebastien Lété": [
    {
      name: "Drum Litle Solo 1",
      slug: "sebastien-lete-drum-litle-solo-1",
      image: "sebastien-lete-drum-litle-solo-1.jpg",
    },
    {
      name: "Drum Litle Solo 2",
      slug: "sebastien-lete-drum-litle-solo-2",
      image: "sebastien-lete-drum-litle-solo-2.jpg",
    },
    {
      name: "Drum Litle Solo 3",
      slug: "sebastien-lete-drum-litle-solo-3",
      image: "sebastien-lete-drum-litle-solo-3.jpg",
    },
    {
      name: "Drum Litle Solo 4",
      slug: "sebastien-lete-drum-litle-solo-4",
      image: "sebastien-lete-drum-litle-solo-4.jpg",
    },
    {
      name: "Drums Litle Solo 5",
      slug: "sebastien-lete-drums-litle-solo-5",
      image: "sebastien-lete-drums-litle-solo-5.jpg",
    },
    {
      name: "Drums Litle Solo 6",
      slug: "sebastien-lete-drums-litle-solo-6",
      image: "sebastien-lete-drums-litle-solo-6.jpg",
    },
  ],
  "Remi Parson": [
    {
      name: "Du Petrole (Instrumental)",
      slug: "remi-parson-du-petrole-instrumental",
      image: "remi-parson-du-petrole-instrumental.jpg",
    },
  ],
  Funboys: [
    {
      name: "Dum Dum Ehavi",
      slug: "funboys-dum-dum-ehavi",
      image: "funboys-dum-dum-ehavi.jpg",
    },
    {
      name: "That Guy",
      slug: "funboys-that-guy",
      image: "funboys-that-guy.jpg",
    },
  ],
  "Ena-N": [
    { name: "Dumb", slug: "ena-n-dumb", image: "ena-n-dumb.jpg" },
    { name: "Ena Top", slug: "ena-n-ena-top", image: "ena-n-ena-top.jpg" },
  ],
  Uran: [
    { name: "EMP", slug: "uran-emp", image: "uran-emp.jpg" },
    { name: "Onormal", slug: "uran-onormal", image: "uran-onormal.jpg" },
  ],
  "Rudolf Abramov": [
    {
      name: "Easy Boy",
      slug: "rudolf-abramov-easy-boy",
      image: "rudolf-abramov-easy-boy.jpg",
    },
    {
      name: "King Kong",
      slug: "rudolf-abramov-king-kong",
      image: "rudolf-abramov-king-kong.jpg",
    },
    {
      name: "Loch",
      slug: "rudolf-abramov-loch",
      image: "rudolf-abramov-loch.jpg",
    },
    {
      name: "Projekt 4",
      slug: "rudolf-abramov-projekt-4",
      image: "rudolf-abramov-projekt-4.jpg",
    },
    {
      name: "Rachmana Litzlan",
      slug: "rudolf-abramov-rachmana-litzlan",
      image: "rudolf-abramov-rachmana-litzlan.jpg",
    },
  ],
  Fabich: [
    {
      name: "Ecstasy feat. Bambie Thug",
      slug: "fabich-ecstasy-feat-bambie-thug",
      image: "fabich-ecstasy-feat-bambie-thug.jpg",
    },
    {
      name: "Hundred feat. Jae Fly & Shaefri",
      slug: "fabich-hundred-feat-jae-fly-and-shaefri",
      image: "fabich-hundred-feat-jae-fly-and-shaefri.jpg",
    },
    {
      name: "Lessons In Love feat. Bambie Thug",
      slug: "fabich-lessons-in-love-feat-bambie-thug",
      image: "fabich-lessons-in-love-feat-bambie-thug.jpg",
    },
    {
      name: "On My Mind feat. Poppy WS",
      slug: "fabich-on-my-mind-feat-poppy-ws",
      image: "fabich-on-my-mind-feat-poppy-ws.jpg",
    },
    {
      name: "Overtime feat. James Vickery",
      slug: "fabich-overtime-feat-james-vickery",
      image: "fabich-overtime-feat-james-vickery.jpg",
    },
  ],
  Bergi: [
    {
      name: "Edelweiss",
      slug: "bergi-edelweiss",
      image: "bergi-edelweiss.jpg",
    },
    {
      name: "Marbles Around The Light",
      slug: "bergi-marbles-around-the-light",
      image: "bergi-marbles-around-the-light.jpg",
    },
    {
      name: "The Bell Tolls For Hemingway",
      slug: "bergi-the-bell-tolls-for-hemingway",
      image: "bergi-the-bell-tolls-for-hemingway.jpg",
    },
  ],
  "Vicente Navarro": [
    {
      name: "El Afilador",
      slug: "vicente-navarro-el-afilador",
      image: "vicente-navarro-el-afilador.jpg",
    },
    {
      name: "El Puente",
      slug: "vicente-navarro-el-puente",
      image: "vicente-navarro-el-puente.jpg",
    },
    {
      name: "En El Río",
      slug: "vicente-navarro-en-el-rio",
      image: "vicente-navarro-en-el-rio.jpg",
    },
    {
      name: "Esternón",
      slug: "vicente-navarro-esternon",
      image: "vicente-navarro-esternon.jpg",
    },
    {
      name: "Las Montañas",
      slug: "vicente-navarro-las-montanas",
      image: "vicente-navarro-las-montanas.jpg",
    },
  ],
  Andy: [
    { name: "El Barrio", slug: "andy-el-barrio", image: "andy-el-barrio.jpg" },
    {
      name: "El Barrio (Jay Lamar and Jesse Oliver Remix)",
      slug: "andy-el-barrio-jay-lamar-and-jesse-oliver-remix",
      image: "andy-el-barrio-jay-lamar-and-jesse-oliver-remix.jpg",
    },
    {
      name: "El Barrio (The Supermen Lovers Remix)",
      slug: "andy-el-barrio-the-supermen-lovers-remix",
      image: "andy-el-barrio-the-supermen-lovers-remix.jpg",
    },
    { name: "Traffic", slug: "andy-traffic", image: "andy-traffic.jpg" },
  ],
  "Los Fulanos": [
    {
      name: "El Que No Esta Se Lo Pierde (More Disco Than Disco Version)",
      slug:
        "los-fulanos-el-que-no-esta-se-lo-pierde-more-disco-than-disco-version",
      image:
        "los-fulanos-el-que-no-esta-se-lo-pierde-more-disco-than-disco-version.jpg",
    },
    {
      name: "El Que No Esta Se Lo Pierde (Part 1)",
      slug: "los-fulanos-el-que-no-esta-se-lo-pierde-part-1",
      image: "los-fulanos-el-que-no-esta-se-lo-pierde-part-1.jpg",
    },
    {
      name: "El Que No Esta Se Lo Pierde (Part 2)",
      slug: "los-fulanos-el-que-no-esta-se-lo-pierde-part-2",
      image: "los-fulanos-el-que-no-esta-se-lo-pierde-part-2.jpg",
    },
    {
      name: "Fourty Five (FTM Remix)",
      slug: "los-fulanos-fourty-five-ftm-remix",
      image: "los-fulanos-fourty-five-ftm-remix.jpg",
    },
    {
      name: "Inspector Rodriguez",
      slug: "los-fulanos-inspector-rodriguez",
      image: "los-fulanos-inspector-rodriguez.jpg",
    },
    {
      name: "Kind Of Guy",
      slug: "los-fulanos-kind-of-guy",
      image: "los-fulanos-kind-of-guy.jpg",
    },
    {
      name: "Kind Of Guy (One Man Rework)",
      slug: "los-fulanos-kind-of-guy-one-man-rework",
      image: "los-fulanos-kind-of-guy-one-man-rework.jpg",
    },
    {
      name: "Manny",
      slug: "los-fulanos-manny",
      image: "los-fulanos-manny.jpg",
    },
    {
      name: "Prelude",
      slug: "los-fulanos-prelude",
      image: "los-fulanos-prelude.jpg",
    },
    {
      name: "Sobran Cueros",
      slug: "los-fulanos-sobran-cueros",
      image: "los-fulanos-sobran-cueros.jpg",
    },
    {
      name: "Sobran Cueros (Sabo Moombath Remix)",
      slug: "los-fulanos-sobran-cueros-sabo-moombath-remix",
      image: "los-fulanos-sobran-cueros-sabo-moombath-remix.jpg",
    },
    {
      name: "The End Of The World",
      slug: "los-fulanos-the-end-of-the-world",
      image: "los-fulanos-the-end-of-the-world.jpg",
    },
    {
      name: "Why Don't We Do Some Boogaloo?",
      slug: "los-fulanos-why-don-t-we-do-some-boogaloo",
      image: "los-fulanos-why-don-t-we-do-some-boogaloo.jpg",
    },
    {
      name: "You Know What I Mean",
      slug: "los-fulanos-you-know-what-i-mean",
      image: "los-fulanos-you-know-what-i-mean.jpg",
    },
  ],
  Radiofunkens: [
    {
      name: "El Turista Espacial",
      slug: "radiofunkens-el-turista-espacial",
      image: "radiofunkens-el-turista-espacial.jpg",
    },
    {
      name: "La Manzana",
      slug: "radiofunkens-la-manzana",
      image: "radiofunkens-la-manzana.jpg",
    },
    {
      name: "Sumatra",
      slug: "radiofunkens-sumatra",
      image: "radiofunkens-sumatra.jpg",
    },
    {
      name: "Verde",
      slug: "radiofunkens-verde",
      image: "radiofunkens-verde.jpg",
    },
  ],
  "Fabrizio Mammarella": [
    {
      name: "Elea",
      slug: "fabrizio-mammarella-elea",
      image: "fabrizio-mammarella-elea.jpg",
    },
  ],
  "Maxime Baudin": [
    {
      name: "Envolée",
      slug: "maxime-baudin-envolee",
      image: "maxime-baudin-envolee.jpg",
    },
    {
      name: "Interlude",
      slug: "maxime-baudin-interlude",
      image: "maxime-baudin-interlude.jpg",
    },
    {
      name: "La Réponse d'Elise",
      slug: "maxime-baudin-la-reponse-d-elise",
      image: "maxime-baudin-la-reponse-d-elise.jpg",
    },
    {
      name: "Obsession Part 1",
      slug: "maxime-baudin-obsession-part-1",
      image: "maxime-baudin-obsession-part-1.jpg",
    },
    {
      name: "Obsession Part 2",
      slug: "maxime-baudin-obsession-part-2",
      image: "maxime-baudin-obsession-part-2.jpg",
    },
    {
      name: "Odyssey Of Love",
      slug: "maxime-baudin-odyssey-of-love",
      image: "maxime-baudin-odyssey-of-love.jpg",
    },
    {
      name: "Prelude",
      slug: "maxime-baudin-prelude",
      image: "maxime-baudin-prelude.jpg",
    },
    {
      name: "Variation",
      slug: "maxime-baudin-variation",
      image: "maxime-baudin-variation.jpg",
    },
  ],
  Ved: [
    {
      name: "Erickson Indirect",
      slug: "ved-erickson-indirect",
      image: "ved-erickson-indirect.jpg",
    },
    { name: "Jakriborg", slug: "ved-jakriborg", image: "ved-jakriborg.jpg" },
    {
      name: "Looney Tubas",
      slug: "ved-looney-tubas",
      image: "ved-looney-tubas.jpg",
    },
    { name: "Neo Geo", slug: "ved-neo-geo", image: "ved-neo-geo.jpg" },
    { name: "Omikron", slug: "ved-omikron", image: "ved-omikron.jpg" },
    { name: "Univerb", slug: "ved-univerb", image: "ved-univerb.jpg" },
  ],
  "Rodion And Mammarella": [
    {
      name: "Escape From Kyoto",
      slug: "rodion-and-mammarella-escape-from-kyoto",
      image: "rodion-and-mammarella-escape-from-kyoto.jpg",
    },
    {
      name: "Escape From Kyoto (Alien Alien Remix)",
      slug: "rodion-and-mammarella-escape-from-kyoto-alien-alien-remix",
      image: "rodion-and-mammarella-escape-from-kyoto-alien-alien-remix.jpg",
    },
    {
      name: "Genziana",
      slug: "rodion-and-mammarella-genziana",
      image: "rodion-and-mammarella-genziana.jpg",
    },
    {
      name: "Inner Outer",
      slug: "rodion-and-mammarella-inner-outer",
      image: "rodion-and-mammarella-inner-outer.jpg",
    },
    {
      name: "Majella",
      slug: "rodion-and-mammarella-majella",
      image: "rodion-and-mammarella-majella.jpg",
    },
  ],
  Runa: [
    {
      name: "Espiritu Mesetario",
      slug: "runa-espiritu-mesetario",
      image: "runa-espiritu-mesetario.jpg",
    },
    {
      name: "La Defensiva",
      slug: "runa-la-defensiva",
      image: "runa-la-defensiva.jpg",
    },
    {
      name: "La Ofensiva",
      slug: "runa-la-ofensiva",
      image: "runa-la-ofensiva.jpg",
    },
    {
      name: "Mar de Discordias",
      slug: "runa-mar-de-discordias",
      image: "runa-mar-de-discordias.jpg",
    },
    {
      name: "Nueva Realidad",
      slug: "runa-nueva-realidad",
      image: "runa-nueva-realidad.jpg",
    },
    {
      name: "Revoluciones Fugaces",
      slug: "runa-revoluciones-fugaces",
      image: "runa-revoluciones-fugaces.jpg",
    },
    {
      name: "Rito Estacional",
      slug: "runa-rito-estacional",
      image: "runa-rito-estacional.jpg",
    },
    {
      name: "Rizoma de Culpa",
      slug: "runa-rizoma-de-culpa",
      image: "runa-rizoma-de-culpa.jpg",
    },
    {
      name: "Silencios Por Tratar",
      slug: "runa-silencios-por-tratar",
      image: "runa-silencios-por-tratar.jpg",
    },
  ],
  Elora: [
    { name: "Espora", slug: "elora-espora", image: "elora-espora.jpg" },
    { name: "Fuego", slug: "elora-fuego", image: "elora-fuego.jpg" },
    {
      name: "Hay Tigres en mi jardin",
      slug: "elora-hay-tigres-en-mi-jardin",
      image: "elora-hay-tigres-en-mi-jardin.jpg",
    },
    { name: "Pez", slug: "elora-pez", image: "elora-pez.jpg" },
    {
      name: "Solo tú sabes",
      slug: "elora-solo-tu-sabes",
      image: "elora-solo-tu-sabes.jpg",
    },
  ],
  Douze: [
    {
      name: "Eternity's Call (Blende Remix)",
      slug: "douze-eternity-s-call-blende-remix",
      image: "douze-eternity-s-call-blende-remix.jpg",
    },
    {
      name: "Les Paradis Artificiels",
      slug: "douze-les-paradis-artificiels",
      image: "douze-les-paradis-artificiels.jpg",
    },
  ],
  Justine: [
    { name: "Etrange", slug: "justine-etrange", image: "justine-etrange.jpg" },
    {
      name: "Orient Express",
      slug: "justine-orient-express",
      image: "justine-orient-express.jpg",
    },
    {
      name: "Teeth Are Falling",
      slug: "justine-teeth-are-falling",
      image: "justine-teeth-are-falling.jpg",
    },
  ],
  Apeiron: [
    {
      name: "Exdespacio",
      slug: "apeiron-exdespacio",
      image: "apeiron-exdespacio.jpg",
    },
  ],
  Trees: [
    { name: "Exodus", slug: "trees-exodus", image: "trees-exodus.jpg" },
    {
      name: "Get Advanced",
      slug: "trees-get-advanced",
      image: "trees-get-advanced.jpg",
    },
    { name: "Rootwork", slug: "trees-rootwork", image: "trees-rootwork.jpg" },
    {
      name: "Rootwork (Dj F Restructure)",
      slug: "trees-rootwork-dj-f-restructure",
      image: "trees-rootwork-dj-f-restructure.jpg",
    },
    {
      name: "What's Left",
      slug: "trees-what-s-left",
      image: "trees-what-s-left.jpg",
    },
    {
      name: "What's Left (Shigeto Extended Remix)",
      slug: "trees-what-s-left-shigeto-extended-remix",
      image: "trees-what-s-left-shigeto-extended-remix.jpg",
    },
  ],
  "I Me Mine": [
    {
      name: "Expectations feat. General Elektriks",
      slug: "i-me-mine-expectations-feat-general-elektriks",
      image: "i-me-mine-expectations-feat-general-elektriks.jpg",
    },
    { name: "Once", slug: "i-me-mine-once", image: "i-me-mine-once.jpg" },
  ],
  "Monsieur et Madame": [
    {
      name: "Extasia",
      slug: "monsieur-et-madame-extasia",
      image: "monsieur-et-madame-extasia.jpg",
    },
    {
      name: "Hit Loves In Bossanova",
      slug: "monsieur-et-madame-hit-loves-in-bossanova",
      image: "monsieur-et-madame-hit-loves-in-bossanova.jpg",
    },
    {
      name: "Je n'ai pas le temps de m'ennuyer",
      slug: "monsieur-et-madame-je-n-ai-pas-le-temps-de-m-ennuyer",
      image: "monsieur-et-madame-je-n-ai-pas-le-temps-de-m-ennuyer.jpg",
    },
    {
      name: "Mer Plate",
      slug: "monsieur-et-madame-mer-plate",
      image: "monsieur-et-madame-mer-plate.jpg",
    },
    {
      name: "Sabo et Moi",
      slug: "monsieur-et-madame-sabo-et-moi",
      image: "monsieur-et-madame-sabo-et-moi.jpg",
    },
    {
      name: "Sexy Guy",
      slug: "monsieur-et-madame-sexy-guy",
      image: "monsieur-et-madame-sexy-guy.jpg",
    },
  ],
  "Roe Deers & Curses": [
    {
      name: "Fade Away",
      slug: "roe-deers-and-curses-fade-away",
      image: "roe-deers-and-curses-fade-away.jpg",
    },
    {
      name: "Fade Away (Jonathan Kusuma Remix)",
      slug: "roe-deers-and-curses-fade-away-jonathan-kusuma-remix",
      image: "roe-deers-and-curses-fade-away-jonathan-kusuma-remix.jpg",
    },
    {
      name: "To The End",
      slug: "roe-deers-and-curses-to-the-end",
      image: "roe-deers-and-curses-to-the-end.jpg",
    },
  ],
  "Arigato Massai": [
    {
      name: "Faded Love feat. Hayley Tapp",
      slug: "arigato-massai-faded-love-feat-hayley-tapp",
      image: "arigato-massai-faded-love-feat-hayley-tapp.jpg",
    },
    {
      name: "Hayley feat. Fannie Lineros",
      slug: "arigato-massai-hayley-feat-fannie-lineros",
      image: "arigato-massai-hayley-feat-fannie-lineros.jpg",
    },
    {
      name: "No Matter What",
      slug: "arigato-massai-no-matter-what",
      image: "arigato-massai-no-matter-what.jpg",
    },
    {
      name: "Shut Up",
      slug: "arigato-massai-shut-up",
      image: "arigato-massai-shut-up.jpg",
    },
    {
      name: "We Love feat. Fannie Lineros",
      slug: "arigato-massai-we-love-feat-fannie-lineros",
      image: "arigato-massai-we-love-feat-fannie-lineros.jpg",
    },
  ],
  "System Olympia": [
    {
      name: "Falling In Love",
      slug: "system-olympia-falling-in-love",
      image: "system-olympia-falling-in-love.jpg",
    },
    {
      name: "Falling In Love (Instrumental)",
      slug: "system-olympia-falling-in-love-instrumental",
      image: "system-olympia-falling-in-love-instrumental.jpg",
    },
    {
      name: "Mystified",
      slug: "system-olympia-mystified",
      image: "system-olympia-mystified.jpg",
    },
    {
      name: "Scandalous",
      slug: "system-olympia-scandalous",
      image: "system-olympia-scandalous.jpg",
    },
  ],
  Corcs: [
    {
      name: "Families Trencades",
      slug: "corcs-families-trencades",
      image: "corcs-families-trencades.jpg",
    },
    {
      name: "Firma Aqui",
      slug: "corcs-firma-aqui",
      image: "corcs-firma-aqui.jpg",
    },
    {
      name: "Fix It And Carry On",
      slug: "corcs-fix-it-and-carry-on",
      image: "corcs-fix-it-and-carry-on.jpg",
    },
    {
      name: "Jackie Mittoo Has A Spam Message In His Inbox",
      slug: "corcs-jackie-mittoo-has-a-spam-message-in-his-inbox",
      image: "corcs-jackie-mittoo-has-a-spam-message-in-his-inbox.jpg",
    },
    {
      name: "Llapits I Paper",
      slug: "corcs-llapits-i-paper",
      image: "corcs-llapits-i-paper.jpg",
    },
    {
      name: "Mel Al Pot",
      slug: "corcs-mel-al-pot",
      image: "corcs-mel-al-pot.jpg",
    },
    {
      name: "No Cal Tornar Sempre A Casa",
      slug: "corcs-no-cal-tornar-sempre-a-casa",
      image: "corcs-no-cal-tornar-sempre-a-casa.jpg",
    },
    {
      name: "Penjant D'Un Fil D'Estany",
      slug: "corcs-penjant-d-un-fil-d-estany",
      image: null,
    },
    {
      name: "Pere Meets The Llop",
      slug: "corcs-pere-meets-the-llop",
      image: "corcs-pere-meets-the-llop.jpg",
    },
    {
      name: "Qua Tal Si Deixem De Guardar Les Cebes...",
      slug: "corcs-qua-tal-si-deixem-de-guardar-les-cebes",
      image: null,
    },
    {
      name: "Tic De Castells",
      slug: "corcs-tic-de-castells",
      image: "corcs-tic-de-castells.jpg",
    },
  ],
  G23: [
    { name: "Famille", slug: "g23-famille", image: "g23-famille.jpg" },
    { name: "Febbraio", slug: "g23-febbraio", image: "g23-febbraio.jpg" },
    {
      name: "Ianuarii Ira",
      slug: "g23-ianuarii-ira",
      image: "g23-ianuarii-ira.jpg",
    },
    { name: "Les Ruines", slug: "g23-les-ruines", image: "g23-les-ruines.jpg" },
    {
      name: "Lune Intermittente",
      slug: "g23-lune-intermittente",
      image: "g23-lune-intermittente.jpg",
    },
    { name: "Mains", slug: "g23-mains", image: "g23-mains.jpg" },
    {
      name: "Metal , Plastic and Wood",
      slug: "g23-metal-plastic-and-wood",
      image: "g23-metal-plastic-and-wood.jpg",
    },
    {
      name: "Shaolin Temperature",
      slug: "g23-shaolin-temperature",
      image: "g23-shaolin-temperature.jpg",
    },
    {
      name: "Sweat and Tears",
      slug: "g23-sweat-and-tears",
      image: "g23-sweat-and-tears.jpg",
    },
  ],
  "Discotexas Band": [
    {
      name: "Family Affair",
      slug: "discotexas-band-family-affair",
      image: "discotexas-band-family-affair.jpg",
    },
    {
      name: "Family Affair (Instrumental)",
      slug: "discotexas-band-family-affair-instrumental",
      image: "discotexas-band-family-affair-instrumental.jpg",
    },
  ],
  "Fantastic Mister Zguy": [
    {
      name: "Fantastic Doesn't Have An Electric Guitar",
      slug: "fantastic-mister-zguy-fantastic-doesn-t-have-an-electric-guitar",
      image:
        "fantastic-mister-zguy-fantastic-doesn-t-have-an-electric-guitar.jpg",
    },
    {
      name: "It's Always The Same",
      slug: "fantastic-mister-zguy-it-s-always-the-same",
      image: "fantastic-mister-zguy-it-s-always-the-same.jpg",
    },
    {
      name: "Tropical Truit",
      slug: "fantastic-mister-zguy-tropical-truit",
      image: "fantastic-mister-zguy-tropical-truit.jpg",
    },
    {
      name: "Z That's My Letter",
      slug: "fantastic-mister-zguy-z-that-s-my-letter",
      image: "fantastic-mister-zguy-z-that-s-my-letter.jpg",
    },
    {
      name: "Zguy And The Doctor",
      slug: "fantastic-mister-zguy-zguy-and-the-doctor",
      image: "fantastic-mister-zguy-zguy-and-the-doctor.jpg",
    },
    {
      name: "Zguy On The Silk Road",
      slug: "fantastic-mister-zguy-zguy-on-the-silk-road",
      image: "fantastic-mister-zguy-zguy-on-the-silk-road.jpg",
    },
  ],
  "French Masterz": [
    {
      name: "Fantasy",
      slug: "french-masterz-fantasy",
      image: "french-masterz-fantasy.jpg",
    },
  ],
  "Pardon Moi": [
    {
      name: "Faster Moving Traffic",
      slug: "pardon-moi-faster-moving-traffic",
      image: "pardon-moi-faster-moving-traffic.jpg",
    },
    {
      name: "Happy Song",
      slug: "pardon-moi-happy-song",
      image: "pardon-moi-happy-song.jpg",
    },
    {
      name: "Happy Song (Daniel Monaco Remix)",
      slug: "pardon-moi-happy-song-daniel-monaco-remix",
      image: "pardon-moi-happy-song-daniel-monaco-remix.jpg",
    },
    {
      name: "Power To The People",
      slug: "pardon-moi-power-to-the-people",
      image: "pardon-moi-power-to-the-people.jpg",
    },
    {
      name: "Rodeo Star",
      slug: "pardon-moi-rodeo-star",
      image: "pardon-moi-rodeo-star.jpg",
    },
    {
      name: "Rodeo Star (Franz Scala Remix)",
      slug: "pardon-moi-rodeo-star-franz-scala-remix",
      image: "pardon-moi-rodeo-star-franz-scala-remix.jpg",
    },
    {
      name: "The Camera Loves You",
      slug: "pardon-moi-the-camera-loves-you",
      image: "pardon-moi-the-camera-loves-you.jpg",
    },
    {
      name: "Touch 2 Much",
      slug: "pardon-moi-touch-2-much",
      image: "pardon-moi-touch-2-much.jpg",
    },
  ],
  "Dulce Pajara De Juventud": [
    {
      name: "Feel",
      slug: "dulce-pajara-de-juventud-feel",
      image: "dulce-pajara-de-juventud-feel.jpg",
    },
  ],
  Xad: [
    { name: "Feel Good", slug: "xad-feel-good", image: "xad-feel-good.jpg" },
    { name: "Morning", slug: "xad-morning", image: "xad-morning.jpg" },
  ],
  Ricca: [
    {
      name: "Feeling Good",
      slug: "ricca-feeling-good",
      image: "ricca-feeling-good.jpg",
    },
    { name: "Morning", slug: "ricca-morning", image: "ricca-morning.jpg" },
    { name: "Running", slug: "ricca-running", image: "ricca-running.jpg" },
  ],
  Timing: [
    {
      name: "Feeling Strong",
      slug: "timing-feeling-strong",
      image: "timing-feeling-strong.jpg",
    },
    {
      name: "Formentera",
      slug: "timing-formentera",
      image: "timing-formentera.jpg",
    },
    { name: "Illusion", slug: "timing-illusion", image: "timing-illusion.jpg" },
  ],
  Krater: [
    {
      name: "Felix Culpa",
      slug: "krater-felix-culpa",
      image: "krater-felix-culpa.jpg",
    },
    { name: "Labyrint", slug: "krater-labyrint", image: "krater-labyrint.jpg" },
  ],
  Aleem: [
    {
      name: "Felix Yo ! (Figueretas Remix)",
      slug: "aleem-felix-yo-figueretas-remix",
      image: "aleem-felix-yo-figueretas-remix.jpg",
    },
    {
      name: "Un Si Beau Dimanche",
      slug: "aleem-un-si-beau-dimanche",
      image: "aleem-un-si-beau-dimanche.jpg",
    },
  ],
  "Sam Plays": [
    { name: "Fiesta", slug: "sam-plays-fiesta", image: "sam-plays-fiesta.jpg" },
  ],
  Yeuz: [
    { name: "Find It", slug: "yeuz-find-it", image: "yeuz-find-it.jpg" },
    { name: "Global", slug: "yeuz-global", image: "yeuz-global.jpg" },
    { name: "PCM", slug: "yeuz-pcm", image: "yeuz-pcm.jpg" },
    { name: "Spare", slug: "yeuz-spare", image: "yeuz-spare.jpg" },
    { name: "Storm", slug: "yeuz-storm", image: "yeuz-storm.jpg" },
    { name: "Wave", slug: "yeuz-wave", image: "yeuz-wave.jpg" },
  ],
  Heymoonshaker: [
    {
      name: "Find Myself A Home",
      slug: "heymoonshaker-find-myself-a-home",
      image: "heymoonshaker-find-myself-a-home.jpg",
    },
  ],
  Meera: [
    {
      name: "Fine Without You",
      slug: "meera-fine-without-you",
      image: "meera-fine-without-you.jpg",
    },
    {
      name: "Little Of Your Time",
      slug: "meera-little-of-your-time",
      image: "meera-little-of-your-time.jpg",
    },
    {
      name: "Think Straight",
      slug: "meera-think-straight",
      image: "meera-think-straight.jpg",
    },
  ],
  "Dunny Brazz": [
    {
      name: "Finish Line",
      slug: "dunny-brazz-finish-line",
      image: "dunny-brazz-finish-line.jpg",
    },
    {
      name: "I'm a Hitta",
      slug: "dunny-brazz-i-m-a-hitta",
      image: "dunny-brazz-i-m-a-hitta.jpg",
    },
  ],
  Snail: [
    {
      name: "Fire Plane Planet",
      slug: "snail-fire-plane-planet",
      image: "snail-fire-plane-planet.jpg",
    },
    {
      name: "Melvin's Mop",
      slug: "snail-melvin-s-mop",
      image: "snail-melvin-s-mop.jpg",
    },
    {
      name: "Oyasumi Hiroshi San",
      slug: "snail-oyasumi-hiroshi-san",
      image: "snail-oyasumi-hiroshi-san.jpg",
    },
    {
      name: "Stratofighter Blip Blip",
      slug: "snail-stratofighter-blip-blip",
      image: "snail-stratofighter-blip-blip.jpg",
    },
  ],
  "Will Samson": [
    {
      name: "Flow,The Moon",
      slug: "will-samson-flow-the-moon",
      image: "will-samson-flow-the-moon.jpg",
    },
    {
      name: "Forestry (Day Four)",
      slug: "will-samson-forestry-day-four",
      image: "will-samson-forestry-day-four.jpg",
    },
    {
      name: "Ground Luminosity",
      slug: "will-samson-ground-luminosity",
      image: "will-samson-ground-luminosity.jpg",
    },
    {
      name: "Night Canyon",
      slug: "will-samson-night-canyon",
      image: "will-samson-night-canyon.jpg",
    },
    {
      name: "Pyrton Bells",
      slug: "will-samson-pyrton-bells",
      image: "will-samson-pyrton-bells.jpg",
    },
    {
      name: "Shimmer (Day Two)",
      slug: "will-samson-shimmer-day-two",
      image: "will-samson-shimmer-day-two.jpg",
    },
    {
      name: "Sunbeamer Part1",
      slug: "will-samson-sunbeamer-part1",
      image: "will-samson-sunbeamer-part1.jpg",
    },
    {
      name: "Suspended",
      slug: "will-samson-suspended",
      image: "will-samson-suspended.jpg",
    },
    {
      name: "Tumble",
      slug: "will-samson-tumble",
      image: "will-samson-tumble.jpg",
    },
    {
      name: "When I Was A Mountain",
      slug: "will-samson-when-i-was-a-mountain",
      image: "will-samson-when-i-was-a-mountain.jpg",
    },
  ],
  Plum: [
    { name: "Flower", slug: "plum-flower", image: "plum-flower.jpg" },
    { name: "Help Me", slug: "plum-help-me", image: "plum-help-me.jpg" },
    { name: "Memphis", slug: "plum-memphis", image: "plum-memphis.jpg" },
    { name: "My Love", slug: "plum-my-love", image: "plum-my-love.jpg" },
    { name: "Old Love", slug: "plum-old-love", image: "plum-old-love.jpg" },
    { name: "Old Love (Edit)", slug: "plum-old-love-edit", image: null },
    { name: "Play me", slug: "plum-play-me", image: "plum-play-me.jpg" },
    { name: "Sensation", slug: "plum-sensation", image: "plum-sensation.jpg" },
  ],
  "Magic Pop Hotel": [
    {
      name: "Flowers",
      slug: "magic-pop-hotel-flowers",
      image: "magic-pop-hotel-flowers.jpg",
    },
    {
      name: "How Deep Is My Love",
      slug: "magic-pop-hotel-how-deep-is-my-love",
      image: "magic-pop-hotel-how-deep-is-my-love.jpg",
    },
    {
      name: "Into The Wild",
      slug: "magic-pop-hotel-into-the-wild",
      image: "magic-pop-hotel-into-the-wild.jpg",
    },
    {
      name: "Magical Garden",
      slug: "magic-pop-hotel-magical-garden",
      image: "magic-pop-hotel-magical-garden.jpg",
    },
    {
      name: "Part Of My Life",
      slug: "magic-pop-hotel-part-of-my-life",
      image: "magic-pop-hotel-part-of-my-life.jpg",
    },
    {
      name: "Shamelessness",
      slug: "magic-pop-hotel-shamelessness",
      image: "magic-pop-hotel-shamelessness.jpg",
    },
    {
      name: "Sleeping",
      slug: "magic-pop-hotel-sleeping",
      image: "magic-pop-hotel-sleeping.jpg",
    },
    {
      name: "Sweet Smelling Night",
      slug: "magic-pop-hotel-sweet-smelling-night",
      image: "magic-pop-hotel-sweet-smelling-night.jpg",
    },
    {
      name: "You Work It Out",
      slug: "magic-pop-hotel-you-work-it-out",
      image: "magic-pop-hotel-you-work-it-out.jpg",
    },
    {
      name: "Your Smile",
      slug: "magic-pop-hotel-your-smile",
      image: "magic-pop-hotel-your-smile.jpg",
    },
  ],
  "Funkmaster Ozone": [
    {
      name: "Freakazoids Groove",
      slug: "funkmaster-ozone-freakazoids-groove",
      image: "funkmaster-ozone-freakazoids-groove.jpg",
    },
  ],
  "Philosophy Of Sound": [
    {
      name: "Freedom,What For (A.N.D.Y Remix)",
      slug: "philosophy-of-sound-freedom-what-for-a-n-d-y-remix",
      image: "philosophy-of-sound-freedom-what-for-a-n-d-y-remix.jpg",
    },
    {
      name: "Freedom,What For (Tonik Youth Remix)",
      slug: "philosophy-of-sound-freedom-what-for-tonik-youth-remix",
      image: "philosophy-of-sound-freedom-what-for-tonik-youth-remix.jpg",
    },
    {
      name: "It Is Like That (Ilya Santana Bizzaro Disco Mix)",
      slug:
        "philosophy-of-sound-it-is-like-that-ilya-santana-bizzaro-disco-mix",
      image:
        "philosophy-of-sound-it-is-like-that-ilya-santana-bizzaro-disco-mix.jpg",
    },
    {
      name: "It Is Like That (Instrumental)",
      slug: "philosophy-of-sound-it-is-like-that-instrumental",
      image: "philosophy-of-sound-it-is-like-that-instrumental.jpg",
    },
    {
      name: "It Is Like That (Radio Edit)",
      slug: "philosophy-of-sound-it-is-like-that-radio-edit",
      image: "philosophy-of-sound-it-is-like-that-radio-edit.jpg",
    },
  ],
  Aphonia: [
    {
      name: "From A to B",
      slug: "aphonia-from-a-to-b",
      image: "aphonia-from-a-to-b.jpg",
    },
    {
      name: "From A to B (Franz Scala Remix)",
      slug: "aphonia-from-a-to-b-franz-scala-remix",
      image: "aphonia-from-a-to-b-franz-scala-remix.jpg",
    },
    {
      name: "From A to B (Kris Baha Remix)",
      slug: "aphonia-from-a-to-b-kris-baha-remix",
      image: "aphonia-from-a-to-b-kris-baha-remix.jpg",
    },
  ],
  Carontte: [
    {
      name: "From Red Horizons",
      slug: "carontte-from-red-horizons",
      image: "carontte-from-red-horizons.jpg",
    },
  ],
  Naufragi: [
    {
      name: "Gahinga",
      slug: "naufragi-gahinga",
      image: "naufragi-gahinga.jpg",
    },
  ],
  Sacre: [{ name: "Gaia", slug: "sacre-gaia", image: "sacre-gaia.jpg" }],
  "Space Ranger": [
    {
      name: "Galactic Spice",
      slug: "space-ranger-galactic-spice",
      image: "space-ranger-galactic-spice.jpg",
    },
    {
      name: "Nightmoves",
      slug: "space-ranger-nightmoves",
      image: "space-ranger-nightmoves.jpg",
    },
    {
      name: "Superstring (Rayko Remix)",
      slug: "space-ranger-superstring-rayko-remix",
      image: "space-ranger-superstring-rayko-remix.jpg",
    },
  ],
  Laish: [
    { name: "Gambling", slug: "laish-gambling", image: "laish-gambling.jpg" },
    {
      name: "Isolation",
      slug: "laish-isolation",
      image: "laish-isolation.jpg",
    },
    {
      name: "Learning to Love The Bomb",
      slug: "laish-learning-to-love-the-bomb",
      image: "laish-learning-to-love-the-bomb.jpg",
    },
    {
      name: "Love On The Conditional",
      slug: "laish-love-on-the-conditional",
      image: "laish-love-on-the-conditional.jpg",
    },
    {
      name: "My Litle Prince",
      slug: "laish-my-litle-prince",
      image: "laish-my-litle-prince.jpg",
    },
    {
      name: "Pendelum Swing",
      slug: "laish-pendelum-swing",
      image: "laish-pendelum-swing.jpg",
    },
    {
      name: "Rattling Around",
      slug: "laish-rattling-around",
      image: "laish-rattling-around.jpg",
    },
    {
      name: "Song For Everything",
      slug: "laish-song-for-everything",
      image: "laish-song-for-everything.jpg",
    },
    {
      name: "The Last Time",
      slug: "laish-the-last-time",
      image: "laish-the-last-time.jpg",
    },
    { name: "Vague", slug: "laish-vague", image: "laish-vague.jpg" },
    {
      name: "We Haven't Made Any Money",
      slug: "laish-we-haven-t-made-any-money",
      image: "laish-we-haven-t-made-any-money.jpg",
    },
    {
      name: "Wrote Of Freedom",
      slug: "laish-wrote-of-freedom",
      image: "laish-wrote-of-freedom.jpg",
    },
  ],
  "Bouncer Crew": [
    {
      name: "Ganjaman",
      slug: "bouncer-crew-ganjaman",
      image: "bouncer-crew-ganjaman.jpg",
    },
  ],
  "The Lifers": [
    {
      name: "Garden Of Fever",
      slug: "the-lifers-garden-of-fever",
      image: "the-lifers-garden-of-fever.jpg",
    },
  ],
  "Jon Keliehor": [
    {
      name: "Gateway to the Celestial Ocean",
      slug: "jon-keliehor-gateway-to-the-celestial-ocean",
      image: "jon-keliehor-gateway-to-the-celestial-ocean.jpg",
    },
    {
      name: "Night of the Equinox",
      slug: "jon-keliehor-night-of-the-equinox",
      image: "jon-keliehor-night-of-the-equinox.jpg",
    },
    {
      name: "Per Neter II",
      slug: "jon-keliehor-per-neter-ii",
      image: "jon-keliehor-per-neter-ii.jpg",
    },
    {
      name: "Temple of the Net",
      slug: "jon-keliehor-temple-of-the-net",
      image: "jon-keliehor-temple-of-the-net.jpg",
    },
    {
      name: "The Beginning Of Time",
      slug: "jon-keliehor-the-beginning-of-time",
      image: "jon-keliehor-the-beginning-of-time.jpg",
    },
    {
      name: "The Memory Of Water",
      slug: "jon-keliehor-the-memory-of-water",
      image: "jon-keliehor-the-memory-of-water.jpg",
    },
  ],
  "The Right Ons": [
    {
      name: "Get Back",
      slug: "the-right-ons-get-back",
      image: "the-right-ons-get-back.jpg",
    },
    {
      name: "Get Back (Instrumental)",
      slug: "the-right-ons-get-back-instrumental",
      image: "the-right-ons-get-back-instrumental.jpg",
    },
    {
      name: "I Do What I Want",
      slug: "the-right-ons-i-do-what-i-want",
      image: "the-right-ons-i-do-what-i-want.jpg",
    },
    {
      name: "I Do What I Want (Instrumental)",
      slug: "the-right-ons-i-do-what-i-want-instrumental",
      image: "the-right-ons-i-do-what-i-want-instrumental.jpg",
    },
    {
      name: "I Do What I Want To Do (Emperor Machine Remix)",
      slug: "the-right-ons-i-do-what-i-want-to-do-emperor-machine-remix",
      image: "the-right-ons-i-do-what-i-want-to-do-emperor-machine-remix.jpg",
    },
    {
      name: "Long Road",
      slug: "the-right-ons-long-road",
      image: "the-right-ons-long-road.jpg",
    },
    {
      name: "Long Road (Instrumental)",
      slug: "the-right-ons-long-road-instrumental",
      image: "the-right-ons-long-road-instrumental.jpg",
    },
    {
      name: "On The Radio",
      slug: "the-right-ons-on-the-radio",
      image: "the-right-ons-on-the-radio.jpg",
    },
    {
      name: "On The Radio (Instrumental)",
      slug: "the-right-ons-on-the-radio-instrumental",
      image: "the-right-ons-on-the-radio-instrumental.jpg",
    },
    {
      name: "Purple Neon Lights",
      slug: "the-right-ons-purple-neon-lights",
      image: "the-right-ons-purple-neon-lights.jpg",
    },
    {
      name: "Purple Neon Lights (Instrumental)",
      slug: "the-right-ons-purple-neon-lights-instrumental",
      image: "the-right-ons-purple-neon-lights-instrumental.jpg",
    },
    {
      name: "Purple Neon Lights (Telonius Remix)",
      slug: "the-right-ons-purple-neon-lights-telonius-remix",
      image: "the-right-ons-purple-neon-lights-telonius-remix.jpg",
    },
    {
      name: "There She Goes",
      slug: "the-right-ons-there-she-goes",
      image: "the-right-ons-there-she-goes.jpg",
    },
    {
      name: "There She Goes (Instrumental)",
      slug: "the-right-ons-there-she-goes-instrumental",
      image: "the-right-ons-there-she-goes-instrumental.jpg",
    },
    {
      name: "Time Will Tell",
      slug: "the-right-ons-time-will-tell",
      image: "the-right-ons-time-will-tell.jpg",
    },
    {
      name: "Time Will Tell (Instrumental)",
      slug: "the-right-ons-time-will-tell-instrumental",
      image: "the-right-ons-time-will-tell-instrumental.jpg",
    },
  ],
  "From The Bush": [
    { name: "Get By", slug: "from-the-bush-get-by", image: null },
    { name: "Omni Wish", slug: "from-the-bush-omni-wish", image: null },
    {
      name: "Soul Saint Ouen",
      slug: "from-the-bush-soul-saint-ouen",
      image: null,
    },
    { name: "Supreme Shit", slug: "from-the-bush-supreme-shit", image: null },
  ],
  "Justin Faust": [
    {
      name: "Get Down (Original)",
      slug: "justin-faust-get-down-original",
      image: "justin-faust-get-down-original.jpg",
    },
    {
      name: "Girl Talk (Bit Funk Remix)",
      slug: "justin-faust-girl-talk-bit-funk-remix",
      image: "justin-faust-girl-talk-bit-funk-remix.jpg",
    },
    {
      name: "Girl Talk (Gloves Remix)",
      slug: "justin-faust-girl-talk-gloves-remix",
      image: "justin-faust-girl-talk-gloves-remix.jpg",
    },
    {
      name: "Girl Talk (Herr Styler Remix)",
      slug: "justin-faust-girl-talk-herr-styler-remix",
      image: "justin-faust-girl-talk-herr-styler-remix.jpg",
    },
    {
      name: "Girl Talk (Original)",
      slug: "justin-faust-girl-talk-original",
      image: "justin-faust-girl-talk-original.jpg",
    },
    {
      name: "High Hopes (Jay Lamar & Jesse Oliver Remix)",
      slug: "justin-faust-high-hopes-jay-lamar-and-jesse-oliver-remix",
      image: "justin-faust-high-hopes-jay-lamar-and-jesse-oliver-remix.jpg",
    },
    {
      name: "High Hopes (Original)",
      slug: "justin-faust-high-hopes-original",
      image: "justin-faust-high-hopes-original.jpg",
    },
    {
      name: "Holdin On (Nightriders Remix)",
      slug: "justin-faust-holdin-on-nightriders-remix",
      image: "justin-faust-holdin-on-nightriders-remix.jpg",
    },
    {
      name: "Slowin On (2CV Remix)",
      slug: "justin-faust-slowin-on-2cv-remix",
      image: "justin-faust-slowin-on-2cv-remix.jpg",
    },
    {
      name: "Slowin On (Mastercris Remix)",
      slug: "justin-faust-slowin-on-mastercris-remix",
      image: "justin-faust-slowin-on-mastercris-remix.jpg",
    },
    {
      name: "Space Rhumba (Original Mix)",
      slug: "justin-faust-space-rhumba-original-mix",
      image: "justin-faust-space-rhumba-original-mix.jpg",
    },
    {
      name: "Space Rhumba (Xinobi Remix)",
      slug: "justin-faust-space-rhumba-xinobi-remix",
      image: "justin-faust-space-rhumba-xinobi-remix.jpg",
    },
    {
      name: "Spellbound (Nteinbint Remix)",
      slug: "justin-faust-spellbound-nteinbint-remix",
      image: "justin-faust-spellbound-nteinbint-remix.jpg",
    },
    {
      name: "Tonight and Tomorrow (Paradisko Remix)",
      slug: "justin-faust-tonight-and-tomorrow-paradisko-remix",
      image: "justin-faust-tonight-and-tomorrow-paradisko-remix.jpg",
    },
  ],
  FMZ: [
    {
      name: "Get Down To This 2K13 (Reload Extended)",
      slug: "fmz-get-down-to-this-2k13-reload-extended",
      image: "fmz-get-down-to-this-2k13-reload-extended.jpg",
    },
    {
      name: "Just Yeah (Radio Edit)",
      slug: "fmz-just-yeah-radio-edit",
      image: "fmz-just-yeah-radio-edit.jpg",
    },
  ],
  "Beat Maker": [
    {
      name: "Get Ready Now (Radio Edit)",
      slug: "beat-maker-get-ready-now-radio-edit",
      image: "beat-maker-get-ready-now-radio-edit.jpg",
    },
  ],
  Koosto: [
    {
      name: "Get The Fuck",
      slug: "koosto-get-the-fuck",
      image: "koosto-get-the-fuck.jpg",
    },
    {
      name: "The Party",
      slug: "koosto-the-party",
      image: "koosto-the-party.jpg",
    },
  ],
  Obi: [
    { name: "Get Up", slug: "obi-get-up", image: "obi-get-up.jpg" },
    {
      name: "Get Up (Instrumental)",
      slug: "obi-get-up-instrumental",
      image: "obi-get-up-instrumental.jpg",
    },
    {
      name: "On The Road To You",
      slug: "obi-on-the-road-to-you",
      image: "obi-on-the-road-to-you.jpg",
    },
    {
      name: "On The Road To You (Instrumental)",
      slug: "obi-on-the-road-to-you-instrumental",
      image: null,
    },
    {
      name: "So Fine So Good (Instrumental)",
      slug: "obi-so-fine-so-good-instrumental",
      image: null,
    },
    { name: "Understand", slug: "obi-understand", image: "obi-understand.jpg" },
    {
      name: "Understand (Instrumental)",
      slug: "obi-understand-instrumental",
      image: null,
    },
    {
      name: "You Make Me Crazy (Instrumental)",
      slug: "obi-you-make-me-crazy-instrumental",
      image: null,
    },
  ],
  "Petit Navire": [
    {
      name: "Get Up Get Over",
      slug: "petit-navire-get-up-get-over",
      image: "petit-navire-get-up-get-over.jpg",
    },
    {
      name: "Givin' Up",
      slug: "petit-navire-givin-up",
      image: "petit-navire-givin-up.jpg",
    },
  ],
  "Preach Ankobia": [
    {
      name: "Ghetto Pop",
      slug: "preach-ankobia-ghetto-pop",
      image: "preach-ankobia-ghetto-pop.jpg",
    },
    {
      name: "Look Who's Back",
      slug: "preach-ankobia-look-who-s-back",
      image: "preach-ankobia-look-who-s-back.jpg",
    },
  ],
  "Tropical Popsicle": [
    {
      name: "Ghost Beacons",
      slug: "tropical-popsicle-ghost-beacons",
      image: "tropical-popsicle-ghost-beacons.jpg",
    },
    {
      name: "Havana",
      slug: "tropical-popsicle-havana",
      image: "tropical-popsicle-havana.jpg",
    },
  ],
  Baywaves: [
    { name: "Gliss", slug: "baywaves-gliss", image: "baywaves-gliss.jpg" },
    {
      name: "Marsupilami",
      slug: "baywaves-marsupilami",
      image: "baywaves-marsupilami.jpg",
    },
    {
      name: "The Freak Kingdom",
      slug: "baywaves-the-freak-kingdom",
      image: "baywaves-the-freak-kingdom.jpg",
    },
    {
      name: "Time Is Passing U By",
      slug: "baywaves-time-is-passing-u-by",
      image: "baywaves-time-is-passing-u-by.jpg",
    },
    {
      name: "To The North",
      slug: "baywaves-to-the-north",
      image: "baywaves-to-the-north.jpg",
    },
  ],
  Aloud: [
    { name: "Go", slug: "aloud-go", image: "aloud-go.jpg" },
    {
      name: "Sex & Sun Part II",
      slug: "aloud-sex-and-sun-part-ii",
      image: "aloud-sex-and-sun-part-ii.jpg",
    },
  ],
  "Lonely in the rain": [
    {
      name: "Go Home feat. Mark O",
      slug: "lonely-in-the-rain-go-home-feat-mark-o",
      image: "lonely-in-the-rain-go-home-feat-mark-o.jpg",
    },
    {
      name: "Somewhere Unknown feat. Mark O",
      slug: "lonely-in-the-rain-somewhere-unknown-feat-mark-o",
      image: "lonely-in-the-rain-somewhere-unknown-feat-mark-o.jpg",
    },
  ],
  "Diana Oliveira": [
    {
      name: "Goal",
      slug: "diana-oliveira-goal",
      image: "diana-oliveira-goal.jpg",
    },
    {
      name: "Shut Off",
      slug: "diana-oliveira-shut-off",
      image: "diana-oliveira-shut-off.jpg",
    },
    {
      name: "Stuck In My Head",
      slug: "diana-oliveira-stuck-in-my-head",
      image: "diana-oliveira-stuck-in-my-head.jpg",
    },
  ],
  Moisees: [
    {
      name: "Going To Nowhere",
      slug: "moisees-going-to-nowhere",
      image: "moisees-going-to-nowhere.jpg",
    },
    {
      name: "Little Changes",
      slug: "moisees-little-changes",
      image: "moisees-little-changes.jpg",
    },
    {
      name: "Train Station Philosophy",
      slug: "moisees-train-station-philosophy",
      image: "moisees-train-station-philosophy.jpg",
    },
  ],
  Kruton: [
    {
      name: "Gold Blood Friction (Kruton Remix)",
      slug: "kruton-gold-blood-friction-kruton-remix",
      image: "kruton-gold-blood-friction-kruton-remix.jpg",
    },
    {
      name: "Initiation Spindle",
      slug: "kruton-initiation-spindle",
      image: "kruton-initiation-spindle.jpg",
    },
    {
      name: "Knight Lore",
      slug: "kruton-knight-lore",
      image: "kruton-knight-lore.jpg",
    },
  ],
  "Herr Styler": [
    {
      name: "Gone (Original)",
      slug: "herr-styler-gone-original",
      image: "herr-styler-gone-original.jpg",
    },
    {
      name: "Gone (Remix)",
      slug: "herr-styler-gone-remix",
      image: "herr-styler-gone-remix.jpg",
    },
    {
      name: "Heaven",
      slug: "herr-styler-heaven",
      image: "herr-styler-heaven.jpg",
    },
    {
      name: "I Know",
      slug: "herr-styler-i-know",
      image: "herr-styler-i-know.jpg",
    },
    {
      name: "I Know (Broken Remix)",
      slug: "herr-styler-i-know-broken-remix",
      image: "herr-styler-i-know-broken-remix.jpg",
    },
    {
      name: "Jack (Depressed Buttons Remix)",
      slug: "herr-styler-jack-depressed-buttons-remix",
      image: "herr-styler-jack-depressed-buttons-remix.jpg",
    },
    {
      name: "Jack (Fare Soldi Remix)",
      slug: "herr-styler-jack-fare-soldi-remix",
      image: "herr-styler-jack-fare-soldi-remix.jpg",
    },
    {
      name: "Jack (Moullinex Remix)",
      slug: "herr-styler-jack-moullinex-remix",
      image: "herr-styler-jack-moullinex-remix.jpg",
    },
    {
      name: "Jack (Radio Edit)",
      slug: "herr-styler-jack-radio-edit",
      image: "herr-styler-jack-radio-edit.jpg",
    },
    {
      name: "Let's Rock",
      slug: "herr-styler-let-s-rock",
      image: "herr-styler-let-s-rock.jpg",
    },
    {
      name: "Mirrorballs",
      slug: "herr-styler-mirrorballs",
      image: "herr-styler-mirrorballs.jpg",
    },
    {
      name: "Necklace Forest",
      slug: "herr-styler-necklace-forest",
      image: "herr-styler-necklace-forest.jpg",
    },
    {
      name: "Necklace Forest (Edit)",
      slug: "herr-styler-necklace-forest-edit",
      image: "herr-styler-necklace-forest-edit.jpg",
    },
    {
      name: "Pienzm",
      slug: "herr-styler-pienzm",
      image: "herr-styler-pienzm.jpg",
    },
    {
      name: "Snow In Paris",
      slug: "herr-styler-snow-in-paris",
      image: "herr-styler-snow-in-paris.jpg",
    },
    {
      name: "Snow In Paris (Ari Remix)",
      slug: "herr-styler-snow-in-paris-ari-remix",
      image: "herr-styler-snow-in-paris-ari-remix.jpg",
    },
    {
      name: "Snow In Paris (Scuala Furano Remix)",
      slug: "herr-styler-snow-in-paris-scuala-furano-remix",
      image: "herr-styler-snow-in-paris-scuala-furano-remix.jpg",
    },
    {
      name: "We Are The Ones",
      slug: "herr-styler-we-are-the-ones",
      image: "herr-styler-we-are-the-ones.jpg",
    },
    {
      name: "We Are The Ones (R-ASH Remix)",
      slug: "herr-styler-we-are-the-ones-r-ash-remix",
      image: "herr-styler-we-are-the-ones-r-ash-remix.jpg",
    },
    {
      name: "Zero Ghosts Out The Door",
      slug: "herr-styler-zero-ghosts-out-the-door",
      image: "herr-styler-zero-ghosts-out-the-door.jpg",
    },
  ],
  "Alien Tango": [
    {
      name: "Good Evening",
      slug: "alien-tango-good-evening",
      image: "alien-tango-good-evening.jpg",
    },
    {
      name: "Sexy Time",
      slug: "alien-tango-sexy-time",
      image: "alien-tango-sexy-time.jpg",
    },
    {
      name: "War House",
      slug: "alien-tango-war-house",
      image: "alien-tango-war-house.jpg",
    },
    {
      name: "Wonderful Land",
      slug: "alien-tango-wonderful-land",
      image: "alien-tango-wonderful-land.jpg",
    },
  ],
  "Fat Phaze": [
    {
      name: "Goodbye Horses (Dalcan Remix)",
      slug: "fat-phaze-goodbye-horses-dalcan-remix",
      image: "fat-phaze-goodbye-horses-dalcan-remix.jpg",
    },
  ],
  "Jose Manuel": [
    {
      name: "Got Down",
      slug: "jose-manuel-got-down",
      image: "jose-manuel-got-down.jpg",
    },
  ],
  "Le Macchine": [
    { name: "Greg", slug: "le-macchine-greg", image: "le-macchine-greg.jpg" },
  ],
  "Thriller U": [
    {
      name: "Groove My Mind",
      slug: "thriller-u-groove-my-mind",
      image: "thriller-u-groove-my-mind.jpg",
    },
  ],
  "Dani Red": [
    {
      name: "Guerilla Mental",
      slug: "dani-red-guerilla-mental",
      image: "dani-red-guerilla-mental.jpg",
    },
  ],
  Jesse: [
    {
      name: "Harmonies",
      slug: "jesse-harmonies",
      image: "jesse-harmonies.jpg",
    },
    {
      name: "Mountain Boogie",
      slug: "jesse-mountain-boogie",
      image: "jesse-mountain-boogie.jpg",
    },
    {
      name: "Possibilities",
      slug: "jesse-possibilities",
      image: "jesse-possibilities.jpg",
    },
    { name: "Shazzy", slug: "jesse-shazzy", image: "jesse-shazzy.jpg" },
  ],
  Deadlinz: [
    {
      name: "Head to the Sky",
      slug: "deadlinz-head-to-the-sky",
      image: "deadlinz-head-to-the-sky.jpg",
    },
  ],
  Moto: [
    {
      name: "Heartbreaker",
      slug: "moto-heartbreaker",
      image: "moto-heartbreaker.jpg",
    },
    {
      name: "Magic Pool",
      slug: "moto-magic-pool",
      image: "moto-magic-pool.jpg",
    },
    {
      name: "Only You (Supermen Lovers Remix)",
      slug: "moto-only-you-supermen-lovers-remix",
      image: "moto-only-you-supermen-lovers-remix.jpg",
    },
    { name: "Who Cares", slug: "moto-who-cares", image: "moto-who-cares.jpg" },
    {
      name: "You Belong",
      slug: "moto-you-belong",
      image: "moto-you-belong.jpg",
    },
  ],
  Simpleton: [
    {
      name: "Heaven Me Reach",
      slug: "simpleton-heaven-me-reach",
      image: "simpleton-heaven-me-reach.jpg",
    },
    {
      name: "Mr Gunhead",
      slug: "simpleton-mr-gunhead",
      image: "simpleton-mr-gunhead.jpg",
    },
    {
      name: "Need A Litle Magic",
      slug: "simpleton-need-a-litle-magic",
      image: "simpleton-need-a-litle-magic.jpg",
    },
    {
      name: "So You Born",
      slug: "simpleton-so-you-born",
      image: "simpleton-so-you-born.jpg",
    },
    {
      name: "Them Fe Hear",
      slug: "simpleton-them-fe-hear",
      image: "simpleton-them-fe-hear.jpg",
    },
    {
      name: "Them Talk About Man",
      slug: "simpleton-them-talk-about-man",
      image: "simpleton-them-talk-about-man.jpg",
    },
    {
      name: "You Plant The Seed",
      slug: "simpleton-you-plant-the-seed",
      image: "simpleton-you-plant-the-seed.jpg",
    },
  ],
  Edgär: [
    {
      name: "Heaven Tricks",
      slug: "edgaer-heaven-tricks",
      image: "edgaer-heaven-tricks.jpg",
    },
    {
      name: "Two Trees",
      slug: "edgaer-two-trees",
      image: "edgaer-two-trees.jpg",
    },
  ],
  "Play Paul & Leicos": [
    {
      name: "Hell's Belles",
      slug: "play-paul-and-leicos-hell-s-belles",
      image: "play-paul-and-leicos-hell-s-belles.jpg",
    },
  ],
  Elephanz: [
    {
      name: "Henri IV",
      slug: "elephanz-henri-iv",
      image: "elephanz-henri-iv.jpg",
    },
  ],
  "With All Due Respect": [
    {
      name: "Hindi Ko Alam",
      slug: "with-all-due-respect-hindi-ko-alam",
      image: "with-all-due-respect-hindi-ko-alam.jpg",
    },
    {
      name: "I Didn't Know",
      slug: "with-all-due-respect-i-didn-t-know",
      image: "with-all-due-respect-i-didn-t-know.jpg",
    },
    {
      name: "Let Love Find You",
      slug: "with-all-due-respect-let-love-find-you",
      image: "with-all-due-respect-let-love-find-you.jpg",
    },
    {
      name: "Make You Mind",
      slug: "with-all-due-respect-make-you-mind",
      image: "with-all-due-respect-make-you-mind.jpg",
    },
    {
      name: "Meet Me At Midnight",
      slug: "with-all-due-respect-meet-me-at-midnight",
      image: "with-all-due-respect-meet-me-at-midnight.jpg",
    },
    {
      name: "Sunset On Punta Paloma",
      slug: "with-all-due-respect-sunset-on-punta-paloma",
      image: "with-all-due-respect-sunset-on-punta-paloma.jpg",
    },
    {
      name: "The Selfish Guy",
      slug: "with-all-due-respect-the-selfish-guy",
      image: "with-all-due-respect-the-selfish-guy.jpg",
    },
    {
      name: "There Must Be Love",
      slug: "with-all-due-respect-there-must-be-love",
      image: "with-all-due-respect-there-must-be-love.jpg",
    },
    {
      name: "Up From The Ground",
      slug: "with-all-due-respect-up-from-the-ground",
      image: "with-all-due-respect-up-from-the-ground.jpg",
    },
  ],
  "Rodion And Sean Patrick": [
    {
      name: "Hit the Ground",
      slug: "rodion-and-sean-patrick-hit-the-ground",
      image: "rodion-and-sean-patrick-hit-the-ground.jpg",
    },
  ],
  Capsula: [
    {
      name: "Hit's' n ' Miss",
      slug: "capsula-hit-s-n-miss",
      image: "capsula-hit-s-n-miss.jpg",
    },
  ],
  "Global Tracks": [
    {
      name: "Hither Green",
      slug: "global-tracks-hither-green",
      image: "global-tracks-hither-green.jpg",
    },
    {
      name: "Shelley",
      slug: "global-tracks-shelley",
      image: "global-tracks-shelley.jpg",
    },
  ],
  Kojak: [
    { name: "Hold Me", slug: "kojak-hold-me", image: "kojak-hold-me.jpg" },
  ],
  Monaldin: [
    {
      name: "Hold Me",
      slug: "monaldin-hold-me",
      image: "monaldin-hold-me.jpg",
    },
  ],
  "Felix Schorn": [
    { name: "Home", slug: "felix-schorn-home", image: "felix-schorn-home.jpg" },
  ],
  "Moullinex and Nastio Mosquito": [
    {
      name: "Hope And Dope",
      slug: "moullinex-and-nastio-mosquito-hope-and-dope",
      image: "moullinex-and-nastio-mosquito-hope-and-dope.jpg",
    },
  ],
  "Rozi Plain": [
    {
      name: "Humans",
      slug: "rozi-plain-humans",
      image: "rozi-plain-humans.jpg",
    },
  ],
  Rumia: [
    { name: "Hurt", slug: "rumia-hurt", image: "rumia-hurt.jpg" },
    {
      name: "Lying In Bed",
      slug: "rumia-lying-in-bed",
      image: "rumia-lying-in-bed.jpg",
    },
    {
      name: "No One Is Going Out",
      slug: "rumia-no-one-is-going-out",
      image: "rumia-no-one-is-going-out.jpg",
    },
    { name: "Reborn", slug: "rumia-reborn", image: "rumia-reborn.jpg" },
  ],
  "Tiffany Berton": [
    {
      name: "I Hate Loving You",
      slug: "tiffany-berton-i-hate-loving-you",
      image: "tiffany-berton-i-hate-loving-you.jpg",
    },
    {
      name: "I Hate Loving You (Folk Version)",
      slug: "tiffany-berton-i-hate-loving-you-folk-version",
      image: "tiffany-berton-i-hate-loving-you-folk-version.jpg",
    },
    {
      name: "My Flaws",
      slug: "tiffany-berton-my-flaws",
      image: "tiffany-berton-my-flaws.jpg",
    },
  ],
  "L.Reid": [
    {
      name: "I Have No Voice",
      slug: "l-reid-i-have-no-voice",
      image: "l-reid-i-have-no-voice.jpg",
    },
    { name: "Seasons", slug: "l-reid-seasons", image: "l-reid-seasons.jpg" },
    {
      name: "The Mocking Bird",
      slug: "l-reid-the-mocking-bird",
      image: "l-reid-the-mocking-bird.jpg",
    },
  ],
  LVNE: [
    { name: "I Need", slug: "lvne-i-need", image: "lvne-i-need.jpg" },
    { name: "Tribes", slug: "lvne-tribes", image: "lvne-tribes.jpg" },
  ],
  "R-ASH": [
    {
      name: "I Own You",
      slug: "r-ash-i-own-you",
      image: "r-ash-i-own-you.jpg",
    },
  ],
  UM: [
    {
      name: "I Say No feat. Tisha",
      slug: "um-i-say-no-feat-tisha",
      image: "um-i-say-no-feat-tisha.jpg",
    },
  ],
  "Ruth and The Adelians": [
    {
      name: "I Wanna Tell You",
      slug: "ruth-and-the-adelians-i-wanna-tell-you",
      image: "ruth-and-the-adelians-i-wanna-tell-you.jpg",
    },
    {
      name: "I'm A Woman",
      slug: "ruth-and-the-adelians-i-m-a-woman",
      image: "ruth-and-the-adelians-i-m-a-woman.jpg",
    },
    {
      name: "La Nuit m'appartient",
      slug: "ruth-and-the-adelians-la-nuit-m-appartient",
      image: "ruth-and-the-adelians-la-nuit-m-appartient.jpg",
    },
  ],
  "Frankie Paul": [
    {
      name: "I Will Never Look For Love Again",
      slug: "frankie-paul-i-will-never-look-for-love-again",
      image: "frankie-paul-i-will-never-look-for-love-again.jpg",
    },
  ],
  Sea: [
    {
      name: "I Wish feat. Yaeow",
      slug: "sea-i-wish-feat-yaeow",
      image: "sea-i-wish-feat-yaeow.jpg",
    },
  ],
  "Vox Low": [
    {
      name: "I'll Save You Anyway",
      slug: "vox-low-i-ll-save-you-anyway",
      image: "vox-low-i-ll-save-you-anyway.jpg",
    },
  ],
  "Suzy & Los Quattro": [
    {
      name: "I.O.U",
      slug: "suzy-and-los-quattro-i-o-u",
      image: "suzy-and-los-quattro-i-o-u.jpg",
    },
  ],
  "Alessandro Adriani & Franz Scala": [
    {
      name: "Il Confine",
      slug: "alessandro-adriani-and-franz-scala-il-confine",
      image: "alessandro-adriani-and-franz-scala-il-confine.jpg",
    },
  ],
  "Raashan Ahmad": [
    {
      name: "In Love With Wax",
      slug: "raashan-ahmad-in-love-with-wax",
      image: "raashan-ahmad-in-love-with-wax.jpg",
    },
    {
      name: "My Imagination",
      slug: "raashan-ahmad-my-imagination",
      image: "raashan-ahmad-my-imagination.jpg",
    },
    {
      name: "Pain On Black",
      slug: "raashan-ahmad-pain-on-black",
      image: "raashan-ahmad-pain-on-black.jpg",
    },
    {
      name: "Remember",
      slug: "raashan-ahmad-remember",
      image: "raashan-ahmad-remember.jpg",
    },
  ],
  Redemption: [
    {
      name: "In The Name",
      slug: "redemption-in-the-name",
      image: "redemption-in-the-name.jpg",
    },
    {
      name: "In The Name (Instrumental)",
      slug: "redemption-in-the-name-instrumental",
      image: "redemption-in-the-name-instrumental.jpg",
    },
  ],
  FLM: [
    {
      name: "In The Party",
      slug: "flm-in-the-party",
      image: "flm-in-the-party.jpg",
    },
  ],
  "Best Youth and Moullinex": [
    {
      name: "In The Shade",
      slug: "best-youth-and-moullinex-in-the-shade",
      image: "best-youth-and-moullinex-in-the-shade.jpg",
    },
  ],
  "Ilya Santana": [
    {
      name: "Infamous Lovers (Kasper Bjork Remix)",
      slug: "ilya-santana-infamous-lovers-kasper-bjork-remix",
      image: "ilya-santana-infamous-lovers-kasper-bjork-remix.jpg",
    },
    {
      name: "Infamous Lovers (Original)",
      slug: "ilya-santana-infamous-lovers-original",
      image: "ilya-santana-infamous-lovers-original.jpg",
    },
    {
      name: "Infamous Lovers (Telonius Remix)",
      slug: "ilya-santana-infamous-lovers-telonius-remix",
      image: "ilya-santana-infamous-lovers-telonius-remix.jpg",
    },
    {
      name: "Involution",
      slug: "ilya-santana-involution",
      image: "ilya-santana-involution.jpg",
    },
  ],
  Gordon: [
    {
      name: "Inner Path to Outer Space",
      slug: "gordon-inner-path-to-outer-space",
      image: "gordon-inner-path-to-outer-space.jpg",
    },
    {
      name: "Lakeside Sunrise",
      slug: "gordon-lakeside-sunrise",
      image: "gordon-lakeside-sunrise.jpg",
    },
    {
      name: "Stairway To Love Dungeon",
      slug: "gordon-stairway-to-love-dungeon",
      image: "gordon-stairway-to-love-dungeon.jpg",
    },
  ],
  "Rove Dogs": [
    {
      name: "Innocense Lost",
      slug: "rove-dogs-innocense-lost",
      image: "rove-dogs-innocense-lost.jpg",
    },
    {
      name: "Whithout Glitter (X-ecutioners Remix)",
      slug: "rove-dogs-whithout-glitter-x-ecutioners-remix",
      image: "rove-dogs-whithout-glitter-x-ecutioners-remix.jpg",
    },
  ],
  Destino: [
    {
      name: "Isla Grande",
      slug: "destino-isla-grande",
      image: "destino-isla-grande.jpg",
    },
    { name: "Louis", slug: "destino-louis", image: "destino-louis.jpg" },
    {
      name: "Louis (Alek Lee)",
      slug: "destino-louis-alek-lee",
      image: "destino-louis-alek-lee.jpg",
    },
    {
      name: "Petit Soleil",
      slug: "destino-petit-soleil",
      image: "destino-petit-soleil.jpg",
    },
  ],
  Dipcrusher: [
    {
      name: "Islands",
      slug: "dipcrusher-islands",
      image: "dipcrusher-islands.jpg",
    },
    { name: "Shiny", slug: "dipcrusher-shiny", image: "dipcrusher-shiny.jpg" },
  ],
  "Nina Johansson": [
    {
      name: "It's Not Our Time",
      slug: "nina-johansson-it-s-not-our-time",
      image: "nina-johansson-it-s-not-our-time.jpg",
    },
    {
      name: "Johnny",
      slug: "nina-johansson-johnny",
      image: "nina-johansson-johnny.jpg",
    },
    {
      name: "One Step Too Low",
      slug: "nina-johansson-one-step-too-low",
      image: "nina-johansson-one-step-too-low.jpg",
    },
    {
      name: "Would You Follow",
      slug: "nina-johansson-would-you-follow",
      image: "nina-johansson-would-you-follow.jpg",
    },
  ],
  "Mushroom Project": [
    {
      name: "Its",
      slug: "mushroom-project-its",
      image: "mushroom-project-its.jpg",
    },
  ],
  Monality: [
    { name: "Itsula", slug: "monality-itsula", image: "monality-itsula.jpg" },
    {
      name: "Up and Down",
      slug: "monality-up-and-down",
      image: "monality-up-and-down.jpg",
    },
  ],
  "Lil Thug": [
    {
      name: "Jeune Loup",
      slug: "lil-thug-jeune-loup",
      image: "lil-thug-jeune-loup.jpg",
    },
    {
      name: "Spoutnik",
      slug: "lil-thug-spoutnik",
      image: "lil-thug-spoutnik.jpg",
    },
  ],
  "La Diligence": [
    { name: "Jim Clark", slug: "la-diligence-jim-clark", image: null },
  ],
  Blowfly: [
    {
      name: "Jimmy Wants To Dance feat. Real Fake MC",
      slug: "blowfly-jimmy-wants-to-dance-feat-real-fake-mc",
      image: "blowfly-jimmy-wants-to-dance-feat-real-fake-mc.jpg",
    },
  ],
  "Ewert And The 2 Dragons": [
    {
      name: "Jolene",
      slug: "ewert-and-the-2-dragons-jolene",
      image: "ewert-and-the-2-dragons-jolene.jpg",
    },
    {
      name: "Road To The Hill",
      slug: "ewert-and-the-2-dragons-road-to-the-hill",
      image: "ewert-and-the-2-dragons-road-to-the-hill.jpg",
    },
    {
      name: "There's Only Love",
      slug: "ewert-and-the-2-dragons-there-s-only-love",
      image: "ewert-and-the-2-dragons-there-s-only-love.jpg",
    },
  ],
  "Niv Ast": [
    {
      name: "Jungle Marvin",
      slug: "niv-ast-jungle-marvin",
      image: "niv-ast-jungle-marvin.jpg",
    },
  ],
  "Earl Grey": [
    {
      name: "Just Clap",
      slug: "earl-grey-just-clap",
      image: "earl-grey-just-clap.jpg",
    },
    { name: "Pong", slug: "earl-grey-pong", image: "earl-grey-pong.jpg" },
    {
      name: "Regent's Park",
      slug: "earl-grey-regent-s-park",
      image: "earl-grey-regent-s-park.jpg",
    },
    {
      name: "Through The City",
      slug: "earl-grey-through-the-city",
      image: "earl-grey-through-the-city.jpg",
    },
    {
      name: "Through The City (Alien Alien Remix)",
      slug: "earl-grey-through-the-city-alien-alien-remix",
      image: "earl-grey-through-the-city-alien-alien-remix.jpg",
    },
    {
      name: "Through The City (Instrumental)",
      slug: "earl-grey-through-the-city-instrumental",
      image: "earl-grey-through-the-city-instrumental.jpg",
    },
    {
      name: "You Broke The Chain",
      slug: "earl-grey-you-broke-the-chain",
      image: "earl-grey-you-broke-the-chain.jpg",
    },
  ],
  "Michael Gadiva": [
    {
      name: "Just Do It",
      slug: "michael-gadiva-just-do-it",
      image: "michael-gadiva-just-do-it.jpg",
    },
  ],
  "Dim Sum": [
    {
      name: "Just Need",
      slug: "dim-sum-just-need",
      image: "dim-sum-just-need.jpg",
    },
  ],
  "Holy Oysters": [
    {
      name: "Kaleidoscope",
      slug: "holy-oysters-kaleidoscope",
      image: "holy-oysters-kaleidoscope.jpg",
    },
    {
      name: "My Mind Slipped Away",
      slug: "holy-oysters-my-mind-slipped-away",
      image: "holy-oysters-my-mind-slipped-away.jpg",
    },
    { name: "Oh", slug: "holy-oysters-oh", image: "holy-oysters-oh.jpg" },
    {
      name: "Supersonic",
      slug: "holy-oysters-supersonic",
      image: "holy-oysters-supersonic.jpg",
    },
    {
      name: "Take Me for a Ride",
      slug: "holy-oysters-take-me-for-a-ride",
      image: "holy-oysters-take-me-for-a-ride.jpg",
    },
  ],
  "R. Missing": [
    {
      name: "Kelly Was A Philistine",
      slug: "r-missing-kelly-was-a-philistine",
      image: "r-missing-kelly-was-a-philistine.jpg",
    },
    { name: "Mouser", slug: "r-missing-mouser", image: "r-missing-mouser.jpg" },
  ],
  "The Edge": [
    {
      name: "Kill Your Idols",
      slug: "the-edge-kill-your-idols",
      image: "the-edge-kill-your-idols.jpg",
    },
  ],
  Telonius: [
    {
      name: "Kiss Your Face",
      slug: "telonius-kiss-your-face",
      image: "telonius-kiss-your-face.jpg",
    },
    {
      name: "Last Night (Radio Version)",
      slug: "telonius-last-night-radio-version",
      image: "telonius-last-night-radio-version.jpg",
    },
    { name: "Now", slug: "telonius-now", image: "telonius-now.jpg" },
  ],
  "Guilhem Desq": [
    {
      name: "La Libellule Et Le Baobab",
      slug: "guilhem-desq-la-libellule-et-le-baobab",
      image: "guilhem-desq-la-libellule-et-le-baobab.jpg",
    },
  ],
  Pupille: [
    {
      name: "Las Gracias De Nada",
      slug: "pupille-las-gracias-de-nada",
      image: "pupille-las-gracias-de-nada.jpg",
    },
  ],
  "Motorcycle Boy": [
    {
      name: "Laser",
      slug: "motorcycle-boy-laser",
      image: "motorcycle-boy-laser.jpg",
    },
    {
      name: "Siluro Slows Down",
      slug: "motorcycle-boy-siluro-slows-down",
      image: "motorcycle-boy-siluro-slows-down.jpg",
    },
    {
      name: "Squalo",
      slug: "motorcycle-boy-squalo",
      image: "motorcycle-boy-squalo.jpg",
    },
  ],
  "Think Twice": [
    {
      name: "Last Call",
      slug: "think-twice-last-call",
      image: "think-twice-last-call.jpg",
    },
    {
      name: "You Never Know",
      slug: "think-twice-you-never-know",
      image: "think-twice-you-never-know.jpg",
    },
  ],
  "Silicon Boogie": [
    {
      name: "Last Night (The Supermen Lovers Remix)",
      slug: "silicon-boogie-last-night-the-supermen-lovers-remix",
      image: "silicon-boogie-last-night-the-supermen-lovers-remix.jpg",
    },
  ],
  Rubik: [
    {
      name: "Laws Of Gravity",
      slug: "rubik-laws-of-gravity",
      image: "rubik-laws-of-gravity.jpg",
    },
    {
      name: "World Around You",
      slug: "rubik-world-around-you",
      image: "rubik-world-around-you.jpg",
    },
  ],
  "Neon Flake": [
    { name: "Le Reve", slug: "neon-flake-le-reve", image: null },
    { name: "O Ma Matto", slug: "neon-flake-o-ma-matto", image: null },
    {
      name: "The Whisper Of Nature",
      slug: "neon-flake-the-whisper-of-nature",
      image: null,
    },
  ],
  "Kiff One": [
    {
      name: "Lie To Me (Koosto Remix)",
      slug: "kiff-one-lie-to-me-koosto-remix",
      image: "kiff-one-lie-to-me-koosto-remix.jpg",
    },
  ],
  "Dark Strands": [
    {
      name: "Lights Out",
      slug: "dark-strands-lights-out",
      image: "dark-strands-lights-out.jpg",
    },
    {
      name: "Night Drive",
      slug: "dark-strands-night-drive",
      image: "dark-strands-night-drive.jpg",
    },
    {
      name: "Opaque Kingdom",
      slug: "dark-strands-opaque-kingdom",
      image: "dark-strands-opaque-kingdom.jpg",
    },
    {
      name: "Subtractive Ocean",
      slug: "dark-strands-subtractive-ocean",
      image: "dark-strands-subtractive-ocean.jpg",
    },
    {
      name: "This Much I Know",
      slug: "dark-strands-this-much-i-know",
      image: "dark-strands-this-much-i-know.jpg",
    },
    {
      name: "Unknown Truths",
      slug: "dark-strands-unknown-truths",
      image: "dark-strands-unknown-truths.jpg",
    },
    {
      name: "We Own The Night",
      slug: "dark-strands-we-own-the-night",
      image: "dark-strands-we-own-the-night.jpg",
    },
    {
      name: "Will Last Forever",
      slug: "dark-strands-will-last-forever",
      image: "dark-strands-will-last-forever.jpg",
    },
  ],
  Batist: [
    {
      name: "Like A Dog",
      slug: "batist-like-a-dog",
      image: "batist-like-a-dog.jpg",
    },
    { name: "New Hard", slug: "batist-new-hard", image: "batist-new-hard.jpg" },
    {
      name: "Saturday Night",
      slug: "batist-saturday-night",
      image: "batist-saturday-night.jpg",
    },
    { name: "Way Mama", slug: "batist-way-mama", image: "batist-way-mama.jpg" },
    { name: "Window", slug: "batist-window", image: "batist-window.jpg" },
  ],
  "P.M.D.C": [
    { name: "Like it", slug: "p-m-d-c-like-it", image: "p-m-d-c-like-it.jpg" },
  ],
  Sophialorenians: [
    {
      name: "Locomotion",
      slug: "sophialorenians-locomotion",
      image: "sophialorenians-locomotion.jpg",
    },
  ],
  "Will Stratton": [
    {
      name: "Long Live The Hudson River",
      slug: "will-stratton-long-live-the-hudson-river",
      image: "will-stratton-long-live-the-hudson-river.jpg",
    },
  ],
  "Lost Tapes": [
    {
      name: "Lost In Youth",
      slug: "lost-tapes-lost-in-youth",
      image: "lost-tapes-lost-in-youth.jpg",
    },
    {
      name: "Slumber Party",
      slug: "lost-tapes-slumber-party",
      image: "lost-tapes-slumber-party.jpg",
    },
    {
      name: "Speechless",
      slug: "lost-tapes-speechless",
      image: "lost-tapes-speechless.jpg",
    },
    {
      name: "This Is Want I Wanted",
      slug: "lost-tapes-this-is-want-i-wanted",
      image: "lost-tapes-this-is-want-i-wanted.jpg",
    },
  ],
  "Jennie Laws": [
    {
      name: "Love Easily",
      slug: "jennie-laws-love-easily",
      image: "jennie-laws-love-easily.jpg",
    },
    {
      name: "Lovesick",
      slug: "jennie-laws-lovesick",
      image: "jennie-laws-lovesick.jpg",
    },
    {
      name: "Sabotage",
      slug: "jennie-laws-sabotage",
      image: "jennie-laws-sabotage.jpg",
    },
    {
      name: "Sailing Away",
      slug: "jennie-laws-sailing-away",
      image: "jennie-laws-sailing-away.jpg",
    },
    {
      name: "Your Love",
      slug: "jennie-laws-your-love",
      image: "jennie-laws-your-love.jpg",
    },
  ],
  "Alex Guerrero": [
    {
      name: "Love Somebody",
      slug: "alex-guerrero-love-somebody",
      image: "alex-guerrero-love-somebody.jpg",
    },
    {
      name: "Who Said feat. Anabella",
      slug: "alex-guerrero-who-said-feat-anabella",
      image: "alex-guerrero-who-said-feat-anabella.jpg",
    },
  ],
  "Micah P. Hinson": [
    {
      name: "Love,Wait For Me",
      slug: "micah-p-hinson-love-wait-for-me",
      image: "micah-p-hinson-love-wait-for-me.jpg",
    },
  ],
  "Jackie Moontan": [
    {
      name: "Lucia Lashes",
      slug: "jackie-moontan-lucia-lashes",
      image: "jackie-moontan-lucia-lashes.jpg",
    },
    {
      name: "Of Youth",
      slug: "jackie-moontan-of-youth",
      image: "jackie-moontan-of-youth.jpg",
    },
    {
      name: "Pelvic Trust",
      slug: "jackie-moontan-pelvic-trust",
      image: "jackie-moontan-pelvic-trust.jpg",
    },
    {
      name: "Red Hands",
      slug: "jackie-moontan-red-hands",
      image: "jackie-moontan-red-hands.jpg",
    },
    {
      name: "Speed Dating",
      slug: "jackie-moontan-speed-dating",
      image: "jackie-moontan-speed-dating.jpg",
    },
  ],
  "The Author": [
    {
      name: "Lucky Charm",
      slug: "the-author-lucky-charm",
      image: "the-author-lucky-charm.jpg",
    },
  ],
  "Elea Calvet": [
    { name: "Lust", slug: "elea-calvet-lust", image: "elea-calvet-lust.jpg" },
    {
      name: "Sacrifice",
      slug: "elea-calvet-sacrifice",
      image: "elea-calvet-sacrifice.jpg",
    },
    {
      name: "Sacrifice (Instrumental)",
      slug: "elea-calvet-sacrifice-instrumental",
      image: "elea-calvet-sacrifice-instrumental.jpg",
    },
    {
      name: "Trigger",
      slug: "elea-calvet-trigger",
      image: "elea-calvet-trigger.jpg",
    },
    {
      name: "Trigger (Instrumental)",
      slug: "elea-calvet-trigger-instrumental",
      image: "elea-calvet-trigger-instrumental.jpg",
    },
  ],
  Kritic: [
    { name: "Makizar", slug: "kritic-makizar", image: "kritic-makizar.jpg" },
  ],
  Wash: [
    { name: "Man Touch", slug: "wash-man-touch", image: "wash-man-touch.jpg" },
  ],
  "Karen Koltrane": [
    {
      name: "Mano Vapor",
      slug: "karen-koltrane-mano-vapor",
      image: "karen-koltrane-mano-vapor.jpg",
    },
  ],
  "Immaculate Rivombo": [
    {
      name: "Mbira Girls",
      slug: "immaculate-rivombo-mbira-girls",
      image: "immaculate-rivombo-mbira-girls.jpg",
    },
    {
      name: "Soudani Dub",
      slug: "immaculate-rivombo-soudani-dub",
      image: "immaculate-rivombo-soudani-dub.jpg",
    },
  ],
  "The Psychedelic Schafferson": [
    {
      name: "Membrillo's Ride",
      slug: "the-psychedelic-schafferson-membrillo-s-ride",
      image: "the-psychedelic-schafferson-membrillo-s-ride.jpg",
    },
    {
      name: "Rugby",
      slug: "the-psychedelic-schafferson-rugby",
      image: "the-psychedelic-schafferson-rugby.jpg",
    },
  ],
  "Daniel Monaco": [
    {
      name: "Middle Fist",
      slug: "daniel-monaco-middle-fist",
      image: "daniel-monaco-middle-fist.jpg",
    },
  ],
  "Jerez Le Cam Quartet": [
    {
      name: "Molodojoni",
      slug: "jerez-le-cam-quartet-molodojoni",
      image: "jerez-le-cam-quartet-molodojoni.jpg",
    },
    {
      name: "Ofofof",
      slug: "jerez-le-cam-quartet-ofofof",
      image: "jerez-le-cam-quartet-ofofof.jpg",
    },
    {
      name: "Orsai",
      slug: "jerez-le-cam-quartet-orsai",
      image: "jerez-le-cam-quartet-orsai.jpg",
    },
    {
      name: "Pasos Nocturnos",
      slug: "jerez-le-cam-quartet-pasos-nocturnos",
      image: "jerez-le-cam-quartet-pasos-nocturnos.jpg",
    },
    {
      name: "Trepada",
      slug: "jerez-le-cam-quartet-trepada",
      image: "jerez-le-cam-quartet-trepada.jpg",
    },
    {
      name: "Yamparata",
      slug: "jerez-le-cam-quartet-yamparata",
      image: "jerez-le-cam-quartet-yamparata.jpg",
    },
  ],
  "Mr Tea": [
    { name: "Momentum", slug: "mr-tea-momentum", image: "mr-tea-momentum.jpg" },
    {
      name: "Vanishing Point",
      slug: "mr-tea-vanishing-point",
      image: "mr-tea-vanishing-point.jpg",
    },
  ],
  "Major Cat": [
    {
      name: "Momentum",
      slug: "major-cat-momentum",
      image: "major-cat-momentum.jpg",
    },
  ],
  "Flowers Must Die": [
    {
      name: "Montana",
      slug: "flowers-must-die-montana",
      image: "flowers-must-die-montana.jpg",
    },
    {
      name: "Nusrat",
      slug: "flowers-must-die-nusrat",
      image: "flowers-must-die-nusrat.jpg",
    },
  ],
  "Orijinal Fox": [
    {
      name: "Moombahton Style (Club Mix)",
      slug: "orijinal-fox-moombahton-style-club-mix",
      image: "orijinal-fox-moombahton-style-club-mix.jpg",
    },
    {
      name: "Moombahton Style (Radio Edit)",
      slug: "orijinal-fox-moombahton-style-radio-edit",
      image: "orijinal-fox-moombahton-style-radio-edit.jpg",
    },
  ],
  Lazydisco: [
    {
      name: "More Tigers (Mirror People Remix)",
      slug: "lazydisco-more-tigers-mirror-people-remix",
      image: "lazydisco-more-tigers-mirror-people-remix.jpg",
    },
  ],
  "Puma & The Dolphin": [
    {
      name: "Morning Plants",
      slug: "puma-and-the-dolphin-morning-plants",
      image: "puma-and-the-dolphin-morning-plants.jpg",
    },
    {
      name: "Number",
      slug: "puma-and-the-dolphin-number",
      image: "puma-and-the-dolphin-number.jpg",
    },
  ],
  "Sara Costa": [
    {
      name: "My Way feat. Opé Smith",
      slug: "sara-costa-my-way-feat-ope-smith",
      image: "sara-costa-my-way-feat-ope-smith.jpg",
    },
  ],
  "New Digital Fidelity": [
    {
      name: "Nebula",
      slug: "new-digital-fidelity-nebula",
      image: "new-digital-fidelity-nebula.jpg",
    },
  ],
  "Jimmy London": [
    {
      name: "New York City",
      slug: "jimmy-london-new-york-city",
      image: "jimmy-london-new-york-city.jpg",
    },
  ],
  "Deborahe Glasgow": [
    {
      name: "No One Can Take My Place",
      slug: "deborahe-glasgow-no-one-can-take-my-place",
      image: "deborahe-glasgow-no-one-can-take-my-place.jpg",
    },
    {
      name: "The Mind Is Willing",
      slug: "deborahe-glasgow-the-mind-is-willing",
      image: "deborahe-glasgow-the-mind-is-willing.jpg",
    },
  ],
  Gallo: [
    {
      name: "Not Enough",
      slug: "gallo-not-enough",
      image: "gallo-not-enough.jpg",
    },
  ],
  Rebeka: [
    {
      name: "Nothing To Give (Mirror People Remix)",
      slug: "rebeka-nothing-to-give-mirror-people-remix",
      image: "rebeka-nothing-to-give-mirror-people-remix.jpg",
    },
    {
      name: "Nothing To Give (feat Mirror People)",
      slug: "rebeka-nothing-to-give-feat-mirror-people",
      image: "rebeka-nothing-to-give-feat-mirror-people.jpg",
    },
    { name: "Stars", slug: "rebeka-stars", image: "rebeka-stars.jpg" },
    {
      name: "Stars (Discotexas Remix)",
      slug: "rebeka-stars-discotexas-remix",
      image: "rebeka-stars-discotexas-remix.jpg",
    },
    {
      name: "Stars (Mirror People Club Remix)",
      slug: "rebeka-stars-mirror-people-club-remix",
      image: "rebeka-stars-mirror-people-club-remix.jpg",
    },
  ],
  "Al Lover": [
    {
      name: "Ode To a Dead Riddum (Martin Hannett Blues)",
      slug: "al-lover-ode-to-a-dead-riddum-martin-hannett-blues",
      image: "al-lover-ode-to-a-dead-riddum-martin-hannett-blues.jpg",
    },
  ],
  Khemis: [
    {
      name: "On Fait Les Comptes",
      slug: "khemis-on-fait-les-comptes",
      image: "khemis-on-fait-les-comptes.jpg",
    },
  ],
  "Tan Low": [
    {
      name: "On Guard",
      slug: "tan-low-on-guard",
      image: "tan-low-on-guard.jpg",
    },
  ],
  "Jeune No": [
    {
      name: "On Se Ressemble",
      slug: "jeune-no-on-se-ressemble",
      image: "jeune-no-on-se-ressemble.jpg",
    },
  ],
  "White Bamby": [
    {
      name: "On The Sand (Mr Gonzo Remix)",
      slug: "white-bamby-on-the-sand-mr-gonzo-remix",
      image: "white-bamby-on-the-sand-mr-gonzo-remix.jpg",
    },
  ],
  Altieri: [
    { name: "Onikabu", slug: "altieri-onikabu", image: "altieri-onikabu.jpg" },
    {
      name: "Red Town",
      slug: "altieri-red-town",
      image: "altieri-red-town.jpg",
    },
    { name: "Sayoko", slug: "altieri-sayoko", image: "altieri-sayoko.jpg" },
  ],
  "The Octopus": [
    {
      name: "Opus Number 1",
      slug: "the-octopus-opus-number-1",
      image: "the-octopus-opus-number-1.jpg",
    },
  ],
  "Sauvage World": [
    {
      name: "Over The Edge",
      slug: "sauvage-world-over-the-edge",
      image: "sauvage-world-over-the-edge.jpg",
    },
  ],
  "Rodion And LSD": [
    {
      name: "Owl And Wizzle feat. Mz Sunday Luv",
      slug: "rodion-and-lsd-owl-and-wizzle-feat-mz-sunday-luv",
      image: "rodion-and-lsd-owl-and-wizzle-feat-mz-sunday-luv.jpg",
    },
  ],
  "Johnny Paguro": [
    {
      name: "Parabolica",
      slug: "johnny-paguro-parabolica",
      image: "johnny-paguro-parabolica.jpg",
    },
  ],
  Oniric: [
    { name: "Paris", slug: "oniric-paris", image: "oniric-paris.jpg" },
    { name: "Pasaje", slug: "oniric-pasaje", image: "oniric-pasaje.jpg" },
  ],
  "The Dustaphonics": [
    {
      name: "Party Girl",
      slug: "the-dustaphonics-party-girl",
      image: "the-dustaphonics-party-girl.jpg",
    },
    {
      name: "Q Sounds Groove",
      slug: "the-dustaphonics-q-sounds-groove",
      image: "the-dustaphonics-q-sounds-groove.jpg",
    },
    {
      name: "Witch Of The Night",
      slug: "the-dustaphonics-witch-of-the-night",
      image: "the-dustaphonics-witch-of-the-night.jpg",
    },
  ],
  "Garnett Silk": [
    {
      name: "Passing Judgement",
      slug: "garnett-silk-passing-judgement",
      image: "garnett-silk-passing-judgement.jpg",
    },
  ],
  Appaloosa: [
    {
      name: "Patchwork (Attar Remix)",
      slug: "appaloosa-patchwork-attar-remix",
      image: "appaloosa-patchwork-attar-remix.jpg",
    },
    {
      name: "Patchwork (Bostro Pesopeo Remix)",
      slug: "appaloosa-patchwork-bostro-pesopeo-remix",
      image: "appaloosa-patchwork-bostro-pesopeo-remix.jpg",
    },
    {
      name: "Patchwork (Original)",
      slug: "appaloosa-patchwork-original",
      image: "appaloosa-patchwork-original.jpg",
    },
    {
      name: "Sinister (Original Mix)",
      slug: "appaloosa-sinister-original-mix",
      image: "appaloosa-sinister-original-mix.jpg",
    },
  ],
  "Timothy J. Fairplay": [
    {
      name: "Pathfinder Theme",
      slug: "timothy-j-fairplay-pathfinder-theme",
      image: "timothy-j-fairplay-pathfinder-theme.jpg",
    },
    {
      name: "UFOs Over China",
      slug: "timothy-j-fairplay-ufos-over-china",
      image: "timothy-j-fairplay-ufos-over-china.jpg",
    },
  ],
  "The Caribbean House": [
    {
      name: "Pavone Nero",
      slug: "the-caribbean-house-pavone-nero",
      image: "the-caribbean-house-pavone-nero.jpg",
    },
  ],
  "Max Jones": [
    {
      name: "Perisur",
      slug: "max-jones-perisur",
      image: "max-jones-perisur.jpg",
    },
    {
      name: "Perisur (Cornelius Doctor Emotion Remix)",
      slug: "max-jones-perisur-cornelius-doctor-emotion-remix",
      image: "max-jones-perisur-cornelius-doctor-emotion-remix.jpg",
    },
    {
      name: "Perisur (Jepe Remix)",
      slug: "max-jones-perisur-jepe-remix",
      image: "max-jones-perisur-jepe-remix.jpg",
    },
    { name: "Poche", slug: "max-jones-poche", image: "max-jones-poche.jpg" },
  ],
  "The Pineapple Twins": [
    {
      name: "Pineapple",
      slug: "the-pineapple-twins-pineapple",
      image: "the-pineapple-twins-pineapple.jpg",
    },
  ],
  Alligatorz: [
    {
      name: "Piranha (R-ASH Remix)",
      slug: "alligatorz-piranha-r-ash-remix",
      image: "alligatorz-piranha-r-ash-remix.jpg",
    },
  ],
  "Francisco & Cosmo": [
    {
      name: "Planeta",
      slug: "francisco-and-cosmo-planeta",
      image: "francisco-and-cosmo-planeta.jpg",
    },
    {
      name: "Planeta (Edit)",
      slug: "francisco-and-cosmo-planeta-edit",
      image: "francisco-and-cosmo-planeta-edit.jpg",
    },
  ],
  Tagliabue: [
    {
      name: "Pluviale",
      slug: "tagliabue-pluviale",
      image: "tagliabue-pluviale.jpg",
    },
  ],
  "Busta Flex": [
    {
      name: "Posteur",
      slug: "busta-flex-posteur",
      image: "busta-flex-posteur.jpg",
    },
    {
      name: "Soldat",
      slug: "busta-flex-soldat",
      image: "busta-flex-soldat.jpg",
    },
  ],
  Maxamillion: [
    {
      name: "Power Of My Melodies feat. Kalina",
      slug: "maxamillion-power-of-my-melodies-feat-kalina",
      image: "maxamillion-power-of-my-melodies-feat-kalina.jpg",
    },
  ],
  Diederdas: [
    { name: "Praia", slug: "diederdas-praia", image: "diederdas-praia.jpg" },
    {
      name: "Praia (Instrumental)",
      slug: "diederdas-praia-instrumental",
      image: "diederdas-praia-instrumental.jpg",
    },
  ],
  "Spr!": [
    { name: "Psygnosis", slug: "spr-psygnosis", image: "spr-psygnosis.jpg" },
  ],
  "Bigg Meuj": [
    {
      name: "Puff Daddy",
      slug: "bigg-meuj-puff-daddy",
      image: "bigg-meuj-puff-daddy.jpg",
    },
  ],
  D: [{ name: "Pusherman", slug: "d-pusherman", image: "d-pusherman.jpg" }],
  BNMC: [{ name: "Radio", slug: "bnmc-radio", image: "bnmc-radio.jpg" }],
  "Dj Cam": [
    { name: "Raise Up", slug: "dj-cam-raise-up", image: "dj-cam-raise-up.jpg" },
    {
      name: "Voodoo Child (Dj Premier Remix)",
      slug: "dj-cam-voodoo-child-dj-premier-remix",
      image: "dj-cam-voodoo-child-dj-premier-remix.jpg",
    },
  ],
  "Mat Le Rouge": [
    {
      name: "Red Alert",
      slug: "mat-le-rouge-red-alert",
      image: "mat-le-rouge-red-alert.jpg",
    },
    {
      name: "Soul Raide",
      slug: "mat-le-rouge-soul-raide",
      image: "mat-le-rouge-soul-raide.jpg",
    },
  ],
  "Roman Kouder": [
    {
      name: "Rhodz",
      slug: "roman-kouder-rhodz",
      image: "roman-kouder-rhodz.jpg",
    },
  ],
  Aélpéacha: [
    {
      name: "Rider c'est pas facile",
      slug: "aelpeacha-rider-c-est-pas-facile",
      image: "aelpeacha-rider-c-est-pas-facile.jpg",
    },
  ],
  "Seven Dub": [
    {
      name: "Rock It Tonight (Aleem & Seven Dub Remix)",
      slug: "seven-dub-rock-it-tonight-aleem-and-seven-dub-remix",
      image: "seven-dub-rock-it-tonight-aleem-and-seven-dub-remix.jpg",
    },
  ],
  "Phat Project": [
    { name: "Runner", slug: "phat-project-runner", image: null },
  ],
  Boostee: [
    {
      name: "Rêve de Gamin",
      slug: "boostee-reve-de-gamin",
      image: "boostee-reve-de-gamin.jpg",
    },
  ],
  Prigida: [
    { name: "Sally", slug: "prigida-sally", image: "prigida-sally.jpg" },
  ],
  "A Point Of View": [
    {
      name: "Scream Of Soldiers",
      slug: "a-point-of-view-scream-of-soldiers",
      image: "a-point-of-view-scream-of-soldiers.jpg",
    },
    {
      name: "Shiny Night",
      slug: "a-point-of-view-shiny-night",
      image: "a-point-of-view-shiny-night.jpg",
    },
  ],
  Lamagaia: [
    {
      name: "Seabass",
      slug: "lamagaia-seabass",
      image: "lamagaia-seabass.jpg",
    },
    {
      name: "Space Normal Speed",
      slug: "lamagaia-space-normal-speed",
      image: "lamagaia-space-normal-speed.jpg",
    },
  ],
  "Bait e Borghi": [
    {
      name: "Senti Questa",
      slug: "bait-e-borghi-senti-questa",
      image: "bait-e-borghi-senti-questa.jpg",
    },
  ],
  "Druk 11000": [
    {
      name: "Sibsoo Bazaar",
      slug: "druk-11000-sibsoo-bazaar",
      image: "druk-11000-sibsoo-bazaar.jpg",
    },
    {
      name: "Zamboling",
      slug: "druk-11000-zamboling",
      image: "druk-11000-zamboling.jpg",
    },
  ],
  Pompeya: [
    { name: "Sister", slug: "pompeya-sister", image: "pompeya-sister.jpg" },
    {
      name: "Sister (Pharao Black Magic remix)",
      slug: "pompeya-sister-pharao-black-magic-remix",
      image: "pompeya-sister-pharao-black-magic-remix.jpg",
    },
    {
      name: "Sister (Rubinskee Remix)",
      slug: "pompeya-sister-rubinskee-remix",
      image: "pompeya-sister-rubinskee-remix.jpg",
    },
    {
      name: "Sister (Space Ranger Remix)",
      slug: "pompeya-sister-space-ranger-remix",
      image: "pompeya-sister-space-ranger-remix.jpg",
    },
  ],
  Pan: [
    {
      name: "Six Feet Under",
      slug: "pan-six-feet-under",
      image: "pan-six-feet-under.jpg",
    },
    {
      name: "Too Much In My Mind",
      slug: "pan-too-much-in-my-mind",
      image: "pan-too-much-in-my-mind.jpg",
    },
  ],
  "Greg Ceven": [
    {
      name: "Sky is the Limit (Radio Edit)",
      slug: "greg-ceven-sky-is-the-limit-radio-edit",
      image: "greg-ceven-sky-is-the-limit-radio-edit.jpg",
    },
  ],
  "Lonely In The Rain": [
    {
      name: "Slow Down featuring Devyn Moon",
      slug: "lonely-in-the-rain-slow-down-featuring-devyn-moon",
      image: "lonely-in-the-rain-slow-down-featuring-devyn-moon.jpg",
    },
  ],
  "Glen Ricks": [
    { name: "Smile", slug: "glen-ricks-smile", image: "glen-ricks-smile.jpg" },
    {
      name: "Woke Up Crying",
      slug: "glen-ricks-woke-up-crying",
      image: "glen-ricks-woke-up-crying.jpg",
    },
  ],
  "Raiders Of The Lost Arp": [
    {
      name: "Spacer Rotla",
      slug: "raiders-of-the-lost-arp-spacer-rotla",
      image: "raiders-of-the-lost-arp-spacer-rotla.jpg",
    },
  ],
  "Deadstock 33s": [
    {
      name: "Spirit World",
      slug: "deadstock-33s-spirit-world",
      image: "deadstock-33s-spirit-world.jpg",
    },
    {
      name: "Swans (Inflagranti Remix)",
      slug: "deadstock-33s-swans-inflagranti-remix",
      image: "deadstock-33s-swans-inflagranti-remix.jpg",
    },
    {
      name: "Swans (Original)",
      slug: "deadstock-33s-swans-original",
      image: "deadstock-33s-swans-original.jpg",
    },
    {
      name: "Trixy",
      slug: "deadstock-33s-trixy",
      image: "deadstock-33s-trixy.jpg",
    },
  ],
  "Andy Balcon": [
    {
      name: "Standing Sideways",
      slug: "andy-balcon-standing-sideways",
      image: "andy-balcon-standing-sideways.jpg",
    },
  ],
  Discodromo: [
    {
      name: "Star and Rain",
      slug: "discodromo-star-and-rain",
      image: "discodromo-star-and-rain.jpg",
    },
  ],
  Outtake: [
    {
      name: "Stati Alterati (Acid In The Mix)",
      slug: "outtake-stati-alterati-acid-in-the-mix",
      image: "outtake-stati-alterati-acid-in-the-mix.jpg",
    },
  ],
  "Son & Stepson": [
    {
      name: "Stick",
      slug: "son-and-stepson-stick",
      image: "son-and-stepson-stick.jpg",
    },
  ],
  "Big Dope P": [
    {
      name: "Still Trill feat. Feadz and DMP (R-ASH Remix)",
      slug: "big-dope-p-still-trill-feat-feadz-and-dmp-r-ash-remix",
      image: "big-dope-p-still-trill-feat-feadz-and-dmp-r-ash-remix.jpg",
    },
  ],
  "Yos Angel": [
    {
      name: "Sueltate",
      slug: "yos-angel-sueltate",
      image: "yos-angel-sueltate.jpg",
    },
  ],
  Lvne: [
    {
      name: "Summer Blossom",
      slug: "lvne-summer-blossom",
      image: "lvne-summer-blossom.jpg",
    },
  ],
  "Male Madame": [
    {
      name: "Sunny Saint Mark (Cameo Culture Remix)",
      slug: "male-madame-sunny-saint-mark-cameo-culture-remix",
      image: "male-madame-sunny-saint-mark-cameo-culture-remix.jpg",
    },
  ],
  "Niki Demiller": [
    {
      name: "Sur L'Asphalte",
      slug: "niki-demiller-sur-l-asphalte",
      image: "niki-demiller-sur-l-asphalte.jpg",
    },
  ],
  "Peter Z and Joey Casanova": [
    {
      name: "Swag Check",
      slug: "peter-z-and-joey-casanova-swag-check",
      image: "peter-z-and-joey-casanova-swag-check.jpg",
    },
  ],
  "Leo Justi and Brazzabelle": [
    {
      name: "Swipe It Off feat Zanillya",
      slug: "leo-justi-and-brazzabelle-swipe-it-off-feat-zanillya",
      image: "leo-justi-and-brazzabelle-swipe-it-off-feat-zanillya.jpg",
    },
    {
      name: "Swipe It Off feat Zanillya (Instrumental)",
      slug: "leo-justi-and-brazzabelle-swipe-it-off-feat-zanillya-instrumental",
      image:
        "leo-justi-and-brazzabelle-swipe-it-off-feat-zanillya-instrumental.jpg",
    },
  ],
  "Glimmer Of Blooms": [
    {
      name: "Take My Hand",
      slug: "glimmer-of-blooms-take-my-hand",
      image: "glimmer-of-blooms-take-my-hand.jpg",
    },
  ],
  "The Rippers": [
    {
      name: "Take The City",
      slug: "the-rippers-take-the-city",
      image: "the-rippers-take-the-city.jpg",
    },
  ],
  "Fabich & Jafunk": [
    {
      name: "Talk To Me feat. Liska",
      slug: "fabich-and-jafunk-talk-to-me-feat-liska",
      image: "fabich-and-jafunk-talk-to-me-feat-liska.jpg",
    },
  ],
  "Takiru and Eran Yaari": [
    {
      name: "Tanduri",
      slug: "takiru-and-eran-yaari-tanduri",
      image: "takiru-and-eran-yaari-tanduri.jpg",
    },
  ],
  "Simon Nardis": [
    {
      name: "That Summer",
      slug: "simon-nardis-that-summer",
      image: "simon-nardis-that-summer.jpg",
    },
  ],
  "The Unfinished Sympathy": [
    {
      name: "The Loveless Curse",
      slug: "the-unfinished-sympathy-the-loveless-curse",
      image: "the-unfinished-sympathy-the-loveless-curse.jpg",
    },
    {
      name: "You've Got A Long Run",
      slug: "the-unfinished-sympathy-you-ve-got-a-long-run",
      image: "the-unfinished-sympathy-you-ve-got-a-long-run.jpg",
    },
  ],
  "Panama Disco Lights": [
    {
      name: "The Mood Iam In (Gameboyz Remix)",
      slug: "panama-disco-lights-the-mood-iam-in-gameboyz-remix",
      image: "panama-disco-lights-the-mood-iam-in-gameboyz-remix.jpg",
    },
    {
      name: "The Mood Iam In (Original)",
      slug: "panama-disco-lights-the-mood-iam-in-original",
      image: "panama-disco-lights-the-mood-iam-in-original.jpg",
    },
    {
      name: "The Mood Iam In (Rodion Nero Dub Remix)",
      slug: "panama-disco-lights-the-mood-iam-in-rodion-nero-dub-remix",
      image: "panama-disco-lights-the-mood-iam-in-rodion-nero-dub-remix.jpg",
    },
    {
      name: "The Mood Iam In (Space Ranger Remix)",
      slug: "panama-disco-lights-the-mood-iam-in-space-ranger-remix",
      image: "panama-disco-lights-the-mood-iam-in-space-ranger-remix.jpg",
    },
  ],
  "Adam Fearn And Electer": [
    {
      name: "The Raven (Instrumental)",
      slug: "adam-fearn-and-electer-the-raven-instrumental",
      image: "adam-fearn-and-electer-the-raven-instrumental.jpg",
    },
  ],
  Bellevue: [
    {
      name: "This Is Gonna Blow",
      slug: "bellevue-this-is-gonna-blow",
      image: "bellevue-this-is-gonna-blow.jpg",
    },
  ],
  Mijo: [
    { name: "Thxtasy", slug: "mijo-thxtasy", image: "mijo-thxtasy.jpg" },
    {
      name: "Thxtasy (D.Y.O.R. Remix)",
      slug: "mijo-thxtasy-d-y-o-r-remix",
      image: "mijo-thxtasy-d-y-o-r-remix.jpg",
    },
    {
      name: "Thxtasy (Paulor Remix)",
      slug: "mijo-thxtasy-paulor-remix",
      image: "mijo-thxtasy-paulor-remix.jpg",
    },
    {
      name: "Thxtasy (The Chica Alt Remix)",
      slug: "mijo-thxtasy-the-chica-alt-remix",
      image: "mijo-thxtasy-the-chica-alt-remix.jpg",
    },
    {
      name: "Thxtasy (The Chica Remix)",
      slug: "mijo-thxtasy-the-chica-remix",
      image: "mijo-thxtasy-the-chica-remix.jpg",
    },
  ],
  Vektorkat: [
    {
      name: "Time Is Up",
      slug: "vektorkat-time-is-up",
      image: "vektorkat-time-is-up.jpg",
    },
    {
      name: "Time Is Up (Blacksoul Remix)",
      slug: "vektorkat-time-is-up-blacksoul-remix",
      image: "vektorkat-time-is-up-blacksoul-remix.jpg",
    },
    {
      name: "Time Is Up (Crusz Remix)",
      slug: "vektorkat-time-is-up-crusz-remix",
      image: "vektorkat-time-is-up-crusz-remix.jpg",
    },
    {
      name: "Time Is Up (Walter Remix)",
      slug: "vektorkat-time-is-up-walter-remix",
      image: "vektorkat-time-is-up-walter-remix.jpg",
    },
    {
      name: "Time Is Up (Yellow Shark Remix)",
      slug: "vektorkat-time-is-up-yellow-shark-remix",
      image: "vektorkat-time-is-up-yellow-shark-remix.jpg",
    },
    {
      name: "Wyno (Elite Superstar Remix)",
      slug: "vektorkat-wyno-elite-superstar-remix",
      image: "vektorkat-wyno-elite-superstar-remix.jpg",
    },
    {
      name: "Wyno (Original)",
      slug: "vektorkat-wyno-original",
      image: "vektorkat-wyno-original.jpg",
    },
  ],
  "Moon Runner": [
    {
      name: "Tlatohua",
      slug: "moon-runner-tlatohua",
      image: "moon-runner-tlatohua.jpg",
    },
  ],
  Italoconnection: [
    {
      name: "Today Tomorrow",
      slug: "italoconnection-today-tomorrow",
      image: "italoconnection-today-tomorrow.jpg",
    },
  ],
  "The Mamba": [
    { name: "Trails", slug: "the-mamba-trails", image: "the-mamba-trails.jpg" },
  ],
  Liberato: [
    {
      name: "Tu T'E Scurdat E Me",
      slug: "liberato-tu-t-e-scurdat-e-me",
      image: "liberato-tu-t-e-scurdat-e-me.jpg",
    },
  ],
  Birds: [
    {
      name: "Tunnel Vision",
      slug: "birds-tunnel-vision",
      image: "birds-tunnel-vision.jpg",
    },
  ],
  Sebastopol: [
    { name: "Ully", slug: "sebastopol-ully", image: "sebastopol-ully.jpg" },
  ],
  Leyet: [
    {
      name: "Use To You",
      slug: "leyet-use-to-you",
      image: "leyet-use-to-you.jpg",
    },
  ],
  "Tres Coronas": [
    {
      name: "Vamos A Jugar feat. Kafu Banton",
      slug: "tres-coronas-vamos-a-jugar-feat-kafu-banton",
      image: "tres-coronas-vamos-a-jugar-feat-kafu-banton.jpg",
    },
  ],
  "Golden Bug and The Limiñanas": [
    {
      name: "Variation Sur 3 Bancs",
      slug: "golden-bug-and-the-liminanas-variation-sur-3-bancs",
      image: "golden-bug-and-the-liminanas-variation-sur-3-bancs.jpg",
    },
    {
      name: "Variation Sur 3 Bancs (Destino Remix)",
      slug: "golden-bug-and-the-liminanas-variation-sur-3-bancs-destino-remix",
      image:
        "golden-bug-and-the-liminanas-variation-sur-3-bancs-destino-remix.jpg",
    },
    {
      name: "Variation Sur 3 Bancs (Pilooski Instrumental Remix)",
      slug:
        "golden-bug-and-the-liminanas-variation-sur-3-bancs-pilooski-instrumental-remix",
      image:
        "golden-bug-and-the-liminanas-variation-sur-3-bancs-pilooski-instrumental-remix.jpg",
    },
    {
      name: "Variation Sur 3 Bancs (Pilooski Remix)",
      slug: "golden-bug-and-the-liminanas-variation-sur-3-bancs-pilooski-remix",
      image:
        "golden-bug-and-the-liminanas-variation-sur-3-bancs-pilooski-remix.jpg",
    },
  ],
  Clarysse: [
    {
      name: "Vocé Me Da",
      slug: "clarysse-voce-me-da",
      image: "clarysse-voce-me-da.jpg",
    },
  ],
  "Roe Deers": [
    { name: "Volko", slug: "roe-deers-volko", image: "roe-deers-volko.jpg" },
    { name: "Volko", slug: "roe-deers-volko", image: "roe-deers-volko.jpg" },
  ],
  Gabriel: [
    {
      name: "Wanna Ahah!",
      slug: "gabriel-wanna-ahah",
      image: "gabriel-wanna-ahah.jpg",
    },
  ],
  Orent: [
    {
      name: "Wasted (Alex Cortes and Orion Remix)",
      slug: "orent-wasted-alex-cortes-and-orion-remix",
      image: "orent-wasted-alex-cortes-and-orion-remix.jpg",
    },
    {
      name: "Wasted (Gold Bomb Remix)",
      slug: "orent-wasted-gold-bomb-remix",
      image: "orent-wasted-gold-bomb-remix.jpg",
    },
  ],
  "Bufi and La Royale": [
    {
      name: "Watch Out",
      slug: "bufi-and-la-royale-watch-out",
      image: "bufi-and-la-royale-watch-out.jpg",
    },
    {
      name: "Watch Out ( Yan Wagner Rough Disco Mix)",
      slug: "bufi-and-la-royale-watch-out-yan-wagner-rough-disco-mix",
      image: "bufi-and-la-royale-watch-out-yan-wagner-rough-disco-mix.jpg",
    },
  ],
  Satellite: [
    {
      name: "We're Gonna Get Out",
      slug: "satellite-we-re-gonna-get-out",
      image: "satellite-we-re-gonna-get-out.jpg",
    },
  ],
  "Miss Bee": [
    {
      name: "Weak Knees",
      slug: "miss-bee-weak-knees",
      image: "miss-bee-weak-knees.jpg",
    },
  ],
  Kassiel: [
    {
      name: "West Hills",
      slug: "kassiel-west-hills",
      image: "kassiel-west-hills.jpg",
    },
  ],
  "Mushrooms Project": [
    {
      name: "Wet Voodoo",
      slug: "mushrooms-project-wet-voodoo",
      image: "mushrooms-project-wet-voodoo.jpg",
    },
  ],
  "Mr Tout Le Monde": [
    {
      name: "Where Are You",
      slug: "mr-tout-le-monde-where-are-you",
      image: "mr-tout-le-monde-where-are-you.jpg",
    },
  ],
  "Jo Vincenzo": [
    {
      name: "Woods",
      slug: "jo-vincenzo-woods",
      image: "jo-vincenzo-woods.jpg",
    },
  ],
  "Chynna Blue": [
    {
      name: "Work it (Instrumental)",
      slug: "chynna-blue-work-it-instrumental",
      image: "chynna-blue-work-it-instrumental.jpg",
    },
  ],
  "Mr Tout le Monde": [
    {
      name: "You I",
      slug: "mr-tout-le-monde-you-i",
      image: "mr-tout-le-monde-you-i.jpg",
    },
  ],
  Trent: [
    { name: "Zanzibar", slug: "trent-zanzibar", image: "trent-zanzibar.jpg" },
  ],
  "Heinrich Dressel": [
    {
      name: "Équipe 82",
      slug: "heinrich-dressel-equipe-82",
      image: "heinrich-dressel-equipe-82.jpg",
    },
  ],
}
export const allGenres = [
  "World",
  "Drums and Percussion",
  "Folk Acoustic",
  "Electro Club",
  "Epic-Electro",
  "Cinematic - Electronic",
  "Pop-Folk",
  "Pop-Rock",
  "Electro Funk",
  "Hip-Hop West Coast",
  "Hip-Hop Old School",
  "House",
  "Electronica",
  "Broken beat",
  "Hip-Hop Experimental",
  "Electro-Acoustic",
  "Ambient",
  "Dubstep / Future bass",
  "Funk",
  "80's",
  "Electropop",
  "Disco - House",
  "Girly Pop",
  "Electronic Rock",
  "Driving Electro",
  "Hip-Hop East Coast",
  "Urban Soul",
  "Epic-Rock",
  "Jazz",
  "World Soul",
  "Folk",
  "Blues",
  "Trip hop",
  "Psychedelic / Krautrock",
  "Indie Dance",
  "Punk / Garage Rock",
  "Hard Rock",
  "World Electronic",
  "Rock",
  "Classic",
  "New Wave",
  "Tango",
  "Lounge",
  "Cinematic - Folk",
  "Cinematic - Rock",
  "Soul",
  "Cinematic - Suspense",
  "Pop",
  "Epic-Orchestral",
  "Reggae / Ragga / Dub",
  "Retro Futuristic",
  "Techno",
  "Cinematic - Classic",
  "Rockabilly / Surf",
  "Modern Jazz",
  "Rock and Roll 50’s",
  "Soul / Funk oldies",
  "Metal",
  "Epic-Pop",
  "Cinematic - World",
  "Rock 70's",
  "Breakbeat",
  "Experimental / Noise",
  "Bossa Nova",
  "Dance / Eurodance",
  "French Touch",
  "Trap",
  "Swing / Electro Swing",
  "EDM",
  "Samba",
  "Disco",
  "Reggaeton",
  "Video game / 8 bits",
  "Grunge / Shoegaze",
  "Flamenco / Rumba",
]
